/**
 * Traduction native (Moroccan Amazigh (Standard Moroccan Tamazight, ISO zgh, Latin script — not Tifinagh)) — généré par scripts/translate-i18n-gaps.mjs
 * Modèle: gpt-4o-mini. Ne pas éditer à la main sans besoin ; relancer i18n:gaps puis translate si les clés changent.
 */
export const zghGapTranslations: Record<string, string> = {
  "nav.dashboard": "Tazwart n ubrid",
  "nav.projects": "Tajmilt",
  "nav.eduflow": "EduFlow",
  "nav.audiobooks": "Tiwizi n tazrawt",
  "nav.audio_studio": "Tizi n tazrawt",
  "nav.store": "Tazrigt",
  "nav.analytics": "Tazrawt",
  "nav.users": "Ihder",
  "nav.settings": "Tazrigt",
  "nav.profile": "Tazrigt",
  "profile.institution": "Tazwit",
  "profile.institutionHint": "Akked n LyrraOne ikka d-ttwalt s yid n tazwit. Azzay n tazwit yella d-ttwalt s yid n umdaw.",
  "profile.institutionUnknownName": "Tazwit (ism ur yella)",
  "nav.notifications": "Tazrawt",
  "nav.help": "Ayd",
  "nav.community": "Tazrawt",
  "nav.library": "Tazrigt",
  "nav.certificates": "Ittijjat",
  "nav.institution": "Tazwit",
  "nav.groups": "Igrin",
  "nav.learners": "Ihder",
  "nav.myLearning": "Tazrawt n yid",
  "nav.reports": "Tazrawt",
  "nav.qualiopi": "Qualiopi",
  "nav.training_plan": "Tazrawt n tazwit",
  "nav.catalog": "Tazrigt",
  "nav.competencies": "Tazrawt",
  "nav.budget": "Budjet",
  "nav.campaigns": "Tazrawt",
  "nav.codir": "CODIR",
  "nav.home": "Akked",
  "nav.producerAssignments": "Azzay n tazrawt",
  "nav.videos": "Tazrawt",
  "nav.sounds": "Tazrawt",
  "nav.images": "Tazrawt",
  "pages.images.title": "Tazrawt",
  "pages.images.pasteHint": "Nekka d-ttwalt s yid (Ctrl+V / Cmd+V)",
  "pages.images.emptyHint": "Sser, tazrigt s yid, nekk d-ttwalt s yid (Ctrl+V / Cmd+V).",
  "pages.images.viewLarge": "Ssefru s yid",
  "pages.images.lightboxTitle": "Aperçu n tazrawt",
  "pages.images.lightboxClose": "Sser",
  "pages.images.lightboxBackdropClose": "Sser n apercu",
  "pages.images.lightboxPrev": "Tasga n yid",
  "pages.images.lightboxNext": "Tasga n yid nni",
  "nav.documents": "Imekkan",
  "nav.podcasts": "Podcasts",
  "nav.webinars": "Webinaires",
  "nav.webinarsEnterprise": "Webinaires (tadawt)",
  "webinar.room.capacityFull": "Tazrigt a ttaḥt sa tazrigt nni ({{max}} iḍ n yiman iḍ yenn). Rreḥ aḥed.",
  "webinar.room.participants": "Iḍ n yiman",
  "webinar.room.chat": "Chat",
  "webinar.room.speechTab": "Tazrigt",
  "webinar.room.speechPanelHint": "Tiwzi n yid n yiman iḍ yenn (tazrigt n yid n tazrigt). Ism n yiman iḍ yenn d isem n yiman iḍ yenn.",
  "webinar.room.speechEmpty": "Mara yiman iḍ yenn yebda iḍ yenn, tiwzi tḥeḍ iḥed s isem n yiman iḍ yenn. Tazrigt tḥeḍ d tazrigt n yid n tazrigt.",
  "webinar.room.speechUnknownSpeaker": "Yiman",
  "webinar.room.speechPresenterActive": "Tiwzi n yid n yiman iḍ yenn tḥeḍ d yiman iḍ yenn (tab n Tazrigt).",
  "webinar.room.speechUnsupportedBrowser": "Tazrigt n yid n yiman iḍ yenn ur tḥeḍ d yid n tazrigt (rreḥ aḥed Chrome neɣ Edge).",
  "webinar.room.sidePanelTabs": "Iḍ n yiman, tazrigt n yiman, sondegh neɣ chat",
  "webinar.room.you": "k",
  "webinar.room.showParticipantsPanel": "Ssaḥ iḥed n Iḍ n yiman",
  "webinar.room.hideParticipantsPanel": "Ssaḥ iḥed",
  "webinar.room.leave": "Ssaḥ iḥed",
  "webinar.room.contentFocusExpand": "Aḍu n tazrigt s yid n yiman",
  "webinar.room.contentFocusCollapse": "Ssaḥ d yid n yiman neɣ yiman",
  "webinar.room.contentFocusAriaExpand": "Aḍu n tazrigt, tazrigt n yid neɣ tazrigt n yid s yid n yiman ur nni",
  "webinar.room.liveDocumentLabel": "Fichier (PDF neɣ PowerPoint)",
  "webinar.room.liveDocumentUploadChoice": "Ssaḥ iḥed n fichier",
  "webinar.room.liveDocumentUploading": "Ssend...",
  "webinar.room.liveDocumentUploadError": "Ur tḥeḍ d fichier. Ssaḥ iḥed n format (PDF neɣ PowerPoint) neɣ tazrigt (max. 40 Mo).",
  "webinar.room.liveDocumentClose": "Ssaḥ d fichier",
  "webinar.room.liveDocumentBehindScreen": "Fichier ur tḥeḍ d yid - ssaḥ d yid n yiman.",
  "webinar.room.waitingSharedContentExtended": "Ssaḥ d yid n yiman iḍ yenn: tazrigt n tazrigt, fichier (PDF neɣ PowerPoint) neɣ tazrigt n yiman.",
  "webinar.room.liveDocumentOfficeHint": "Mara ur tḥeḍ d yid (HTTP local neɣ fichier iḍ yenn), ssaḥ d yid n yiman.",
  "webinar.room.liveDocumentOpenOrDownload": "Ssaḥ neɣ ssend d fichier",
  "webinar.room.liveDocumentNoInlinePreview": "Aḍu n fichier ur tḥeḍ d yid s yid. Ssaḥ d yid n yiman.",
  "webinar.room.liveDocumentOpenTab": "Ssaḥ",
  "webinar.room.pollTab": "Sondegh",
  "webinar.room.poll.regionTitle": "Sondegh n webinaire",
  "webinar.room.poll.presenterHint": "Ssaḥ iḥed n sual neɣ 2 ɣer 8 iḍ. Sondegh tḥeḍ d yid n yiman; ur tḥeḍ d yid n yiman iḍ yenn.",
  "webinar.room.poll.questionLabel": "Sual",
  "webinar.room.poll.questionPlaceholder": "Ex. : Anwa tazrigt tḥeḍ d yid?",
  "webinar.room.poll.optionsLabel": "Iḍ n tazrigt",
  "webinar.room.poll.optionNumber": "Iḍ",
  "webinar.room.poll.choiceLabel": "Tazrigt",
  "webinar.room.poll.addOption": "Sserh aẓru",
  "webinar.room.poll.removeLastOption": "Sserh aẓru n yid",
  "webinar.room.poll.launch": "Sseɣ aẓru",
  "webinar.room.poll.waitingParticipant": "Ur illi aẓru n yid. L'animatour yella ad sseɣ aẓru.",
  "webinar.room.poll.voteHint": "Aẓru n yid s yid n uḍu: tzemreḍ ad tḥeḍḍeḍ aẓru n yid s yid n uḍu.",
  "webinar.room.poll.yourVote": "aḍru nnek",
  "webinar.room.poll.resultsHeading": "Iḍelli (animatour)",
  "webinar.room.poll.noVotesYet": "Ur illi aḍru n yid.",
  "webinar.room.poll.totalVotes": "Aḍru n yid: {{n}}",
  "webinar.room.poll.closePoll": "Sserh aẓru",
  "webinar.room.contentFocusAriaCollapse": "Sserh aẓru n tazmert n taddart akked tazmert n yid",
  "webinar.room.exitDirectTitle": "Sseɣ aẓru n webinaire?",
  "webinar.room.exitDirectMessage": "Ttḥeḍḍeḍ aẓru n taddart s link iḍu (ur tḥeḍḍeḍ s taddart n taddart). Tzemreḍ ad sserh aẓru. Ma ur yella aḥeḍḍeḍ, tzemreḍ ad tḥeḍḍeḍ s yid nnek.",
  "webinar.room.exitDirectConfirm": "Sserh aẓru",
  "webinar.room.publicGateTitle": "Tazmert s webinaire",
  "webinar.room.publicGateHint": "L'organisateur yella ad sserh tazmert s yid: sserh aẓru nnek, sserh aḍru n yid (8 aḍru min.) akked sserh aḍru n yid.",
  "webinar.room.publicGateEmail": "E-mail",
  "webinar.room.publicGateLogin": "Identifiant",
  "webinar.room.publicGatePassword": "Mot de passe",
  "webinar.room.publicGatePasswordHintParticipant": "Tazmert n yid: tazmert. Tazmert n yid: aḍru nnek akked mot de passe. Aḍru 8 min.",
  "webinar.room.publicGateSubmit": "Sserh s taddart",
  "webinar.room.publicGateSubmitting": "Tazmert…",
  "webinar.room.publicGateDenied": "E-mail ur mot de passe ur illi.",
  "webinar.room.socketGateDenied": "Ur tzemreḍ ad sserh aẓru n taddart: tazmert n yid ur illi ur tḥeḍḍeḍ. Rreḍ ad tḥeḍḍeḍ s taddart akked e-mail akked mot de passe.",
  "nav.parcours": "Parcours",
  "nav.eduflowList": "Formations",
  "nav.funnels": "Funnels n tazmert",
  "nav.section.marketing": "Marketing & tazmert",
  "nav.section.institution": "Gestion & tazmert",
  "nav.marketingHub": "Tazmert n tazmert",
  "nav.contacts": "Contacts",
  "nav.emailMarketing": "Email marketing",
  "nav.automations": "Automatisations",
  "nav.siteWeb": "Site web",
  "nav.creatorPage": "Page n tcreatour",
  "nav.crm": "Pipeline CRM",
  "nav.affiliate": "Affiliation",
  "nav.booking": "Calendrier",
  "nav.communities": "Communautés",
  "nav.webinarsEvergreen": "Webinaires",
  "nav.physicalProducts": "Produits physiques",
  "nav.smsMarketing": "SMS",
  "nav.section.pilotage": "Tazrigt",
  "nav.section.activity": "Aḍu n yid",
  "nav.section.creation": "Tazrigt",
  "nav.section.medias": "Médias",
  "nav.section.aide": "Tazrigt",
  "sidebar.brandTagline": "Tazrigt",
  "sidebar.logoInstitutionAlt": "Logo n tazrigt",
  "sidebar.expand": "Aḍu le menu",
  "sidebar.collapse": "Sser le menu",
  "sidebar.expandAria": "Aḍu le barra latérale",
  "sidebar.collapseAria": "Sser le barra latérale",
  "dashboard.kindPodcast": "Podcast",
  "pages.learners.title": "Aḍu n yid",
  "pages.learners.description": "Ssuḍeḍ la progression n yid nwen",
  "pages.learners.enrolledFormations": "Tazrigt yellan",
  "pages.learners.notStarted": "Ur yettwas",
  "pages.learners.startedOn": "Sseḍ {{date}}",
  "pages.learners.detailedTraces": "Traces n tazrigt · {{flowTitle}}",
  "pages.learners.statsEvents": "Aḍu n yid: {{count}}",
  "pages.learners.statsResponses": "Aḍu n yid: {{count}}",
  "pages.learners.statsBlockSessions": "Aḍu n yid n blocs: {{count}}",
  "pages.learners.timePerBlock": "Waṭas n bloc",
  "pages.learners.lastEvents": "Aḍu n yid n yid",
  "pages.learners.blockSessionInProgress": "(d in progress)",
  "pages.learners.blockTimeOnBlock": "({{duration}} ɣer a bloc)",
  "pages.learners.trackingEvent.unknown": "Aḍu",
  "pages.learners.trackingEvent.training_enter": "Aḍu n tazrigt",
  "pages.learners.trackingEvent.training_exit": "Sser ou sseḍ n tazrigt",
  "pages.learners.trackingEvent.training_completed": "Tazrigt tzemreḍ",
  "pages.learners.trackingEvent.block_enter": "Aḍu n bloc",
  "pages.learners.trackingEvent.block_exit": "Sser d bloc",
  "pages.learners.trackingEvent.response_submitted": "Aḍu ou validé yeḍ",
  "pages.learners.trackingEvent.progress_sync": "Synchronisation n progression",
  "pages.learners.refresh": "Aḍu",
  "pages.learners.exportCsv": "Exporté CSV",
  "pages.learners.statTotal": "Total n yid",
  "pages.learners.statInProgress": "D in progress",
  "pages.learners.statCompleted": "Tzemreḍ",
  "pages.learners.statAvgProgress": "Progression moy.",
  "pages.learners.searchPlaceholder": "Rechercher ɣer ism ou email…",
  "pages.learners.filterAllFlows": "Tazrigt yellan",
  "pages.learners.sortRecent": "Aḍu n yid",
  "pages.learners.sortName": "Isem A-Z",
  "pages.learners.sortProgress": "Tazrigt",
  "pages.learners.colLearner": "Apreant",
  "pages.learners.colFormations": "Tazrigt",
  "pages.learners.colProgress": "Tazrigt",
  "pages.learners.colCompleted": "Tazrigt",
  "pages.learners.colTime": "Tazrigt",
  "pages.learners.colLastAccess": "Aksas n yid",
  "pages.learners.colActions": "Aksas",
  "pages.learners.openProgressDashboard": "Tazrigt n tazrigt",
  "pages.learners.dashboardTitle": "Tazrigt n apreant",
  "pages.learners.dashboardBack": "Ssa n list",
  "pages.learners.dashboardInvalidId": "Id n apreant ur yella",
  "pages.learners.dashboardNotFound": "Apreant ur yella negh ur tazgirt",
  "pages.learners.dashboardOverviewHint": "Tazrigt n tazrigt: tazrigt EduFlow i d-yeffren ad yella, tazrigt akked podcasts i d-yeffren i lakk n Lyrra i d-yeffren s wawal n e-mail.",
  "pages.learners.tabOverview": "Tazrigt",
  "pages.learners.tabFormations": "Tazrigt",
  "pages.learners.tabParcours": "Tazrigt",
  "pages.learners.tabPodcasts": "Podcasts",
  "pages.learners.sectionFormations": "Tazrigt",
  "pages.learners.sectionParcours": "Tazrigt",
  "pages.learners.sectionPodcasts": "Podcasts",
  "pages.learners.emptyParcours": "Ur yella tazrigt i d-yeffren i lakk n Lyrra s wawal n e-mail.",
  "pages.learners.emptyPodcasts": "Ur yella podcast i d-yeffren i lakk n Lyrra s wawal n e-mail.",
  "pages.learners.linkedAccountHint": "Tazrigt akked podcasts yella gher i d-yeffren i Lyrra s wawal n e-mail amek yella ad yeffren.",
  "pages.learners.kpiEduflows": "Tazrigt",
  "pages.learners.kpiAvgProgress": "Tazrigt amezwaru",
  "pages.learners.kpiPaths": "Tazrigt",
  "pages.learners.kpiPodcasts": "Podcasts",
  "pages.learners.kpiCompletedFormations": "{{count}} tazrigt",
  "pages.learners.pathProgressLabel": "{{done}} / {{total}} tazrigt",
  "pages.learners.pathAssignedOn": "Ssed le {{date}}",
  "pages.learners.podcastCompleted": "Tazrigt",
  "pages.learners.podcastInProgress": "D-yeffren",
  "pages.learners.pathStatusPublished": "Yella",
  "pages.learners.pathStatusDraft": "Tazrigt",
  "pages.learners.openInDesigner": "Ssa gher lqed",
  "pages.learners.openParcoursEditor": "Ssa tazrigt",
  "pages.learners.viewPodcasts": "Wali podcasts",
  "pages.learners.loading": "D-yeffren i d-yeffren...",
  "pages.learners.loadError": "Ur n-yella d-yeffren i d-yeffren",
  "pages.learners.retry": "Rjaâ",
  "pages.learners.emptyFiltered": "Ula d-ttwawen nniḍen",
  "pages.learners.emptyFilteredHint": "Ssaḥli d-ttwawen nniḍen",
  "pages.learners.emptyNone": "Ula d-ttwawen yessir",
  "pages.learners.emptyNoneHint": "Ittwawen yebdu ḥna ḍ-ttwawen nniḍen i yessirun ɣef tɣurfin nwen",
  "pages.learners.pagination": "Page {{page}} ɣer {{totalPages}} · {{total}} ttawawen",
  "pages.learners.prev": "Aḍu",
  "pages.learners.next": "Ssu",
  "pages.learners.csvLastName": "Isem",
  "pages.learners.csvFirstName": "Tazmert",
  "pages.learners.csvEmail": "Email",
  "pages.learners.csvFormations": "Tɣurfin",
  "pages.learners.csvAvgProgress": "Tazmert n t-progress",
  "pages.learners.csvTotalTime": "Aṭas n t-ṭṭaw",
  "pages.learners.csvLastActivity": "Aḍu n t-activity",
  "eduflowList.status.draft": "Tawḍi",
  "eduflowList.status.published": "Iḍu",
  "eduflowList.status.archived": "Iḍu ɣef t-ṭṭaw",
  "eduflowList.badge.enterpriseShell": "Aḍu n t-ttawen",
  "eduflowList.badge.enterpriseLinked": "T-ttawen",
  "eduflowList.badge.toProduce": "Iḍu ɣef",
  "eduflow.list.blocksCount": "{{count}} blocks",
  "eduflow.list.noContent": "Ula d-content",
  "eduflow.list.minutesShort": "{{count}} min",
  "eduflow.list.tooltip.openMissions": "Uḍu Mes missions",
  "eduflow.list.tooltip.edit": "Ssaḥli",
  "eduflow.list.shellHint": "Fiche d-ttwawen nwen — ssaḥli d-EduFlow ɣef « Mes missions ». ",
  "breadcrumb.label": "Fil d'Ariane",
  "breadcrumb.home": "Aḍu",
  "breadcrumb.dashboard": "Tableau de bord",
  "breadcrumb.projects": "Projets",
  "breadcrumb.eduflow": "Formations",
  "breadcrumb.learners": "Apprenants",
  "breadcrumb.analytics": "Analytiques",
  "breadcrumb.videos": "Vidéos",
  "breadcrumb.sounds": "Sons",
  "breadcrumb.images": "Images",
  "breadcrumb.documents": "Documents",
  "breadcrumb.store": "Boutique",
  "breadcrumb.help": "Aide",
  "breadcrumb.admin": "Administration",
  "breadcrumb.settings": "Paramètres",
  "breadcrumb.profile": "Profil",
  "breadcrumb.groups": "Igrup",
  "breadcrumb.branding": "Tasga n tmazirt",
  "breadcrumb.landingPage": "Taqsi n tazrigt",
  "breadcrumb.webhooks": "Webhooks",
  "breadcrumb.campaigns": "Tazrigt",
  "breadcrumb.competencies": "Tazrawt",
  "breadcrumb.compliance": "Tazrawt",
  "breadcrumb.reports": "Tazrawt",
  "breadcrumb.budget": "Budjet",
  "breadcrumb.catalog": "Tazrigt",
  "breadcrumb.integrations": "Tazrawt",
  "breadcrumb.requests": "Tazrawt",
  "breadcrumb.team": "Taqsi",
  "breadcrumb.reviews": "Tazrawt",
  "breadcrumb.training": "Tazrawt",
  "breadcrumb.skills": "Tazrawt",
  "breadcrumb.certificates": "Ighil n tazrawt",
  "breadcrumb.new": "Anew",
  "breadcrumb.edit": "Ssnid",
  "breadcrumb.podcasts": "Podcasts",
  "breadcrumb.episodes": "Iḍef",
  "breadcrumb.parcours": "Tazrawt",
  "breadcrumb.producerAssignments": "Tazrawt n tazrawt",
  "header.toggleMenu": "Ssnid neɣ sɣur n menu",
  "header.search": "Sserḥe…",
  "header.toggleTheme": "Ssnid tazrawt n tazrigt",
  "header.profile": "Profil",
  "header.settings": "Iḍef n tazrawt",
  "header.backToInstitutionAdmin": "Tazrawt n tazrigt",
  "header.openTrainerWorkspace": "Asefru n tazrawt",
  "header.logout": "Ssnid",
  "footer.madeWith": "Fait avec",
  "footer.forEducation": "i tazrawt",
  "footer.legal": "Liens légaux",
  "footer.terms": "CGU",
  "footer.privacy": "Confidentialité",
  "footer.accessibility": "Accessibilité",
  "footer.a11yCenter": "Accessibilité",
  "footer.supportChat": "Aide & support",
  "btn.save": "Ssave",
  "btn.cancel": "Annuller",
  "btn.delete": "Ssupprimer",
  "btn.edit": "Snaḍer",
  "btn.create": "Sseḍer",
  "btn.add": "Sseḍḍer",
  "btn.close": "Sserḥer",
  "btn.confirm": "Sseḥḥer",
  "btn.back": "Ssuḥu",
  "btn.next": "Ssuḍu",
  "btn.previous": "Ssuḍu n wul",
  "btn.submit": "Sseḥḥer",
  "btn.search": "Sseɣer",
  "btn.filter": "Sseḍḍer",
  "btn.export": "Sseɣer",
  "btn.import": "Sseḍḍer",
  "btn.download": "Sseḍḍer",
  "btn.upload": "Sseḍḍer",
  "btn.refresh": "Sseḥḥer",
  "btn.retry": "Sseḥḥer",
  "btn.view": "Sseɣer",
  "btn.details": "Tazmert",
  "btn.publish": "Sseḍḍer",
  "btn.unpublish": "Sseḍḍer",
  "btn.duplicate": "Sseḍḍer",
  "btn.archive": "Sseḍḍer",
  "btn.restore": "Sseḥḥer",
  "btn.send": "Ssend",
  "btn.apply": "Sseḍḍer",
  "btn.reset": "Sseḥḥer",
  "btn.select_all": "Sseḍḍer yid",
  "btn.deselect_all": "Sseḍḍer yid",
  "btn.load_more": "Sseḍḍer ɣef",
  "btn.show_more": "Sseɣer ɣef",
  "btn.show_less": "Sseɣer ɣef",
  "btn.copy": "Sseḍḍer",
  "btn.share": "Sseḍḍer",
  "btn.preview": "Sseɣer",
  "btn.continue": "Sseḥḥer",
  "btn.skip": "Sseḥḥer",
  "form.email": "Aḍres n email",
  "form.password": "Aḍris n password",
  "form.password_confirm": "Sseḥḥer aḍris n password",
  "form.first_name": "Isem n wul",
  "form.last_name": "Isem n umar",
  "form.name": "Ism",
  "form.phone": "Aṭṭelefoun",
  "form.address": "Aḍḍar",
  "form.city": "Tizi",
  "form.zip": "Aḍḍar n umḍan",
  "form.country": "Tamurt",
  "form.title": "Tittre",
  "form.description": "Tazrigt",
  "form.category": "Tazrigt",
  "form.tags": "Tag",
  "form.status": "Tazmert",
  "form.role": "Rul",
  "form.language": "Tamaḍa",
  "form.date": "Asgwas",
  "form.start_date": "Asgwas n tazmert",
  "form.end_date": "Asgwas n tazmert",
  "form.duration": "Tazrigt",
  "form.price": "Aḍḍar",
  "form.avatar": "Tazmert n tazrigt",
  "form.required": "Aḍḍar",
  "form.optional": "Aḍḍar n tazmert",
  "form.select_placeholder": "Sselḍi...",
  "form.search_placeholder": "Sserḥi...",
  "form.no_results": "Ulac tazmert",
  "form.file_drop": "Sserḥi ɣef aḍḍar ɣer hna neɣ sselḍi ɣer aḍḍar",
  "form.max_size": "Aḍḍar n tazmert : {{size}}",
  "form.institution": "Tazmert",
  "form.department": "Taqmirt",
  "form.group": "Aḍḍar",
  "form.level": "Iḍrimen",
  "form.notes": "Aḍḍar",
  "form.url": "URL",
  "form.content": "Aḍḍar",
  "form.thumbnail": "Tazmert",
  "error.required": "Aḍḍar n tazmert",
  "error.email_invalid": "Aḍḍar n email ulac",
  "error.password_min": "Aḍḍar n umḍan i d-yetṭeḍ ɣef {{min}} iḍrimen",
  "error.password_match": "Aḍḍar n umḍan ur d-yetṭeḍ",
  "error.min_length": "Aḍḍar n {{min}} iḍrimen",
  "error.max_length": "Aḍḍar n {{max}} iḍrimen",
  "error.min_value": "Aḍḍar n umḍan ulac {{min}}",
  "error.max_value": "Aḍḍar n umḍan ulac {{max}}",
  "error.invalid_url": "URL urar",
  "error.file_too_large": "Tafayt i d-ttwafaq",
  "error.file_type": "Tayri n tafayt ur d-ttwafaq",
  "error.generic": "Akked n tazmert i d-ttwafaq",
  "error.network": "Akked n tazmert n uḍu",
  "error.unauthorized": "D-ttwafaq i d-ttwafaq",
  "error.forbidden": "Akked ur d-ttwafaq",
  "error.not_found": "Akked ur d-ttwafaq",
  "error.server": "Akked n uḍu n tazmert",
  "error.conflict": "Akked ur d-ttwafaq",
  "error.rate_limit": "Tazmert i d-ttwafaq, s-sbitar",
  "auth.login": "S-ttwafaq",
  "auth.logout": "S-ttwafaq ur",
  "auth.register": "S-senfay",
  "auth.forgot_password": "Tazmert ur d-ttwafaq ?",
  "auth.reset_password": "S-senfay n tazmert",
  "auth.otp_title": "S-ttwafaq s-cod",
  "auth.otp_sent": "Cod n tazmert i d-ttwafaq i {{email}}",
  "auth.otp_placeholder": "S-senfay cod i 6 yid",
  "auth.google_login": "S-ttwafaq s-Google",
  "auth.remember_me": "S-senfay i",
  "auth.no_account": "Ur d-ttwafaq ?",
  "auth.has_account": "D-ttwafaq ?",
  "auth.welcome_back": "Azul, {{name}} !",
  "auth.login_success": "S-ttwafaq i d-ttwafaq",
  "auth.register_success": "D-ttwafaq i d-ttwafaq",
  "auth.logout_success": "S-ttwafaq ur i d-ttwafaq",
  "role.teacher": "Amuddu",
  "role.institution": "Tazmert",
  "role.institution_admin": "Amuddu n tazmert",
  "role.admin": "Amuddu",
  "role.drh": "DRH",
  "role.rh": "RH",
  "role.resp_formation": "Amuddu n tazmert",
  "role.manager": "Amuddu",
  "role.collaborator": "Amuddu",
  "role.learner": "Aḍris",
  "dashboard.title": "Tazmert n tazmert",
  "dashboard.welcome": "Azul, {{name}}",
  "dashboard.recent_projects": "Projets n tazmert",
  "dashboard.recent_activity": "Tazmert n tazmert",
  "dashboard.quick_actions": "Akked n tazmert",
  "dashboard.stats": "Istatistiqen",
  "dashboard.total_projects": "Ihder n projets",
  "dashboard.total_learners": "Ihder n apprenants",
  "dashboard.total_eduflows": "Ihder n formations",
  "dashboard.completion_rate": "Taux n tazrigt",
  "dashboard.active_users": "Imaziɣen n usager",
  "dashboard.new_registrations": "Inskripsiyen nwen",
  "dashboard.revenue": "Tazrigt n afus",
  "dashboard.subtitle": "Tazrigt n tazrigt-ik",
  "dashboard.home.greeting": "Azul {{name}}",
  "dashboard.home.greetingSubtitle": "Sseɣr i formations, podcasts d i parcours yid n IA.",
  "dashboard.home.primaryCta": "Sseɣr formation",
  "dashboard.home.continueEditing": "Sseɣr d uḍu n tazrigt",
  "dashboard.home.publishRate": "Taux n tazrigt",
  "dashboard.home.totalFormations": "Formations sseɣr",
  "dashboard.home.uniqueLearners": "Apprenants yid n",
  "dashboard.home.calendarKicker": "Aḍris nniḍen",
  "dashboard.home.recentWork": "Tazrigt nniḍen",
  "dashboard.home.viewAll": "Sseɣr llan",
  "dashboard.home.quickAccess": "Aḍris n wussan",
  "dashboard.home.loading": "Sseɣr n tazrigt n dashboard…",
  "dashboard.home.defaultName": "formateur·rice",
  "dashboard.lo.heroTitle": "Azwaw i tazrigt-ik n tazrigt.",
  "dashboard.lo.heroSubtitle": "Sseɣr i formations, podcasts d i parcours yid n IA.",
  "dashboard.lo.newFormation": "Formation nwen",
  "dashboard.lo.generateAi": "Sseɣr i IA",
  "dashboard.lo.aiGenerations": "Générations n IA",
  "dashboard.lo.recentActivity": "Aḍris nniḍen",
  "dashboard.lo.activityFormationPublished": "Formation sseɣr",
  "dashboard.lo.activityFormationEdited": "Formation tazrigt",
  "dashboard.lo.activityPodcastPublished": "Podcast sseɣr",
  "dashboard.lo.activityPodcastEdited": "Podcast tazrigt",
  "dashboard.welcomeSub": "Ihi, ma yella i tazrigt-ik.",
  "dashboard.projects": "Projets",
  "dashboard.eduflows": "Formations",
  "dashboard.publishedFlows": "Parcours sseɣr",
  "dashboard.certificatesIssued": "Certificats sseɣr",
  "dashboard.activityEmpty": "Ala yella aḍris nniḍen i tazrigt-ik neɣ podcasts.",
  "dashboard.loadError": "Ur ttuɣal ad yessineḍ i tazrigt n dashboard.",
  "dashboard.learners": "Apprenants",
  "dashboard.newProject": "Proje nwen",
  "dashboard.newEduFlow": "Formation nwen",
  "dashboard.uploadMedia": "Sserḥa n media",
  "dashboard.viewDocs": "Tawtut",
  "dashboard.recentProjects": "Tajmilt n wawal",
  "dashboard.noRecentProjects": "Ur nniḍen tajmilt",
  "dashboard.activity": "Aḍris",
  "dashboard.searchProjects": "Sserḥa tajmilt...",
  "dashboard.noProjects": "Ur nniḍen tajmilt i wakken",
  "dashboard.createFirst": "Sserḥa tajmilt ikker i tḥeddar",
  "dashboard.createProject": "Sserḥa tajmilt",
  "dashboard.projectTitle": "Asem n tajmilt",
  "dashboard.recentActivity": "Aḍris nniḍen",
  "dashboard.roleSpecific": "Tawtut ikker d tazmert n umḍak.",
  "dashboard.calendar.mon": "Lun",
  "dashboard.calendar.wed": "Mer",
  "dashboard.calendar.fri": "Ven",
  "dashboard.calendar.less": "Azzay",
  "dashboard.calendar.more": "Azzay",
  "dashboard.calendar.tooltip": "{{count}} aḍris(s) ɣef {{date}}",
  "dashboard.mock.updated2h": "Ila 2 uḍris",
  "dashboard.mock.updated5h": "Ila 5 uḍris",
  "dashboard.mock.updatedYesterday": "Ayer",
  "dashboard.home": "Akkul",
  "dashboard.analytics": "Analytique",
  "dashboard.settings": "Tazmert",
  "dashboard.analyticsComingSoon": "Analytique ɣef tazmert",
  "dashboard.settingsComingSoon": "Tazmert ɣef tazmert",
  "pages.analytics.title": "Analytique",
  "pages.analytics.description": "Tawtut n tazmert akked tazmert",
  "pages.analytics.subtitle": "Sserḥa tazmert, sserḥa tazmert n tazmert ɣef tazmert akked tazmert.",
  "pages.analytics.filters.period": "Tazmert",
  "pages.analytics.filters.flow": "Tadrart",
  "pages.analytics.filters.allFlows": "Iḍen n tadrart",
  "pages.analytics.period.7d": "7 uḍris nniḍen",
  "pages.analytics.period.30d": "30 uḍris nniḍen",
  "pages.analytics.period.90d": "90 uḍris nniḍen",
  "pages.analytics.period.365d": "12 iḍen nniḍen",
  "pages.analytics.addChart": "Sserḥa tazmert",
  "pages.analytics.resetLayout": "Snerḥa tazmert",
  "pages.analytics.dragHint": "Sserḥa ɣef tazmert",
  "pages.analytics.size.sm": "S",
  "pages.analytics.size.md": "M",
  "pages.analytics.size.lg": "L",
  "pages.analytics.removeChart": "Ssaḥeḍ aḍḍiḍ",
  "pages.analytics.kind.completion_line": "Tamurt n tḥeḍḍi",
  "pages.analytics.kind.learners_bar": "Aḥlali n module",
  "pages.analytics.kind.status_pie": "Tazrawt n status",
  "pages.analytics.kind.engagement_area": "Tems n tḥeḍḍi",
  "pages.analytics.series.completion": "Taux n tḥeḍḍi (%)",
  "pages.analytics.series.learners": "Aḥlali",
  "pages.analytics.series.hours": "Ssaṭ",
  "pages.analytics.status.completed": "Ssaḥeḍ",
  "pages.analytics.status.in_progress": "D inna",
  "pages.analytics.status.dropped": "Ssaḥeḍ",
  "pages.analytics.status.not_started": "Ur ssaḥeḍ",
  "pages.analytics.loadError": "Ur nsaḥeḍ ara yid n data n analytics.",
  "pages.analytics.retry": "Ssaḥeḍ aḍḍiḍ",
  "pages.analytics.axis.bucket": "P. {{n}}",
  "pages.analytics.mock.wd0": "Ssen",
  "pages.analytics.mock.wd1": "Ssa",
  "pages.analytics.mock.wd2": "Ssa",
  "pages.analytics.mock.wd3": "Sseḍ",
  "pages.analytics.mock.wd4": "Sseḍ",
  "pages.analytics.mock.wd5": "Sseḍ",
  "pages.analytics.mock.wd6": "Sseḍ",
  "pages.analytics.emptyCharts": "Ssaḥeḍ aḍḍiḍ i tḥeḍḍiḍ i data.",
  "pages.analytics.comingSoonDesc": "Ssaḥeḍ i tazrawt n tḥeḍḍiḍ, taux n tḥeḍḍi, tḥeḍḍi n aḥlali akked tazrawt n performance.",
  "pages.help.title": "Aɣbalu n tḥeḍḍi",
  "pages.help.description": "Dokumentasiyon akked taɣbalt",
  "pages.help.hubIntro": "Temtawt i tḥeḍḍi n Lyrra: tḥeḍḍiḍ aḍḍiḍ i tḥeḍḍiḍ n documentation, tutorial akked tickets n taɣbalt.",
  "pages.help.searchPlaceholder": "Rechercher une thématique…",
  "pages.help.noResults": "Ur yella ara tazrawt i tḥeḍḍiḍ.",
  "pages.help.configHint": "Amazigh n tḥeḍḍi: tḥeḍḍiḍ i URLs, articles neɣ base n connaissances ma tḥeḍḍiḍ.",
  "pages.help.comingSoonDesc": "Ssaḥeḍ i documentation, tutorial akked taɣbalt n tḥeḍḍiḍ i tḥeḍḍiḍ.",
  "pages.help.modal.steps": "D tḥeḍḍiḍ",
  "pages.help.modal.tips": "Aɣbalu",
  "pages.help.modal.related": "Iḍeḍ",
  "pages.help.openArticle": "Uḍeḍ aḍḍiḍ",
  "pages.help.onboardingFlowMissing": "Tḥeḍḍi ur yella ara",
  "pages.help.onboardingFlowMissingDesc": "Ssaḥeḍ i seeds backend (db:seed:onboarding-eduflow, db:seed:onboarding-navigation-eduflow, db:seed:onboarding-profile-eduflow, db:seed:onboarding-roles-eduflow, db:seed:onboarding-block-types-eduflow, db:seed:onboarding-designer-overview-eduflow, db:seed:onboarding-branches-eduflow, db:seed:onboarding-validation-eduflow, db:seed:onboarding-objectives-eduflow, db:seed:onboarding-ai-designer-eduflow, db:seed:onboarding-publication-status-eduflow, db:seed:onboarding-publication-links-eduflow, db:seed:onboarding-catalog-visibility-eduflow, db:seed:onboarding-enrollments-eduflow, db:seed:onboarding-groups-cohorts-eduflow, db:seed:onboarding-progress-eduflow, db:seed:onboarding-certificates-eduflow akked db:seed:onboarding-media-library-eduflow) neɣ ssaḥeḍ VITE_ONBOARDING_DASHBOARD_FLOW_ID / VITE_ONBOARDING_NAVIGATION_FLOW_ID / VITE_ONBOARDING_PROFILE_FLOW_ID / VITE_ONBOARDING_ROLES_FLOW_ID / VITE_ONBOARDING_BLOCK_TYPES_FLOW_ID / VITE_ONBOARDING_DESIGNER_OVERVIEW_FLOW_ID / VITE_ONBOARDING_BRANCHES_FLOW_ID / VITE_ONBOARDING_VALIDATION_FLOW_ID / VITE_ONBOARDING_OBJECTIVES_FLOW_ID / VITE_ONBOARDING_AI_DESIGNER_FLOW_ID / VITE_ONBOARDING_PUBLICATION_STATUS_FLOW_ID / VITE_ONBOARDING_PUBLICATION_LINKS_FLOW_ID / VITE_ONBOARDING_CATALOG_VISIBILITY_FLOW_ID / VITE_ONBOARDING_ENROLLMENTS_FLOW_ID / VITE_ONBOARDING_GROUPS_COHORTS_FLOW_ID / VITE_ONBOARDING_PROGRESS_FLOW_ID / VITE_ONBOARDING_CERTIFICATES_FLOW_ID / VITE_ONBOARDING_MEDIA_LIBRARY_FLOW_ID.",
  "pages.help.onboardingDashboardPlayerTitle": "Tḥeḍḍi — Tableau de bord Lyrra (onboarding)",
  "pages.help.onboardingNavigationPlayerTitle": "Tḥeḍḍi — Navigation & menu latéral Lyrra (onboarding)",
  "pages.help.onboardingProfilePlayerTitle": "Tḥeḍḍi — Profil & préférences Lyrra (onboarding)",
  "pages.help.onboardingRolesPlayerTitle": "Tḥeḍḍi — Rôles akked droits d'accès Lyrra (onboarding)",
  "pages.help.onboardingBlockTypesPlayerTitle": "Tḥeḍḍi — Types n blocs EduFlow (onboarding)",
  "pages.help.onboardingDesignerOverviewPlayerTitle": "Tazrigt — Tazrigt n umddu EduFlow (onboarding)",
  "pages.help.onboardingBranchesPlayerTitle": "Tazrigt — Ibrayen & tazrigt EduFlow (onboarding)",
  "pages.help.onboardingValidationPlayerTitle": "Tazrigt — Tazrigt n umddu EduFlow (onboarding)",
  "pages.help.onboardingObjectivesPlayerTitle": "Tazrigt — Ijij n tazrigt EduFlow (onboarding)",
  "pages.help.onboardingAiDesignerPlayerTitle": "Tazrigt — Amsay n IA n umddu LyrraOne (onboarding)",
  "pages.help.onboardingPublicationStatusPlayerTitle": "Tazrigt — Tazrigt, tazrigt d iḍu LyrraOne (onboarding)",
  "pages.help.onboardingPublicationLinksPlayerTitle": "Tazrigt — Ilinks n tazrigt & tazrigt LyrraOne (onboarding)",
  "pages.help.onboardingCatalogVisibilityPlayerTitle": "Tazrigt — Tazrigt & tazrigt LyrraOne (onboarding)",
  "pages.help.onboardingEnrollmentsPlayerTitle": "Tazrigt — Iḍu & iḥedran LyrraOne (onboarding)",
  "pages.help.onboardingGroupsCohortsPlayerTitle": "Tazrigt — Igrup & ikohort LyrraOne (onboarding)",
  "pages.help.onboardingProgressPlayerTitle": "Tazrigt — Tazrigt & waḍi n tazrigt LyrraOne (onboarding)",
  "pages.help.onboardingCertificatesPlayerTitle": "Tazrigt — Ijij n tazrigt LyrraOne (onboarding)",
  "pages.help.onboardingMediaLibraryPlayerTitle": "Tazrigt — Tazrigt n umddu LyrraOne (onboarding)",
  "dashboard.period.week": "Asbu",
  "dashboard.period.month": "Aḍar",
  "dashboard.period.quarter": "Tazrigt",
  "dashboard.vsLastPeriod": "s tazrigt n tazrigt ({{period}})",
  "dashboard.completionPercent": "Tazrigt %",
  "dashboard.activeLearners": "Iḥedran n umddu",
  "dashboard.sessions": "Seshin",
  "dashboard.activityType.completion": "Tazrigt",
  "dashboard.activityType.enrollment": "Iḍu",
  "dashboard.activityType.milestone": "Tazrigt",
  "dashboard.activityType.feedback": "Tazrigt",
  "dashboard.activityType.start": "Iḍu",
  "dashboard.totalLearners": "Iḥedran n umddu",
  "dashboard.activeEduFlows": "Tazrigt n umddu",
  "dashboard.publishedTraining": "Tazrigt n umddu",
  "dashboard.activeUsersPeriod": "Iḍu n umddu (période)",
  "dashboard.completionRate": "Tazrigt n tazrigt",
  "dashboard.npsScore": "NPS n tazrigt",
  "dashboard.topEduFlows": "Tazrigt n umddu",
  "dashboard.topEduFlowsHint": "Tazrigt n tazrigt n umddu (tazrigt s umddu n iḍu).",
  "dashboard.engagement": "Tazrigt n umddu",
  "dashboard.xp_earned": "XP n tazrigt",
  "dashboard.streak": "Série n tazrigt",
  "dashboard.level": "Niv {{level}}",
  "dashboard.badges_earned": "Badges n tazrigt",
  "dashboard.next_level": "Niv n tazrigt",
  "dashboard.no_projects": "Ala tazrigt n umddu",
  "dashboard.create_first": "Snaḍ aḍu n umddu",
  "dashboard.pending_reviews": "Tazrigt n tazrigt",
  "dashboard.upcoming_deadlines": "Iḍeḍen i d-yennun",
  "podcast.episodes.pageTitle": "Iḍeḍen",
  "podcast.episodes.count": "{{count}} iḍeḍen(n)",
  "podcast.episodes.newEpisode": "Iḍeḍ nwen",
  "podcast.episodes.searchPlaceholder": "Sserḥeḍ s umḍak…",
  "podcast.episodes.filterAllStatuses": "Yiwel n yidles",
  "podcast.episodes.filterAllPodcasts": "Yiwel n iḍeḍen",
  "podcast.episodes.filterDraft": "Aḍuḍ",
  "podcast.episodes.filterPublished": "Iḥeḍ",
  "podcast.episodes.unassignedPodcast": "Ur nniḍen",
  "podcast.episodes.generateVoiceOff": "Sserḥeḍ tazmert n tmeddurt",
  "podcast.episodes.generateVoiceConfirmTitle": "Sserḥeḍ tazmert n tmeddurt?",
  "podcast.episodes.generateVoiceConfirmMessage": "Iḍeḍ « {{title}} » yebḍa yessentel ({{count}} tsegmert(n)). Yella ad yeggiḍ ar tazrigt n minit.",
  "podcast.episodes.generateVoiceConfirmButton": "Sserḥeḍ",
  "podcast.episodes.generateNoBlocks": "Ur yella tazmert walla tazmert n umḍak ʕla yid iḍeḍ — sserḥeḍ l-editeur ḍeɣ ad d-ssinḍeḍ.",
  "podcast.episodes.generateSuccess": "Tazmert n tmeddurt sserḥet ʕla « {{title}} » ({{count}} tsegmert(n)).",
  "podcast.episodes.generateError": "Tazmert n tmeddurt ur sserḥet.",
  "podcast.episodes.publish": "Iḥeḍ iḍeḍ",
  "podcast.episodes.publishConfirmTitle": "Iḥeḍ aḍuḍ nwen?",
  "podcast.episodes.publishConfirmMessage": "« {{title}} » yebḍa yessentel ʕla l-ibad i d-yennun ʕla yid iḍeḍ (statut iḥeḍ).",
  "podcast.episodes.publishConfirmButton": "Iḥeḍ",
  "podcast.episodes.publishSuccess": "« {{title}} » yebḍa iḥeḍ.",
  "podcast.episodes.publishError": "Ur sserḥet iḥeḍ.",
  "podcast.episodes.emptyTitle": "Ur yella iḍeḍ",
  "podcast.episodes.emptyHint": "Sserḥeḍ iḍeḍ nwen i d-ssinḍeḍ",
  "podcast.episodes.emptyCreateCta": "Sserḥeḍ iḍeḍ",
  "podcast.episodes.backPodcasts": "Iḍeḍen",
  "podcast.episodes.paginationTotal": "{{total}} iḍeḍ(n) ʕla l-ḥaṣr",
  "podcast.episodes.pageOf": "Page {{page}} / {{totalPages}}",
  "podcast.episodes.deleteTitle": "Ssil iḍeḍ?",
  "podcast.episodes.deleteHint": "« {{title}} » yebḍa yessentel ʕla l-ḥaṣr.",
  "podcast.episodes.deleteCancel": "Aneḍ",
  "podcast.episodes.deleteConfirm": "Ssil",
  "podcast.episodes.statusPublished": "Iḥeḍ",
  "podcast.episodes.statusDraft": "Aḍuḍ",
  "podcast.episodes.noDescription": "Ur yella tazmert",
  "podcast.episodes.noAudio": "Ur yella tazmert n audio",
  "podcast.episodes.audioReady": "Audio yebḍa iḥeḍ",
  "podcast.episodes.retry": "Sserḥeḍ ḍeɣ",
  "podcast.createEpisode.panelTitle": "Iḍeḍ nwen",
  "podcast.createEpisode.panelSubtitle": "Sserḥeḍ umḍak, ma yella, tazmert akked tasnawt. Aḥeḍ yebḍa yessentel, iḍeḍ yebḍa iḥeḍ akked l-editeur yebḍa yessentel ʕla l-muḍḍa.",
  "podcast.createEpisode.titleLabel": "Umḍak",
  "podcast.createEpisode.descriptionLabel": "Tazrigt",
  "podcast.createEpisode.coverLabel": "Taswir n tazrigt (aẓruy)",
  "podcast.createEpisode.coverHint": "JPEG, PNG, WebP neɣ GIF — max 5 Mo.",
  "podcast.createEpisode.coverChoose": "Ssar taswir",
  "podcast.createEpisode.coverRemove": "Sseɣ taswir",
  "podcast.createEpisode.titlePlaceholder": "Ex. : Tazrigt n module tazrigt",
  "podcast.createEpisode.descriptionPlaceholder": "Aɣbalu, imik… (aẓruy)",
  "podcast.createEpisode.validate": "Ssar u tḥeqqiḍ l’éditeur",
  "podcast.createEpisode.titleRequired": "Tazrigt d aẓruy.",
  "podcast.createEpisode.error": "Ur nḥeqqiḍ ara tazrigt.",
  "podcast.createEpisode.uploadCoverError": "Tazrigt i d-ḥeqqiḍ, ḍaɣ tḥeqqiḍ n taswir ur d-ḥeqqiḍ ara.",
  "podcast.createEpisode.coverTooLarge": "Taswir ur tḥeqqiḍ ara 5 Mo.",
  "podcast.editor.defaultNewTitle": "Tazrigt nniḍen",
  "eduflow.title": "Éditeur EduFlow",
  "eduflow.new_flow": "Tazrigt n uḍu",
  "eduflow.list.title": "Tazrigt",
  "eduflow.list.subtitle": "Ssar iḥedran n tazrigt n tazrigt",
  "eduflow.list.searchPlaceholder": "Ssar tazrigt…",
  "eduflow.list.import": "Ssar",
  "eduflow.list.importHint": "Fichier .lyrra (médias inclus) neɣ export JSON historique Lyrra V1.",
  "eduflow.list.importSuccess": "Tazrigt i d-ssar. L’éditeur i d-ḥeqqiḍ.",
  "eduflow.list.importError": "Ur nssar ara — tḥeqqiḍ l-fichier (.lyrra neɣ export JSON valid, aḍuḍ bloc).",
  "eduflow.list.filterAll": "Kull",
  "eduflow.list.filterDraft": "Brouillons",
  "eduflow.list.filterPublished": "Publiés",
  "eduflow.list.filterArchived": "Archivés",
  "eduflow.list.archiveFormation": "Arḍa tazrigt",
  "eduflow.list.restoreFromArchive": "Sseɣ seg l-archive (brouillon)",
  "eduflow.list.archiveSuccess": "Tazrigt i d-arḍa",
  "eduflow.list.archiveError": "Ur n-arḍa ara tazrigt.",
  "eduflow.list.restoreSuccess": "Tazrigt i d-sseɣ en brouillon",
  "eduflow.list.restoreError": "Ur n-sseɣ ara tazrigt.",
  "eduflow.list.viewModeGrid": "Tazrigt n mosaïque",
  "eduflow.list.viewModeList": "Tazrigt n liste",
  "eduflow.list.viewByCategory": "Tazrigt n catégories",
  "eduflow.list.categoryBack": "Kull les catégories",
  "eduflow.list.categoryBrowseHint": "Ssar une catégorie i d-ḥeqqiḍ i tazrigt n tazrigt.",
  "eduflow.list.categoryFormationCount": "{{count}} tazrigt(s)",
  "eduflow.list.categoryEmptyFiltered": "Ur d-ḥeqqiḍ ara tazrigt deg tazrigt (filtre neɣ recherche actifs).",
  "eduflow.list.uncategorizedCardHint": "Tazrigt n tazrigt ur d-ḥeqqiḍ ara l-étikette n catégorie.",
  "eduflow.list.uncategorized": "Ur d-catégorie",
  "eduflow.list.manageCategories": "Ssar les catégories",
  "eduflow.list.categoriesPanelTitle": "Iḍraren n tmeddurt",
  "eduflow.list.noCategoryAvailable": "Akked iḍraren ur ḥeḍran.",
  "eduflow.list.categoriesSaveError": "Ur ḍuḥen ara iḍraren.",
  "eduflow.list.emptyFilteredTitle": "Ur ḥeḍran ɣef tazwara",
  "eduflow.list.emptyFilteredHint": "Ssaḥeḍ ɣef tazwara nwen neɣ ɣef tazwara.",
  "eduflow.list.emptyFirstTitle": "Sseḥḥu tmeddurt nwen",
  "eduflow.list.emptyFirstHint": "Ssaḥeḍ ɣef tazwara n tmeddurt s wussan n tmeddurt.",
  "eduflow.list.emptyCreateCta": "Sseḥḥu tmeddurt nwen",
  "eduflow.list.deleteToTrashTitle": "Sseḥḥu tmeddurt ɣef tazwara?",
  "eduflow.list.deleteToTrashBody": "« {{title}} » yebḍa ɣef tazwara nwen (sseḥḥu n tmeddurt). Iḍraren nwen yebḍa ɣef tazwara.",
  "eduflow.list.deleteToTrashConfirm": "Sseḥḥu ɣef tazwara",
  "eduflow.createFormation.panelTitle": "Tmeddurt n uḍris",
  "eduflow.createFormation.panelSubtitle": "Ssaḥeḍ ɣef tazwara neɣ tazwara. S wussan, tmeddurt yebḍa, ɣef tmeddurt n wussan.",
  "eduflow.createFormation.titleLabel": "Tazwara",
  "eduflow.createFormation.descriptionLabel": "Tazwara n tmeddurt",
  "eduflow.createFormation.titlePlaceholder": "Ex. : Iḍraren ɣef tmeddurt n ḥeḍran",
  "eduflow.createFormation.descriptionPlaceholder": "Azzay, ɣef tmeddurt, etc. (ur ḥeḍran)",
  "eduflow.createFormation.validate": "Sseḥḥu neɣ ɣef tmeddurt",
  "eduflow.createFormation.titleRequired": "Tazwara d tazwara.",
  "eduflow.createFormation.error": "Ur ḍuḥen ara tmeddurt.",
  "eduflow.shareFormation.title": "Sseḥḥu tmeddurt",
  "eduflow.shareFormation.publicLinkTitle": "Tazwara n tmeddurt (ur ḥeḍran)",
  "eduflow.shareFormation.publicLinkCopy": "Ssaḥeḍ tazwara",
  "eduflow.shareFormation.publicLinkCopied": "Ssaḥeḍ",
  "eduflow.shareFormation.publishRequired": "Sseḥḥu tmeddurt ɣef tazwara n tmeddurt.",
  "eduflow.shareFormation.embedTitle": "Tazwara n tmeddurt neɣ tmeddurt n wussan",
  "eduflow.shareFormation.embedHint": "Ssaḥeḍ ɣef tazwara nwen. Tazwara ur ḥeḍran ɣef tmeddurt; ɣef tmeddurt n wussan, ssaḥeḍ ɣef tazwara n wussan.",
  "eduflow.shareFormation.embedCopy": "Ssaḥeḍ tazwara HTML",
  "eduflow.shareFormation.embedCopied": "Ssaḥeḍ",
  "eduflow.shareFormation.embedCloseAria": "Sseḥḥu",
  "eduflow.shareFormation.embedButtonLabel": "Sseḥḥu : {{title}}",
  "eduflow.shareFormation.embedToggle": "Tmeddurt n site web",
  "eduflow.shareFormation.removeAccessSuccess": "Accès yebḍa ɣef tmeddurt.",
  "eduflow.shareFormation.removeAccessError": "Ur ḍuḥen ara yebḍa tmeddurt.",
  "eduflow.shareFormation.assignSuccess": "Tmeddurt yebḍa neɣ email n tmeddurt yebḍa.",
  "eduflow.shareFormation.assignError": "Ur ḍuḥen ara yebḍa tmeddurt.",
  "eduflow.shareFormation.createAssignSuccess": "Akked yebḍa/ɣef, tmeddurt yebḍa neɣ email n tmeddurt yebḍa.",
  "eduflow.shareFormation.createLearnerError": "Ur ḍuḥen ara yebḍa tmeddurt.",
  "eduflow.shareFormation.selectExistingLearner": "Sseḥḥu tmeddurt n tmeddurt",
  "eduflow.shareFormation.searchLearnerPlaceholder": "Ssaḥeḍ tmeddurt (ism, ism n tmeddurt, email)",
  "eduflow.shareFormation.loadingLearners": "Ssaḥeḍ tmeddurt...",
  "eduflow.shareFormation.noLearnerAvailable": "Akked tmeddurt ur ḥeḍran.",
  "eduflow.shareFormation.hideQuickCreate": "Sserd n tcrea n tazrigt",
  "eduflow.shareFormation.createNewLearner": "Sserd tazrigt n tazrigt",
  "eduflow.shareFormation.firstNameRequired": "Ism n tazrigt *",
  "eduflow.shareFormation.lastNameRequired": "Ism *",
  "eduflow.shareFormation.emailRequired": "Email *",
  "eduflow.shareFormation.createShareInvite": "Sserd, sserd d iɣeḍ n tazrigt",
  "eduflow.shareFormation.assignedLearnersCount_one": "{{count}} tazrigt assignée",
  "eduflow.shareFormation.assignedLearnersCount_other": "{{count}} tazrigt assignées",
  "eduflow.shareFormation.noAssignedLearner": "Ur yella tazrigt assignée i wakka tazrigt.",
  "eduflow.shareFormation.removeAccessTitle": "Sserd l'accès",
  "eduflow.shareFormation.inviteEmailsTitle": "Sserd s email (akk n yid) ",
  "eduflow.shareFormation.inviteEmailsHint": "Yid n yid: akkan LyrraOne ɣef yid n tazrigt. Iɣeḍ ur yella ur nniḍen — sserd « Sserd tazrigt n tazrigt » i sserd.",
  "eduflow.shareFormation.inviteEmailsPlaceholder": "Yid n yid i tura neɣ s yid n yid\nexemple@lyrra.fr, autre@entreprise.com",
  "eduflow.shareFormation.inviteEmailsSubmit": "Sserd yid n yid i tazrigt",
  "eduflow.shareFormation.inviteEmailsInvalid": "Sserd yid n yid nniḍen.",
  "eduflow.shareFormation.inviteEmailsError": "Ur sserd yid n yid.",
  "eduflow.shareFormation.inviteEmailsSummaryOk": "{{count}} yid(s) sserd.",
  "eduflow.shareFormation.inviteEmailsSummaryNoAccount": "{{count}} ur yella yid LyrraOne.",
  "eduflow.shareFormation.inviteEmailsSummaryAlready": "{{count}} ur sserd.",
  "eduflow.participant.flowTitle": "Taqsi n tazrigt",
  "eduflow.participant.stepWelcome": "Ahlan",
  "eduflow.participant.stepModule1": "Module 1",
  "eduflow.participant.stepEvaluation": "Taqsi",
  "eduflow.participant.stepContentPlaceholder": "Amazigh n tazrigt i tazrigt.",
  "eduflow.edit_flow": "Sserd taqsi",
  "eduflow.flow_name": "Ism n taqsi",
  "eduflow.block_palette": "Palette n tazrigt",
  "eduflow.canvas": "Canvas",
  "eduflow.properties": "Tazrigt",
  "eduflow.publish": "Sserd",
  "eduflow.publish_confirm": "Ttawt i tserd i wakka taqsi?",
  "eduflow.save_draft": "Sserd l'brouillon",
  "eduflow.preview": "Aperçu",
  "eduflow.versions": "Versions",
  "eduflow.versionHistory": "Tazrigt n versions",
  "eduflow.versionHistory.count": "{{count}} version(s)",
  "eduflow.versionHistory.create": "Sserd version",
  "eduflow.versionHistory.createVersion": "Sserd v{{version}}",
  "eduflow.versionHistory.minor": "Aḍu",
  "eduflow.versionHistory.major": "Aḍu n tazrigt",
  "eduflow.versionHistory.minorBadge": "Version aḍu",
  "eduflow.versionHistory.majorBadge": "Version aḍu n tazrigt",
  "eduflow.versionHistory.latest": "Akhir",
  "eduflow.versionHistory.public": "Version n wass",
  "eduflow.versionHistory.publicActive": "Di tprodukti",
  "eduflow.versionHistory.publish": "Seddq a version",
  "eduflow.versionHistory.publishCta": "Seddq",
  "eduflow.versionHistory.openPublicPlayer": "Ftaḥ player n wass",
  "eduflow.versionHistory.copyPublicPlayer": "Nqed l-link n wass",
  "eduflow.versionHistory.copyPublicPlayerError": "Ur nqeḍ ara l-link n wass",
  "eduflow.versionHistory.systemPublished": "Seddq n {{version}}",
  "eduflow.versionHistory.systemSaved": "Tseggwa n {{version}}",
  "eduflow.versionHistory.systemAutosaveRestore": "Tseggwa tamurt ssaḥa ḍaḥa n {{version}}",
  "eduflow.versionHistory.descriptionPlaceholder": "Tazmert n tchanjment…",
  "eduflow.versionHistory.empty": "Ur nḥeḍ ara version.",
  "eduflow.versionHistory.emptyHint": "Tseggwa version s tḥeḍ ḥna.",
  "eduflow.versionHistory.blocks": "{{count}} bloc",
  "eduflow.versionHistory.restoreTitle": "Tzriḍ version v{{version}}?",
  "eduflow.versionHistory.restoreWarning": "Ameḍḍan nniḍen yella yeddu. Taseggwa tamurt ssaḥa yella qbel tziḍ.",
  "eduflow.versionHistory.createSuccess": "Version {{version}} tḥeḍ",
  "eduflow.versionHistory.createError": "Aḍris di tḥeḍ n version",
  "eduflow.versionHistory.restoreSuccess": "Version {{version}} tziḍ",
  "eduflow.versionHistory.restoreError": "Aḍris di tziḍ",
  "eduflow.versionHistory.publishSuccess": "Version {{version}} teddq",
  "eduflow.versionHistory.publishError": "Aḍris di teddq",
  "eduflow.versionHistory.now": "d lḥeqq",
  "eduflow.versionHistory.minutesAgo": "yella {{count}} min",
  "eduflow.versionHistory.hoursAgo": "yella {{count}} h",
  "eduflow.versionHistory.yesterday": "ayen",
  "eduflow.versionHistory.daysAgo": "yella {{count}} j",
  "eduflow.add_block": "Seddq bloc",
  "eduflow.remove_block": "Suffre bloc",
  "eduflow.connect_blocks": "Sewweq les blocs",
  "eduflow.undo": "Aḍris",
  "eduflow.redo": "Rettab",
  "eduflow.zoom_in": "Zom",
  "eduflow.zoom_out": "Dzoom",
  "eduflow.fit_view": "Ajuster la vue",
  "eduflow.auto_layout": "Disposition tamurt",
  "eduflow.unsaved_changes": "Tchanjment ur nḥeḍ ara",
  "eduflow.blocks.quiz_mcq": "QCM",
  "eduflow.blocks.quiz_open": "Suʔal ftaḥ",
  "eduflow.blocks.video": "Vidéo",
  "eduflow.blocks.audio": "Audio",
  "eduflow.blocks.text": "Tazrigt",
  "eduflow.blocks.evaluation": "Tazrigt",
  "eduflow.blocks.form": "Tafukt",
  "eduflow.blocks.mindmap": "Tafukt n tazrigt",
  "eduflow.blocks.poll": "Tazrigt",
  "eduflow.blocks.flashcard": "Flashcard",
  "eduflow.blocks.timeline": "Tazrigt n tazrigt",
  "eduflow.blocks.pdf": "Document PDF",
  "eduflow.blocks.image": "Taswira",
  "eduflow.blocks.code": "Code",
  "eduflow.blocks.whiteboard": "Tafukt l'ahmar",
  "eduflow.blocks.ai_chat": "Chat IA",
  "eduflow.blocks.certificate": "Ighram",
  "eduflow.blocks.attendance": "Tazrigt",
  "eduflow.blocks.sortable": "Tazrigt",
  "eduflow.blocks.pair_matching": "Tazrigt n tazrigt",
  "eduflow.blocks.drawing": "Tazrigt",
  "eduflow.blocks.embed": "Tazrigt n tazrigt",
  "eduflow.blocks.h5p": "H5P",
  "eduflow.blocks.scorm": "SCORM",
  "eduflow.blocks.conditional": "Tazrigt",
  "eduflow.blocks.timer": "Minuteur",
  "eduflow.blocks.randomizer": "Aléatoire",
  "eduflow.blocks.grouping": "Regroupement",
  "eduflow.blocks.debate": "Tazrigt",
  "eduflow.blocks.roleplay": "Jeu de rôle",
  "eduflow.blocks.simulation": "Simulation",
  "eduflow.blocks.scenario": "Scénario",
  "eduflow.blocks.checklist": "Checklist",
  "eduflow.blocks.kanban": "Kanban",
  "eduflow.blocks.peer_review": "Tazrigt n tazrigt",
  "eduflow.designer.paletteCategory.structure": "Tazrigt & tazrigt",
  "eduflow.designer.paletteCategory.content": "Tazrigt & médias",
  "eduflow.designer.paletteCategory.interactive": "Amanar & tazrigt",
  "eduflow.designer.paletteCategory.accessibility": "Amanar (DYS)",
  "eduflow.designer.paletteCategory.enterprise": "Tazrigt & avancé",
  "eduflow.designer.flowSettings.toolbarTitle": "Paramètres tazrigt & l'ahmar",
  "eduflow.designer.flowSettings.panelTitle": "Paramètres n tazrigt",
  "eduflow.designer.flowSettings.intro": "Amanar yella d tazrigt n l'ahmar (tazrigt, tazrigt, taswira). Ighram « Précédent » yella d tazrigt i tazrigt n tazrigt.",
  "eduflow.designer.flowSettings.titleLabel": "Tazrigt n tazrigt",
  "eduflow.designer.flowSettings.descriptionLabel": "Tazrigt n tazrigt",
  "eduflow.designer.flowSettings.coverLabel": "Taswira n tazrigt",
  "eduflow.designer.flowSettings.coverUpload": "Ssar asnaw",
  "eduflow.designer.flowSettings.coverUrlPlaceholder": "Nekka d URL n asnaw (https://…)",
  "eduflow.designer.flowSettings.coverRemove": "Ssar asnaw",
  "eduflow.designer.flowSettings.allowPreviousLabel": "Buttun « Iḍeb » deg lmedder",
  "eduflow.designer.flowSettings.allowPreviousHint": "Aḍu: l'apprenant ur yessineḍ ara deg ulac n lblock (ur d-ttwelf ara s yid).",
  "eduflow.designer.flowSettings.focusGuard.title": "Tazmert n tazmert n focus",
  "eduflow.designer.flowSettings.focusGuard.hint": "Ma yessineḍ l'apprenant seg ltab ulac n lpage, tazmert tḥeqqed (tazmert tgriz, tḥeqqed deg lclick).",
  "eduflow.designer.flowSettings.focusGuard.limitLabel": "Iḍeḍen yessineḍ",
  "eduflow.designer.flowSettings.focusGuard.unlimited": "Ur yebḍu",
  "eduflow.designer.flowSettings.focusGuard.limited": "Yebḍu",
  "eduflow.designer.flowSettings.focusGuard.lossesUnit": "tazmert(s) n focus yessineḍ",
  "eduflow.designer.flowSettings.focusGuard.blockWarning": "Sg lḥed, l'apprenant ur yessineḍ ara yebḍu tazmert.",
  "eduflow.designer.flowSettings.coverUploadError": "Ur nsaḍ ara asnaw.",
  "eduflow.designer.flowSettings.certificate.uploadError": "Aḍu n lserver ur yebḍu.",
  "eduflow.designer.flowSettings.certificate.uploadFailed": "Ur nsaḍ ara lmodel Word.",
  "eduflow.designer.blockLabel.start": "Ssar",
  "eduflow.designer.blockLabel.end": "Ttaw",
  "eduflow.designer.blockLabel.summary": "Tazmert",
  "eduflow.summary.editorHint": "Tazmert n tazmert wala tazmert n lformation. Kull tazmert tḥeqqed s asnaw n umḍan deg lmedder.",
  "eduflow.summary.addItem": "Ssar iḍeḍ",
  "eduflow.summary.emptyList": "Ur yella iḍeḍ s lḥed. Ssar iḍeḍ.",
  "eduflow.summary.itemPlaceholder": "Ex. : Iḍeḍ n tazmert n tazmert n tazmert",
  "eduflow.designer.blockLabel.form": "Tazmert",
  "eduflow.designer.blockLabel.loop": "Tazmert n tazmert",
  "eduflow.designer.blockLabel.merge": "Tazmert",
  "eduflow.designer.blockLabel.split": "Tazmert n tazmert",
  "eduflow.designer.blockLabel.subflow": "Tazmert n tazmert",
  "eduflow.designer.blockLabel.timer": "Tazmert",
  "eduflow.designer.blockLabel.email": "Email n tazmert",
  "eduflow.designer.blockLabel.text": "Tazmert",
  "eduflow.designer.blockLabel.podcast": "PodCast",
  "eduflow.designer.blockLabel.video": "Vidéo",
  "eduflow.designer.blockLabel.audio": "Audio",
  "eduflow.designer.blockLabel.image": "Asnaw n tazmert",
  "eduflow.designer.blockLabel.pdf": "Document PDF",
  "eduflow.designer.blockLabel.browser": "Page web n tazmert",
  "eduflow.designer.blockLabel.presentation": "Diaporama",
  "eduflow.designer.blockLabel.timeline": "Tazmert n tazmert",
  "eduflow.designer.blockLabel.chart": "Graphique n tazmert",
  "eduflow.designer.blockLabel.mindmap": "Carte mentale",
  "eduflow.designer.blockLabel.visual_ai": "Visuel IA",
  "eduflow.designer.blockLabel.quiz_mcq": "Quiz (QCM / V-F / Ordre)",
  "eduflow.designer.blockLabel.poll": "Sondage n tazrigt",
  "eduflow.designer.blockLabel.self_assessment": "Tazrigt n tazrigt",
  "eduflow.selfAssessment.panelTitle": "Tazrigt n tazrigt",
  "eduflow.selfAssessment.panelHint": "Ssetti d imazighen yellan ad tazrigt: tazrigt gher tazrigt, akked, ma yella, tasnawt n tazrigt i tazrigt.",
  "eduflow.selfAssessment.scaleLabel": "Tazrigt n tazrigt",
  "eduflow.selfAssessment.scaleHint": "S 1 i N (ex. 5 = Likert)",
  "eduflow.selfAssessment.criteriaSection": "Imazighen",
  "eduflow.selfAssessment.addCriterion": "Seddel",
  "eduflow.selfAssessment.emptyCriteria": "Ur yella imazighen. Seddel aql i tazrigt ad tazrigt.",
  "eduflow.selfAssessment.criterionTitle": "Tazrigt",
  "eduflow.selfAssessment.criterionTitlePh": "Ex. Tazrigt, Tazrigt…",
  "eduflow.selfAssessment.criterionDescription": "Tasnawt (akud n tazrigt)",
  "eduflow.selfAssessment.criterionDescriptionPh": "Ssetti ma yella tazrigt ad tazrigt walla amek yella ad tazrigt…",
  "eduflow.selfAssessment.moveUp": "Ssefru",
  "eduflow.selfAssessment.moveDown": "Ssefru",
  "eduflow.selfAssessment.removeCriterion": "Ssefru aql n tazrigt",
  "eduflow.selfAssessment.responseTypeLabel": "Tazrigt n tazrigt",
  "eduflow.selfAssessment.typeNumeric": "Izzif",
  "eduflow.selfAssessment.typeNumericHint": "Boutons 1 i N",
  "eduflow.selfAssessment.typeStars": "Izzif",
  "eduflow.selfAssessment.typeStarsHint": "Tazrigt n tazrigt",
  "eduflow.selfAssessment.typeText": "Tazrigt n tazrigt",
  "eduflow.selfAssessment.typeTextHint": "Badges (imazighen) walla tazrigt n tazrigt gher tazrigt",
  "eduflow.selfAssessment.badgeOptionsLabel": "Tazrigt (badges)",
  "eduflow.selfAssessment.badgeOptionsHint": "Imazighen walla tasnawt gher tazrigt: tazrigt ad tazrigt gher tazrigt. Ur yella tazrigt → tazrigt n tazrigt.",
  "eduflow.selfAssessment.removeBadge": "Ssefru",
  "eduflow.selfAssessment.badgeInputPlaceholder": "Ex. Tazrigt, Ur yella, Tazrigt…",
  "eduflow.selfAssessment.addBadge": "Seddel",
  "eduflow.selfAssessment.starCountLabel": "Nni n izzif",
  "eduflow.selfAssessment.starCountHint": "Tazrigt 5",
  "eduflow.selfAssessment.textModeHint": "Tazrigt ad tazrigt tazrigt gher kull tazrigt. Tazrigt n tazrigt yella d tazrigt gher imazighen.",
  "eduflow.designer.blockLabel.evaluation": "Tazrigt n tazrigt",
  "eduflow.designer.blockLabel.phrase_reveal": "Tazrigt n tazrigt",
  "eduflow.designer.blockLabel.voice_assessment": "Tazrigt n tazrigt",
  "eduflow.designer.blockLabel.dys_reader": "Lecteur DYS (syllabes + TTS)",
  "eduflow.designer.blockLabel.dys_image_zones": "Tasnawt n tazrigt",
  "eduflow.designer.blockLabel.dys_clock": "Saâ n tazrigt DYS",
  "eduflow.designer.blockLabel.dys_reading_practice": "Tazrigt n tazrigt",
  "eduflow.designer.blockLabel.glossary": "Tazrigt + Quiz n tazrigt",
  "eduflow.designer.blockLabel.html": "HTML / JavaScript n tazrigt",
  "eduflow.designer.blockLabel.certification": "Tazrigt (template Word)",
  "eduflow.designer.blockLabel.signature": "Tazrigt n tazrigt",
  "eduflow.designer.blockLabel.facial_recognition": "Tazwit n tazwit",
  "eduflow.designer.blockLabel.attendance": "Tazmert n umalu",
  "eduflow.designer.startBlockTitle": "Tazrigt",
  "eduflow.designer.placeholderUntitled": "Ala tazwit",
  "eduflow.designer.placeholderFlowDescription": "Tazwit n tazrigt (255 yid n tazwit)",
  "eduflow.designer.saving": "Tazrigt…",
  "eduflow.designer.unsaved": "Ur tazrigt ara",
  "eduflow.designer.saved": "Tazrigt",
  "eduflow.designer.blocksPanelTitle": "Iblan",
  "eduflow.designer.paletteSearchLabel": "Sserḥeḍ iblan",
  "eduflow.designer.paletteSearchPlaceholder": "Sserḥeḍ iblan…",
  "eduflow.designer.paletteSearchEmpty": "Ur illi iblan yefkaḍ i tserḥit.",
  "eduflow.designer.autoLayoutShort": "Tazwit n tazrigt",
  "eduflow.designer.validate": "Ssaḥḥeḍ",
  "eduflow.designer.validateTitle": "Ssaḥḥeḍ tazrigt",
  "eduflow.designer.validationBeforePreview": "Ssaḥḥeḍ iḍelli n tazrigt iḍelli n tazrigt.",
  "eduflow.designer.validationBeforePublish": "Ssaḥḥeḍ iḍelli n tazrigt iḍelli n tazrigt.",
  "eduflow.designer.aiShort": "IA",
  "eduflow.designer.aiTitle": "Aseggas IA",
  "eduflow.designer.ragChatbotTitle": "Chatbot n tazrigt",
  "eduflow.ragChatbot.panelTitle": "Chatbot n tazrigt (RAG)",
  "eduflow.ragChatbot.loadError": "Ur nsaḥḥu tazwit n chatbot.",
  "eduflow.ragChatbot.needDoc": "Sserḥeḍ aḍuḍ iḍelli n tazwit iḍelli n tazrigt.",
  "eduflow.ragChatbot.enabledOk": "Chatbot yefkaḍ i tazrigt.",
  "eduflow.ragChatbot.disabledOk": "Chatbot ur yefkaḍ ara.",
  "eduflow.ragChatbot.toggleError": "Ur nsaḥḥu tazwit.",
  "eduflow.ragChatbot.uploadOk": "Tazwit yefkaḍ.",
  "eduflow.ragChatbot.uploadSavedNotIndexed": "Tazwit yefkaḍ. Ur yefkaḍ ara i RAG ma yella ur nḥeḍ ara tazwit n tazwit.",
  "eduflow.ragChatbot.ragIndexFailed": "Tazwit yefkaḍ, macci ur nḥeḍ ara. Ssaḥḥeḍ pgvector (DATABASE_VECTOR_URL) akked Mistral, ssaḥḥeḍ ma yella.",
  "eduflow.ragChatbot.uploadError": "Tazwit ur nsaḥḥu ara.",
  "eduflow.ragChatbot.confirmDelete": "Sseḥḥeḍ aḍuḍ akked tazwit?",
  "eduflow.ragChatbot.deleted": "Tazwit yesseḥḥed.",
  "eduflow.ragChatbot.deleteError": "Ur nsaḥḥu ara.",
  "eduflow.ragChatbot.vectorHint": "Iḍelli n tazwit n PDF / TXT / MD : ssaḥḥeḍ DATABASE_VECTOR_URL neɣ PGVECTOR_HOST (PostgreSQL + extension pgvector) akked Mistral di Administration → Intégrations plateforme (clé + modèle d’embeddings). Macci, tazwit akked nḥeḍ ur nsaḥḥu ara.",
  "eduflow.ragChatbot.chatHint": "Iḍelli n tazwit akked embeddings RAG yefkaḍ Mistral. Tazwit yefkaḍ iḍelli n tazwit n tazrigt yefkaḍ iḍelli n tazwit yefkaḍ iḍelli n tazwit.",
  "eduflow.ragChatbot.playerToggle": "Sserḥeḍ di tazrigt",
  "eduflow.ragChatbot.playerToggleHint": "Iḍelli n tazwit yefkaḍ iḍelli n tazwit n tazrigt : iḍelli n tazwit n tazrigt, akked iḍelli n tazwit yefkaḍ ma yella.",
  "eduflow.ragChatbot.addDocument": "Sserḥeḍ aḍuḍ (PDF, TXT, MD)",
  "eduflow.ragChatbot.docCount": "Iḍelli n tazwit yefkaḍ : {{count}}",
  "eduflow.ragChatbot.emptyDocs": "Ur illi aḍuḍ. Chatbot ur yefkaḍ ara iḍelli n tazwit n tazrigt.",
  "eduflow.ragChatbot.open": "Sserḥeḍ aseggas",
  "eduflow.ragChatbot.dialogTitle": "Aseggas n tazrigt",
  "eduflow.ragChatbot.playerDisclaimer": "Iḍeṛ n yidles n ddunit akked lqim n tazrigt aṭas.",
  "eduflow.ragChatbot.playerWelcome": "Sseḍḍiḍ ɣef lqim neɣ lqim n ddunit.",
  "eduflow.ragChatbot.playerError": "Ur nɣiḍ ara ɣef lqim. Sseḍḍiḍ ɣef tazrigt.",
  "eduflow.ragChatbot.placeholder": "Ssuḍiḍ n lqim...",
  "eduflow.ragChatbot.send": "Ssend",
  "eduflow.designer.aiPanel.welcome": "Sseḍḍiḍ ɣef ma ttwaliḍ. Lblak ifka d **Propriétés** d lqim n tazrigt. Ussin d **viseur** ɣef tazrigt (canevas + formulaire) : l'IA tazmert akked tazmert n lqim.",
  "eduflow.designer.aiPanel.askBeforeAct": "Ssuḍiḍ ɣef lqim n tazrigt",
  "eduflow.designer.aiPanel.askBeforeActHint": "Ma ttwaliḍ, yella lqim n tazrigt ɣef lqim n ddunit ɣef lqim n lqim.",
  "eduflow.designer.aiPanel.captureScreenHint": "Ssuḍiḍ ɣef lqim akked lpanal n Propriétés (tazmert n lqim)",
  "eduflow.designer.aiPanel.captureReady": "Tazmert ɣef lqim — ssin lqim n tazrigt.",
  "eduflow.designer.aiPanel.captureFailed": "Ur nɣiḍ ara ɣef lqim.",
  "eduflow.designer.aiPanel.captureAttached": "Tazmert n lqim ɣef lqim n tazrigt n lqim",
  "eduflow.designer.aiPanel.removeCapture": "Ssuḍiḍ",
  "eduflow.designer.aiPanel.captureInMessage": "Tazmert n lqim",
  "eduflow.designer.aiPanel.statusCapturing": "Tazmert n lqim...",
  "eduflow.designer.aiPanel.statusAnalyzing": "Tazmert n lqim akked lblak ifka...",
  "eduflow.designer.aiPanel.statusWorking": "Tazmert ɣef lqim n tazrigt...",
  "eduflow.designer.aiPanel.statusApplying": "Tazmert ɣef lqim n tazrigt...",
  "eduflow.designer.aiPanel.captureDisclaimer": "L'IA yella d ɣef lqim : ssuḍiḍ ɣef lqim n tazrigt. Ssuḍiḍ ɣef lqim (Ctrl+V) neɣ ussin lqim.",
  "eduflow.designer.resizeAiPanel": "Ssuḍiḍ ɣef lpanal n l'IA",
  "eduflow.designer.aiPanel.subtitle": "Co-pilote : lqim, lqim akked lqim.",
  "eduflow.designer.aiPanel.focusContextLabel": "Cible :",
  "eduflow.designer.aiPanel.focusPrimary": "« {{label}} » ({{type}}) — Propriétés",
  "eduflow.designer.aiPanel.focusMulti": "{{count}} lblak ɣef lqim — ssuḍiḍ ɣef ma ttwaliḍ neɣ lblak ɣef lqim.",
  "eduflow.designer.aiPanel.focusNone": "Ur yella lblak ɣef lqim — ssuḍiḍ ɣef Propriétés ɣef un nœud neɣ ssuḍiḍ ɣef lqim n lqim.",
  "eduflow.designer.aiPanel.followUpsLabel": "Ssuḍiḍ n lqim",
  "eduflow.designer.aiPanel.ideasToggle": "Idées ɣef lqim",
  "eduflow.designer.aiPanel.advancedToggle": "Options (streaming, sources, raccourcis...)",
  "eduflow.designer.aiPanel.removeDocument": "Ssuḍiḍ",
  "eduflow.designer.aiPanel.importDocumentTitle": "Ssuḍiḍ PDF, Word neɣ PowerPoint",
  "eduflow.designer.aiPanel.webSourcesLabel": "Lqim n lqim (max 3, optionnel)",
  "eduflow.designer.aiPanel.webSourcesPlaceholder": "https://exemple.fr/doc\nhttps://...",
  "eduflow.designer.aiPanel.idea.auditPath": "Audite lqim n lqim : impasses, nœuds isolés akked lqim n lqim — ssuḍiḍ ɣef lqim n tazrigt.",
  "eduflow.designer.aiPanel.idea.microLearning": "Ssuḍiḍ ɣef lqim n tazrigt, ssuḍiḍ ɣef lqim n tazrigt n lqim n micro-learning ɣef lqim n tazrigt.",
  "eduflow.designer.aiPanel.idea.formativeGap": "Ssuḍiḍ ɣef lqim n tazrigt (activité courte) ɣef lqim n tazrigt.",
  "eduflow.designer.aiPanel.idea.titleCoherence": "Aline les titres n lblak ɣef lqim n tazrigt akked lqim n lqim n tazrigt.",
  "eduflow.designer.aiPanel.idea.remediation": "Ssuḍiḍ ɣef lqim n remédiation ɣef lqim n tazrigt (branche échec / score bas)",
  "eduflow.designer.aiPanel.idea.mobileWording": "Raccourcis akked clarifie les textes HTML n lblak ɣef lqim n tazrigt.",
  "eduflow.designer.aiPanel.idea.quizWording": "Unifie le style n lqim n tazrigt (« Choisis », « Sélectionnez », niveau formel...) ɣef lqim n tazrigt.",
  "eduflow.designer.aiPanel.idea.summaryBeforeEnd": "Ssuḍiḍ neɣ ssuḍiḍ ɣef lqim n tazrigt ɣef lqim n tazrigt.",
  "eduflow.designer.aiPanel.streamMode": "Streaming",
  "eduflow.designer.aiPanel.streamModeHint": "Lqim n tazrigt yella d ɣef lqim n lqim ; lqim n tazrigt n lqim yella d ɣef lqim n streaming.",
  "eduflow.designer.aiPanel.streamError": "Flux IA iḍeḥṛu neɣ yefka.",
  "eduflow.designer.aiPanel.streamIncomplete": "Tazmert inḍiḍen s uḍuṛ. Rreḥiḍ neɣ dduz le streaming.",
  "eduflow.designer.aiPanel.skillPath": "Audit n uḍuṛ (uḍuṛ)",
  "eduflow.designer.aiPanel.skillPathHint": "Analis n tazmert n uḍuṛ iḍeḥṛu s uḍuṛ.",
  "eduflow.designer.aiPanel.skillQuiz": "Tazmert QCM iḍeḥṛu (uḍuṛ)",
  "eduflow.designer.aiPanel.skillQuizHint": "Gabarit officiel quiz_mcq s uḍuṛ.",
  "eduflow.designer.aiPanel.thinking": "L'assistant iḍeḥṛu…",
  "eduflow.designer.aiPanel.serverSkills": "Renforts s uḍuṛ",
  "eduflow.designer.aiPanel.quickActions": "Aksiyun n tazmert",
  "eduflow.designer.aiPanel.placeholder": "Suʕal, idea, relecture, structure n uḍuṛ, tazmert n bloc…",
  "eduflow.designer.aiPanel.apply": "Aẓuḍ s uḍuṛ",
  "eduflow.designer.aiPanel.autoApply": "Aẓuḍ aḍuḍ s uḍuṛ",
  "eduflow.designer.aiPanel.autoApplyHint": "Tazmert n l'assistant iḍeḥṛu yeggi uḍuṛ ur yella ɣef « Aẓuḍ ».",
  "eduflow.designer.aiPanel.dismissOps": "Igner",
  "eduflow.designer.aiPanel.applied": "Tazmert iḍeḥṛu s uḍuṛ.",
  "eduflow.designer.aiPanel.applyPartial": "Aẓuḍ s tazmert: {{details}}",
  "eduflow.designer.aiPanel.applyFailed": "Ur yella tazmert iḍeḥṛu s uḍuṛ (format n tazmert neɣ tipes n blocs ur iḍeḥṛu).",
  "eduflow.designer.aiPanel.objectivesSaved": "Iḍeḥṛu n tazmert iḍeḥṛu (panneau Iḍeḥṛu).",
  "eduflow.designer.aiPanel.objectivesSaveError": "Ur yella aḍuḍ n iḍeḥṛu. Rreḥiḍ.",
  "eduflow.designer.aiPanel.error": "Ur yella aḍuḍ ɣef l'assistant. Ccḥiḍ iḍeḥṛu IA (clé API) neɣ le réseau.",
  "eduflow.designer.aiPanel.newConversation": "Tazmert n uḍuṛ",
  "eduflow.designer.aiPanel.clearConversation": "Sḥuḍ tazmert",
  "eduflow.designer.aiPanel.conversationHistory": "Tazmert n uḍuṛ",
  "eduflow.designer.aiPanel.deleteConversation": "Snaḍ",
  "eduflow.designer.aiPanel.maxConversations": "Ttḥuḍt iḍeḥṛu n {{max}} tazmert iḍeḥṛu. Snaḍ ḥed tazmert ɣef aḍuḍ n uḍuṛ.",
  "eduflow.designer.aiPanel.unnamedConversation": "Tazmert",
  "eduflow.designer.aiQuick.plan": "Plani n uḍuṛ",
  "eduflow.designer.aiQuick.expand": "Blocs interactifs",
  "eduflow.designer.aiQuick.quiz": "Module QCM",
  "eduflow.designer.aiQuick.objectives": "Iḍeḥṛu (panneau)",
  "eduflow.designer.aiQuick.rewriteFocus": "Rekṛi tazmert n Propriétés",
  "eduflow.designer.aiQuick.translateFocus": "Traduire tazmert n Propriétés (EN)",
  "eduflow.designer.voiceShort": "Tazmert",
  "eduflow.designer.voiceTitle": "Configuration n tazmert",
  "eduflow.designer.objectivesShort": "Iḍeḥṛu",
  "eduflow.designer.objectivesTitle": "Iḍeḥṛu n tazmert",
  "eduflow.designer.flowVariablesTitle": "Variables globales",
  "eduflow.designer.flowVariables.subtitle": "Definissez des paires clé / valeur. Utilisez @suivi du nom de la clé dans les titres et descriptions des blocs (ex. @nom_formation). Les valeurs sont substituées pour les apprenants.",
  "eduflow.designer.flowVariables.empty": "Ur yella variable. Aẓuḍ ḥed ɣef aḍuḍ n tazmert.",
  "eduflow.designer.flowVariables.keyLabel": "Clé",
  "eduflow.designer.flowVariables.keyPlaceholder": "ex. nom_formation",
  "eduflow.designer.flowVariables.keyHelp": "Lettres, chiffres, tiret et underscore ur iḍeḥṛu. Sensible ɣef l'case ɣef @cle.",
  "eduflow.designer.flowVariables.valueLabel": "Aghbalu n tmeddurt",
  "eduflow.designer.flowVariables.valuePlaceholder": "Teggi n tmeddurt i @cle",
  "eduflow.designer.flowVariables.add": "Seddel tmeddurt",
  "eduflow.designer.flowVariables.delete": "Ssefru",
  "eduflow.designer.flowVariables.invalidKey": "Yennayen yella d uḍu n tmeddurt, ur yella ara d amezwaru.",
  "eduflow.designer.flowVariables.duplicateKey": "Sniḍen yella d uḍu n tmeddurt (ur ttuḍ ara d amezwaru) ur yella ara.",
  "eduflow.designer.flowVariables.savedToast": "Tmeddurtin yellan",
  "eduflow.designer.flowVariables.errorToast": "Ur nsaḥ ara tmeddurtin.",
  "eduflow.designer.flowVariables.saveNow": "Ssefru",
  "eduflow.designer.blockFlowVariablesHint": "Tmeddurtin n yidles: sseddu @votre_cle deg tazrigt neɣ tazwara (ssefru-d iḍen { } deg tazrigt n tazwara).",
  "eduflow.designer.blockFlowVariablesPreviewTitle": "Aperçu (tazrigt)",
  "eduflow.designer.blockFlowVariablesPreviewDescription": "Aperçu (tazwara)",
  "eduflow.designer.flowVariables.mentionNoMatch": "Ur yella ara tmeddurt i d-yettnu.",
  "eduflow.designer.formFieldsSlash.mentionNoMatch": "Ur yella ara tazwara i d-yettnu.",
  "eduflow.designer.onlineCount": "{{count}} deg ussan",
  "eduflow.designer.editingBlocks_one": "{{count}} bloc deg tmeddurt",
  "eduflow.designer.editingBlocks_other": "{{count}} blocs deg tmeddurt",
  "eduflow.designer.invite": "Ssefru",
  "eduflow.designer.inviteTitle": "Ssefru d uḍu n tmeddurt",
  "eduflow.designer.exportTitle": "Ssefru leqla",
  "eduflow.designer.importTitle": "Ssefru leqla (fichier neɣ ssefru JSON)",
  "eduflow.designer.exportNeedSavedFlow": "Ssefru leqla iḍen s tmeddurt n .lyrra.",
  "eduflow.designer.canvasUntitled": "Ur yella ara d tazrigt",
  "eduflow.designer.selectBlock": "Ssefru bloc",
  "eduflow.designer.selectBlockHint": "Ssefru d bloc deg leqla iḍen s tmeddurt n yidles",
  "eduflow.designer.blockPropertiesSubtitle": "Tmeddurt n bloc",
  "eduflow.designer.textVoiceoverHint": "Ttawit tmeddurt iḍen s tazwara neɣ tmeddurt n bloc.",
  "eduflow.designer.blockLockedReadOnly": "Ablac yella d uḍu: tmeddurtin yellan deg tazwara n yidles.",
  "eduflow.designer.blockTitleField": "Tazrigt",
  "eduflow.designer.blockTitlePlaceholder": "Tazrigt n bloc",
  "eduflow.designer.newFlowDefaultTitle": "Tmeddurt n weḥdi",
  "eduflow.designer.you": "K",
  "eduflow.designer.blockInfoPosition": "ID: {{id}} | Tazrigt: ({{x}}, {{y}})",
  "eduflow.designer.toastBlockCopied": "Bloc yellan",
  "eduflow.designer.toastCollaboratorInvited": "Uḍu yellan",
  "eduflow.designer.toastInviteError": "Ur nsaḥ ara ssefru d uḍu",
  "eduflow.designer.createFlowError": "Ur nsaḥ ara ssefru leqla",
  "eduflow.designer.loadFlowError": "Ur nsaḥ ara ssefru leqla.",
  "eduflow.designer.loadFlowForbidden": "Ur ttuḍ ara d leqla.",
  "eduflow.designer.loadFlowNotFound": "Leqla ur yella ara neɣ ttuḍ.",
  "eduflow.duplicateFlowError": "Ur nsaḥ ara ssefru leqla.",
  "eduflow.designer.editConnection": "Seddel leqla",
  "eduflow.designer.deleteConnection": "Ssuprir la connexion",
  "eduflow.translation.toolbarTitle": "Ttraduciton n tcontent",
  "eduflow.translation.toolbarShort": "Ttraduciton",
  "eduflow.translation.title": "Ttraduciton multilingue",
  "eduflow.translation.subtitle": "Ttraducit les textes n blocs (IA) d rgénér la voix off n descripcions ma yed. Les résultats snt enregistrés par langue.",
  "eduflow.translation.subtitleV2": "Cchoisissez une voix Mistral par langue : elles snt pour les voix off générées n le player (ttraduciton à la demande). Les jobs n ttraduciton ci-dessous snt optionnels.",
  "eduflow.translation.voicesSection": "Voix TTS par langue",
  "eduflow.translation.voicesSectionHint": "Aperçu n la langue concernée. Sans voix choisie : « Marie - sad » pour le français, l’italien et l’espagnol ; « Paul - sad » pour les autres langues.",
  "eduflow.translation.voicesLangCount": "{{count}} langues (FR, EN, ES, DE, IT, PT, LB, UK, RU, AR) : choisissez une voix n la liste, puis « Écouter » pour un court extrait.",
  "eduflow.translation.voicesLoadError": "Impossible d’charger les voix. Vérifiez votre connexion ou réessayez.",
  "eduflow.translation.voicePreview": "Écouter",
  "eduflow.translation.previewStop": "Stop",
  "eduflow.translation.voicePlaceholder": "— Choisir une voix —",
  "eduflow.translation.voiceSelectAria": "Voix pour {{lang}}",
  "eduflow.translation.voicesSaveError": "Impossible d’sauvegarder les voix.",
  "eduflow.translation.selectVoiceFirst": "Choisissez une voix pour cette langue.",
  "eduflow.translation.previewError": "Échec n la lecture audio.",
  "eduflow.translation.batchSection": "Ttraducit précalculées (optionnel)",
  "eduflow.translation.batchSectionHint": "Le player peut ttraducir à la volée ; lancez un job seulement si vous voulez figer texte + audio n base à l’avance.",
  "eduflow.translation.sourceLang": "Langue source du parcours",
  "eduflow.translation.bulkSection": "Toutes les langues",
  "eduflow.translation.includeText": "Texte",
  "eduflow.translation.includeAudio": "Audio (voix off description)",
  "eduflow.translation.runAll": "Ttraducir toutes les langues (sauf la source)",
  "eduflow.translation.runAllHint": "Lance un job par langue cible parmi les 12 langues supportées, en excluant la langue source.",
  "eduflow.translation.perLanguage": "Par langue",
  "eduflow.translation.sourceBadge": "Source",
  "eduflow.translation.runOne": "Ttraducir",
  "eduflow.translation.history": "Jobs récents",
  "eduflow.translation.noHistory": "Aucun job pour l’instant.",
  "eduflow.translation.saveFirst": "Enregistrez le parcours avant de lancer une ttraduciton.",
  "eduflow.translation.prefsSaveError": "Impossible d’enregistrer les préférences n ttraduciton (cases Texte / Audio par langue).",
  "eduflow.translation.jobStarted": "Ttraduciton lancée vers {{lang}}.",
  "eduflow.translation.jobError": "Impossible de lancer la ttraduciton.",
  "eduflow.translation.bulkStarted": "{{count}} ttraduciton(s) lancée(s).",
  "eduflow.translation.bulkNone": "Aucun nouveau job : des ttraducitons snt déjà n cours pour toutes les langues cibles, ou les options snt vides.",
  "eduflow.translation.bulkError": "Impossible de lancer les ttraducitons groupées.",
  "eduflow.translation.statusPending": "En attente",
  "eduflow.translation.statusProcessing": "En cours",
  "eduflow.translation.statusCompleted": "Terminé",
  "eduflow.translation.statusFailed": "Échec",
  "eduflow.translation.missingSourceAudioHint": "Ttraduciton avec audio : générez d’abord la voix off (langue {{lang}}) pour chaque description longue. Bloc(s) concerné(s) ({{count}}) : {{blocks}}.",
  "eduflow.translation.missingSourceAudioToast": "{{count}} bloc(s) ur n-ttwri n tmazirt: {{blocks}}. Sggen l-audio seg yid n bloc, ur t-ssin.",
  "project.title": "Iprojet",
  "project.new": "Iprojet nwen",
  "project.name": "Ism n tprojet",
  "project.description": "Tazrawt n tprojet",
  "project.status.draft": "Tawriwt",
  "project.status.published": "Ihder",
  "project.status.archived": "Ihder n tazrawt",
  "project.status.in_review": "Di tazrawt",
  "project.visibility.public": "Amazigh",
  "project.visibility.private": "Azzay",
  "project.visibility.institution": "Ittwasn",
  "project.no_projects": "Ur n-ttwri nni",
  "project.delete_confirm": "D amek i d-ttwri tazrawt a?",
  "store.title": "Tazrigt",
  "store.search": "Sggen di tazrigt",
  "store.categories": "Ihder",
  "store.price": "Azzay",
  "store.free": "Azzay",
  "store.buy": "Ssi",
  "store.add_to_cart": "Sggen di tazrigt",
  "store.cart": "Tazrigt",
  "store.checkout": "Sggen",
  "store.reviews": "Avi",
  "store.rating": "Tazrawt",
  "store.my_purchases": "Ihder n iwen",
  "store.no_items": "Ur n-ttwri nni",
  "audio.title": "Studio n Audio",
  "audio.audiobooks": "Ihder n audio",
  "audio.new_audiobook": "Ihder n audio nwen",
  "audio.record": "Sggen",
  "audio.stop": "Azzay",
  "audio.play": "Tazrawt",
  "audio.pause": "Azzay",
  "audio.volume": "Tazrawt",
  "audio.tracks": "Ihder",
  "audio.add_track": "Sggen di tazrawt",
  "audio.remove_track": "Sggen n tazrawt",
  "audio.effects": "Ihder",
  "audio.export": "Sggen",
  "audio.export_format": "Tazrawt n sggen",
  "audio.duration": "Tazrawt",
  "audio.narrator": "Aɣyul",
  "audio.chapter": "Tazrawt",
  "notification.title": "Iɣewwa",
  "notification.mark_all_read": "Ssaɣ aɣyul d asen",
  "notification.no_notifications": "Ula d iɣewwa",
  "notification.new": "Iɣewwa nniḍen",
  "notification.type.info": "Aɣbalu",
  "notification.type.success": "Aɣbalu n tazmert",
  "notification.type.warning": "Aɣbalu n tazmert",
  "notification.type.error": "Aɣbalu n tazmert",
  "settings.title": "Tazrigt",
  "settings.general": "Aɣbalu",
  "settings.account": "Aɣbalu",
  "settings.security": "Tazmert",
  "settings.appearance": "Tazrigt",
  "settings.notifications": "Iɣewwa",
  "settings.language": "Tamazight",
  "settings.theme": "Tazrigt",
  "settings.theme.light": "Aɣyul",
  "settings.theme.dark": "Aɣyul",
  "settings.theme.system": "Tazrigt",
  "settings.accessibility": "Aɣbalu n tazmert",
  "settings.font_size": "Aɣbalu n tazrigt",
  "settings.high_contrast": "Tazmert aɣbalu",
  "settings.reduced_motion": "Mouvements réduits",
  "settings.dyslexia_mode": "Aɣbalu n tazmert",
  "analytics.title": "Aɣbalu",
  "analytics.overview": "Aɣbalu n tazrigt",
  "analytics.learner_progress": "Aɣbalu n tazrigt",
  "analytics.engagement": "Aɣbalu",
  "analytics.completion": "Aɣbalu",
  "analytics.time_spent": "Aɣbalu n tazrigt",
  "analytics.average_score": "Aɣbalu n tazrigt",
  "analytics.export_report": "Ssaɣ aɣbalu",
  "gamification.xp": "XP",
  "gamification.level": "Aɣbalu",
  "gamification.streak": "Aɣbalu",
  "gamification.badges": "Aɣbalu",
  "gamification.leaderboard": "Aɣbalu",
  "gamification.achievements": "Aɣbalu",
  "gamification.daily_goal": "Aɣbalu n tazrigt",
  "gamification.congratulations": "Tanemmirt !",
  "gamification.new_badge": "Badge nwen iḍeblu !",
  "gamification.level_up": "Nivô nwen !",
  "qualiopi.title": "Tazmert n Qualiopi",
  "qualiopi.dashboard": "Tazmert n uḍris n Qualiopi",
  "qualiopi.criteria": "Ameḍḍak {{number}}",
  "qualiopi.indicator": "Ameḍḍak n {{number}}",
  "qualiopi.compliant": "Iḥedran",
  "qualiopi.non_compliant": "Ur iḥedran",
  "qualiopi.partial": "Iḥedran s wussan",
  "qualiopi.not_applicable": "Ur tḥeddem",
  "qualiopi.evidence": "Ameḍḍak",
  "qualiopi.upload_evidence": "Sselḍeḍ ameḍḍak",
  "qualiopi.audit_date": "Asgwas n audit",
  "qualiopi.next_audit": "Audit iḍeblu",
  "qualiopi.compliance_score": "Iḍebḍen n iḥedran",
  "qualiopi.action_plan": "Tazmert n tazmert",
  "training.plan": "Tazmert n tadrart",
  "training.request": "Aḍris n tadrart",
  "training.requests": "Aḍris n tadrart",
  "training.catalog": "Tazmert n tadrart",
  "training.budget": "Ameḍḍak n tadrart",
  "training.campaign": "Tazmert n tazmert",
  "training.competency": "Tazmert n tazmert",
  "training.gap_analysis": "Tazmert n tazmert",
  "training.roi": "Iḍebḍen n tazmert",
  "producerAssignments.intro": "Ici figurent uniquement les contenus que la RH vous a explicitement assignés : fiches catalogue (« coquilles ») à transformer en parcours dans le designer, et podcasts dont vous êtes le producteur désigné. Si les listes sont vides, aucune mission ne vous est attribuée pour l’instant.",
  "producerAssignments.errorForbidden": "Accès refusé : votre rôle ne permet pas d’utiliser cette page. Si vous êtes bien formateur ou RH d’établissement, contactez l’administrateur.",
  "producerAssignments.errorNoInstitution": "Votre compte n’a pas d’établissement rattaché dans l’application (données en base). Un administrateur doit associer votre utilisateur à l’organisation, puis vous reconnecter.",
  "producerAssignments.errorGeneric": "Impossible de charger vos missions.",
  "common.loading": "Sselḍeḍ...",
  "common.refresh": "Aḍris",
  "common.saving": "Sgǝl...",
  "common.saved": "Sgǝl",
  "common.error": "Aḍris",
  "common.success": "Ssucces",
  "common.warning": "Aḍris",
  "common.info": "Ameḍḍak",
  "common.yes": "Ih",
  "common.no": "Ur",
  "common.or": "neɣ",
  "common.and": "d",
  "common.all": "Lḥeqq",
  "common.none": "Aɣyul",
  "common.total": "Tazrigt",
  "common.actions": "Aɣlil",
  "common.created_at": "Sɣur le",
  "common.updated_at": "Sɣur le",
  "common.sort_by": "Tɣur s",
  "common.per_page": "S ɣer page",
  "common.page": "Page",
  "common.of": "s",
  "common.results": "{{count}} aɣlil(ɣ)",
  "common.no_data": "Aɣyul n ddunit",
  "common.coming_soon": "Sɣur tazmert",
  "common.beta": "Bêta",
  "common.new": "Aɣnew",
  "common.delete_confirm": "Aɣlil aɣyul d iɣewwa. Tɣur ?",
  "common.copied": "Sɣur !",
  "common.drag_drop": "Sɣur-ḍeṣ",
  "common.online": "Di tazmert",
  "common.offline": "Di lḥeqq",
  "common.version": "Version",
  "player.next": "Ssu",
  "player.previous": "Iḍu",
  "player.scrollDownHint": "Sɣur-ḍeṣ ɣer tazmert",
  "player.image.clickForAnnotations": "Sɣur ɣer l’image ɣer tɣur n l’annotations",
  "player.image.annotationNoDescription": "Aɣyul n tɣur n l’annotations.",
  "player.image.noneAvailable": "Aɣyul n l’image ur d-yella",
  "player.visualAi.emptyTitle": "Aɣyul n visuel IA",
  "player.visualAi.emptyHint": "Sɣur-ḍeṣ ɣer l-concepteur ɣer sɣur ɣer tɣur n visuel.",
  "player.visualAi.defaultTitle": "Visuel IA",
  "player.visualAi.subtitle": "Tɣur ɣer l-diagramme : zɣu, sɣur-ḍeṣ neɣ sɣur l-mode plein écran.",
  "player.visualAi.openFullscreen": "Sɣur ɣer l-plein écran",
  "player.visualAi.closeFullscreen": "Sɣur ɣer l-plein écran",
  "player.visualAi.badge": "Visuel IA",
  "player.visualAi.viewportLabel": "Diagramme interactif — zɣu neɣ sɣur",
  "player.visualAi.toolbarLabel": "Aɣlil n l-diagramme",
  "player.visualAi.zoomOut": "Zɣu ɣer",
  "player.visualAi.zoomIn": "Zɣu ɣer",
  "player.visualAi.resetZoom": "Sɣur ɣer l-zoom ɣer 100 %",
  "player.visualAi.reset": "100 %",
  "player.visualAi.fitView": "Aɣlil l-diagramme ɣer l-fenêtre",
  "player.visualAi.fit": "Aɣlil",
  "player.visualAi.zoomLevel": "Zɣu {{percent}} %",
  "player.visualAi.viewportHint": "Molette + Ctrl (ou Cmd) i d-zoom. Ikkuf n l-klaweḍ i t-srḍuḍ ɣef uḍf n l-ziḍ. Tab i t-ɣeḍ i l-ikontroli.",
  "player.complete": "Ssar",
  "player.exit": "Sseɣ",
  "player.fullscreen": "Aɣbalu n l-ɣef",
  "player.exitFullscreen": "Sseɣ i l-ɣbalu n l-ɣef",
  "player.webinarFollowBanner": "Tt-suq i l-animatour — l-navigasyon t-ttawt. Tt-tt-ɣeḍ i l-lang n l-ɣef iḍ i l-bouton n l-globe.",
  "player.textBlockTipsHeading": "Iḍraren",
  "player.textBlockReadDone": "Tt-tt-ɣeḍ i l-ktab",
  "player.institutionLogo": "Logo n l-organization",
  "player.exitConfirmTitle": "Sseɣ i l-tadris?",
  "player.exitConfirmMessage": "Tt-tt-ɣeḍ i l-progres n-ik. Aḥḍar i t-sseɣ?",
  "player.focusLostTitle": "Tadris i t-tawt",
  "player.focusLostMessage": "Tt-tt-ɣeḍ i l-windou n l-tadris. Iḍ-tt-ɣeḍ i l-waqt i t-ttawt.",
  "player.focusLostResume": "Cliquer i t-ssuḍ",
  "player.focusLostRemaining": "Ikkuf n l-ḍḍiḍ i t-ttawt: {{remaining}}",
  "player.focusBlockedTitle": "Tadris i t-ttawt",
  "player.focusBlockedMessage": "Tt-tt-ɣeḍ i l-numm n l-ḍḍiḍ i t-ttawt ({{max}}). Ur t-tt-ɣeḍ i l-tadris aḥḍar.",
  "player.unblockRequestButton": "D-tt-ssuḍ i l-deblok n l-formateur",
  "player.unblockRequestAgain": "D-tt-ssuḍ aḥḍar",
  "player.unblockPending": "D-tt-ssuḍ i l-req — i t-ttawt i l-risponse n l-formateur.",
  "player.unblockRejected": "Tt-tt-ssuḍ i l-deblok t-tt-ɣeḍ i l-ɣef.",
  "player.unblockLoginRequired": "Tt-tt-ɣeḍ i l-ḥisab n l-apprenant (ou tt-tt-ɣeḍ i l-link n l-ḥisab i t-tt-ɣeḍ i l-email) i d-tt-ssuḍ i l-deblok.",
  "player.unblockPublicLoginRequired": "I l-mode public ur t-tt-ɣeḍ i l-inscription, d-tt-ssuḍ i l-deblok ur t-tt-ɣeḍ. Tt-tt-ɣeḍ i l-formulaire n l-inscription n l-tadris ou tt-tt-ɣeḍ i LyrraOne.",
  "player.unblockRequestSent": "D-tt-ssuḍ i l-formateur.",
  "player.unblockRequestError": "Ur t-tt-ɣeḍ i l-ssuḍ. R-tt-ssuḍ.",
  "player.unblockApprovedToast": "L-formateur i d-tt-ssuḍ i l-tadris. Aḥḍar i t-ssuḍ!",
  "player.registrationFormHint": "I l-formulaire i d-tt-ssuḍ i l-ḥisab n l-apprenant i l-tadris (email, prénom akked ism n-ik i t-tt-ɣeḍ).",
  "player.registrationFormSuccess": "Inscription i d-tt-ssuḍ. Tt-tt-ɣeḍ i l-tadris.",
  "player.registrationFormError": "Ur t-tt-ɣeḍ i l-inscription.",
  "notifications.unblock.title": "D-tt-ssuḍ i l-deblok",
  "notifications.unblock.message": "{{name}} — {{flow}} ({{count}} iḍḍiḍ(s))",
  "notifications.unblock.unknownLearner": "Un apprenant",
  "notifications.unblock.unknownFlow": "Tadris",
  "notifications.unblock.approve": "D-tt-ssuḍ",
  "notifications.unblock.reject": "Refuser",
  "notifications.unblock.approvedToast": "Tadris i d-tt-ssuḍ i l-apprenant.",
  "notifications.unblock.rejectedToast": "D-tt-ssuḍ i l-deblok t-tt-ɣeḍ.",
  "notifications.unblock.resolveError": "Ur t-tt-ɣeḍ i l-tt-ssuḍ. R-tt-ssuḍ.",
  "player.cancel": "Aḥḍar",
  "player.summary": "Sommaire",
  "player.summary.badge": "Synthèse",
  "player.summary.noItems": "Ur t-tt-ɣeḍ i l-points n l-recapitulatif i t-tt-ɣeḍ i l-bloc.",
  "player.summary.blockTranslating": "Tazrigt d-ittwelleḍ…",
  "player.summary.blockSimplifying": "Tazrigt n tazrigt d-ittwelleḍ…",
  "player.simplifiedTextLoadingTitle": "Tazrigt n tazrigt d-ittwelleḍ…",
  "player.simplifiedTextLoadingHint": "Nekni n-ittwelleḍ d-ittwelleḍ i tazrigt, s-ttwelleḍ n tazrigt d-ittwelleḍ.",
  "player.contents": "Aɣbalu",
  "player.progress": "Iḍelli",
  "player.block": "Bloc",
  "player.parallelBranches": "Aɣbalu n tazrigt",
  "player.parallelBranchesTitle": "A t-sseggas",
  "player.parallelBranchesHint": "Aɣbalu n tazrigt yella d-ittwelleḍ ɣef tazrigt.",
  "player.parallelBranchShowFull": "S-ttwelleḍ ɣef",
  "player.parallelBranchShowLess": "S-ttwelleḍ ɣef",
  "player.parallelBranchChoose": "S-ttwelleḍ",
  "player.parallelBranchDismiss": "S-ttwelleḍ",
  "player.parallelBranchDismissHint": "S-ttwelleḍ ɣef bloc. Use « Suivant » ɣef t-ttwelleḍ tazrigt.",
  "player.parallelBranchesPickTitle": "S-ttwelleḍ tazrigt nwen",
  "player.parallelBranchesPickHint": "Aɣbalu n tazrigt yella d-ittwelleḍ ɣef tazrigt. S-ttwelleḍ ɣef tazrigt nwen ɣef tazrigt.",
  "player.parallelBranchActionReplay": "S-ttwelleḍ tazrigt aɣbalu",
  "player.parallelBranchFromBlock": "S-ttwelleḍ : {{title}}",
  "player.parallelBranchesProgress": "{{done}} / {{total}} tazrigt d-ittwelleḍ",
  "player.parallelBranchesOverview": "Iḍelli",
  "player.parallelBranchStatusDone": "Ittwelleḍ",
  "player.parallelBranchStatusTodo": "Iḍelli",
  "player.parallelBranchStatusNext": "A t-sseggas ɣef",
  "player.parallelBranchAction": "S-ttwelleḍ tazrigt aɣbalu",
  "player.parallelBranchesGridLabel": "Grille n tazrigt",
  "player.parallelBranchesScrollHint": "S-ttwelleḍ ɣef yiman (ou use les flèches) ɣef tazrigt nwen.",
  "player.parallelBranchesPageNav": "Pages n tazrigt",
  "player.parallelBranchesPageIndicator": "Page {{current}} / {{total}}",
  "player.parallelBranchesPrevPage": "Tazrigt n tazrigt",
  "player.parallelBranchesNextPage": "Tazrigt n tazrigt",
  "player.notes": "S-ttwelleḍ n tazrigt...",
  "player.noBlocks": "Aɣbalu ur yella.",
  "player.contentTranslatingTitle": "Tazrigt n aɣbalu ɣef l-zzman nwen…",
  "player.contentTranslatingHint": "Tazrigt d-ittwelleḍ ɣef tazrigt. Yella d-ittwelleḍ ɣef tazrigt.",
  "player.contentLanguageReloadFailed": "Aɣbalu ur yella d-ittwelleḍ ɣef l-zzman (délai ou erreur serveur). La version précédente yella d-ittwelleḍ. Réessayez dans un instant ou précalculez les traductions dans le designer.",
  "player.contentLanguageSubflowHint": "Pour mettre à jour le texte et l’audio, terminez ou quittez la sous-partie en cours, puis choisissez à nouveau la langue.",
  "player.defaultFlowTitle": "Formation",
  "player.docTitle.error": "Formation ur yella",
  "player.docTitle.completed": "Formation ittawelleḍ",
  "player.docTitle.loading": "Ittwelleḍ n formation",
  "player.docTitle.fallback": "Formation",
  "player.initError.title": "Tazrigt d amezwaru i tazrigt",
  "player.initError.loadFailed": "Ur tzaɣ ad tḥemmleḍ tazrigt.",
  "player.initError.loadFailedWithDetail": "Ur tzaɣ ad tḥemmleḍ tazrigt.{{detail}} Ssaḥeḍ aḍuḍ i tazrigt n tazrigt.",
  "player.initError.hintsIntro": "Ttḍuḍ aḍuḍ:",
  "player.initError.hintRefresh": "tḥemmleḍ aḍuḍ ;",
  "player.initError.hintConnection": "tḥemmleḍ aḍuḍ n Internet ;",
  "player.initError.hintRetryLater": "ssaḥeḍ aḍuḍ i tazrigt n tazrigt.",
  "api.error.network": "Ur tḥemmleḍ aḍuḍ n server. Tḥemmleḍ aḍuḍ n tḥemmleḍ.",
  "api.error.unexpected": "Tazrigt ur nḥeḍ ara.",
  "api.error.badRequest": "Tazrigt ur tḥemmleḍ ara.",
  "api.error.forbidden": "Aḍuḍ ur tḥemmleḍ ara.",
  "api.error.notFound": "Aḍuḍ ur nḥeḍ ara.",
  "api.error.conflict": "Tazrigt — aḍuḍ aṭṭan i tazrigt.",
  "api.error.unprocessable": "Aḍuḍ n tazrigt ur tḥemmleḍ ara.",
  "api.error.tooManyRequests": "Tazrigt n tḥemmleḍ ur tḥemmleḍ ara. Ssaḥeḍ aḍuḍ i tazrigt n tazrigt.",
  "api.error.server": "Tazrigt n server n internal.",
  "api.error.badGateway": "Aḍuḍ n tazrigt ur tḥemmleḍ ara.",
  "api.error.maintenance": "Aḍuḍ n tazrigt.",
  "api.error.generic": "Tazrigt {{status}}",
  "player.textBlockReadMinutes": "{{count}} min n tḥemmleḍ",
  "player.textBlockWordCount_one": "{{count}} tamurt",
  "player.textBlockWordCount_other": "{{count}} tamurtin",
  "player.textBlockNoContent": "Ur tḥemmleḍ ara.",
  "player.blockUnknown": "Bloc ur nḥeḍ ara",
  "player.objectivesPanelTitle": "Aḍuḍ n tazrigt",
  "player.objectivesOpenLabel": "Ssaḥeḍ aḍuḍ n tazrigt",
  "player.objectivesCloseLabel": "Ssaḥeḍ aḍuḍ n tazrigt",
  "player.objectivesAchievementRate": "Tazrigt n tḥemmleḍ",
  "player.objectivesAchievedCount": "{{achieved}}/{{total}} aḍuḍ n tḥemmleḍ",
  "player.objectivesNoneDefined": "Ur tḥemmleḍ ara i tazrigt.",
  "player.objectiveCategory.savoir": "Aḍuḍ",
  "player.objectiveCategory.savoirFaire": "Aḍuḍ n tḥemmleḍ",
  "player.objectiveCategory.savoirEtre": "Aḍuḍ n tḥemmleḍ",
  "player.objectiveLevel.connaissance": "Aḍuḍ",
  "player.objectiveLevel.comprehension": "Aḍuḍ",
  "player.objectiveLevel.application": "Aḍuḍ",
  "player.objectiveLevel.analyse": "Aḍuḍ",
  "player.objectiveLevel.synthese": "Aḍuḍ",
  "player.objectiveLevel.evaluation": "Aḍuḍ",
  "player.objectiveBloom": "Bloom · {{level}}",
  "player.objectiveRequired": "Aḍuḍ",
  "player.objectiveLinkedBlocks": "Aḍuḍ n tazrigt",
  "player.objectiveCriterionScore": "Score ≥ {{min}} %",
  "player.objectiveCriterionCompletion": "Tazrigt n ublk",
  "player.objectiveNoLinkedBlocks": "Ublay nni — tazrigt n uḍris ur t-ḥeqqiḍ ara.",
  "player.completion.congratulations": "🎉 Tazrigt !",
  "player.completion.finished": "📋 Tazrigt tazrigt",
  "player.completion.youCompleted": "Ttawriḍt",
  "player.completion.passed": "Tawriḍ ✓",
  "player.completion.failed": "Ur tawriḍ ara ✗",
  "player.completion.requiredScore": "Aɣbalu n tazrigt: {{score}}%",
  "player.completion.totalTime": "Wakt n tazrigt",
  "player.completion.blocksCompleted": "Ublay n tazrigt",
  "player.completion.quizPassed": "Tawriḍ n quiz",
  "player.completion.successRate": "Aɣbalu n tawriḍ",
  "player.completion.blockCompleted": "Tawriḍ ✓",
  "player.completion.blockFailed": "Ur tawriḍ ara ✗",
  "player.completion.blockSkipped": "Iḍu",
  "player.completion.detail": "📊 Tazrigt n ublk",
  "player.completion.type": "Aɣbalu",
  "player.completion.timeSpent": "Wakt iḍu",
  "player.completion.downloadCertificate": "📄 Ssel aṭas n tazrigt",
  "player.completion.certificateSoon": "Aṭas n tazrigt yella yid n tazrigt.",
  "player.completion.restart": "🔄 Rrḍu",
  "player.completion.viewDetails": "📊 Wḍu tazrigt",
  "player.completion.backToDashboard": "← Rrḍu ɣef tazrigt n uḍris",
  "player.completion.embedDismissHint": "Ttawriḍt aṭas. Iḍu, ssel aṭas n tazrigt ɣef tazrigt n tazrigt.",
  "player.completion.embedDismissButton": "Ssel aṭas",
  "player.previewBanner": "Aɣbalu n tazrigt — aṭas n tazrigt yella yid n tazrigt n tazrigt",
  "player.closePreview": "Ssel aṭas",
  "player.flowPreviewMap": "Tazrigt n tazrigt",
  "player.flowPreviewTitle": "Aɣbalu n tazrigt",
  "player.flowPreviewHint": "Aɣbalu n tazrigt (k-ɣef tazrigt). Tazrigt n tazrigt yella yid n tazrigt.",
  "player.flowPreviewLegendCurrent": "Ublk yella yid n tazrigt",
  "player.flowPreviewClose": "Ssel",
  "player.toggleSidebarShow": "Wḍu tazrigt",
  "player.toggleSidebarHide": "Iḍu tazrigt",
  "player.mobileSummary": "Tazrigt",
  "player.mobileObjectives": "Aɣbalu",
  "player.mobileMoreOptions": "Aɣbalu nni",
  "player.sidebarExpand": "Rrḍu tazrigt",
  "player.sidebarCollapse": "Iḍu tazrigt",
  "player.keyboardShortcuts": "Rrḍu n uḍris",
  "player.keyboardShortcutPrev": "Ublk nni",
  "player.keyboardShortcutNext": "Bloc nni",
  "player.keyboardShortcutsHint": "Ssar « Tazrigt n wussan » di tazrigt n yidles (tazrigt di tazrigt n yidles). Ur ttiḍ di tazrigt n yidles.",
  "player.a11yCenter": "Tazrigt n yidles",
  "player.reviewSummary": "Ssiḍ tazrigt",
  "player.viewResults": "Ssiḍ tazrigt",
  "player.submitFirst": "Ssar d awal",
  "player.phraseRevealCompleteFirst": "Ssar d awal i tazrigt n yidles",
  "player.phraseReveal.emptyBlock": "Ur yella tazrigt i tazrigt n yidles.",
  "player.phraseReveal.revealNextAria": "Ssar d awal neɣ s Espace i ssiḍ tazrigt n yidles nni.",
  "player.phraseReveal.lastPhraseHint": "Tazrigt nni — ssar d « Nni » i tcontinu.",
  "player.phraseReveal.morePhrasesHint": "Clic, Espace neɣ flèche nni i tazrigt nni.",
  "player.phraseReveal.previousPhrases": "Tazrigt n yidles i ddu ({{count}})",
  "player.certificateUnavailable": "Tazrigt ur ttiḍ i tazrigt n yidles.",
  "player.browser.embeddedContentTitle": "Tazrigt n yidles",
  "player.browser.noValidUrl": "Ur yella URL nni",
  "player.browser.enterHttpsHint": "Ssar d awal i tazrigt n yidles i d https:// (neɣ http://) di tazrigt n yidles.",
  "player.browser.loadingContent": "Ssar d awal i tazrigt…",
  "player.browser.defaultPageTitle": "Tazrigt n yidles",
  "player.browser.continue": "Tcontinu",
  "player.browser.stepSaved": "Tazrigt n yidles ur ttiḍ",
  "player.browser.fullscreen": "Tazrigt n yidles",
  "player.browser.exitFullscreen": "Ssar d awal i tazrigt n yidles",
  "player.podcast.defaultShowTitle": "Podcast",
  "player.podcast.defaultEpisode": "Épisode",
  "player.podcast.loadError": "Ur ttiḍ i tazrigt n yidles.",
  "player.podcast.loadingEpisodes": "Ssar d awal i tazrigt n yidles…",
  "player.podcast.playAll": "Ssar d awal",
  "player.podcast.nextEpisode": "Épisode nni",
  "player.podcast.episodesHeading": "Tazrigt n yidles",
  "player.podcast.noEpisodes": "Ur yella tazrigt n yidles.",
  "player.podcast.noAudio": "Ur yella audio",
  "player.podcast.chainPlayback": "Tazrigt n yidles · {{current}}/{{total}}",
  "player.podcast.selectOrPlayAll": "Ssar d awal i tazrigt n yidles neɣ ssar d awal.",
  "player.podcast.audioUnavailable": "Audio ur ttiḍ i tazrigt n yidles.",
  "player.podcast.showEpisodeText": "Ssiḍ tazrigt",
  "player.podcast.hideEpisodeText": "Ur ssiḍ tazrigt",
  "player.podcast.episodeCount_one": "{{count}} tazrigt",
  "player.podcast.episodeCount_other": "{{count}} tazrigt",
  "player.podcast.showChapters": "Ssiḍ tazrigt n yidles",
  "player.podcast.hideChapters": "Ur ssiḍ tazrigt n yidles",
  "player.podcast.coverDialogLabel": "Tazrigt : {{title}}",
  "player.podcast.coverEnlargePodcast": "Agrandir la pochette du podcast",
  "player.podcast.coverEnlargeEpisode": "Ssaḍa l-pochette n l'épisode",
  "player.podcast.coverEnlarge": "Ssaḍa l-pochette",
  "player.audio.play": "Aḍu",
  "player.audio.pause": "Aḍu n tazmert",
  "player.audio.mute": "Ssaḍa l-sound",
  "player.audio.unmute": "Rraḥ l-sound",
  "player.audio.seek": "Maqṭa n l-piste audio",
  "player.audio.playbackSpeed": "Tazmert n l-ḍu",
  "player.audio.completed": "Piste audio tḥemmert",
  "player.audio.subtitlesAria": "Tazmert t-syncroniḍa s l-ḍu",
  "player.audio.subtitlesWaiting": "L-texte yeddu ḥna ḍu (segment ɣef maqṭa).",
  "player.audio.subtitlesNeedText": "Sseddeḍ l-texte (TTS neɣ l-content n l-block) ḍeɣ yeddu l-segments ḥna.",
  "player.audio.subtitlesHintSr": "Tazmert t-syncroniḍa ɣef: l-texte yeddu ɣef l-durée audio, ur yella timecodes n tɣiḍ.",
  "player.timeline.defaultTitle": "Frise chronologique",
  "player.timeline.subtitle": "Frise chronologique ɣef yeddu.",
  "player.timeline.eventFallback": "Événement",
  "player.timeline.voiceoverLabel": "Voix off",
  "player.timeline.playVoiceover": "Aḍu l-voix off",
  "player.timeline.pauseVoiceover": "Aḍu n tazmert l-voix off",
  "player.timeline.generateVoiceover": "Sseḍḍa l-voix off",
  "player.timeline.showDetail": "Sseḍḍa l-détail",
  "player.timeline.hideDetail": "Ssaḍa l-détail",
  "player.timeline.emptyTitle": "Ur yella événement ɣef a frise",
  "player.timeline.emptyHint": "Sseddeḍ l-étapes ɣef l-panneau n l-config n l-block.",
  "player.timeline.voiceoverUnavailableTitle": "Voix off ur yella",
  "player.timeline.voiceoverUnavailableDesc": "Ftaḥ a parcours ɣef uma formation connectée ḍeɣ sseḍḍa l-audio.",
  "player.timeline.voiceoverTextTooShortTitle": "Texte ur yella ɣef",
  "player.timeline.voiceoverTextTooShortDesc": "Sseddeḍ l-description (aḍu 20 caractères) neɣ l-title ɣef l-voix off.",
  "player.timeline.voiceoverGenerationErrorTitle": "Sseḍḍa l-voix off ur tḥemmert",
  "player.timeline.voiceoverSlowTitle": "Voix off",
  "player.timeline.voiceoverSlowDesc": "Sseḍḍa t-takḍim yeddu ɣef l-waqt. Rraḥ ḥna.",
  "player.timeline.retryLater": "Rraḥ ḥna ɣef l-ḥeqq.",
  "player.timeline.openFullscreen": "Ftaḥ ɣef l-ḍu",
  "player.timeline.openFullscreenAria": "Ftaḥ a frise ɣef l-ḍu",
  "player.timeline.closeFullscreenAria": "Ssaḍa l-ḍu",
  "player.timeline.reviewed": "Chronologie t-ḥemmert",
  "player.video.seek": "Maqṭa n l-video",
  "player.video.subtitlesShow": "Sseḍḍa l-sous-titres",
  "player.video.subtitlesHide": "Ssaḍa l-sous-titres",
  "player.video.trackLabel": "Sous-titres",
  "player.video.completed": "Vidéo tḥemmert",
  "player.video.markWatched": "Nǝg l-video",
  "player.video.defaultIframeTitle": "Tvidi n tmeddurt",
  "player.podcast.playAllAria": "Ssmim ad tssnaw « {{title}} » — {{count}} tmeddurt(s) s wussan",
  "player.podcast.skipNextQueuedAria": "Tmeddurt n tmeddurt n yid n tssnaw",
  "player.podcast.playEpisodeAria": "Tssnaw n tmeddurt : {{title}}",
  "player.podcast.episodeNoAudioAria": "Tmeddurt ur yella s wussan : {{title}}",
  "player.renderError": "Tawuri n tmeddurt n bloc : {{blockType}}",
  "player.blocks.defaultWelcome": "Ahlan s wa sahlan di tmeddurt",
  "player.blocks.defaultEndTitle": "Tazmert !",
  "player.quiz.selectCorrectAnswer": "Sselkim aḍu n tazmert :",
  "player.quiz.correctAnswer": "✓ Aḍu n tazmert !",
  "player.quiz.incorrectAnswer": "✗ Aḍu ur tazmert.",
  "player.blockTimer.aria": "Wakt iḍu s tmeddurt n bloc",
  "player.blockTimer.modeShortCountup": "Minutur",
  "player.blockTimer.modeShortCountdown": "Ddeqmt",
  "player.form.successMessage": "Tanmmirt i yid nwen !",
  "player.form.noFieldsConfigured": "Aneɣ ur yella s tazmert n tmeddurt.",
  "player.selfAssessment.empty": "Ur yella s tazmert i tazmert n tazmert.",
  "player.selfAssessment.continue": "Ssuq",
  "player.selfAssessment.pick": "Sselkim aḍu n tazmert",
  "player.selfAssessment.rateAria": "Tazmert {{n}} : {{label}}",
  "player.selfAssessment.criterionFallback": "tazmert",
  "player.selfAssessment.commentLabel": "Aḍu (n tazmert)",
  "player.selfAssessment.commentPlaceholder": "Tazmert n yid, tazmert n tazmert…",
  "player.selfAssessment.submitted": "Tazmert iḍu s tazmert.",
  "player.selfAssessment.submit": "Ssuq i tazmert nwen",
  "player.selfAssessment.textAnswerPlaceholder": "Aḍu nwen…",
  "player.selfAssessment.pickBadges": "Sselkim aḍu n tazmert n tazmert :",
  "player.evaluation.commentsLabel": "Aḍu (n tazmert)",
  "player.evaluation.commentsPlaceholder": "Ssmim aḍu nwen...",
  "player.evaluation.submitted": "Tazmert iḍu s tazmert",
  "player.evaluation.submit": "Ssuq i tazmert",
  "player.time.lessThanMinute": "Ur tella s yid n tmeddurt",
  "player.time.oneMinute": "1 tmeddurt",
  "player.time.minutes": "{{count}} tmeddurt",
  "player.time.shortSeconds": "{{count}}s",
  "player.time.shortMinutes": "{{count}}min",
  "player.time.shortMinutesSeconds": "{{minutes}}min {{seconds}}s",
  "player.completion.scoreLabel": "Nnig",
  "accessibility.openCenter": "Ftaḥ i tmeddurt n tazmert",
  "accessibility.center": "Tazmert",
  "accessibility.modalTitle": "Tmeddurt n tazmert i tmeddurt",
  "accessibility.modalDescription": "Ssuq i tmeddurt s tmeddurt, tazmert n tmeddurt d tmeddurt n tmeddurt.",
  "accessibility.closeCenter": "Sserr le centre d'accessibilité",
  "accessibility.accessPad.connected": "Lyrra Access Pad yeddu",
  "accessibility.accessPad.playGuide": "Ssemmer le guide LyrraPad",
  "accessibility.accessPad.pauseGuide": "Sserr le guide LyrraPad",
  "accessibility.presets": "Profils iggaren",
  "accessibility.preset.standard.label": "Iggar",
  "accessibility.preset.standard.desc": "Rendu par défaut de l'application.",
  "accessibility.preset.lowVision.label": "Azzay",
  "accessibility.preset.lowVision.desc": "Contraste renforcé, texte agrandi et repères visuels plus nets.",
  "accessibility.preset.dys.label": "Dys",
  "accessibility.preset.dys.desc": "Lecture facilitée avec plus d'espace et une police plus lisible.",
  "accessibility.preset.cumulHint": "Tazmert iḥedran n profilen ma yebda",
  "accessibility.preset.clickToAdd": "Sserr iḍef",
  "accessibility.preset.clickToRemove": "Sserr iḍeff",
  "accessibility.typography": "Tazmert n typographie",
  "accessibility.fontScale": "Talla n texṭ",
  "accessibility.lineHeight": "Iḍrimen",
  "accessibility.letterSpacing": "Iḍrimen n lḥuruf",
  "accessibility.wordSpacing": "Iḍrimen n lkalimat",
  "accessibility.visualAids": "Aides visuales",
  "accessibility.highContrast": "Contraste renforcé",
  "accessibility.highContrastDesc": "Renforce les contrastes de lecture, les bordures et les repères visuels.",
  "accessibility.underlineLinks": "Liens soulignez",
  "accessibility.underlineLinksDesc": "Affiche plus clairement les liens et zones interactives.",
  "accessibility.dyslexiaFont": "Police de lecture facilitée",
  "accessibility.dyslexiaFontDesc": "Utilise une police plus confortable pour les personnes dys et les lecteurs fatigués.",
  "accessibility.reducedMotion": "Mouvements réduits",
  "accessibility.reducedMotionDesc": "Diminue les animations et transitions pour limiter l'inconfort visuel.",
  "accessibility.mouseMagnifier": "Loupe de lecture",
  "accessibility.mouseMagnifierDesc": "Affiche une loupe circulaire qui suit le curseur et grossit le contenu du parcours sous la zone pointée (affichage agrandi en lecture seule).",
  "accessibility.readingMask": "Masque de lecture",
  "accessibility.readingMaskDesc": "Une bande opaque suit le curseur pour isoler la ligne en cours — très utile pour la dyslexie et les TDA/H. Astuce : Option ⌥ + touche =/+ ou Option ⌥ + ↑/↓ (macOS) ; Alt + + / Alt − (Windows/Linux) pour ajuster la hauteur.",
  "accessibility.speakOnSelection": "Synthèse vocale sur sélection",
  "accessibility.speakOnSelectionDesc": "Sélectionnez du texte sur la page : un bouton apparaît pour le lire à voix haute à la demande (différent du mode lecture audio automatique).",
  "accessibility.speakSelection.listen": "Ssemmer le sélection",
  "accessibility.speakSelection.stop": "Arrêter la lecture",
  "accessibility.speakSelection.loading": "Génération…",
  "accessibility.speakSelection.retry": "Réessayer",
  "accessibility.speakSelection.error": "Lecture indisponible, réessayez dans quelques instants.",
  "accessibility.speakSelection.region": "Lire la sélection à voix haute",
  "a11y.voiceGuide.title": "Assistant vocal accessibilité",
  "a11y.help.shortcuts": "Raccourcis clavier",
  "a11y.help.kbdEsc": "Sserr lpanou / tazrigh l-synthèse vocale",
  "a11y.help.kbdMask": "Ajuster lhauteur n lmasque n lqra (masque aktiy)",
  "a11y.help.kbdMaskMac": "Touche = ou + (s-tt n lchiffrin), ou flèches ↑ ↓ m3a Option ⌥",
  "a11y.help.kbdMaskOther": "Windows / Linux : Alt + + / Alt + −",
  "a11y.help.kbdTab": "Naviguer entre léléments interactifs",
  "a11y.help.tips": "Ittis",
  "a11y.voiceGuide.subtitle": "Sserr lkhssas nnek, naktif lkhiyarat l-mzyana 3lik.",
  "a11y.voiceGuide.cta.title": "Sserr lkhssas nnek",
  "a11y.voiceGuide.cta.hint": "Tqll : l'IA tazrigh bttautomatik lkhiyarat l-mzyana 3lik.",
  "a11y.voiceGuide.cta.openLabel": "Ouvrir l'assistant vocal — sserr lkhssas nnek d-accessibilité b l-sawt 3la l3ali",
  "a11y.voiceGuide.cta.start": "Démarrer l'assistant vocal",
  "a11y.voiceGuide.cta.stop": "Arrêter d'écouter",
  "a11y.voiceGuide.status": "Statut",
  "a11y.voiceGuide.statusActive": "En cours",
  "a11y.voiceGuide.youSaid": "Kult",
  "a11y.voiceGuide.reformulation": "Hna chno fhamt",
  "a11y.voiceGuide.applied": "Réglages appliqués",
  "a11y.voiceGuide.resetButton": "Remettre en normal",
  "a11y.voiceGuide.resetExplanation": "Jmi3 lréglages n-accessibilité rja3u l-default.",
  "a11y.voiceGuide.problem": "Problème",
  "a11y.voiceGuide.micReady": "Micro prêt",
  "a11y.voiceGuide.micUnsupported": "Reconnaissance vocale non supportée",
  "a11y.voiceGuide.stage.idle": "Prêt à vous écouter",
  "a11y.voiceGuide.stage.intro": "Nnqss lkhssas...",
  "a11y.voiceGuide.stage.listening": "Nnqss l3lik. Tqll b l-hurriya.",
  "a11y.voiceGuide.stage.thinking": "Nanalize lkhssas nnek...",
  "a11y.voiceGuide.stage.confirmPlaying": "Nnqss...",
  "a11y.voiceGuide.stage.confirmListening": "Qul « oui » bach tconfirmi aw « non » bach t3awd.",
  "a11y.voiceGuide.stage.applying": "Ttbiq n lkhiyarat nnek...",
  "a11y.voiceGuide.stage.done": "Hna tkamlat!",
  "a11y.voiceGuide.stage.error": "Waqa3t wahda l-khata.",
  "a11y.voiceGuide.error.mic": "Ma nqdrch ndkhlu l-micro.",
  "a11y.voiceGuide.error.micDenied": "L-access au microphone t-rfda. Sma7 f l-paramètres n l-browser.",
  "a11y.voiceGuide.error.stt": "Reconnaissance vocale ma kaynach f had l-browser.",
  "a11y.voiceGuide.error.ai": "Analyse IA ma kaynach.",
  "a11y.voiceGuide.error.serverUnavailable": "L-serveur Lyrra ma kayjibch l-rad l-mzyan (akthar : backend ma t-deploych aw khata f l-build). Tqll l-deploiement, b3d rja3 jarrab.",
  "a11y.voiceGuide.error.generic": "Wahd l-chay sser lkhata. Rja3 jarrab aw ajtah lkhiyarat b l-yad.",
  "accessibility.alwaysOn": "Tzid n l-améliorations f l-daw",
  "accessibility.alwaysOnFocus": "Focus n l-kbira akthar wadh",
  "accessibility.alwaysOnLinks": "Liens w léléments interactifs akthar ykhdmo",
  "accessibility.alwaysOnSaved": "Réglages t-saved bttautomatik 3la had l-jihaz",
  "accessibility.navigation": "Navigation",
  "accessibility.keyboardNavigation": "Tazrigt n tazrigt",
  "accessibility.keyboardNavigationDesc": "Ssefru s tazrigt n yid / yid n yid i tazrigt n yid n tazrigt n yid n yid (ssefru s tazrigt n yid n yid).",
  "learner.header.workspace": "Agharas n tazrigt",
  "learner.tabs.home": "Akkul",
  "learner.tabs.parcours": "Agharas n tazrigt",
  "learner.tabs.formations": "Agharas n tazrigt",
  "learner.tabs.webinars": "Webinaires",
  "learner.tabs.podcasts": "Podcasts",
  "learner.tabs.documents": "Imuddukan",
  "learner.tabs.progress": "Tazrigt n tazrigt",
  "learner.tabs.profile": "Profil",
  "learner.sidebar.tagline": "Tazrigt",
  "learner.sidebar.webinars": "Webinaires",
  "learner.webinars.title": "Webinaires nni",
  "learner.webinars.loading": "Ssefru n wwebinaires nwen...",
  "learner.webinars.empty": "Ula d wwebinaire s tazrigt. Izzin n wwebinaires nwen akked tazrigt nni yella d-ittun.",
  "learner.webinars.sectionInvited": "Izzin n wwebinaires",
  "learner.webinars.sectionPresenting": "Tazrigt nni s tazrigt",
  "learner.webinars.emptyInvited": "Ula d izzin s tazrigt.",
  "learner.webinars.emptyPresenting": "Ula d tazrigt s wwebinaire.",
  "learner.webinars.rolePresenter": "Tazrigt",
  "learner.webinars.joinAsPresenter": "Ssefru n tazrigt (tazrigt)",
  "learner.webinars.join": "Ssefru",
  "learner.webinars.invitedOn": "Izzin s",
  "learner.webinars.scheduledFor": "Ssefru s",
  "learner.webinars.duration": "Tazrigt : {{duration}}",
  "learner.webinars.loadError": "Ula d ssefru n wwebinaires.",
  "learner.webinars.status.draft": "Tazrigt",
  "learner.webinars.status.scheduled": "Ssefru",
  "learner.webinars.status.live": "Ssefru",
  "learner.webinars.status.ended": "Izzin",
  "learner.sidebar.myProfile": "Profil nni",
  "learner.sidebar.logout": "Ssefru",
  "learner.sidebar.collapse": "Ssefru n tazrigt",
  "learner.sidebar.expandAria": "Ssefru n tazrigt",
  "learner.sidebar.collapseAria": "Ssefru n tazrigt",
  "learner.sidebar.backToTrainer": "Tazrigt n tazrigt",
  "learner.sidebar.backToTrainerAria": "Ssefru n tazrigt",
  "learner.home.defaultName": "tazrigt·e",
  "learner.home.greeting": "Azul {{name}},",
  "learner.home.greetingSubtitle": "Ssefru s tazrigt nni i tazrigt.",
  "learner.home.resumeMyFormation": "Ssefru n tazrigt nni",
  "learner.home.globalProgress": "Progression globale",
  "learner.home.learningTime": "Tazrigt n tazrigt",
  "learner.home.badges": "Badges yebda",
  "learner.home.calendarKicker": "Tazrigt-iyi",
  "learner.home.quickAccess": "Aksis n yid",
  "learner.learningPath": "Tizri",
  "learner.home.resumeTraining": "Ssefru i tazrigt-ik",
  "learner.home.viewAll": "Ssefru yid →",
  "learner.home.trainingDomains": "Ihder n tazrigt",
  "learner.home.courses": "cours",
  "learner.home.episodes": "épisodes",
  "learner.home.recommendedPodcasts": "Podcasts yebda",
  "learner.home.explore": "Tazrigt →",
  "learner.formations.title": "Tazrigt-iy",
  "learner.formations.searchPlaceholder": "Rechercher une formation…",
  "learner.formations.all": "Tous",
  "learner.formations.formation": "Formation",
  "learner.formations.inProgress": "Di tazrigt",
  "learner.formations.completed": "Azzay",
  "learner.formations.notStarted": "Ur tazrigt",
  "learner.formations.loading": "Tazrigt-ik yebda...",
  "learner.formations.empty": "Ur tazrigt-ik yebda.",
  "learner.formations.progress": "Progression",
  "learner.formations.instructor": "Formateur",
  "learner.formations.opening": "Ouverture...",
  "learner.formations.review": "Revoir",
  "learner.formations.start": "Ssefru",
  "learner.formations.continue": "Ssuq",
  "learner.podcasts.title": "Tazrigt n Podcasts",
  "learner.podcasts.searchPlaceholder": "Rechercher un podcast…",
  "learner.podcasts.all": "Tous",
  "learner.podcasts.assigned": "Podcast yebda",
  "learner.podcasts.defaultCategory": "Podcast",
  "learner.podcasts.loading": "Tazrigt-ik yebda...",
  "learner.podcasts.empty": "Ur podcast yebda.",
  "learner.podcasts.episodes": "épisodes",
  "learner.podcasts.opening": "Ouverture...",
  "learner.podcasts.listen": "Écouter",
  "learner.documents.title": "Tazrigt n documents",
  "learner.documents.loading": "Tazrigt-ik yebda...",
  "learner.documents.view": "Ssefru le document",
  "learner.documents.empty": "Ur document yebda.",
  "learner.documents.personalTitle": "Iɣeḍ n waman",
  "learner.documents.personalHint": "Iɣeḍ n waman ur d-yeǧǧa ɣef-k. Sserḥeḍ ɣef iɣeḍ ɣef yid.",
  "learner.documents.personalEmpty": "Ur d-yeǧǧa iɣeḍ n waman. Sserḥeḍ PDF ɣef yid.",
  "learner.documents.upload": "Sserḥeḍ iɣeḍ",
  "learner.documents.delete": "Ssuḥel",
  "learner.documents.deleteConfirmTitle": "Ssuḥel aɣi iɣeḍ?",
  "learner.documents.deleteConfirmDesc": "Akked agi ur d-yeǧǧa. Iɣeḍ akked tazmert n IA yessurḥu.",
  "learner.documents.cancel": "Sserḥeḍ",
  "learner.documents.confirmDelete": "Ssuḥel",
  "learner.documents.chatReady": "Chat yella",
  "learner.documents.processing": "Tazmert ɣef iɣeḍ…",
  "learner.documents.backToList": "Sɣu ɣef iɣeḍ",
  "learner.documents.chatTitle": "Sseɣḍeḍ iḍeḍ n iɣeḍ",
  "learner.documents.chatPlaceholder": "Sseɣḍeḍ ɣef iɣeḍ…",
  "learner.documents.chatPlaceholderHint": "Sseɣḍeḍ iḍeḍ n iɣeḍ. L'assistant ur yessurḥu illa ɣef tazmert n iɣeḍ.",
  "learner.documents.chatError": "Tawuri yella.",
  "learner.documents.preview": "Aperçu",
  "learner.documents.indexing": "Tazmert n iɣeḍ ɣef yid…",
  "learner.progress.title": "Ma Progression",
  "learner.progress.completedFormations": "Tazmert n tazmert",
  "learner.progress.trainingHours": "Iḍuran n tazmert",
  "learner.progress.listenedPodcasts": "Podcasts yessurḥu",
  "learner.progress.earnedBadges": "Badges yessurḥu",
  "learner.progress.weeklyActivity": "Tazmert n lḥeqq",
  "learner.progress.badges": "Badges",
  "learner.progress.recentActivity": "Tazmert n lḥeqq",
  "learner.progress.rarity.common": "Aɣbalu",
  "learner.progress.rarity.rare": "Aɣbalu n tazmert",
  "learner.progress.rarity.epic": "Aɣbalu n tazmert",
  "learner.progress.rarity.legendary": "Aɣbalu n tazmert",
  "learner.progress.days.mon": "Lun",
  "learner.progress.days.tue": "Mar",
  "learner.progress.days.wed": "Mer",
  "learner.progress.days.thu": "Jeu",
  "learner.progress.days.fri": "Ven",
  "learner.progress.days.sat": "Sam",
  "learner.progress.days.sun": "Dim",
  "learner.profile.title": "Mon Profil",
  "learner.profile.defaultName": "Apprenant",
  "learner.profile.defaultEmail": "apprenant@exemple.com",
  "learner.profile.memberSince": "Membre ɣef yennayer 2024",
  "learner.profile.editProfile": "Meddel iɣeḍ",
  "learner.profile.formations": "Tazrigt",
  "learner.profile.hours": "Ihurs",
  "learner.profile.podcasts": "Podcasts",
  "learner.profile.badges": "Badges",
  "learner.profile.preferences": "Tazrawt",
  "learner.profile.theme": "Tazmert",
  "learner.profile.themeLight": "Azzay",
  "learner.profile.themeDark": "Azzar",
  "learner.profile.themeSystem": "Système",
  "learner.profile.language": "Tamazight",
  "learner.profile.notifications": "Taznat",
  "learner.profile.fontSize": "Tayri n ttext",
  "learner.profile.fontNormal": "Ammar",
  "learner.profile.fontLarge": "Azzay",
  "learner.profile.highContrast": "Azzay n tazrigt",
  "learner.profile.a11ySection": "Aksil",
  "learner.profile.dangerZone": "Tazrigt n tazrigt",
  "learner.profile.logoutBtn": "Sseggas",
  "learner.parcours.title": "Iparcours-iwen",
  "learner.parcours.assigned": "iparcours iwen",
  "learner.parcours.loading": "Ikkar n i-parcours-iwen…",
  "learner.parcours.loadError": "Ur ttuɣal i-parcours-iwen.",
  "learner.parcours.noAssigned": "Ur iḥeddu iparcours",
  "learner.parcours.noAssignedDesc": "Iformateur-ik yessineḍ-ik iparcours hna.",
  "learner.parcours.completedBadge": "Iɣezzay ✓",
  "learner.parcours.by": "S",
  "learner.parcours.contents": "tacontenu",
  "learner.parcours.completedItems": "Iɣezzayen",
  "learner.parcours.emptyPath": "Ur iḥeddu tacontenu di w-parcours.",
  "learner.parcours.locked": "Iɣezzay aḥeddu d awal",
  "learner.parcours.review": "Revi",
  "learner.parcours.listen": "Sseɣ",
  "learner.parcours.open": "Sseɣ",
  "learner.modal.loading": "Ikkar…",
  "learner.modal.noEpisodes": "Ur iḥeddu tɣrigt.",
  "learner.modal.markedDone": "✓ Iɣezzay ɣef tɣrigt",
  "learner.modal.listenThenMark": "Sseɣ aḥeddu ɣef tɣrigt",
  "learner.modal.alreadyDone": "Iɣezzay ɣef tɣrigt",
  "learner.modal.markDone": "Iɣezzay ɣef tɣrigt",
  "learner.modal.formationDone": "✓ Tazrigt iɣezzay",
  "learner.modal.completeThenMark": "Iɣezzay tazrigt aḥeddu ɣef tɣrigt",
  "learner.modal.formationAlreadyDone": "Iɣezzay ɣef tazrigt",
  "learner.modal.markFormationDone": "Iḍeḍ ɣef tazrigt",
  "learner.modal.formationInstruction": "Ssiḍ ɣef yiman n tazrigt-agi deg lqim, ɣef wayen, ɣef ɣeṭṭeḍ ɣef tazrigt-agi ɣef tazrigt-ik.",
  "learner.modal.launchFormation": "Ssen tazrigt",
  "learner.modal.openFormationHint": "Ssiḍ tazrigt deg uselmad n yid, ɣef wayen, ɣef ɣeṭṭeḍ ɣef tazrigt-ik.",
  "learner.home.loadingHome": "Ssen ɣef tazrigt-ik…",
  "learner.home.noFormationsAssigned": "Ur yella tazrigt nniḍen ɣef wayen. Iḍeḍen ɣef wayen ɣef ma yefkaḍ-ik umḍak.",
  "learner.home.loadingPaths": "Ssen ɣef yiman-ik…",
  "learner.home.noPathsAssigned": "Ur yella yiman nniḍen ɣef wayen. Iḍeḍen ɣef wayen ɣef ma yefkaḍ-ik umḍak.",
  "learner.home.byTheme": "Iɣewwa n yiman-ik",
  "learner.home.themesHint": "Iɣewwa yella ɣef yid n tazrigt-ik akked podcasts nniḍen.",
  "learner.home.categoryOther": "Aḍris",
  "learner.home.contentsCount_one": "{{count}} tazrigt",
  "learner.home.contentsCount_other": "{{count}} tazrigt",
  "learner.home.viewThemeFormations": "Sseḍ ɣef {{count}} tazrigt n yiman",
  "learner.home.viewThemePodcasts": "Sseḍ ɣef {{count}} podcasts n yiman",
  "learner.home.resumeSubtitleProgress": "Tazrigt {{percent}} %",
  "learner.home.resumeSubtitleNotStarted": "Ur ssen ɣef wayen",
  "learner.home.podcastsAssigned": "Podcasts nniḍen",
  "learner.home.viewAllPodcasts": "Sseḍ ɣef wayen →",
  "learner.home.gamificationHomeHint": "Tazrigt n badges akked tazrigt yella deg uselmad « Ma tazrigt ».",
  "learner.home.gamificationHomeCta": "Ssen ma tazrigt",
  "learner.podcasts.mineTitle": "Iɣewwa n podcasts-ik",
  "learner.podcasts.episodeCount_one": "{{count}} iḍeḍ",
  "learner.podcasts.episodeCount_other": "{{count}} iḍeḍen",
  "learner.progress.loading": "Ssen ɣef tazrigt-ik…",
  "learner.progress.statPodcastsCompleted": "Podcasts iḍeḍen",
  "learner.progress.statTimeFormationsHours": "Waṭas ɣef tazrigt (s)",
  "learner.progress.statAssignedContents": "Tazrigt nniḍen",
  "learner.progress.weeklyEstimated": "Tazrigt n 7 iḍeḍen n yid (nniḍen)",
  "learner.progress.badgesSoon": "Badges akked tazrigt yella ɣef wayen deg uselmad-ik.",
  "learner.progress.gamificationSection": "Aḍris akked tazrigt",
  "learner.progress.gamificationLevelLine": "Aḍris {{level}} — {{name}}",
  "learner.progress.gamificationXpToNext": "Iḍeḍ {{xp}} XP ɣef aḍris nniḍen",
  "learner.progress.rewardFormation": "Tazrigt iḍeḍ",
  "learner.progress.rewardPathItem": "Aḍris n tazrigt",
  "learner.progress.rewardPathComplete": "Tazrigt iḍeḍ",
  "learner.progress.rewardDesignerBlocks": "Puan n tazrigt (blocs)",
  "learner.progress.rewardDesignerPerfect": "Bonus n tazrigt perfect",
  "learner.progress.rewardDesignerBadge": "Badge n tazrigt",
  "learner.progress.rewardDesignerBadgeNoXp": "Ur yella puan XP (tazrigt n tazrigt)",
  "learner.progress.badgesEmpty": "Ssiḍ tazrigt ur tazrigt-ik ɣef wayen ɣef ma yefkaḍ-ik puan akked tazrigt-ik.",
  "learner.progress.plusXp": "+{{xp}} XP",
  "learner.progress.noRecentHint": "Akkud n tazwart nniḍen. Fteḥ i tmeddurt neɣ i podcast ɣef uḍu nniḍen.",
  "learner.progress.hoursShort": "{{hours}} ɣ",
  "learner.profile.statFormationsRatio": "Tmeddurt (tazwarat / tazwart)",
  "learner.profile.statTimeFormations": "Tazwart n tmeddurt (ɣ)",
  "learner.profile.statPodcastsAssigned": "Podcasts yellan",
  "learner.profile.statPathsAssigned": "Parcours yellan",
  "learner.profile.memberSincePrefix": "Membre s wawal {{date}}",
  "learner.parcours.playPath": "Ssuḍ i tmeddurt",
  "learner.parcours.playPathTitle": "Fteḥ i tmeddurt ɣef tazwart nniḍen di tabḍa nniḍen",
  "learner.parcours.steps_zero": "Akkud n tazwar",
  "learner.parcours.steps_one": "1 tazwar",
  "learner.parcours.steps_other": "{{count}} tazwart",
  "learner.parcours.doneBadge": "Tazwar",
  "learner.parcours.completedSingle": "{{done}}/{{total}} tazwart",
  "learner.parcours.completedPlural": "{{done}}/{{total}} tazwart",
  "learner.parcours.byAuthor": "S wawal {{firstName}} {{lastName}}",
  "learner.parcours.pathListAria": "Llist n tmeddurt",
  "learner.parcours.assignedCount_one": "{{count}} tmeddurt yellan",
  "learner.parcours.assignedCount_other": "{{count}} tmeddurt yellan",
  "learner.pathPlayer.loading": "Tazwart n tmeddurt…",
  "learner.pathPlayer.errorGeneric": "Aḍris",
  "learner.pathPlayer.pathNotFound": "Tmeddurt ur ttuḍin",
  "learner.pathPlayer.loadError": "Ur nsaḥ i tmeddurt.",
  "learner.pathPlayer.backToPaths": "Sɣur i tmeddurt",
  "learner.pathPlayer.showTocAria": "Fhḍ i tazwart",
  "learner.pathPlayer.prevActivityAria": "Tazwart nniḍen",
  "learner.pathPlayer.prev": "Nniḍen",
  "learner.pathPlayer.nextActivityAria": "Tazwart nniḍen",
  "learner.pathPlayer.next": "Ssuḍ",
  "learner.pathPlayer.closePlayerTitle": "Sserḥ i tmeddurt",
  "learner.pathPlayer.close": "Sserḥ",
  "learner.pathPlayer.congrats": "Tazmert",
  "learner.pathPlayer.pathCompleteTitle": "Tmeddurt tamurt",
  "learner.pathPlayer.pathCompleteBody": "Tzert i tazwart nniḍen n tmeddurt « {{title}} ». ",
  "learner.pathPlayer.activitiesCompleted_one": "{{count}} tazwart tazert",
  "learner.pathPlayer.activitiesCompleted_other": "{{count}} tazwart tazert",
  "learner.pathPlayer.seeMyPaths": "Fhḍ i tmeddurt nniḍen",
  "learner.pathPlayer.closeTocAria": "Sserḥ i tazwart",
  "learner.pathPlayer.tocNavAria": "Tazwart n tmeddurt",
  "learner.pathPlayer.pathTypeLabel": "Tmeddurt n tazwart",
  "learner.pathPlayer.noDescription": "Akkud n tazwart.",
  "learner.pathPlayer.activityCount_zero": "Akkud n tazwart",
  "learner.pathPlayer.activityCount_one": "1 tazrigt",
  "learner.pathPlayer.activityCount_other": "{{count}} tazrigt",
  "learner.pathPlayer.progressPercent": "Tazrigt {{percent}}%",
  "learner.pathPlayer.quit": "Ssefru",
  "learner.pathPlayer.summary": "Akhbar",
  "learner.pathPlayer.outsideModule": "Dda module",
  "learner.pathPlayer.moduleContents": "Imazighen n module",
  "learner.pathPlayer.step": "Tazrigt",
  "learner.pathPlayer.podcastHint": "Smaâ l'épisode, ssenna tazrigt amek tzemreḍ.",
  "learner.pathPlayer.showChapters": "Ssefru yid n chapters",
  "learner.pathPlayer.hideChapters": "Sserḥu yid n chapters",
  "learner.pathPlayer.showText": "Ssefru l'text",
  "learner.pathPlayer.hideText": "Sserḥu l'text",
  "learner.pathPlayer.selectEpisode": "Sselḍu épisode i tzemreḍ.",
  "learner.pathPlayer.loadingShort": "Ssefru...",
  "learner.pathPlayer.noEpisodes": "Ala yid épisode i d-ttwafaq.",
  "learner.pathPlayer.listenThenMark": "Smaâ amek tzemreḍ",
  "learner.pathPlayer.updating": "Ssefru...",
  "learner.pathPlayer.alreadyDone": "Dda tzemreḍ",
  "learner.pathPlayer.markComplete": "Tzemreḍ amek tzemreḍ",
  "learner.pathPlayer.nextStepBtn": "Tazrigt n tazrigt",
  "learner.pathPlayer.embeddedFormationHint": "Tazrigt tssna d-ttwafaq i l'parcours. Ussin l'akhbar i l'ghurfa n tazrigt.",
  "learner.pathPlayer.loadingFormation": "Ssefru n tazrigt...",
  "learner.pathPlayer.loadingReader": "Ssefru n l'lecteur...",
  "learner.pathPlayer.emptyPathTitle": "Ala yid parcours i d-ttwafaq d tazrigt.",
  "learner.pathPlayer.emptyPathDesc": "Imazighen yid d-ttwafaq i l'organisme n tazrigt. Tzemreḍ ssefru aṭṭas u tzemreḍ d-ttwafaq.",
  "learner.pathPlayer.pickActivity": "Sselḍu tazrigt i l'akhbar i tzemreḍ.",
  "learner.pathPlayer.footerStep": "Tazrigt {{current}} / {{total}}",
  "learner.pathPlayer.unmute": "Aẓru l'son",
  "learner.pathPlayer.mute": "Sserḥu l'son",
  "learner.activity.flowCompleted": "Tazrigt « {{title}} » tzemreḍ",
  "learner.activity.flowProgress": "Tazrigt « {{title}} » — {{progress}} %",
  "learner.activity.podcast": "Podcast « {{title}} »",
  "learner.webinars.durationMin": "{{m}} min",
  "learner.webinars.durationH": "{{h}} h",
  "learner.webinars.durationHM": "{{h}} h {{m}}",
  "learner.formations.durationHours": "{{hours}} h",
  "rh.page.documentTitle": "Pilotage RH - LyrraOne",
  "rh.dashboard.title": "Tableau de bord RH",
  "rh.dashboard.subtitle": "Vue d’ensemble tazrigt & tazrigt n l'ghurfa",
  "rh.dashboard.activeCampaigns": "Campagnes actives",
  "rh.dashboard.pendingAssignmentsKpi": "Assignations (i d-ttwafaq / i d-ttwafaq)",
  "rh.dashboard.pendingRequestsCount": "Iggur n tazrigt",
  "rh.dashboard.completionRateLabel": "Tawt n tazrigt (parcours)",
  "rh.dashboard.budgetUsed": "Azzay n tazrigt yufka",
  "rh.dashboard.budgetNotSet": "Ur nsen",
  "rh.dashboard.progressLabel": "Tawt (%)",
  "rh.dashboard.chartCampaignsTitle": "Tawt n tazrigt",
  "rh.dashboard.chartFormationsTitle": "Tawt n tazrigt (inscriptions)",
  "rh.dashboard.campaignProgress": "Azzay n tazrigt",
  "rh.dashboard.chartCampaignsHint": "Tawt amaynut n tazrigt n tazrigt.",
  "rh.dashboard.chartFormationsHint": "Tazrigt n tazrigt i d-yuḍen (s n tazrigt i d-ttwafqen).",
  "rh.dashboard.upcomingDeadlines": "Iḍu n tazrigt i d-ttwafqen",
  "rh.dashboard.recentActivity": "Aḍris n tazrigt",
  "rh.dashboard.recentActivityHint": "Tazrigt n tazrigt d-yuḍen.",
  "rh.dashboard.viewAll": "Ssaḍ yellan",
  "rh.dashboard.exportReport": "Sgud aḍris",
  "rh.dashboard.exportSoon": "Sgud yufka s tazrigt.",
  "rh.dashboard.newCampaign": "Tazrigt n uḍu",
  "rh.dashboard.createCampaign": "Sgud tazrigt",
  "rh.dashboard.reviewRequests": "Sgud iggur n tazrigt",
  "rh.dashboard.skillsMap": "Tazrigt n tazrigt",
  "rh.dashboard.budgetOverview": "Tawt n azzay",
  "rh.dashboard.loadError": "Ur nsaḍ ad yufka tazrigt RH.",
  "rh.dashboard.emptyChart": "Ur nsen d-dat n tazrigt i d-ttwafqen.",
  "rh.dashboard.emptyDeadlines": "Ur nsen d-idd n tazrigt i d-ttwafqen.",
  "rh.dashboard.emptyRecent": "Ur nsen d-aḍris n tazrigt.",
  "rh.dashboard.kindAssignment": "Tazrigt",
  "rh.dashboard.kindCompletion": "Parcours terminé",
  "rh.dashboard.justNow": "Ssaḍ",
  "rh.dashboard.learnerInsightTitle": "Tazrigt n tazrigt (d-dat n tazrigt)",
  "rh.dashboard.learnerInsightHint": "Inscriptions n tazrigt i d-yuḍen: scores n tazrigt, friction per bloc, tazrigt n tazrigt.",
  "rh.dashboard.enrollmentsTotal": "Inscriptions",
  "rh.dashboard.completionGlobal": "Complétés",
  "rh.dashboard.avgTimePerEnrollment": "Tawt amaynut / inscription",
  "rh.dashboard.notStarted": "Ur nsen",
  "rh.dashboard.stalled": "D-ttwafqen (>30 j. ur nsen tazrigt)",
  "rh.dashboard.topFlowsDetail": "Parcours les plus suivis",
  "rh.dashboard.colFlow": "Parcours",
  "rh.dashboard.colEnrolled": "Inscrits",
  "rh.dashboard.colCompletedPct": "Complétion",
  "rh.dashboard.colAvgTime": "Tawt amaynut",
  "rh.dashboard.colAvgScore": "Score moy.",
  "rh.dashboard.blockFrictionTitle": "Blocs les plus frictionnels (sessions ≥3)",
  "rh.dashboard.colBlock": "Bloc",
  "rh.dashboard.colSessions": "Sessions",
  "rh.dashboard.colBlockCompletion": "Complétion bloc",
  "rh.dashboard.recentEvalTitle": "Dernières évaluations",
  "rh.dashboard.evalComment": "Commentaire",
  "rh.dashboard.exportOk": "Export CSV téléchargé.",
  "rh.dashboard.exportFail": "Échec du téléchargement.",
  "institution.dashboard.trainingCardTitle": "Suivi formations (inscriptions)",
  "institution.dashboard.trainingCardHint": "Vue agrégée sur tous les parcours de l’établissement.",
  "institution.dashboard.trainingCompleted": "parcours terminés",
  "institution.dashboard.trainingAvgMinutes": "min moy. / inscription",
  "rh.status.urgent": "Urgent",
  "rh.status.soon": "Proche",
  "rh.status.upcoming": "À venir",
  "rh.status.pending": "En cours",
  "rh.status.approved": "Terminé",
  "rh.status.rejected": "Annulé",
  "admin.nav.stats": "Statistiques",
  "admin.nav.users": "Utilisateurs",
  "admin.nav.support": "Support et chat",
  "admin.nav.institutions": "Établissements",
  "admin.nav.contracts": "Contrats",
  "admin.nav.editors": "Éditeurs",
  "admin.nav.podcasts": "Podcasts",
  "admin.nav.sounds": "Sons Lyrra",
  "admin.nav.templates": "Templates formations",
  "admin.nav.demoFormations": "Formations démo",
  "admin.nav.templatesImages": "Modèles d’image",
  "admin.nav.tools": "Outils",
  "admin.nav.files": "Fichiers",
  "admin.nav.logs": "Journaux",
  "admin.nav.webhooks": "Webhooks",
  "admin.nav.email": "Email",
  "admin.nav.docusign": "DocuSign",
  "admin.docusign.title": "Intégration DocuSign",
  "admin.docusign.subtitle": "Clé d’intégration, identifiants API et clé privée RSA (JWT). Stockés en base, plus dans Docker.",
  "admin.docusign.statusOk": "Configuré",
  "admin.docusign.statusIncomplete": "Incomplet",
  "admin.docusign.keyStored": "Clé privée enregistrée",
  "admin.docusign.consentHint": "Pour la première utilisation JWT, le compte DocuSign doit avoir accepté le consentement d’application (URL fournie par DocuSign). En cas d’erreur 401/403, vérifiez la clé PEM, la clé d’intégration et ce consentement.",
  "admin.docusign.loading": "Chargement…",
  "admin.docusign.loadError": "Impossible de charger la configuration DocuSign",
  "admin.docusign.saved": "Paramètres DocuSign enregistrés",
  "admin.docusign.saveError": "Akkud nniḍen ur ttuɣal",
  "admin.docusign.save": "Ssaḍ",
  "admin.docusign.reload": "Ssaḍ nniḍen",
  "admin.docusign.fieldIntegrationKey": "Akkud n tazmert (ID n umḍak / client ID)",
  "admin.docusign.fieldUserId": "ID n umḍak DocuSign (GUID)",
  "admin.docusign.fieldAccountId": "ID n uḍil (account ID)",
  "admin.docusign.fieldBasePath": "URL n tazmert n API REST",
  "admin.docusign.fieldOauthHost": "Akkud OAuth (ur d-https://)",
  "admin.docusign.fieldRsa": "Akkud n tazmert RSA (PEM)",
  "admin.docusign.oauthPlaceholder": "account-d.docusign.com",
  "admin.docusign.rsaPlaceholderKeep": "Ssaḍ nniḍen i tazmert nniḍen",
  "admin.docusign.rsaPlaceholderNew": "Ssaḍ nniḍen i tazmert .pem (BEGIN … END)",
  "admin.smtp.cardTitle": "Ssend n email (SMTP)",
  "admin.smtp.subtitle": "Akkud, port, tazmert d-ussan akked umḍak. Yewwiḍen di tazmert — ur d-variables Docker SMTP_* wala EMAIL_FROM.",
  "admin.smtp.host": "Akkud SMTP (hôte)",
  "admin.smtp.port": "Port",
  "admin.smtp.secure": "TLS/SSL (port 465)",
  "admin.smtp.user": "Umḍak",
  "admin.smtp.password": "Akkud n ussan",
  "admin.smtp.passwordPlaceholder": "Ssaḍ nniḍen i tazmert nniḍen",
  "admin.smtp.passwordPlaceholderNew": "Akkud n ussan SMTP",
  "admin.smtp.fromEmail": "Email n umḍak",
  "admin.smtp.fromName": "Ism n umḍak (From)",
  "admin.smtp.hint": "Akkud n umḍak d-usin + ussan. Tessaḍ di tazmert n umḍak (email n tessaḍ) ssaḍ nniḍen.",
  "admin.smtp.save": "Ssaḍ SMTP",
  "admin.smtp.saved": "Akkud n SMTP yewwiḍen",
  "admin.smtp.saveError": "Akkud nniḍen ur ttuɣal",
  "admin.smtp.loadError": "Ur ttuɣal ad yewwiḍ SMTP",
  "admin.smtp.loading": "Yewwiḍ…",
  "admin.smtp.configured": "Akkud yewwiḍen",
  "admin.smtp.notConfigured": "Aẓuḍ",
  "admin.nav.smtp": "Tazmert SMTP",
  "admin.nav.regulatoryWatch": "Veille Lyrra",
  "admin.nav.leBref": "Le Bref",
  "admin.nav.helpCenter": "Aḍris n tazmert",
  "admin.nav.platform": "Tazmert n tazmert",
  "admin.nav.eduflowPalette": "Palette EduFlow",
  "admin.users.adminScopeTitle": "Akkud n tazmert n umḍak",
  "admin.users.adminScopeFull": "Akkud nniḍen (tazmert n yid)",
  "admin.users.adminScopeRestricted": "Akkud nniḍen i tazmert n yid",
  "admin.users.adminScopeHint": "Akkud n umḍak ur d-yeḍḍen illa di tazmert n yid. Ssaḍ nniḍen i tazmert n yid, aḍu iḥeddu ad yewwiḍ (wala ssaḍ nniḍen i tazmert n yid) iḥeddu ad yewwiḍ tazmert akked tazmert API.",
  "admin.users.adminScopeNeedOne": "Ssaḍ aḍu i tazmert n yid, wala ssaḍ nniḍen i akkud nniḍen.",
  "admin.helpCenter.title": "Tiznit n tazmert",
  "admin.helpCenter.subtitle": "Iḍraren yefka d tazmert s /aide akked /help : tazmert, titr, tazmert n tazmert akked llink (tiznit /… neɣ URL https) ifka d uḍḍa s wul.",
  "admin.helpCenter.reload": "Aḍu",
  "admin.helpCenter.loadError": "Aḍu ur ttuɣal.",
  "admin.helpCenter.saveError": "Aḍu ur ttuɣal.",
  "admin.helpCenter.deleteError": "Aḍu ur ttuɣal.",
  "admin.helpCenter.saved": "Iḍu",
  "admin.helpCenter.deleted": "Iḍu",
  "admin.helpCenter.catCreated": "Tazmert iḍu",
  "admin.helpCenter.topicCreated": "Fiche iḍu",
  "admin.helpCenter.catTitleRequired": "Titr n tazmert d aḍu.",
  "admin.helpCenter.topicFieldsRequired": "Titr akked llink n tazmert d aḍu.",
  "admin.helpCenter.newCategory": "Tazmert nniḍen",
  "admin.helpCenter.createCategory": "Tazmert nniḍen",
  "admin.helpCenter.editCategory": "Ssned tazmert",
  "admin.helpCenter.createTopic": "Fiche nniḍen",
  "admin.helpCenter.editTopic": "Ssned fiche",
  "admin.helpCenter.fieldTitle": "Titr",
  "admin.helpCenter.fieldDescription": "Tazmert",
  "admin.helpCenter.fieldIconKey": "Ikoni Lucide",
  "admin.helpCenter.fieldIconKeyHint": "Sselḍi ikoni ; aḍu yefka d uḍḍa s wul akked ɣef lbutton.",
  "admin.helpCenter.fieldFormationUrl": "Llink n tazmert",
  "admin.helpCenter.formationPickPlaceholder": "— Sselḍi tazmert nniḍen —",
  "admin.helpCenter.formationPickHint": "Iḍraren yefka d tazmert nniḍen yefka d uḍḍa s laccess public ur ttuɣal.",
  "admin.helpCenter.formationPickLoading": "Aḍu n tazmert…",
  "admin.helpCenter.publicFlowsLoadError": "Ur ttuɣal d llist n tazmert nniḍen.",
  "admin.helpCenter.legacyFormationPickLabel": "Llink iḍu (ur d llist)",
  "admin.helpCenter.fieldSort": "Tazmert",
  "admin.helpCenter.fieldActive": "Yefka",
  "admin.helpCenter.save": "Iḍu",
  "admin.helpCenter.edit": "Ssned",
  "admin.helpCenter.addTopic": "Fiche",
  "admin.helpCenter.empty": "Ur yettwasen tazmert. Sselḍi tazmert akked s fiches.",
  "admin.helpCenter.noTopics": "Ur yettwasen fiches d wul tazmert.",
  "admin.helpCenter.badgeActive": "Yefka",
  "admin.helpCenter.badgeInactive": "Mesked",
  "admin.helpCenter.iconLabel": "Ikoni",
  "admin.helpCenter.confirmDeleteCategory": "Ssupprimi tazmert aḍu akked yewwi s fiches ?",
  "admin.helpCenter.confirmDeleteTopic": "Ssupprimi fiche ?",
  "admin.nav.formationMigration": "Migration n tazmert",
  "admin.nav.formationDuplicate": "Duplication n tazmert",
  "admin.nav.lyrraOneFormations": "Tazmert n LyrraOne",
  "admin.lyrraOneFormations.title": "Tazrigt n LyrraOne",
  "admin.lyrraOneFormations.subtitle": "Ssaḥḍiḍ ɣef tazrigt n LyrraOne : amekka n tazrigt yella d-ssin (aḥric n PLATFORM_EDUFLOW_OWNER_USER_ID neɣ aḥric n yid n tazrigt), les collaborateurs yella d-ssin, akked yella d-ssin les administrateurs ɣef tazrigt di designer.",
  "admin.lyrraOneFormations.searchLabel": "Taqsiṭ (tazrigt neɣ ID n tazrigt)",
  "admin.lyrraOneFormations.searchPlaceholder": "Ex. onboarding neɣ UUID…",
  "admin.lyrraOneFormations.search": "Taqsiṭ",
  "admin.lyrraOneFormations.searchMin": "Ssaḥḍiḍ ɣef 2 tazrigt.",
  "admin.lyrraOneFormations.results": "Iḥeḍran",
  "admin.lyrraOneFormations.noResults": "Aucun tazrigt yella.",
  "admin.lyrraOneFormations.badge": "LyrraOne",
  "admin.lyrraOneFormations.detailHint": "Le créateur akked les anciens collaborateurs yella d-ssin ɣef tazrigt. Les apprenants akked le lecteur public ur yella d-ssin.",
  "admin.lyrraOneFormations.assign": "Ssaḥḍiḍ ɣef LyrraOne",
  "admin.lyrraOneFormations.alreadyAssigned": "D-ssin ɣef LyrraOne",
  "admin.lyrraOneFormations.confirm": "Tazrigt n LyrraOne yella d-ssin? Tazrigt yella d-ssin ur ttuḍiḍ ɣef w-aḥric : tazrigt ur yella d-ssin ɣef les administrateurs n tazrigt.",
  "admin.lyrraOneFormations.success": "Tazrigt « {{title}} » : ssaḥḍiḍ ɣef LyrraOne yella d-ssin.",
  "admin.lyrraOneFormations.assignedListTitle": "Tazrigt yella d-ssin ɣef LyrraOne",
  "admin.lyrraOneFormations.assignedListEmpty": "Aucun tazrigt ɣef w-aḥric. Ssaḥḍiḍ ɣef taqsiṭ ɣef w-aḥric ɣef ssaḥḍiḍ.",
  "admin.lyrraOneFormations.refreshList": "Aṭṭaḥ ɣef llist",
  "admin.lyrraOneFormations.openDesigner": "Designer",
  "admin.lyrraOneFormations.assignSectionTitle": "Taqsiṭ akked ssaḥḍiḍ ɣef tazrigt akher",
  "admin.lyrraOneFormations.publicPolicyHint": "Les tazrigt yella d-ssin ɣef LyrraOne yella d-ssin ɣef tazrigt, yella d-ssin ɣef ur yella d-ssin (lien /f/…) akked yella d-ssin ɣef tazrigt (QR, iframe n centre d’aide).",
  "admin.lyrraOneFormations.drawerTitle": "Lien public & QR code",
  "admin.lyrraOneFormations.publicShortLink": "Lien court (recommandé)",
  "admin.lyrraOneFormations.publicLongLink": "Lien lecteur public (UUID)",
  "admin.lyrraOneFormations.copy": "Ssaḥḍiḍ",
  "admin.lyrraOneFormations.copied": "Ssaḥḍiḍ ɣef l-presse-papiers.",
  "admin.lyrraOneFormations.copyFailed": "Ur yella d-ssin (navigateur neɣ permissions).",
  "admin.lyrraOneFormations.publicLinksUnavailable": "Liens ur yella d-ssin : ssaḥḍiḍ ɣef tazrigt public neɣ ssaḥḍiḍ « Mettre à jour l’accès public » ma tazrigt yella d-ssin ɣef w-aḥric.",
  "admin.lyrraOneFormations.publicIncomplete": "Accès public ur yella d-ssin",
  "admin.lyrraOneFormations.publicRepairHint": "Ce tazrigt yella d-ssin ɣef LyrraOne walakin ur yella d-ssin ɣef les réglages publics complets (publication, accès anonyme, code court).",
  "admin.lyrraOneFormations.publicRepairCta": "Mettre à jour l’accès public",
  "admin.lyrraOneFormations.publicRepairOk": "Accès public yella d-ssin ɣef « {{title}} ». ",
  "admin.formationDuplicate.title": "Dupliquer une formation ɣef tazrigt akher",
  "admin.formationDuplicate.subtitle": "Taqsiṭ ɣef tazrigt, ssaḥḍiḍ tazrigt akked aḥric n tazrigt n tazrigt. Tazrigt n l-ijja ur yella d-ssin. La copie yella d-brouillon (ur yella d-ssin catalogue, sessions neɣ collaborateurs).",
  "admin.formationDuplicate.searchLabel": "Taqsiṭ (tazrigt neɣ ID n tazrigt)",
  "admin.formationDuplicate.searchPlaceholder": "Ex. onboarding neɣ UUID…",
  "admin.formationDuplicate.search": "Taqsiṭ",
  "admin.formationDuplicate.searchMin": "Ssaḥḍiḍ ɣef 2 tazrigt.",
  "admin.formationDuplicate.results": "Iḥeḍran",
  "admin.formationDuplicate.noResults": "Aucun tazrigt yella.",
  "admin.formationDuplicate.currentOwner": "Aḥric n tazrigt",
  "admin.formationDuplicate.currentInstitution": "Tazrigt n l-ijja",
  "admin.formationDuplicate.targetInstitution": "Tazrigt n l-copie",
  "admin.formationDuplicate.pickInstitution": "Ssar asnaw…",
  "admin.formationDuplicate.newOwner": "Ameqqran n tazart (amuddu / RH)",
  "admin.formationDuplicate.pickOwner": "Ssar akont…",
  "admin.formationDuplicate.noCandidates": "Ur yella akont iḍelliḍ deg-sent asnaw.",
  "admin.formationDuplicate.duplicate": "Dduplika tazart",
  "admin.formationDuplicate.confirm": "Ssnif a copy n tazart aɣer akont iḍelliḍ? Tazart n tazart ur tḥeddar ara.",
  "admin.formationDuplicate.success": "Copy ssnif: « {{title}} » iḍelliḍ i {{email}}. Iḍel n tazart n uḍu: {{newFlowId}}.",
  "admin.formationDuplicate.loadInstitutionsError": "Ur nsaḥ aḍuḍ n asnaw.",
  "admin.formationDuplicate.loadCandidatesError": "Ur nsaḥ aḍuḍ n akont iḍelliḍ.",
  "admin.formationMigration.title": "Migra tazart iḍelliḍen",
  "admin.formationMigration.subtitle": "Ssar tazart EduFlow, ssar asnaw n tazart n tazart u akont iḍelliḍ (amuddu, RH, etc.). Iḍelliḍen akked asnaw n tazart yewwiḍen; iḍelliḍen catalog, kampanyat akked imaziɣen n asnaw n yidwen yewwiḍen.",
  "admin.formationMigration.searchLabel": "Ttawt (tazart neɣ ID n tazart)",
  "admin.formationMigration.searchPlaceholder": "Ex. onboarding neɣ UUID…",
  "admin.formationMigration.search": "Ssar",
  "admin.formationMigration.searchMin": "Ssar 2 yid n tazart.",
  "admin.formationMigration.results": "Iḥedran",
  "admin.formationMigration.noResults": "Ur yella tazart iḍelliḍ.",
  "admin.formationMigration.currentOwner": "Ameqqran n tazart",
  "admin.formationMigration.currentInstitution": "Asnaw n tazart",
  "admin.formationMigration.targetInstitution": "Asnaw n tazart n tazart",
  "admin.formationMigration.pickInstitution": "Ssar asnaw…",
  "admin.formationMigration.newOwner": "Ameqqran n uḍu (amuddu / RH)",
  "admin.formationMigration.pickOwner": "Ssar akont…",
  "admin.formationMigration.noCandidates": "Ur yella akont iḍelliḍ deg-sent asnaw.",
  "admin.formationMigration.migrate": "Migra tazart",
  "admin.formationMigration.confirm": "Ssnif a migra? Iḍelliḍen akked asnaw yewwiḍen, iḍelliḍen RH/catalog ur yewwiḍen neɣ ur yewwiḍen.",
  "admin.formationMigration.success": "Migra ssnif: « {{title}} » d-yeḍelliḍ i {{email}}.",
  "admin.formationMigration.clearedCatalog": "Iḍel n fich catalog yewwiḍ (fich n asnaw n yidwen).",
  "admin.formationMigration.loadInstitutionsError": "Ur nsaḥ aḍuḍ n asnaw.",
  "admin.formationMigration.loadCandidatesError": "Ur nsaḥ aḍuḍ n akont iḍelliḍ.",
  "admin.regulatoryWatch.title": "Veille — alertes LyrraOne",
  "admin.regulatoryWatch.subtitle": "Ssnif a alerte deg timeline « Veille réglementaire » n yidwen asnaw. Iḍelliḍ ur yewwiḍen deg OF; yewwiḍen yewwiḍen, yewwiḍen akked yewwiḍen.",
  "admin.regulatoryWatch.refresh": "Aḥdith",
  "admin.regulatoryWatch.loadError": "Ur nsaḥ aḍuḍ.",
  "admin.regulatoryWatch.validationRequired": "Tazart, tazart akked src ur yellan.",
  "admin.regulatoryWatch.publishError": "Ur nsaḥ aḥdith.",
  "admin.regulatoryWatch.newBroadcastTitle": "Alaḍ n alerte n tazart",
  "admin.regulatoryWatch.placeholderTitle": "Tazart",
  "admin.regulatoryWatch.placeholderDescription": "Tazart (yewwiḍen deg OF)",
  "admin.regulatoryWatch.placeholderSource": "Iḍel neɣ referens n src",
  "admin.regulatoryWatch.category.reglementaire": "Réglementaire",
  "admin.regulatoryWatch.category.pedagogique": "Pédagogique",
  "admin.regulatoryWatch.category.technique": "Tiqniqt",
  "admin.regulatoryWatch.category.sectoriel": "Sektorial",
  "admin.regulatoryWatch.impact.fort": "Taqt fort",
  "admin.regulatoryWatch.impact.moyen": "Taqt moyen",
  "admin.regulatoryWatch.impact.faible": "Taqt faible",
  "admin.regulatoryWatch.publishing": "Tazrigt…",
  "admin.regulatoryWatch.publishButton": "Tazrig di kul l'istitution n tazrigt",
  "admin.regulatoryWatch.historyTitle": "Tazrigt & akus n tazrigt",
  "admin.regulatoryWatch.loading": "Tazrigt…",
  "admin.regulatoryWatch.empty": "Ula d tazrigt n tazrigt i yid.",
  "admin.regulatoryWatch.institutionsCount": "{{count}} istitution(s)",
  "admin.regulatoryWatch.ackProgress": "Akked: {{ack}}/{{total}} ({{pct}}%)",
  "admin.regulatoryWatch.byAuthor": "S n {{who}}",
  "admin.regulatoryWatch.unknownAuthor": "—",
  "admin.leBref.title": "Le Bref — kalandrier n tazrigt",
  "admin.leBref.subtitle": "Tazrigt n yura tazrigt di l'page amuddu /le-bref. Un seul tazrigt « tazrig » i yura n yura.",
  "admin.leBref.refresh": "Azzay",
  "admin.leBref.loadError": "Tazrigt ur tzemrem.",
  "admin.leBref.validationTitle": "Asmi n tazrigt d asgwas.",
  "admin.leBref.validationBlocks": "Ssefru d bloc (tixsi, audio, quiz ou sondage).",
  "admin.leBref.validationBlocksInvalid": "Ula d bloc n tazrigt: ssin d quiz (aswel + 2 n yid, aswel n yid d amuddu), URL n audio, akked tixsi ur tzemrem.",
  "admin.leBref.blocksHint": "Ssefru tazrigt s blocs (tixsi, médias, quiz, sondage — ur tzemrem HTML). Les anciens tazrig n format HTML yewwen i tazrigt.",
  "admin.leBref.block.text": "Tixsi",
  "admin.leBref.block.audio": "Audio",
  "admin.leBref.block.quiz": "Quiz",
  "admin.leBref.block.poll": "Sondage",
  "admin.leBref.blocksEmpty": "Ssefru d blocs (tixsi, audio, quiz, sondage). Ur tzemrem s HTML.",
  "admin.leBref.block.moveUp": "Ssaq",
  "admin.leBref.block.moveDown": "Ssefru",
  "admin.leBref.block.remove": "Ssuq bloc",
  "admin.leBref.block.textPlaceholder": "Paragraphe (tixsi n tazrigt ou tazrigt n yid)",
  "admin.leBref.block.audioUrl": "URL n fichier audio",
  "admin.leBref.block.audioCaption": "Tazrigt (asagwas)",
  "admin.leBref.block.quizQuestion": "Aswel",
  "admin.leBref.block.quizOptions": "Asnaw",
  "admin.leBref.block.optionLabel": "Asnaw",
  "admin.leBref.block.addOption": "Ssefru d asnaw",
  "admin.leBref.block.quizFeedback": "Tazrigt s tazrigt (asagwas)",
  "admin.leBref.block.pollQuestion": "Aswel n sondage",
  "admin.leBref.block.pollMulti": "Ikkal n yid",
  "admin.leBref.block.image": "Taswira",
  "admin.leBref.block.video": "Vidéo",
  "admin.leBref.block.imageUrl": "URL n tazrigt (HTTPS neɣ media yebɣa)",
  "admin.leBref.block.imageAlt": "Tazrigt n tazrigt (asɣuḍ)",
  "admin.leBref.block.imageCaption": "Tazrigt n tazrigt i d-yetḥeḍ ɣef tazrigt (aḍuḍ)",
  "admin.leBref.block.videoHint": "Lien YouTube, Vimeo neɣ URL d-ɣef video (mp4, WebM…), sɣur d-ɣef designer.",
  "admin.leBref.block.videoUrl": "URL n video",
  "admin.leBref.block.videoPoster": "Tazrigt n tazrigt (poster), URL aḍuḍ — sɣur ɣef les fichiers video yebɣa",
  "admin.leBref.block.videoCaption": "Tazrigt neɣ tazrigt (aḍuḍ)",
  "admin.leBref.block.audioTtsHint": "Tazrigt yeddu s Mistral TTS; tazrigt yeddu d-ɣef tazrigt n tazrigt (sɣur ɣef les blocs audio n designer).",
  "admin.leBref.block.audioTtsPlaceholder": "Tazrigt i yeddu ɣef tazrigt…",
  "admin.leBref.block.audioTtsGenerate": "Syntétiser (Mistral TTS)",
  "admin.leBref.block.audioTtsReady": "Audio yeddu — i d-yetḥeḍ ɣef l’enregistrement ma tazrigt t-chuḍ.",
  "admin.leBref.block.audioUrlReadonly": "Fichier audio",
  "admin.leBref.block.audioPreviewUnsupported": "Aperçu ur yeddu",
  "admin.leBref.block.audioTtsNeedText": "Saisissez d-ɣef tazrigt i yeddu.",
  "admin.leBref.block.audioTtsBadResponse": "Réponse TTS ur yeddu.",
  "admin.leBref.block.audioTtsError": "Synthèse ur yeddu (Mistral TTS / intégrations).",
  "admin.leBref.saveError": "Enregistrement ur yeddu.",
  "admin.leBref.deleteError": "Suppression ur yeddu.",
  "admin.leBref.confirmDelete": "Ssupprimer aḍuḍ n brief ?",
  "admin.leBref.quizJsonInvalid": "JSON n quiz ur yeddu.",
  "admin.leBref.aiError": "Génération IA ur yeddu (clé Mistral / intégrations plateforme).",
  "admin.leBref.prevMonth": "Aḍuḍ n yennayer",
  "admin.leBref.nextMonth": "Aḍuḍ n yennayer",
  "admin.leBref.legend": "Tazrigt",
  "admin.leBref.status.published": "Yeddu",
  "admin.leBref.status.draft": "Brouillon",
  "admin.leBref.status.archived": "Archivé",
  "admin.leBref.clickDayHint": "Cliquez aḍuḍ ɣef yennayer i d-yetḥeḍ aḍuḍ n brief ɣef tazrigt.",
  "admin.leBref.editBrief": "Modifier aḍuḍ n brief",
  "admin.leBref.newBrief": "Aḍuḍ n brief nwen",
  "admin.leBref.aiBlockTitle": "Assistant IA (Mistral)",
  "admin.leBref.aiThemePlaceholder": "Thème neɣ consigne (ex. résumé + quiz, sondage pratiques RH, URL article, lien YouTube…)",
  "admin.leBref.aiContextHint": "Précisez l’objectif : résumé, quiz, sondage d’avis, version audio, neɣ collez une URL / un lien image neɣ vidéo — l’IA d-yetḥeḍ les types n blocs (tazrigt, audio, tazrigt, video, quiz, sondage).",
  "admin.leBref.aiGenerate": "Remplir s l’IA",
  "admin.leBref.titlePlaceholder": "Tazrigt",
  "admin.leBref.excerptPlaceholder": "Chapô / extrait court",
  "admin.leBref.bodyPlaceholder": "Corps (HTML yeddu : p, strong, em, ul, li, br)",
  "admin.leBref.audioUrlPlaceholder": "URL audio aḍuḍ (mp3, etc.)",
  "admin.leBref.quizPlaceholder": "Quiz JSON aḍuḍ : {\"questions\":[{\"question\":\"…\",\"options\":[\"A\",\"B\",\"C\",\"D\"],\"correctIndex\":0,\"feedback\":\"…\"}]}",
  "admin.leBref.save": "Enregistrer",
  "admin.leBref.create": "Créer",
  "admin.leBref.resetForm": "Aḍuḍ / effacer",
  "admin.leBref.delete": "Ssupprimer",
  "admin.leBref.monthListTitle": "Ibrif n wussan",
  "admin.leBref.loading": "Izzin…",
  "admin.leBref.emptyMonth": "Ur illi iibrif di tazwara.",
  "admin.leBref.edit": "Seddel",
  "admin.smtp.pageTitle": "Tazrigt SMTP",
  "admin.smtp.pageHint": "Aserf n tazrigt i yiman n email (tazrigt, tazrigt n yid, etc.).",
  "support.chat.title": "Tazrigt Lyrra",
  "support.chat.subtitle": "Ssaḍ i tazwurt-ik: tazrigt n wul nniḍen yessawal-ik hna.",
  "support.chat.empty": "Sseḍḍi i tazwurt-ik ɣef tazrigt.",
  "support.chat.placeholder": "Tazwurt-ik…",
  "support.chat.send": "Ssend",
  "support.chat.open": "Sserḥ i tazrigt n tazrigt",
  "support.chat.fromSupport": "Tazrigt",
  "support.chat.fromYou": "Ineɣ",
  "admin.support.title": "Tazrigt n tazrigt",
  "admin.support.loadError": "Ur nelli i tazrigt.",
  "admin.support.replyError": "Ur nelli i ssawal.",
  "admin.support.selectThread": "Sselḍ i tazrigt-ik ɣef tazwurt.",
  "admin.support.replyPlaceholder": "Tazwurt-ik ɣef l'utilisateur…",
  "admin.support.sendReply": "Ssend",
  "admin.support.refresh": "Sreḍḍ",
  "admin.support.user": "Utilisateur",
  "admin.support.subject": "Tazwurt",
  "admin.support.status": "Tazrigt",
  "admin.support.priority": "Aḍris",
  "admin.support.updated": "Izzin",
  "admin.support.messages": "Tazwurt n tazrigt",
  "admin.support.newestFirst": "yesser nniḍen di llaḥ",
  "admin.support.allStatuses": "Ikkur n tazrigt",
  "admin.support.linearCreate": "Ssnif i tazrigt Linear",
  "admin.support.linearOpen": "Sserḥ di Linear",
  "admin.support.linearError": "Ur nelli i ssnif i tazrigt Linear. Sseḍḍi LINEAR_API_KEY di aserf.",
  "producerAssignments.createInDesigner": "Ssnif / sserḥ i tazrigt",
  "producerAssignments.draft": "Brouillon",
  "producerAssignments.enterprise": "Tazrigt",
  "producerAssignments.enterprisePaths": "Ikkur n tazrigt",
  "producerAssignments.episodes": "ép.",
  "producerAssignments.formations": "Fichas n tazrigt",
  "producerAssignments.markCompleted": "Smark i tazrigt",
  "producerAssignments.markInProgress": "Di tazrigt",
  "producerAssignments.markReady": "Iḍu",
  "producerAssignments.modulesCatalog": "{{count}} module(s) catalogue · mis à jour {{date}}",
  "producerAssignments.noneEnterprisePaths": "Aucune demande de parcours entreprise.",
  "producerAssignments.noneFormations": "Aucune fiche assignée.",
  "producerAssignments.nonePodcasts": "Aucun podcast assigné.",
  "producerAssignments.openInDesigner": "Ouvrir dans le designer",
  "producerAssignments.openPodcasts": "Studio podcast",
  "producerAssignments.planningDeadline": "Échéance {{date}}",
  "producerAssignments.planningFrom": "À partir du {{date}}",
  "producerAssignments.planningRange": "{{start}} → {{end}}",
  "producerAssignments.podcasts": "Podcasts à produire",
  "producerAssignments.productionStatus.completed": "Terminé",
  "producerAssignments.productionStatus.in_progress": "En cours",
  "producerAssignments.productionStatus.not_started": "Pas commencé",
  "producerAssignments.productionStatus.published": "Publié",
  "producerAssignments.publishedCatalog": "Publié catalogue",
  "producerAssignments.rhPlanning": "Planning RH",
  "producerAssignments.subtitle": "Formations à créer dans le designer et podcasts à produire, assignés par la RH.",
  "producerAssignments.title": "Mes missions de production",
  "podcasts.actions.cancel": "Annuler",
  "podcasts.actions.close": "Fermer",
  "podcasts.actions.create": "Créer",
  "podcasts.actions.edit": "Modifier",
  "podcasts.actions.retry": "Réessayer",
  "podcasts.actions.save": "Enregistrer",
  "podcasts.actions.saving": "Sauvegarde…",
  "podcasts.actions.share": "Partager",
  "podcasts.category.ariaGroup": "Catégorie du podcast",
  "podcasts.category.emptyBanner": "Ajoutez des catégories dans l'espace Institution pour mieux organiser les podcasts.",
  "podcasts.category.emptyInstitutionHint": "Aucune catégorie institution pour l'instant — vous pouvez publier sans.",
  "podcasts.category.noneChip": "Sans catégorie",
  "podcasts.category.sectionTitle": "Catégorie",
  "podcasts.category.withCategoriesHint": "Classement dans le catalogue et filtres côté institution.",
  "podcasts.cover.ariaDropzone": "Choisir ou déposer une image de couverture",
  "podcasts.cover.browseFiles": "parcourir les fichiers",
  "podcasts.cover.cancelNewFile": "Annuler le nouveau fichier",
  "podcasts.cover.dragDrop": "Glissez-déposez une image",
  "podcasts.cover.dropHere": "Déposez l'image ici",
  "podcasts.cover.errorMaxSize": "L'image ne doit pas dépasser 5 Mo.",
  "podcasts.cover.errorUnsupportedFormat": "Format d'image non supporté.",
  "podcasts.cover.formatsHint": "PNG, JPG, WebP, GIF · max 5 Mo",
  "podcasts.cover.help": "Format carré recommandé. Glissez-déposez un fichier ou cliquez pour parcourir.",
  "podcasts.cover.or": "ou",
  "podcasts.cover.replaceHint": "Ssar l'image",
  "podcasts.cover.sectionTitle": "Image n tazwart",
  "podcasts.deleteDialog.body": "« {{title}} » yella yeddu s yid. Iḍeḍ n yid yellan d-ttwalt ɣef a podcast aḥed. Iḍeḍ n yid iḍen d-ttwalt ɣef podcasts ɣer yellan. A administrateur yella yeddu s yid iḍeḍ n podcast s yid n institution.",
  "podcasts.deleteDialog.confirm": "Ssar s yid",
  "podcasts.deleteDialog.title": "Ssar a podcast s yid ?",
  "podcasts.editPanel.createdOn": "Ssar le ",
  "podcasts.editPanel.headerTitle": "Ssar a podcast",
  "podcasts.editPanel.saving": "Ssar…",
  "podcasts.editPanel.statsEpisodes": "Iḍeḍ : ",
  "podcasts.editPanel.statsSubscribers": "Abonnés : ",
  "podcasts.editPanel.successSaved": "Tazwart n yid yella yeddu",
  "podcasts.episodeStatus.draft": "Brouillon",
  "podcasts.episodeStatus.published": "Publié",
  "podcasts.episodesPanel.addEpisode": "Ssar iḍeḍ",
  "podcasts.episodesPanel.emptySubtitle": "Ssar iḍeḍ s a podcast",
  "podcasts.episodesPanel.emptyTitle": "Aucun iḍeḍ",
  "podcasts.episodesPanel.episodeCount": "{{count}} iḍeḍ(ⴰ)",
  "podcasts.episodesPanel.noEpisodeAvailable": "Aucun iḍeḍ yella",
  "podcasts.episodesPanel.remove": "Retirer",
  "podcasts.episodesPanel.searchPlaceholder": "Rechercher un iḍeḍ…",
  "podcasts.episodesPanel.title": "Iḍeḍ n a podcast",
  "podcasts.pdfImport.openButton": "Importer un document",
  "podcasts.pdfImport.pickPodcastTitle": "Ssar a podcast n tazwart",
  "podcasts.pdfImport.noPodcast": "Ssar a podcast aḥed ur nḥeb s yid.",
  "podcasts.pdfImport.noPodcastMatch": "Aucun podcast ur yella d-ttwalt.",
  "podcasts.list.actionImportDocument": "Importer un document (PDF ou Markdown)",
  "podcasts.pdfImport.title": "Importer un document (PDF ou Markdown)",
  "podcasts.pdfImport.subtitle": "Ssar iḍeḍ n a podcast « {{podcast}} » s yid n tazwart",
  "podcasts.pdfImport.hint": "Le document yella yeddu s yid : Titre 1 / # → iḍeḍ, Titre 2 / ## → chapitre, paragraphes → blocs. Les PDF yella yeddu s yid n Markdown ɣef relecture d-ttwalt. Formats : PDF ou .md.",
  "podcasts.pdfImport.convertingPdf": "Ssar n PDF s yid n Markdown…",
  "podcasts.pdfImport.markdownReviewTitle": "Valider le Markdown généré",
  "podcasts.pdfImport.markdownReviewSubtitle": "Podcast « {{podcast}} » — Markdown yella yeddu s yid n PDF. Relisez, corrigez les titres (# / ##) puis validez.",
  "podcasts.pdfImport.markdownReviewHint": "Vérifiez que chaque iḍeḍ yella yeddu s # d-ttwalt chaque chapitre s ##. Vous pouvez corriger le texte avant de continuer.",
  "podcasts.pdfImport.markdownEditorLabel": "Contenu Markdown",
  "podcasts.pdfImport.markdownEditorHint": "# Iḍeḍ · ## Chapitre · paragraphes = blocs n script",
  "podcasts.pdfImport.validateMarkdown": "Valider d-ttwalt s yid n tazwart",
  "podcasts.pdfImport.editMarkdown": "Modifier le Markdown",
  "podcasts.pdfImport.markdownEmpty": "Le Markdown yella ur yella.",
  "podcasts.pdfImport.dropLabel": "Ddeḍ s PDF ou fichier .md, ou ssar fichier",
  "podcasts.pdfImport.chooseFile": "Ssar fichier",
  "podcasts.pdfImport.analyzing": "Analyse n tazwart…",
  "podcasts.pdfImport.pageCount": "{{count}} page(ⴰ)",
  "podcasts.pdfImport.lineCount": "{{count}} tizi(n)",
  "podcasts.pdfImport.stats": "{{episodes}} aytma(n) · {{chapters}} tazrigt(n) · {{blocks}} tizi(n)",
  "podcasts.pdfImport.episodeLabel": "Aytma {{index}} — {{title}}",
  "podcasts.pdfImport.sectionsCount": "{{count}} tizi(n)",
  "podcasts.pdfImport.confirm": "Ssnif aytma(n)",
  "podcasts.pdfImport.importing": "Ssnif d-ttwelfin…",
  "podcasts.pdfImport.previewError": "Ur nttas nniḍen ad t-ttwelfiḍ a d-document.",
  "podcasts.pdfImport.importError": "Aḍris n ttawelfiḍ.",
  "podcasts.pdfImport.invalidFile": "Ssnif i d-ttwelfiḍ, PDF akked Markdown (.md) yella d-ttwelfiḍ.",
  "podcasts.pdfImport.success": "{{episodes}} aytma(n), {{chapters}} tazrigt(n) akked {{blocks}} tizi(n) ssnif.",
  "podcasts.pdfImport.hintEditorPage": "Ssuḍ a t-ttwelfiḍ, t-snif a d-ttwelfiḍ i l-editeur Markdown s-ttawelfiḍ n l-structure (aytma, tazrigt, alertes).",
  "podcasts.pdfImport.editorPageTitle": "Ssnif d-ttwelfiḍ n document",
  "podcasts.pdfImport.editorPageSubtitle": "Podcast « {{podcast}} » — {{file}}",
  "podcasts.pdfImport.editorEmptyHint": "Ssuḍ PDF neɣ fichier Markdown i ssnif. T-ttwelfiḍ a d-ttwelfiḍ i l-structure iḍen a d-ttwelfiḍ aytma(n).",
  "podcasts.pdfImport.backToPodcasts": "Ssnif a d-podcasts",
  "podcasts.pdfImport.replaceFile": "Ssnif d-fichier",
  "podcasts.pdfImport.documentTitleLabel": "Titt n document",
  "podcasts.pdfImport.untitledDocument": "Ur yella d-titt",
  "podcasts.pdfImport.invalidRoute": "Podcast ur yella.",
  "podcasts.pdfImport.fixErrorsBeforeImport": "Ssnif a d-ttwelfiḍ i l-errors n l-structure (panneau n l-yemmas) iḍen a d-ttwelfiḍ aytma(n).",
  "podcasts.pdfImport.structurePanelTitle": "Aide i l-conception",
  "podcasts.pdfImport.structurePanelSubtitle": "Estimation akked alertes i t-ttwelfiḍ.",
  "podcasts.pdfImport.estimatedStructure": "Structure n l-estimation",
  "podcasts.pdfImport.statEpisodes": "Aytma(n)",
  "podcasts.pdfImport.statChapters": "Tazrigt(n)",
  "podcasts.pdfImport.statBlocks": "Blocs",
  "podcasts.pdfImport.noPreviewYet": "Ssuḍ neɣ t-ttwelfiḍ n l-content i d-ttas n l-structure.",
  "podcasts.pdfImport.markdownMeta": "{{lines}} tizi(n) · {{h1}} titt(n) # · {{h2}} titt(n) ##",
  "podcasts.pdfImport.structureBlocked": "L-errors d-ttwelfiḍ i l-import — ssnif a d-ttwelfiḍ i l-Markdown.",
  "podcasts.pdfImport.structureReady": "Structure d-ttwelfiḍ — t-ttwelfiḍ a d-ttwelfiḍ aytma(n).",
  "podcasts.pdfImport.structureIssues": "Alertes n l-structure",
  "podcasts.pdfImport.goToLine": "Ssuḍ a d-tizi {{line}} i l-editeur",
  "podcasts.pdfImport.suggestions": "Suggérances",
  "podcasts.pdfImport.outlinePreview": "Aperçu n l-arborescence",
  "podcasts.pdfImport.conceptionGuide": "Guide n l-structuration",
  "podcasts.pdfImport.guideH1": "# Titt 1 = aytma n l-podcast (ex. tazrigt n l-kitab, part n l-cours).",
  "podcasts.pdfImport.guideH2": "## Titt 2 = tazrigt i d-ayiḍ (tizi, sous-parties).",
  "podcasts.pdfImport.guideBlocks": "Paragraphes akked listes = blocs n narration i d-ttwelfiḍ.",
  "podcasts.pdfImport.guidePdf": "Kull PDF yella d-ttwelfiḍ: rreḍ a d-ttwelfiḍ i l-Markdown n t-ttwelfiḍ akked ajjil i l-# / ## iḍen a d-ttwelfiḍ.",
  "podcasts.error.retry": "Ssnif a d-ttwelfiḍ",
  "podcasts.filters.allCategories": "Tazrigt n l-katègories",
  "podcasts.filters.categoryLabel": "Katègorie",
  "podcasts.filters.searchLabel": "Tazrigt n tazrigt",
  "podcasts.filters.searchPlaceholder": "Tittre, tazrigt…",
  "podcasts.filters.viewCategories": "Tazrigt n tazrawt",
  "podcasts.filters.viewList": "Tazrigt n tazlist",
  "podcasts.form.descriptionLabel": "Tazrigt",
  "podcasts.form.descriptionPlaceholder": "Tazrigt n tazrigt-ik…",
  "podcasts.form.namePlaceholder": "Isem n tazrigt",
  "podcasts.form.titleLabel": "Tittre",
  "podcasts.episodeOrder.label": "Tazrigt n tazrigt",
  "podcasts.episodeOrder.help": "Tazrigt n tazrigt deg tazrigt (yessuf d tazrigt n tazrawt deg l'import).",
  "podcasts.episodeOrder.ariaGroup": "Tazrigt n tazrigt",
  "podcasts.episodeOrder.newestFirst": "Ameqqran → amezwaru",
  "podcasts.episodeOrder.oldestFirst": "Amezwaru → ameqqran",
  "podcasts.language.ariaGroup": "Tamazight n tazrigt",
  "podcasts.language.help": "D amezwaru 11 n tamazight n tazrawt — s tazrigt n tazrigt-ik s yid n tazrawt akked tazrigt n l'interface.",
  "podcasts.language.label": "Tamazight",
  "podcasts.lightbox.ariaClose": "Sser",
  "podcasts.lightbox.ariaDialog": "Aperçu n cover n tazrigt",
  "podcasts.list.actionActivate": "Aẓru",
  "podcasts.list.actionDeactivate": "Ssefru",
  "podcasts.list.actionDelete": "Ssu",
  "podcasts.list.filterAll": "Yid",
  "podcasts.list.filterArchived": "Aẓrigh",
  "podcasts.list.archivePodcast": "Aẓrigh tazrigt",
  "podcasts.list.restoreFromArchive": "Ssefru seg l'archive",
  "podcasts.list.archiveSuccess": "Tazrigt aẓrigh",
  "podcasts.list.archiveError": "Ur ttuḍ tazrigt.",
  "podcasts.list.restoreSuccess": "Tazrigt t-ssefru",
  "podcasts.list.restoreError": "Ur ttuḍ ssefru tazrigt.",
  "podcasts.list.badgeArchived": "Aẓrigh",
  "podcasts.list.emptyArchivedNone": "Ur ttuḍ tazrigt aẓrigh.",
  "podcasts.list.emptyAllArchived": "Yid n tazrigt aẓrigh. Sser l'onglet « Aẓrigh » s yid n tazrigt.",
  "podcasts.list.actionManageEpisodes": "Mennu tazrigt",
  "podcasts.list.actionPreview": "Aperçu & tazrigt",
  "podcasts.list.coverPreviewAria": "Aperçu n cover n tazrigt {{title}}",
  "podcasts.list.createFirst": "Ssn tazrigt",
  "podcasts.list.emptySubtitle": "Ssn tazrigt-ik n yid s tazrigt",
  "podcasts.list.emptyTitle": "Ur ttuḍ tazrigt",
  "podcasts.list.loadError": "Ur ttuḍ ssen tazrigt.",
  "podcasts.list.enterpriseBadge": "Tazrigt",
  "podcasts.list.enterpriseNeedTitle": "Aẓrigh aḍu n tazrigt-ik",
  "podcasts.list.episodesShort": "{{count}} taz.",
  "podcasts.list.groupPodcastCount": "{{count}} podcast(s)",
  "podcasts.list.subscribersShort": "{{count}} abon.",
  "podcasts.list.uncategorized": "Aɣbalu n tazmert",
  "podcasts.modal.errorRequiredFields": "Tazmert akked tazmert n tazrigt d-ittwasen.",
  "podcasts.modal.errorSaveFailed": "Aɣbalu s wussan n tazmert.",
  "podcasts.modal.subtitleNew": "Sserḥeḍ tazmert, tazmert n tazrigt akked imḍan. Ttwaḍḍen ad tḥeḍḍen imḍan s wussan.",
  "podcasts.modal.titleEdit": "Ssned tazmert",
  "podcasts.modal.titleNew": "Tazmert n weḥed",
  "podcasts.page.episodesLink": "Imḍan",
  "podcasts.page.newButton": "Weḥed",
  "podcasts.page.title": "Podcasts",
  "podcasts.page.totalCount": "{{count}} podcast(s)",
  "podcasts.pagination.pageOf": "Page {{page}} / {{total}}",
  "podcasts.pagination.totalSummary": "{{count}} podcast(s) s wussan",
  "podcasts.player.listen": "Ssemḥa",
  "podcasts.player.noAudio": "Ur ḍuḍ n audio",
  "podcasts.player.pause": "Tazmert",
  "podcasts.learner.pageTitle": "Ssemḥa tazmert",
  "podcasts.learner.invalidLink": "Tazmert ur tṭṭfaḍ ur tḥeḍḍen",
  "podcasts.learner.loadError": "Ur ḍuḍ ad tḥeḍḍen tazmert",
  "podcasts.learner.loading": "Tḥeḍḍen tazmert…",
  "podcasts.learner.noEpisodes": "Ur ḍuḍ imḍan n tazmert.",
  "podcasts.learner.listen": "Ssemḥa",
  "podcasts.learner.pause": "Tazmert",
  "podcasts.preview.emptySubtitle": "Aɣbalu n tazmert ur ḍuḍ imḍan",
  "podcasts.preview.emptyTitle": "Ur ḍuḍ imḍan",
  "podcasts.preview.episodeCount": "{{count}} imḍan",
  "podcasts.preview.fallbackDescription": "Ssemḥa imḍan n audio s wussan.",
  "podcasts.preview.playAll": "Ssemḥa s wussan",
  "podcasts.preview.title": "Aperçu n tazmert",
  "podcasts.public": "Podcast",
  "podcasts.public.subscribeButton": "S’abonner ɣef tazmert n weḥed",
  "podcasts.public.subscribeModalTitle": "Sseḥḥed imḍan n weḥed s email",
  "podcasts.public.subscribeModalIntro": "Sserḥeḍ imḍan n wussan. Nneɣ ad nsend email ɣef tazmert n weḥed.",
  "podcasts.public.fieldFirstName": "Ism n weḥed",
  "podcasts.public.fieldLastName": "Ism n uḍḍa",
  "podcasts.public.fieldEmail": "Email",
  "podcasts.public.fieldCompany": "Tazmert (aḍuḍ)",
  "podcasts.public.submitSubscribe": "Ssned l’abonnement",
  "podcasts.public.cancel": "Ssned",
  "podcasts.public.done": "Tama",
  "podcasts.public.subscribeSuccess": "Tanemmirt! Ad tḥeḍḍen ɣef tazmert n weḥed.",
  "podcasts.public.subscribeError": "Ur nttwaf n tazmert. Rriɣ aɣyul.",
  "podcasts.public.subscribeValidationRequired": "Isem, tazmert akked email d-ttwaf.",
  "podcasts.public.totalDuration": "{{duration}} d-ttwaf",
  "podcasts.public.listenExcerpt": "Sseɣ aɣyul",
  "podcasts.playback.resumeAt": "Repriser di {{time}}",
  "podcasts.playback.listened": "Sseɣ",
  "podcasts.playback.listenedCount": "{{count}} sseɣ(iyen)",
  "podcasts.share.assignedLearnersHeading": "{{count}} amḍan(iyen) asnawen",
  "podcasts.share.copied": "Ssiɣ",
  "podcasts.share.copyLink": "Ssiɣ iɣli",
  "podcasts.share.emailPlaceholder": "Email *",
  "podcasts.share.errorCreateLearner": "Ur nttwaf n amḍan.",
  "podcasts.share.errorPublicLink": "Ur nttwaf n iɣli amḍan.",
  "podcasts.share.errorRemoveLearner": "Ur nttwaf n tɣiḍ amḍan.",
  "podcasts.share.errorShare": "Ur nttwaf n ssnaw n uɣdud.",
  "podcasts.share.firstNamePlaceholder": "Isem *",
  "podcasts.share.generatingLink": "Tazmert n iɣli…",
  "podcasts.share.hideQuickCreate": "Sserḥu tazmert n tɣiḍ",
  "podcasts.share.lastNamePlaceholder": "Tazmert *",
  "podcasts.share.loadingAssigned": "Tazmert…",
  "podcasts.share.loadingLearners": "Tazmert n amḍan…",
  "podcasts.share.messageAccessRemoved": "Aḍris yessufr i amḍan.",
  "podcasts.share.messageCreatedAndShared": "Aḍris nttwaf/ayt, uɣdud ssnawet akked email n tazmert yessufr.",
  "podcasts.share.messageShared": "Uɣdud ssnawet akked tazmert yessufr i amḍan.",
  "podcasts.share.noAssignedLearners": "Ur yella amḍan asnawen i uɣdud a.",
  "podcasts.share.noLearnerAvailable": "Ur yella amḍan yessufr.",
  "podcasts.share.panelTitle": "Ssnaw uɣdud",
  "podcasts.share.publicLinkSection": "Iɣli amḍan (ur d-ttwaf)",
  "podcasts.share.removeAccessTitle": "Ssiɣ aḍris",
  "podcasts.share.searchLearnerPlaceholder": "Sserḥu amḍan (tazmert, isem, email)",
  "podcasts.share.selectExistingLearnerLabel": "Sleḍ amḍan yella",
  "podcasts.share.showQuickCreate": "Tɣiḍ amḍan nniḍen",
  "podcasts.share.submitCreateAndInvite": "Tɣiḍ, ssnaw akked ssend tazmert",
  "podcasts.share.socialNetworksHeading": "Ssnaw di lqayṭ",
  "podcasts.share.shareLinkedIn": "Ssnaw di LinkedIn",
  "podcasts.share.shareFacebook": "Ssnaw di Facebook",
  "podcasts.share.shareTwitter": "Ssnaw di X (Twitter)",
  "podcasts.share.publicShareStatsHeading": "Statistiques n uɣdud amḍan",
  "podcasts.share.publicShareStatsVisits": "Visites (uɣdud amḍan)",
  "podcasts.share.publicShareStatsLoading": "Tazmert n statistiques…",
  "podcasts.share.publicShareStatsUnavailable": "Statistiques ur yella d-ttwaf.",
  "podcasts.share.publicShareStatsLinkedIn": "LinkedIn",
  "podcasts.share.publicShareStatsFacebook": "Facebook",
  "podcasts.share.publicShareStatsTwitter": "X (Twitter)",
  "podcasts.share.publicSubscribersHeading": "Iḍraren (notification n email)",
  "podcasts.share.publicSubscribersEmpty": "Ur ḥeḍ iḍraren ɣef uzekka.",
  "podcasts.share.publicSubscribersCompany": "Tazrigt",
  "share.publicQrTitle": "QR code n link n uzekka",
  "share.publicQrError": "Ur nḥeḍ ara QR code.",
  "share.downloadQrPng": "Sselḍ i PNG",
  "podcasts.status.active": "Aẓu",
  "podcasts.status.inactive": "Ur aẓu",
  "learningPaths.card.contents": "{{count}} tcontents",
  "learningPaths.card.delete": "Sseḥḥeḍ",
  "learningPaths.card.edit": "Sseḍra",
  "learningPaths.card.learners": "{{count}} amḍan",
  "learningPaths.card.publish": "Sseḥḥeḍ",
  "learningPaths.card.unpublish": "Ur sseḥḥeḍ",
  "learningPaths.card.updatedAt": "Sseḥḥeḍ {{date}}",
  "learningPaths.createPanel.cancel": "Aneḍ",
  "learningPaths.createPanel.description": "Sseḥḥeḍ ism n uḍḍa; tḥeḍḍeḍ i podcasts d tformasyon.",
  "learningPaths.createPanel.descriptionLabel": "Tazrigt",
  "learningPaths.createPanel.descriptionPlaceholder": "Ameḍḍak n uḍḍa, amḍan ɣef…",
  "learningPaths.createPanel.nameLabel": "Ism n uḍḍa",
  "learningPaths.createPanel.namePlaceholder": "Ex. : Uḍḍa n onboarding RH…",
  "learningPaths.createPanel.submit": "Sseḥḥeḍ uḍḍa",
  "learningPaths.createPanel.title": "Uḍḍa n uḍḍa",
  "learningPaths.deleteDialog.body": "Ttḥeḍḍeḍ « {{title}} ». Aḥeḍ nniḍen ur tḥeḍḍeḍ ara.",
  "learningPaths.deleteDialog.cancel": "Aneḍ",
  "learningPaths.deleteDialog.confirm": "Sseḥḥeḍ",
  "learningPaths.deleteDialog.title": "Sseḥḥeḍ uḍḍa",
  "learningPaths.empty.createFirst": "Sseḥḥeḍ uḍḍa",
  "learningPaths.empty.noPathsHint": "Sseḥḥeḍ i uḍḍa nniḍen ɣef tcombiner podcasts d tformasyon.",
  "learningPaths.empty.noPathsYet": "Ur ḥeḍ uḍḍa ɣef uzekka",
  "learningPaths.empty.noResults": "Ur ḥeḍ iḥeḍ",
  "learningPaths.empty.noResultsHint": "Sseḥḥeḍ i tfilter nwen ur sseḥḥeḍ uḍḍa nniḍen.",
  "learningPaths.error.loadFailed": "Ur nḥeḍ ara uḍḍa",
  "learningPaths.error.retry": "Rreḍ",
  "learningPaths.filters.allStatuses": "Lḥeḍ n lḥeḍ",
  "learningPaths.filters.draft": "Brouillon",
  "learningPaths.filters.published": "Published",
  "learningPaths.filters.searchPlaceholder": "Sseḥḥeḍ i uḍḍa…",
  "learningPaths.page.newButton": "Uḍḍa nniḍen",
  "learningPaths.page.subtitle": "Sseḥḥeḍ i uḍḍa n tformasyon n tazrigt",
  "learningPaths.page.title": "Iɣeṛfan",
  "learningPaths.page.totalCount": "{{count}} iɣeṛfan",
  "learningPaths.pagination.next": "Ssuɣ",
  "learningPaths.pagination.pageOf": "Iɣer {{page}} / {{total}} · {{count}} iɣeṛfan",
  "learningPaths.pagination.previous": "Aɣeṛ",
  "learningPaths.status.draft": "Tazrigt",
  "learningPaths.status.published": "Iḥeḍ",
  "learningPaths.editor.backToList": "Ssuɣ iɣeṛfan",
  "learningPaths.editor.pathNameLabel": "Ism n iɣeṛfan *",
  "learningPaths.editor.idCopyHint": "Aɣyul n iɣeṛfan (iḍeɣ i tmeddurt)",
  "learningPaths.editor.sectionNavAria": "Iɣewwan n tmeddurt n iɣeṛfan",
  "learningPaths.editor.tabContents": "Iḍewwen",
  "learningPaths.editor.tabLearners": "Aɣeṛwan",
  "webinars.card.code": "Aɣyul {{code}}",
  "webinars.card.copyLink": "Ssuɣ iɣer",
  "webinars.card.exportAttendance": "Sselḥ i tazrigt (CSV)",
  "webinars.card.attendanceExportError": "Ur ttuɣal ara i tazrigt.",
  "webinars.card.delete": "Sseɣ",
  "webinars.card.edit": "Ssuɣ",
  "webinars.card.openRoom": "Ssuɣ i tazrigt",
  "webinars.card.publicSignupBadge": "Tazrigt n tmeddurt",
  "webinars.deleteDialog.body": "Sseɣ « {{title}} »? Aɣyul aɣeṛ ur ttuɣal ara.",
  "webinars.deleteDialog.cancel": "Aɣeṛ",
  "webinars.deleteDialog.confirm": "Sseɣ",
  "webinars.deleteDialog.title": "Sseɣ i webinaire",
  "webinars.eligibility.default": "Webinaires ur d-yin ara i tmeddurt-ik (sseɣ i tṭṭa n l'API neɣ aɣeṛ i tmeddurt-ik).",
  "webinars.eligibility.moduleDisabled": "Iɣewwan n webinaires ur yettwasen ara i tmeddurt-ik. Aɣeṛ i tmeddurt-ik i ssuɣ « Aɣeṛ i webinaires » deg Établissement → Webinaires.",
  "webinars.eligibility.noInstitution": "Ur d-yin ara i tmeddurt-ik.",
  "webinars.eligibility.notAuthorized": "Aɣyul-ik ur d-yeḍra ara deg llist n iɣewwan n webinaires. Ssuɣ i tmeddurt-ik i ssuɣ (Pilotage webinaires → Iɣewwan n webinaires).",
  "webinars.eligibility.roleNotAllowed": "Aɣyul-ik ur d-yin ara i tmeddurt n webinaires s wigi aɣyul.",
  "webinars.empty.createFirst": "Ssuɣ webinaire",
  "webinars.empty.noResults": "Ur d-yin ara iɣewwan",
  "webinars.empty.noResultsHint": "Ssuɣ i tmeddurt-ik.",
  "webinars.empty.noWebinarsHint": "Ssuɣ i tazrigt neɣ ssuɣ i tmeddurt-ik seg tmeddurt n iɣewwan.",
  "webinars.empty.noWebinarsYet": "Ur d-yin ara webinaire i tmeddurt",
  "webinars.externalInvite.closeButton": "Fermer",
  "webinars.externalInvite.description": "Iɣewwan ur d-yin ara deg llist n iɣewwan: kull aɣyul yeddu i e-mail s iɣer n tazrigt neɣ i tazrigt n tmeddurt.",
  "webinars.externalInvite.done": "Iḍeɣ.",
  "webinars.externalInvite.duplicatesCount_one": "{{count}} ur d-yin ara i tmeddurt",
  "webinars.externalInvite.duplicatesCount_other": "{{count}} ur d-yin ara i tmeddurt",
  "webinars.externalInvite.emailsHint": "Aɣyul iɣewwan deg lḥeqq, neɣ ssuɣ i tmeddurt. Iddan neɣ i tmeddurt ur d-yin ara.",
  "webinars.externalInvite.emailsLabel": "Aɣyul n e-mail",
  "webinars.externalInvite.emailsPlaceholder": "une.adresse@exemple.fr\nautre@domaine.org",
  "webinars.externalInvite.errorMax200": "Max 200 adresses ssend.",
  "webinars.externalInvite.errorMinOne": "Saisissez au moins une adresse e-mail valide.",
  "webinars.externalInvite.errorsLabel": "erreurs : {{errors}}",
  "webinars.externalInvite.sendButton": "Ssend les invitations",
  "webinars.externalInvite.sendFailed": "Échec d'ssend",
  "webinars.externalInvite.sentCount_one": "{{count}} e-mail ssend",
  "webinars.externalInvite.sentCount_other": "{{count}} e-mails ssend",
  "webinars.externalInvite.skippedCount_one": "{{count}} ignorée",
  "webinars.externalInvite.skippedCount_other": "{{count}} ignorées",
  "webinars.externalInvite.title": "Invitations par e-mail",
  "webinars.invite.duplicatesCount_one": "{{count}} déjà invité",
  "webinars.invite.duplicatesCount_other": "{{count}} déjà invités",
  "webinars.invite.errorsLabel": "erreurs : {{errors}}",
  "webinars.invite.externalButton": "Hors liste (e-mail)",
  "webinars.invite.failed": "Échec",
  "webinars.invite.groupSuccess": "Invitations groupe traitées (e-mails ssend aux membres).",
  "webinars.invite.inviteButton": "Inviter",
  "webinars.invite.learnersHelp": "Recherchez un apprenant de votre établissement : un <strong>e-mail d'invitation</strong> (lien + agenda) est ssend à chaque invitation.",
  "webinars.invite.learnersTitle": "Apprenants",
  "webinars.invite.noCandidates": "Aucun apprenant à afficher (essayez une autre recherche ou utilisez « Hors liste » pour des e-mails externes).",
  "webinars.invite.noInvitations": "Aucune invitation enregistrée.",
  "webinars.invite.searchLabel": "Rechercher un apprenant",
  "webinars.invite.searchPlaceholder": "Nom ou e-mail…",
  "webinars.invite.searching": "Recherche…",
  "webinars.invite.sentCount_one": "{{count}} invitation ssend (e-mail)",
  "webinars.invite.sentCount_other": "{{count}} invitations ssend (e-mail)",
  "webinars.invite.sentInvitationsToggle": "Invitations ssend",
  "webinars.page.newButton": "Nouveau webinaire",
  "webinars.page.searchPlaceholder": "Rechercher…",
  "webinars.page.subtitle": "Liste de vos salles — ouvrez le panneau pour créer, modifier ou inviter des participants.",
  "webinars.page.title": "Webinaires",
  "webinars.panel.backgroundHint": "Image derrière le contenu partagé pour les participants : saisissez une URL (https ou http), importez un fichier (enregistré dans Mes images) ou choisissez une image déjà importée. Laissez vide pour le visuel Lyrra intégré.",
  "webinars.panel.backgroundLabel": "Image de fond (vue participant)",
  "webinars.panel.backgroundPlaceholder": "https://… ou chemin Mes images",
  "webinars.panel.backgroundUrlLabel": "Adresse de l’image (URL)",
  "webinars.panel.backgroundUploadTitle": "Importer une image (Mes images)",
  "webinars.panel.backgroundLibraryTitle": "Mes images",
  "webinars.panel.backgroundLibraryEmpty": "Aucune image pour l’instant — importez ci-dessus ou depuis la page Images du tableau de bord.",
  "webinars.panel.backgroundOpenImagesPage": "Ouvrir la page Images",
  "webinars.panel.backgroundUseDefault": "Utiliser le fond Lyrra par défaut",
  "webinars.panel.backgroundUploading": "Envoi en cours…",
  "webinars.panel.backgroundUploadError": "Tazrigt n tazmert.",
  "webinars.panel.copyLink": "Ssi l-link",
  "webinars.panel.createButton": "Ssnif",
  "webinars.panel.createDescription": "Ssnif i tazmert, ssi tazmert. Ttwaḍḍaḍ ad tḥeḍḍar i tazmert.",
  "webinars.panel.createTitle": "Tazmert n uḍris",
  "webinars.panel.dateLabel": "Ayyur (aḍu)",
  "webinars.panel.deleteButton": "Ssefru",
  "webinars.panel.descriptionLabel": "Tazmert",
  "webinars.panel.durationError": "Ssi tazmert n tazmert s wussan: tmin (ex. 1:00 neɣ 0:45).",
  "webinars.panel.durationHint": "Aḍu ma yella tazmert. Ex. 1:30 i 1 s 30, 0:45 i 45 d.",
  "webinars.panel.durationLabel": "Tazmert (h:mm)",
  "webinars.panel.editTitle": "Tazmert",
  "webinars.panel.loading": "Ssnif…",
  "webinars.panel.openRoom": "Ssnif tazmert",
  "webinars.panel.presentersLabel": "Aḍu n tazmert",
  "webinars.panel.roomCode": "Code tazmert :",
  "webinars.panel.timeHint": "Ma yella: 9:00.",
  "webinars.panel.timeLabel": "Wussan n tazmert",
  "webinars.panel.titleLabel": "Tazmert",
  "webinars.panel.waitingHtmlLabel": "HTML n tazmert n tazmert (aḍu)",
  "webinars.panel.waitingHtmlPlaceholder": "<p>Asleḍ…</p>",
  "webinars.panel.publicAccessTitle": "Tazmert n tazmert n uḍris (formulaire)",
  "webinars.panel.publicAccessHelp": "I tazmert aḍu n tazmert, ssin i tazmert n Lyrra: email, tazmert (aḍu yella) neɣ i tazmert n tazmert aḍu.",
  "webinars.panel.publicFormFixedFieldsHint": "Email neɣ tazmert (8 tazmert min.) yella s tazmert; tssin i tazmert aḍu i tazmert n tazmert aḍu.",
  "webinars.panel.publicFormAddFieldButton": "Ssnif i tazmert",
  "webinars.panel.publicFormFieldNumber": "Tazmert {{n}}",
  "webinars.panel.publicFormFieldLabel": "Tazmert n tazmert",
  "webinars.panel.publicFormFieldType": "Tazmert",
  "webinars.panel.publicFormFieldTypeText": "Tazmert aḍu",
  "webinars.panel.publicFormFieldTypeTextarea": "Tazmert aḍu",
  "webinars.panel.publicFormFieldRequired": "Aḍu",
  "webinars.panel.publicFormFieldRemove": "Ssefru",
  "webinars.panel.publicFormFieldIdHint": "Id n tazmert :",
  "webinars.panel.publicFormFieldLabelRequired": "Kull tazmert yella s tazmert.",
  "webinars.panel.publicAccessLoginLabel": "Id n tazmert n uḍris",
  "webinars.panel.publicAccessPasswordLabel": "Tazmert n tazmert",
  "webinars.panel.publicAccessPasswordPlaceholderNew": "Aḍu 8 tazmert",
  "webinars.panel.publicAccessPasswordPlaceholderKeep": "Ssi tazmert i tazmert n tazmert",
  "webinars.panel.publicAccessPasswordHint": "I tazmert neɣ i tazmert n tazmert: tazmert aḍu (8 tazmert min.). Aḍu: ssi tazmert i tazmert.",
  "webinars.panel.publicAccessLoginRequired": "Ssi id n tazmert i tazmert n uḍris.",
  "webinars.panel.publicAccessPasswordRequired": "Ssi tazmert n tazmert aḍu 8 tazmert.",
  "webinars.panel.publicAccessPasswordMin": "Tazmert n tazmert aḍu yella s 8 tazmert.",
  "webinars.status.draft": "Ameqqran",
  "webinars.status.ended": "Tazrigt",
  "webinars.status.live": "Ssaq",
  "webinars.status.scheduled": "Tazrigt",
  "videos.addPanel.cancel": "Asnaw",
  "videos.addPanel.continue": "Ssuq",
  "videos.addPanel.description": "Ssefru MP4, WebM ne MOV i tazrigt-nwen.",
  "videos.addPanel.dropzoneFormats": "MP4, WebM, MOV",
  "videos.addPanel.dropzoneLabel": "Ssnaw i tselecti n video",
  "videos.addPanel.title": "Ssefru video",
  "videos.addPanel.titleLabel": "Tittre",
  "videos.addPanel.titlePlaceholder": "Tittre n video...",
  "videos.card.delete": "Ssefru",
  "videos.card.edit": "Ssnaw",
  "videos.card.noThumbnail": "Ur nniḍen",
  "videos.card.publishedStudio": "Ssefru (snnaw Studio)",
  "videos.card.draft": "Ameqqran",
  "videos.deleteDialog.body": "« {{title}} » yella yessufr.",
  "videos.deleteDialog.cancel": "Asnaw",
  "videos.deleteDialog.confirm": "Ssefru",
  "videos.deleteDialog.title": "Ssefru video?",
  "videos.empty.addButton": "Ssefru video",
  "videos.empty.description": "Ssefru video nwen i tazrigt-nwen.",
  "videos.empty.title": "Ur nniḍen",
  "videos.page.addButton": "Ssefru video",
  "videos.page.count_one": "{{count}} video di tazrigt-nwen",
  "videos.page.count_other": "{{count}} videos di tazrigt-nwen",
  "videos.page.title": "Videos",
  "videos.page.studioButton": "Studio",
  "videos.studio.title": "Studio n video",
  "videos.studio.rail.prep": "Tazrigt",
  "videos.studio.rail.capture": "Ssnaw",
  "videos.studio.rail.post": "Montage",
  "videos.studio.rail.aria": "Tazrigt n studio n video",
  "videos.studio.badge.setup": "Tazrigt",
  "videos.studio.badge.capture": "Ssnaw",
  "videos.studio.badge.recording": "Tazrigt",
  "videos.studio.badge.post": "Montage",
  "videos.studio.cannotLeaveRecord": "Ssnaw i tazrigt gher tazrigt.",
  "videos.studio.railNeedRecording": "Ssnaw video i tazrigt.",
  "videos.studio.sidebar.captureHelp": "Ssnaw yessufr i tazrigt n flux (tazrigt, tab ne window). Tazrigt i tazrigt yella i tazrigt n Montage.",
  "videos.studio.sidebar.sources": "Imkan",
  "videos.studio.sidebar.recordingLive": "Tazrigt n tazrigt",
  "videos.studio.sidebar.finalizeHint": "Ihi tazrigt s lbiru, sserf i tbutin deg lbar n tazrigt.",
  "videos.studio.canvas.setupEmpty": "Sserf i tazrigt n lpan n tazrigt, s tazrigt i tstep Capture.",
  "videos.studio.stepSetup": "Tazrigt",
  "videos.studio.stepCapture": "Capture",
  "videos.studio.stepPost": "Montage",
  "videos.studio.titleLabel": "Titt n tazrigt",
  "videos.studio.titlePlaceholder": "Ma capture…",
  "videos.studio.saveSetup": "Ssar i tazrigt",
  "videos.studio.fieldDescription": "Tazrigt",
  "videos.studio.fieldCategories": "Ikat",
  "videos.studio.categoriesHint": "Ikat n tazrigt n tazrigt (akli).",
  "videos.studio.categoriesEmptyInstitution": "Akk i kat n tazrigt ur tsetta i tazrigt n tazrigt.",
  "videos.studio.audioTrackPlanned": "Tizraw n audio tazrigt",
  "videos.studio.voiceHumanPlan": "Tizraw n imik (micro n tazrigt)",
  "videos.studio.voiceAiPlan": "Tizraw n IA (ikhtiyar i tmontage)",
  "videos.studio.postVoiceHumanKeep": "Kkat tazraw n imik: tazrigt tazra l'audio n lmicro. Ssar i tfinalisation ma tti tazrigt.",
  "videos.studio.titleUntitled": "Ur tti tazrigt",
  "videos.studio.voiceAiNoVoices": "Ur tti tazraw n IA i tazrigt.",
  "videos.studio.postVoiceAiPipeline": "Tizraw n IA: sserf i ttext, sgen i tizraw n audio, sserf i tazrigt.",
  "videos.studio.allowMedia": "Ssar i tmediat i lscreen akked lmicrophone",
  "videos.studio.controlsHint": "Asti: ihi tazrigt ur tti tazrigt n tbar, sserf i ttab wala tfenster akked ur tti lscreen, wala sserf i tscreen sidi. Espace = pause / reprise ma tti tazrigt.",
  "videos.studio.warnTabOnly": "Kkat tazrigt ur tti ttab: ur tti ttab yura tazrigt, ghas tti ttab n tazrigt. Ihi tazrigt n ttab wala tfenster, sserf i tazrigt akked ikhtiyar « Tazrigt n tscreen ». ",
  "videos.studio.templateMenuTitle": "Menu n tmodel",
  "videos.studio.templateEmpty": "Ur tti tmodel i tazrigt",
  "videos.studio.templatesHintCompact": "Sserf i + i tazrigt, tapply wala tssuppr i tmodel.",
  "videos.studio.overlayAddMusic": "Musique n tazrigt",
  "videos.studio.musicInvalidType": "Format ur tti. Sserf i taudio (MP3, WAV, M4A, OGG).",
  "videos.studio.musicTooLarge": "Tafayt n audio ur tti tzeh 50 Mo.",
  "videos.studio.musicDefault": "Musique",
  "videos.studio.musicAdded": "Musique n tazrigt tazra i ttimeline.",
  "videos.studio.musicUploadError": "Ur tti tazrigt i musique.",
  "videos.studio.layerScreenBorder": "Bord n lscreen",
  "videos.studio.layerScreenBorderSize": "Tsize",
  "videos.studio.layerScreenBorderColor": "Tcolor",
  "videos.studio.layerScreenBorderRadius": "Arrondi n tazrigt",
  "videos.studio.segmentToolsTitle": "Utl n tsection",
  "videos.studio.segmentZoom": "Zoom",
  "videos.studio.segmentResetView": "Réinit. vue",
  "videos.studio.segmentTransition": "Transition",
  "videos.studio.transitionNone": "Ur tti",
  "videos.studio.transitionFade": "Fondu",
  "videos.studio.transitionWipeLeft": "Tazrigt →",
  "videos.studio.transitionSlideUp": "Tazrigt ↑",
  "videos.studio.textEditor.toolbar": "Tazrigt n tazrigt",
  "videos.studio.textEditor.bold": "Azzay",
  "videos.studio.textEditor.italic": "Ittal",
  "videos.studio.textEditor.underline": "Ittay",
  "videos.studio.textEditor.textColor": "Lqim n tazrigt (tazligh)",
  "videos.studio.textEditor.size": "Tamazight",
  "videos.studio.textEditor.font": "Tifinagh",
  "videos.studio.textEditor.fontFamily.system": "Sistem",
  "videos.studio.textEditor.fontFamily.sansInter": "Sans (Inter)",
  "videos.studio.textEditor.fontFamily.serif": "Serif",
  "videos.studio.textEditor.fontFamily.mono": "Mono",
  "videos.studio.textEditor.fontFamily.script": "Script",
  "videos.studio.controlsHintTab": "Ttawt tazrigt n yid: lqim ur tghit a tazrigt n Studio (iwakken ur yufan). Ddu l Studio di tazrigt n yid n lbrwz n lbrwz, d akken i tazrigt n tazrigt. I wakken i Pause, Arrêter ou Terminer, tazrigt di lbrwz i ddu l Studio (Alt+Tab ou Cmd+Tab). Lqim n Espace ur tghit illa i wakken lqim i d lqim n tazrigt.",
  "videos.studio.controlsHintMonitor": "Ttawt tazrigt n yid: tazrigt ur tghit a tazrigt n lqim. I wakken i tazrigt, tazrigt n yid n lqim ou tazrigt n lqim.",
  "videos.studio.controlsHintWindow": "Ttawt tazrigt n yid: lqim n lbrwz (d lqim n yid n lbrwz) ur tghit a tazrigt. I wakken i Pause, Arrêt ou Terminer.",
  "videos.studio.startRecord": "Tazrigt",
  "videos.studio.pause": "Pause",
  "videos.studio.resume": "Ittaw",
  "videos.studio.stop": "Arrêter",
  "videos.studio.terminer": "Terminer",
  "videos.studio.processingUpload": "Tazrigt d tazrigt…",
  "videos.studio.timeline": "Tazrigt",
  "videos.studio.transcript": "Tazrigt n tazrigt",
  "videos.studio.transcriptRefining": "Tazrigt n tazrigt d tazrigt…",
  "videos.studio.transcriptPlaceholder": "Tazrigt n tazrigt n tazrigt i tazrigt a tazrigt…",
  "videos.studio.voiceMode": "Tazrigt n tazrigt",
  "videos.studio.voiceOriginal": "Tazrigt n yid (micro i tazrigt)",
  "videos.studio.voiceAi": "Tazrigt IA (Mistral TTS)",
  "videos.studio.voiceSelect": "Tazrigt",
  "videos.studio.polish": "Tazrigt n tazrigt i tazrigt IA",
  "videos.studio.generateTts": "Tazrigt n tazrigt",
  "videos.studio.applyVoiceover": "Tazrigt n tazrigt IA i tazrigt",
  "videos.studio.preview": "Tazrigt",
  "videos.studio.preview.noFile": "Ur tghit a tazrigt n tazrigt.",
  "videos.studio.bgImage": "Tazrigt n tazrigt",
  "videos.studio.bgImageChoose": "Tazrigt",
  "videos.studio.bgImageInvalidType": "Tazrigt ur tghit a tazrigt. I wakken i tazrigt (PNG, JPG, WebP).",
  "videos.studio.bgImageTooLarge": "Lqim ur tghit a tazrigt 10 Mo.",
  "videos.studio.bgImageLoadError": "Ur tghit a tazrigt n tazrigt.",
  "videos.studio.bgImageUploading": "Tazrigt…",
  "videos.studio.bgImageUploadError": "Ur nttwaf l'image. Rrjaâ.",
  "videos.studio.bgImageLibraryTitle": "Fond studio vidéo",
  "videos.studio.postLayoutTitle": "Cadre & fond",
  "videos.studio.postLayoutHint": "Aperçu aligné sur la vidéo publiée : enregistrez le brouillon puis publiez pour appliquer fond, taille et position.",
  "videos.studio.bgImageVideoSize": "Taille vidéo",
  "videos.studio.dragToMove": "Glisser pour déplacer",
  "videos.studio.finalize": "Finaliser et enregistrer",
  "videos.studio.saveDraft": "Brouillon",
  "videos.studio.publish": "Publier",
  "videos.studio.successDraft": "Vidéo enregistrée en brouillon",
  "videos.studio.successPublish": "Vidéo publiée dans votre bibliothèque",
  "videos.studio.processingPublish": "Traitement de la vidéo en cours…",
  "videos.studio.back": "Retour aux vidéos",
  "videos.studio.errorMedia": "Ur nttwaf l’écran ou l'micro.",
  "videos.studio.errorInsecureContext": "La capture nécessite HTTPS ou localhost. Ouvrez l’application via https:// ou http://127.0.0.1 / localhost.",
  "videos.studio.errorNotSupported": "Ce navigateur ou appareil ne prend pas en charge la capture d’écran ici. Utilisez Chrome ou Edge à jour sur ordinateur.",
  "videos.studio.errorMicDenied": "Micro refusé : autorisez le micro pour ce site (icône cadenas ou ⓘ dans la barre d’adresse), puis réessayez.",
  "videos.studio.errorScreenDenied": "Partage d’écran refusé : dans la fenêtre du navigateur, choisissez un écran ou un onglet et validez « Partager ». ",
  "videos.studio.errorMicMissing": "Aucun micro détecté. Vérifiez le branchement et les réglages système.",
  "videos.studio.errorScreenMissing": "Partage d’écran indisponible sur cet appareil ou ce navigateur.",
  "videos.studio.errorMicBusy": "Micro déjà utilisé par une autre application. Fermez-la puis réessayez.",
  "videos.studio.errorScreenBusy": "Capture d’écran impossible (ressource occupée). Réessayez ou redémarrez le navigateur.",
  "videos.studio.errorScreenCancelled": "Partage d’écran annulé.",
  "videos.studio.errorMicCancelled": "Accès au micro annulé.",
  "videos.studio.errorMicGeneric": "Ur nttwaf l'micro.",
  "videos.studio.errorScreenGeneric": "Ur nttwaf l'écran.",
  "videos.studio.errorScreenEnded": "Partage d’écran arrêté.",
  "videos.studio.mediaHints": "Chrome ou Edge sur ordinateur. Si l’URL est en http:// avec une IP type 192.168.x.x, le navigateur bloque souvent la capture : utilisez http://localhost:5173 ou un HTTPS valide.",
  "videos.studio.errorRecord": "Enregistrement impossible sur ce navigateur.",
  "videos.studio.errorUpload": "Échec de l’envoi.",
  "videos.studio.errorLoadDraft": "Ur nttwaf l'brouillon.",
  "videos.studio.errorTranscribe": "Transcription indisponible.",
  "videos.studio.errorPolish": "Reformulation IA impossible.",
  "videos.studio.errorTts": "Synthèse vocale impossible.",
  "videos.studio.errorMux": "Montage audio impossible.",
  "videos.studio.muxSuccess": "Voix IA appliquée à la vidéo",
  "videos.studio.successFinal": "Vidéo enregistrée dans votre bibliothèque",
  "videos.studio.generatingTimeline": "Génération de la timeline…",
  "videos.studio.crop": "Recadrer",
  "videos.studio.cropReset": "Réinitialiser le recadrage",
  "videos.studio.cropActive": "Recadrage actif — déplacez ou redimensionnez la zone sur la vidéo",
  "videos.studio.cropDone": "Terminer",
  "videos.studio.cropApplied": "Rognage iḍeqqar",
  "videos.studio.cropEdit": "Ssned",
  "videos.studio.cropRemove": "Ssuprimi",
  "videos.studio.trimIn": "IN",
  "videos.studio.trimOut": "OUT",
  "videos.studio.trimDuration": "tazrigt",
  "videos.preview.noFile": "Aɣil nniḍen ur yella.",
  "videos.status.draft": "Tazmert",
  "videos.status.published": "Iḍebbu",
  "sounds.card.delete": "Ssuprimi",
  "sounds.card.download": "Sseɣḍi",
  "sounds.card.mute": "Ssiḍiḍ",
  "sounds.deleteDialog.body": "« {{title}} » yella iḍeqqar s tazmert n tserbant akked tazmert n tmeddurt.",
  "sounds.deleteDialog.cancel": "Aneḍ",
  "sounds.deleteDialog.confirm": "Ssuprimi",
  "sounds.deleteDialog.title": "Ssuprimi aɣil nniḍen ?",
  "sounds.empty.description": "Sseɣḍu aɣil nwen: yella iḍeqqar s tazmert akked yella iḍeqqar s tserbant ur nḥeḍ.",
  "sounds.empty.importButton": "Sseɣḍi aɣil",
  "sounds.empty.title": "Ur yella aɣil nniḍen",
  "sounds.fileSize.bytes": "{{size}} o",
  "sounds.fileSize.kb": "{{size}} Ko",
  "sounds.fileSize.mb": "{{size}} Mo",
  "sounds.importPanel.cancel": "Aneḍ",
  "sounds.importPanel.changeFile": "Ssned aɣil",
  "sounds.importPanel.createTag": "Ssned « {{tag}} »",
  "sounds.importPanel.description": "Ssned aɣil n tmeddurt nwen s tazmert nwen.",
  "sounds.importPanel.descriptionLabel": "Tazmert",
  "sounds.importPanel.descriptionPlaceholder": "Ssned aɣil nniḍen…",
  "sounds.importPanel.dropzoneBrowse": "sseɣḍu",
  "sounds.importPanel.dropzoneFormats": "MP3, WAV, OGG, M4A, AAC, FLAC",
  "sounds.importPanel.dropzoneLabel": "Sseɣḍu aɣil n tmeddurt neɣ",
  "sounds.importPanel.optional": "(aḍuḍ)",
  "sounds.importPanel.submit": "Sseɣḍi",
  "sounds.importPanel.submitting": "Ssend…",
  "sounds.importPanel.tagsHint": "Ssned akked tazmert · Tazmert nwen yella iḍeqqar s tazmert",
  "sounds.importPanel.tagsLabel": "Tazmert",
  "sounds.importPanel.tagsPlaceholder": "Ssned tazmert…",
  "sounds.importPanel.title": "Sseɣḍi aɣil",
  "sounds.importPanel.titleLabel": "Isem",
  "sounds.importPanel.titlePlaceholder": "Isem n aɣil…",
  "sounds.importPanel.titleRequired": "Isem yella aḍuḍ",
  "sounds.noResults": "Ur yella aɣil nniḍen iḍeqqar s « {{query}} »",
  "sounds.page.count_one": "{{count}} tislit — tazmert di tazrigt akked di lserver",
  "sounds.page.count_other": "{{count}} tislit — tazmertin di tazrigt akked di lserver",
  "sounds.page.importButton": "Ssar",
  "sounds.page.searchPlaceholder": "Tittre, tasnif, tag…",
  "sounds.page.title": "Tislit",
  "documents.count_one": "{{count}} tament",
  "documents.count_other": "{{count}} tament",
  "documents.delete.body": "I tament « {{filename}} » yella yeddu di tazrigt nnek.",
  "documents.delete.cancel": "Ssar",
  "documents.delete.confirm": "Ssar",
  "documents.delete.irreversible": "Ihi d amekka yella ur tzemrem.",
  "documents.delete.title": "Ssar i tament ?",
  "documents.importPanel.cancel": "Ssar",
  "documents.importPanel.chooseFile": "Ssar tament PDF",
  "documents.importPanel.description": "I tament yella yeddu di tislit n PDF akked di tazrigt nnek.",
  "documents.importPanel.descriptionLabel": "Tasnif",
  "documents.importPanel.descriptionPlaceholder": "Tasnif (amzun)",
  "documents.importPanel.fileHint": "I tament yella yeddu di tislit n PDF akked di tazrigt nnek.",
  "documents.importPanel.submit": "Ssar",
  "documents.importPanel.title": "Ssar tament PDF",
  "documents.importPanel.titleLabel": "Tittre",
  "documents.importPanel.titlePlaceholder": "Tittre n tament",
  "documents.importPanel.uploading": "Ssar d azzay",
  "documents.importPdf": "Ssar tament PDF",
  "documents.loading": "Tazrigt n tament…",
  "documents.newDocument": "Tament nni",
  "documents.noDocuments": "Ur yella tament",
  "documents.noDocumentsHint": "Ssar tament nnek hna s yid n PDF.",
  "documents.noResults": "Ur yella tament yeggi di tazrigt nnek.",
  "documents.pages_one": "{{count}} lqad",
  "documents.pages_other": "{{count}} lqad",
  "documents.previewTitle": "Aperçu n tament",
  "documents.searchPlaceholder": "Rechercher tament PDF...",
  "documents.share.accessRemoved": "Aksu yella yeddu i l'apprenant.",
  "documents.share.assignedTitle": "L'apprenant i yella yeddu",
  "documents.share.close": "Fermer",
  "documents.share.createAndShare": "Ssar, ssennegh akked ssend",
  "documents.share.createError": "Ur tzemrem i ssnaw.",
  "documents.share.createLearner": "Ssar l'apprenant nni",
  "documents.share.createdSuccess": "Akkunt yella yeddu, tament yella yeddu akked email yeddu.",
  "documents.share.creating": "Ssend…",
  "documents.share.emailPlaceholder": "Email *",
  "documents.share.firstNamePlaceholder": "Isem n tmeddurt *",
  "documents.share.hideCreateLearner": "Sserd ucrem n tmeddurt",
  "documents.share.lastNamePlaceholder": "Isem n lqim *",
  "documents.share.loadingAssigned": "Ihder…",
  "documents.share.loadingLearners": "Ihder n tmeddurt…",
  "documents.share.noAssigned": "Ur nni tmeddurt i d-ttwafaq ar tazmert.",
  "documents.share.noLearners": "Ur nni tmeddurt i d-ttwafaq.",
  "documents.share.removeButton": "Sserd",
  "documents.share.removeError": "Ur nni sserd uccu.",
  "documents.share.searchPlaceholder": "Sserd tmeddurt (isem, tmeddurt, email)",
  "documents.share.selectLearner": "Sleq tmeddurt i d-ttwafaq",
  "documents.share.shareButton": "Sshare",
  "documents.share.shareError": "Ur nni sshare tazmert.",
  "documents.share.sharedSuccess": "Tazmert tshareg d tazmert i d-ttwafaq.",
  "documents.share.title": "Sshare tazmert",
  "documents.subtitle": "Tazmert n PDF i d-ttwafaq di designer.",
  "documents.title": "Tazmert",
  "documents.toast.importError": "Ur nni timport",
  "documents.toast.importErrorDefault": "Timport ur nni yefk.",
  "documents.toast.importSuccess": "Tazmert timporta",
  "documents.toast.importSuccessDesc": "{{filename}} d-ttwafaq i tazmert n tmeddurt.",
  "documents.updating": "Ihder…",
  "help.categories.analytics.description": "Tablaux n bord, tfiltr, d exports i d-ttwafaq l'impact n tformasyon.",
  "help.categories.analytics.title": "Analytique & rapport",
  "help.categories.apprenants.description": "Sserd n t'inscriptions, tcohort, d progression n tmeddurt.",
  "help.categories.apprenants.title": "Tmeddurt, iggawen & ssuq",
  "help.categories.boutique.description": "Ssell ou sserd tformasyon mli t-boutique tsetta.",
  "help.categories.boutique.title": "Boutique & monetisation",
  "help.categories.demarrage.description": "Sserd n l'interface, tprofil d tnavigation i d-ttwafaq di Lyrra.",
  "help.categories.demarrage.title": "Démarrage & compte",
  "help.categories.donnees.description": "RGPD, tconservation, d rights n tmeddurt d t-bonnes pratiques n sécu.",
  "help.categories.donnees.title": "Données personnelles & sécurité",
  "help.categories.eduflow.description": "Sdesign n parcours pédagogiques s blocks, tconnexions d tlogique n tnavigation.",
  "help.categories.eduflow.title": "Parcours & designer EduFlow",
  "help.categories.evaluation.description": "Quiz, t'évaluations, tsondages d t'retours i d-ttwafaq l'acquis.",
  "help.categories.evaluation.title": "Évaluation & pédagogie active",
  "help.categories.institution.description": "Sparamétrer tstructure, tcollaborateurs d t'organisation n tcontenus.",
  "help.categories.institution.title": "Établissement & équipe",
  "help.categories.marque.description": "Saligner tcolors, tlibellés d tparcours n tmeddurt ar t'identité.",
  "help.categories.marque.title": "Marque & expérience utilisateur",
  "help.categories.medias.description": "Sgerer tbibliothèque, timports d ttools n audio / vidéo / image i d-ttwafaq di Lyrra.",
  "help.categories.medias.title": "Médias & studio créatif",
  "help.categories.parcours-v2.description": "Tazrigt, tazrigt, tazrigt : yella d uḍu n tazrigt n tazrigt.",
  "help.categories.parcours-v2.title": "Aḍu n tazrigt & tazrigt n tazrigt",
  "help.categories.podcasts.description": "Sseḍḍa d ssenna n tazrigt n uḍu n tazrigt n tazrigt.",
  "help.categories.podcasts.title": "Podcasts & tazrigt n uḍu",
  "help.categories.publication.description": "Sseḍḍa d tazrigt n tazrigt n tazrigt d tazrigt.",
  "help.categories.publication.title": "Tazrigt & ssenna",
  "help.categories.qualite.description": "Aḍu n tazrigt n tazrigt : tazrigt, aḍu n tazrigt d tazrigt.",
  "help.categories.qualite.title": "Tazrigt, Qualiopi & tazrigt n tazrigt",
  "help.categories.support.description": "Ma yella d uḍu n tazrigt n tazrigt, sseḍḍa d uḍu n tazrigt.",
  "help.categories.support.title": "Tazrigt & ssenna",
  "help.configHint": "Tazrigt n tazrigt : sseḍḍa d uḍu n tazrigt, tazrigt n tazrigt ma tella d tazrigt.",
  "help.description": "Tazrigt d ssenna",
  "help.hubIntro": "Tazrigt n tazrigt n Lyrra : tella d tazrigt n tazrigt d tazrigt, tazrigt n tazrigt.",
  "help.modal.expectedAnswer": "Tazrigt n tazrigt :",
  "help.modal.fallbackHighlight1": "Tazrigt",
  "help.modal.fallbackHighlight2": "Tazrigt n tazrigt",
  "help.modal.fallbackHighlight3": "Aḍu n tazrigt",
  "help.modal.fallbackSectionHeading": "Aḍu n tazrigt",
  "help.modal.fallbackSectionParagraph": "Tazrigt n tazrigt n tazrigt yella d tazrigt n tazrigt.",
  "help.modal.fallbackStep1Desc": "Sseḍḍa d uḍu n tazrigt ma yella d tazrigt.",
  "help.modal.fallbackStep1Title": "Sseḍḍa d tazrigt",
  "help.modal.fallbackStep2Desc": "Tazrigt n tazrigt yella d tazrigt : sseḍḍa d tazrigt.",
  "help.modal.fallbackStep2Title": "Sseḍḍa d tazrigt n tazrigt",
  "help.modal.fallbackStep3Desc": "Sseḍḍa d tazrigt n tazrigt n tazrigt.",
  "help.modal.fallbackStep3Title": "Tazrigt n tazrigt",
  "help.modal.fallbackTip": "Ma yella d uḍu, sseḍḍa d tazrigt n tazrigt.",
  "help.modal.quiz": "Tazrigt n tazrigt",
  "help.modal.related": "Sseḍḍa d tazrigt",
  "help.modal.resources": "Tazrigt",
  "help.modal.steps": "D tazrigt",
  "help.modal.tips": "Tazrigt",
  "help.noResults": "Aḍu n tazrigt n tazrigt.",
  "help.onboarding.ai-designer": "Tazrigt — Aḍu n tazrigt n LyrraOne (onboarding)",
  "help.onboarding.blocks": "Tazrigt — Aḍu n tazrigt n EduFlow (onboarding)",
  "help.onboarding.branches": "Tazrigt — Aḍu n tazrigt n EduFlow (onboarding)",
  "help.onboarding.catalog-visibility": "Tazrigt — Aḍu n tazrigt n LyrraOne (onboarding)",
  "help.onboarding.certificates": "Tazrigt — Aḍu n tazrigt n LyrraOne (onboarding)",
  "help.onboarding.dashboard": "Tazrigt — Aḍu n tazrigt n Lyrra (onboarding)",
  "help.onboarding.designer-overview": "Tazrigt — Aḍu n tazrigt n EduFlow (onboarding)",
  "help.onboarding.enrollments": "Tazrigt — Aḍu n tazrigt n LyrraOne (onboarding)",
  "help.onboarding.groups-cohorts": "Tazrigt — Aḍu n tazrigt n LyrraOne (onboarding)",
  "help.onboarding.media-library": "Tazrigt — Aḍu n tazrigt n LyrraOne (onboarding)",
  "help.onboarding.navigation": "Tazrigt — Tazrigt & amezruy Lyrra (onboarding)",
  "help.onboarding.objectives": "Tazrigt — Iɣewwa n tazrigt EduFlow (onboarding)",
  "help.onboarding.profile": "Tazrigt — Tazrawt & imazighen Lyrra (onboarding)",
  "help.onboarding.progress": "Tazrigt — Tazrigt & waqt iḍu LyrraOne (onboarding)",
  "help.onboarding.publication-links": "Tazrigt — Iɣewwa n tazrigt & tazrigt LyrraOne (onboarding)",
  "help.onboarding.publication-status": "Tazrigt — Aɣbalu, tazrigt akked tazrigt LyrraOne (onboarding)",
  "help.onboarding.roles": "Tazrigt — Iɣewwa akked tazrawt Lyrra (onboarding)",
  "help.onboarding.validation": "Tazrigt — Iɣewwa n tazrigt EduFlow (onboarding)",
  "help.onboardingFlowMissing": "Tazrigt ur ttuɣal",
  "help.onboardingFlowMissingDesc": "Ssuɣ iɣewwa db:seed:onboarding-eduflow akked db:seed:onboarding-navigation-eduflow (backend), neɣ iɣewwa VITE_ONBOARDING_*_FLOW_ID.",
  "help.openArticle": "Sseɣ i tazrigt",
  "help.searchPlaceholder": "Sserḥeḍ i tazrigt…",
  "help.title": "Aɣbalu n tazrigt",
  "help.topics.analytics-exports.description": "Sseɣ i tazrigt n tazrigt i tazrigt n tazrigt.",
  "help.topics.analytics-exports.title": "Tazrigt & tazrigt RH",
  "help.topics.analytics-indicateurs.description": "Tazrigt n tazrigt, tazrigt, tazrigt akked waqt iḍu.",
  "help.topics.analytics-indicateurs.title": "Iɣewwa n tazrigt",
  "help.topics.analytics-vue.description": "Sseɣ i tazrigt, tazrigt akked tazrigt i tazrigt n tazrigt.",
  "help.topics.analytics-vue.title": "Tazrigt n tazrigt",
  "help.topics.app-certificats.description": "Sseɣ i tazrigt n tazrigt akked tazrigt n tazrigt.",
  "help.topics.app-certificats.title": "Tazrigt n tazrigt",
  "help.topics.app-groupes.description": "Sseɣ i tazrigt n tazrigt akked tazrigt.",
  "help.topics.app-groupes.title": "Tazrigt & tazrigt",
  "help.topics.app-inscriptions.description": "Sseɣ i tazrigt n tazrigt i tazrigt, tazrigt akked tazrigt n tazrigt.",
  "help.topics.app-inscriptions.title": "Tazrigt & tazrigt",
  "help.topics.app-progression.description": "Sseɣ i tazrigt, tazrigt akked waqt iḍu i tazrigt.",
  "help.topics.app-progression.title": "Tazrigt & waqt iḍu",
  "help.topics.boutique-offres.description": "Sseɣ i tazrigt n tazrigt i tazrigt n tazrigt.",
  "help.topics.boutique-offres.title": "Tazrigt & tazrigt",
  "help.topics.boutique-paiement.description": "Sseɣ i tazrigt n tazrigt i tazrigt n tazrigt.",
  "help.topics.boutique-paiement.title": "Tazrigt & tazrigt",
  "help.topics.demarrage-navigation.description": "Sseɣ i tazrigt n tazrigt, tazrigt, tazrigt, tazrigt akked tazrigt.",
  "help.topics.demarrage-navigation.title": "Tazrigt & amezruy",
  "help.topics.demarrage-profil.description": "Sseɣ i tazrigt n tazrigt, tazrigt n tazrigt akked tazrigt.",
  "help.topics.demarrage-profil.title": "Tazrawt & imazighen",
  "help.topics.demarrage-roles.description": "Sseɣ i tazrigt n tazrigt, tazrigt n tazrigt akked tazrigt.",
  "help.topics.demarrage-roles.title": "Iɣewwa akked tazrawt",
  "help.topics.demarrage-tableau-bord.description": "Sseɣ i tazrigt n tazrigt, sseɣ i tazrigt n tazrigt akked tazrigt.",
  "help.topics.demarrage-tableau-bord.title": "Tazrigt n tazrigt",
  "help.topics.donnees-conservation.description": "Iɣewwa n tazrigt n tazrigt n tazrigt akked tazrigt.",
  "help.topics.donnees-conservation.title": "Tazrigt n tazrigt",
  "help.topics.donnees-mots-de-passe.description": "Iɣewwa n tazrigt n tazrigt, tazrigt akked tazrigt.",
  "help.topics.donnees-mots-de-passe.title": "Akkounts & tazrigt",
  "help.topics.donnees-rgpd.description": "Aghlalan n ddunit i tazrigtin deg Lyrra akked tazrigt n umdaw.",
  "help.topics.donnees-rgpd.title": "RGPD & tazrigt n tazrigtin",
  "help.topics.eduflow-blocs.description": "Ssar u paramétrer les blocs n tazrigt: tazrigt, vidéo, audio, tazrigt, brancha, etc.",
  "help.topics.eduflow-blocs.title": "Iɣewwan n blocs (tazrigt, quiz, médias…)",
  "help.topics.eduflow-branches.description": "Gérer plusieurs sorties, la convergence des chemins et les règles de navigation.",
  "help.topics.eduflow-branches.title": "Brancha & tazrigt",
  "help.topics.eduflow-concept.description": "Canvas, palette n blocs, sélection, zoom akked tazrigt n tazrigt.",
  "help.topics.eduflow-concept.title": "Tazrigt n tazrigt n umdaw",
  "help.topics.eduflow-ia.description": "Suggérer ou modifier des blocs à l'aide de l'assistant, avec relecture humaine systématique.",
  "help.topics.eduflow-ia.title": "Assistant IA deg umdaw",
  "help.topics.eduflow-objectifs.description": "Lier des objectifs aux blocs pour structurer le référentiel de votre formation.",
  "help.topics.eduflow-objectifs.title": "Aghlalan n tazrigt",
  "help.topics.eduflow-validation.description": "Utiliser le panneau Validation pour détecter erreurs et avertissements avant publication.",
  "help.topics.eduflow-validation.title": "Validation n tazrigt",
  "help.topics.eval-auto-eval.description": "Proposer des parcours adaptatifs en fonction des résultats.",
  "help.topics.eval-auto-eval.title": "Auto-évaluation & remédiation",
  "help.topics.eval-ouverte.description": "Organiser la collecte de réponses libres et la notation manuelle ou semi-automatisée.",
  "help.topics.eval-ouverte.title": "Iɣewwan n tazrigt & correction",
  "help.topics.eval-quiz.description": "Configurer barèmes, feedbacks et tentatives pour un QCM efficace.",
  "help.topics.eval-quiz.title": "Quiz & iɣewwan n tazrigt",
  "help.topics.inst-collaborateurs.description": "Ajouter des formateurs, administrateurs ou RH et gérer les permissions.",
  "help.topics.inst-collaborateurs.title": "Utilisateurs & invitations",
  "help.topics.inst-structure.description": "Définir ce qui est partagé au niveau établissement versus projets personnels.",
  "help.topics.inst-structure.title": "Structure & périmètre",
  "help.topics.inst-trash.description": "Retrouver formations ou podcasts supprimés et les restaurer si besoin.",
  "help.topics.inst-trash.title": "Corbeille & restauration",
  "help.topics.marque-accessibilite.description": "Contrastes, alternatives textuelles et navigation clavier dans les contenus.",
  "help.topics.marque-accessibilite.title": "Accessibilité & lisibilité",
  "help.topics.marque-charte.description": "Comment la marque se reflète dans le player et les espaces apprenants.",
  "help.topics.marque-charte.title": "Charte & couleurs institutionnelles",
  "help.topics.marque-landing.description": "Présenter votre offre de formation côté visiteur lorsque le module est activé.",
  "help.topics.marque-landing.title": "Pages publiques & catalogue",
  "help.topics.medias-bibliotheque.description": "Importer, organiser et réutiliser vidéos, sons, images et documents dans vos blocs.",
  "help.topics.medias-bibliotheque.title": "Bibliothèque média",
  "help.topics.medias-documents.description": "Joindre des ressources téléchargeables et lier la documentation au parcours.",
  "help.topics.medias-documents.title": "Documents & PDF",
  "help.topics.medias-studio-audio.description": "Enregistrer, mixer ou utiliser la synthèse vocale pour enrichir vos contenus.",
  "help.topics.medias-studio-audio.title": "Studio audio & voix",
  "help.topics.medias-video.description": "Bonnes pratiques de format, poids et accessibilité pour les lecteurs intégrés.",
  "help.topics.medias-video.title": "Vidéos & intégrations",
  "help.topics.podcasts-creation.description": "Structurer des épisodes, métadonnées et couvertures pour votre offre audio.",
  "help.topics.podcasts-creation.title": "Ssefru n podcast",
  "help.topics.podcasts-diffusion.description": "Iḍeḍ n tṣaḥa, tḥemmilt ḍeḍ n usage s taddart.",
  "help.topics.podcasts-diffusion.title": "Tḥemmilt & amḍan",
  "help.topics.pub-catalogue.description": "Ssefru tferkit s catalog n taddart neɣ s tferkit ma yella tḥemmlit.",
  "help.topics.pub-catalogue.title": "Catalog & tazmert",
  "help.topics.pub-liens.description": "Ssefru neɣ ssefru les liens iḍeḍ n amḍan, tḥemmilt neɣ tḥemmilt.",
  "help.topics.pub-liens.title": "Liens n tḥemmilt & tḥemmilt",
  "help.topics.pub-statuts.description": "Aḍu n tferkit: ssefru, tḥemmilt, ssefru neɣ ssefru les changements.",
  "help.topics.pub-statuts.title": "Brouillon, ssefru neɣ tazmert",
  "help.topics.qualite-qualiopi.description": "Ssefru les espaces dedd n tḥemmilt iḍeḍ n tazmert neɣ le dossier qualité.",
  "help.topics.qualite-qualiopi.title": "Pré-audit & iḍeḍ n Qualiopi",
  "help.topics.qualite-tracabilite.description": "Ssefru les objectifs, les contenus neɣ les évaluations iḍeḍ n tḥemmilt certifiant.",
  "help.topics.qualite-tracabilite.title": "Traçabilité pédagogique",
  "help.topics.support-contact.description": "Canal n support, ssefru n ticket neɣ les informations iḍeḍ n diagnostic rapide.",
  "help.topics.support-contact.title": "Ssefru le support Lyrra",
  "help.topics.support-faq.description": "Lecteur ur yella, média ur yella, erreur n ssefru: les premiers réflexes.",
  "help.topics.support-faq.title": "Problèmes fréquents",
  "help.topics.support-navigateur.description": "Versions n tḥemmilt, cookies neɣ les extensions iḍeḍ ur yella.",
  "help.topics.support-navigateur.title": "Navigateur & tḥemmilt",
  "help.topics.v2-campagnes.description": "Ssefru le déploiement n tḥemmilt iḍeḍ n populations ciblées s tmeddurt.",
  "help.topics.v2-campagnes.title": "Campagnes & plans n tferkit",
  "help.topics.v2-competences.description": "Ssefru les blocs neɣ les parcours iḍeḍ n les compétences iḍeḍ n reporting métiers.",
  "help.topics.v2-competences.title": "Référentiels n compétences",
  "help.topics.v2-integrations.description": "Iḍeḍ n exchanges s yid n SI-RH, LMS externe neɣ les outils n BI ma yella les connecteurs.",
  "help.topics.v2-integrations.title": "Intégrations & API",
  "pages.images.cancel": "Ssefru",
  "pages.images.changeFile": "Changement n fichier",
  "pages.images.copyUrl": "Ssefru l'URL",
  "pages.images.copyUrlSuccess": "URL ssefru s le presse-papiers.",
  "pages.images.copyUrlError": "Ur yella ssefru l’URL.",
  "pages.images.urlLabel": "URL n tḥemmilt",
  "pages.images.download": "Ssefru",
  "pages.images.downloadSuccess": "Ssefru yella.",
  "pages.images.downloadError": "Ur yella ssefru.",
  "pages.images.count_one": "{{count}} tasnawt s lbibliothèque nwen",
  "pages.images.count_other": "{{count}} tasnawt s lbibliothèque nwen",
  "pages.images.delete": "Ssefru",
  "pages.images.deleteAction": "Ssefru",
  "pages.images.deleteConfirmHint": "yella ssefru d definitivement.",
  "pages.images.deleteTitle": "Ssefru aṭas tasnawt ?",
  "pages.images.descriptionLabel": "Tasnawt (optionnel)",
  "pages.images.descriptionPlaceholder": "Tasnawt ssuq…",
  "pages.images.dropzoneBrowse": "sserb",
  "pages.images.dropzoneFormats": "PNG, JPG, WEBP, GIF",
  "pages.images.dropzoneLabel": "Sserb umaj n image ne",
  "pages.images.fileSize.bytes": "{{size}} o",
  "pages.images.fileSize.kb": "{{size}} Ko",
  "pages.images.fileSize.mb": "{{size}} Mo",
  "pages.images.fileSizeKb": "{{size}} Ko",
  "pages.images.importButton": "Sserb",
  "pages.images.importSubtitle": "Sserb umaj n image s wul n tazrart-ik.",
  "pages.images.importTitle": "Sserb umaj n image",
  "pages.images.noImages": "Ur tella image sserb",
  "pages.images.noResults": "Ur tella yid n tazrart",
  "pages.images.searchPlaceholder": "Sserb umaj n image…",
  "pages.images.submit": "Sserb",
  "pages.images.titleLabel": "Tittre (aɣil)",
  "pages.images.titlePlaceholder": "Isem n image…",
  "pages.images.viewGrid": "Grille",
  "pages.images.viewList": "Liste",
  "pages.images.editPanelTitle": "Ssnif umaj n image",
  "pages.images.editPanelSubtitle": "Tittre, tazrart akked isem n file. Ssnif n file yewwi yella d URL nni (yid n tazrart-ik yella d valid).",
  "pages.images.replaceFileLabel": "Umaj n image nni",
  "pages.images.replaceFileHint": "Tformat yella d aɣil n tazrart n file. URL nni ur yewwi.",
  "pages.images.fileOriginalNameLabel": "Isem n file n wul",
  "pages.images.saveChanges": "Ssnif",
  "pages.images.saveSuccess": "Image yewwi d tazrart.",
  "pages.images.saveError": "Ur tella ssnif.",
  "pages.images.editAction": "Ssnif",
  "accessibility.simplifiedTextMode": "Mode n text yessir",
  "accessibility.simplifiedTextModeDesc": "Yessir yid n texts n page yessir s IA (tazrart yella d valid). Di tazrart, texts n parcours yella d yeddu block s block.",
  "accessibility.simplifiedTextPageLoading": "Yessir n content n wul n page s IA…",
  "accessibility.simplifiedTextPageError": "Ur tella yessir n content n wul n page s waṭṭa. Redd yid nni.",
  "accessibility.imageHoverAudio": "Mode n yid n malvoyant: yeddu audio n image di survol",
  "accessibility.imageHoverAudioDesc": "Mara yella image di survol, IA yessir yid n content n visual (sseɣ base64) akked yeddu tazrart s tɣiw.",
  "accessibility.imageHoverAudio.loading": "Yeddu n tazrart audio…",
  "accessibility.imageHoverAudio.loadingTts": "Yeddu n tazrart audio…",
  "accessibility.imageHoverAudio.loadingVision": "Yessir n image akked yeddu audio…",
  "accessibility.imageHoverAudio.playing": "Yeddu n tazrart…",
  "accessibility.imageHoverAudio.error": "Ur tella yeddu audio.",
  "accessibility.imageHoverAudio.unavailable": "Ur tella tazrart audio s wul n image nni.",
  "admin.dashboard.monthlyRevenue": "Revenus n factures yessir (€)",
  "admin.dashboard.recentActivity": "Activité yessir",
  "admin.dashboard.revenue": "Revenus (aɣil)",
  "admin.dashboard.storageUsed": "Aɣbalu n tazrigt",
  "admin.dashboard.systemHealth": "Tazrawt n ussud",
  "admin.dashboard.totalUsers": "Imik",
  "admin.dashboard.userGrowth": "Imik nwen / aḍris",
  "admin.dashboard.vsLastMonth": "vs aḍris iḍegh",
  "admin.dashboard.activeToday": "Aɣbalu n yid",
  "admin.dashboard.quickActions": "Aɣbalu n tazrigt",
  "admin.shell.collapse": "Sser",
  "admin.shell.collapseSidebar": "Sser aɣbalu n tazrigt",
  "admin.shell.expandSidebar": "Sseɣ aɣbalu n tazrigt",
  "admin.shell.title": "Tazrawt",
  "admin.header.workspace": "Tazrawt n tazrigt",
  "admin.institutionDetail.pageTitle": "Iḍraren — Tazrawt",
  "admin.institutionDetail.backToList": "Sser i tazrigt",
  "auth.acceptTerms": "Nekni aɣbalu",
  "auth.accessDenied": "Aɣbalu ur nniḍen",
  "auth.and": "d",
  "auth.backToLogin": "Sser i tazrawt",
  "auth.checkInbox": "Sser i tazrigt n yid i d-yeḍḍaɣ i tazrigt n uḍu. Ihi yella ad yebɣa aḍris.",
  "auth.confirmPassword": "Sser aɣbalu",
  "auth.confirmRequired": "Sser aɣbalu n tazrigt",
  "auth.createAccount": "Ssnin aɣbalu nwen",
  "auth.email": "Imel",
  "auth.emailInvalid": "Imel ur nniḍen",
  "auth.emailPassword": "Imel & Aɣbalu",
  "auth.emailRequired": "Imel yella ad yebɣa",
  "auth.emailSent": "Imel yebɣa!",
  "auth.firstName": "Ism n yid",
  "auth.firstNameRequired": "Yella ad yebɣa",
  "auth.forgotError": "Ur yebɣa ad yebɣa i tazrigt n uḍu",
  "auth.forgotPassword": "Tazrigt ur yebɣa?",
  "auth.forgotPasswordTitle": "Tazrigt ur yebɣa?",
  "auth.goBack": "Sser iḍegh",
  "auth.goToLogin": "Sser i tazrawt",
  "auth.hasAccount": "Yella aɣbalu?",
  "auth.hidePassword": "Sser aɣbalu",
  "auth.institutionRegister": "Inscription Iḍraren",
  "auth.invalidLink": "Aɣbalu ur nniḍen",
  "auth.invalidLinkDesc": "Aɣbalu n tazrigt ur nniḍen neɣ yella ad yebɣa.",
  "auth.invalidToken": "Aɣbalu ur nniḍen neɣ yella ad yebɣa",
  "auth.lastName": "Ism n tazrigt",
  "auth.lastNameRequired": "Yella ad yebɣa",
  "auth.loginError": "Tazrigt n login. Ssir ad tzerz i tazrawt-ik.",
  "auth.loginOTP": "Login s OTP",
  "auth.loginSubtitle": "Ssir i tazrawt-ik n LyrraOne",
  "auth.newPassword": "Tazrawt n uḍu",
  "auth.otpSubtitle": "Nsentna a 6-ig n umḍak i t-email-ik",
  "auth.otpTitle": "Ssir aḍu n tazrawt",
  "auth.password": "Tazrawt",
  "auth.passwordMin": "Amin 8 yid",
  "auth.passwordMismatch": "Tazrawtin ur d-yuḍen",
  "auth.passwordRequired": "Tazrawt d-yeḍḍa",
  "auth.passwordReset": "Tazrawt tazrigt!",
  "auth.passwordResetDesc": "Tazrawt-ik i d-yeḍḍa ssuḍi.",
  "auth.privacy": "Taqsi n tazrawt",
  "auth.registerError": "Tazrigt n tazrigt.",
  "auth.registerSubtitle": "Ssir i tazrawt-ik s LyrraOne",
  "auth.requestNewLink": "Ssir aḍu n link nniḍen",
  "auth.resendCode": "Ssend aḍu",
  "auth.resendIn": "Ssend aḍu deg",
  "auth.resetError": "Tazrigt n tazrawt ur d-yuḍen",
  "auth.resetPassword": "Ssir tazrawt",
  "auth.resetPasswordSubtitle": "Ssir a tazrawt n uḍu i tazrawt-ik",
  "auth.resetPasswordTitle": "Ssir tazrawt n uḍu nniḍen",
  "auth.sendOTP": "Send aḍu n OTP",
  "auth.sendResetLink": "Send aḍu n link n tazrawt",
  "auth.showPassword": "Ssu tazrawt",
  "auth.terms": "Taqsi n tazrawt",
  "auth.termsRequired": "D-yeḍḍa ad t-yeḍḍen taqsi n tazrawt",
  "auth.welcomeBack": "Ahlan s wul-ik",
  "campaign.analytics.avgProgress": "Progression moy.",
  "campaign.analytics.avgProgressChart": "Progression moyenne",
  "campaign.analytics.completion": "Tawri n tazrawt",
  "campaign.analytics.completionPct": "Tazrawt %",
  "campaign.analytics.completionRate": "Tawri n tazrawt",
  "campaign.analytics.now": "Actuel",
  "campaign.analytics.totalParticipants": "Participants",
  "campaign.budget.none": "Ur d-yuḍen budget.",
  "campaign.budget.title": "Budget prévu",
  "campaign.col.participant": "Participant",
  "campaign.col.progress": "Progression",
  "campaign.col.status": "Statut",
  "campaign.content.placeholderTitle": "Contenus pédagogiques",
  "campaign.detail.actionError": "Aksum ur d-yuḍen.",
  "campaign.detail.back": "Akkud n lcampegnat",
  "campaign.detail.cancel": "Ssnar",
  "campaign.detail.complete": "Sghed",
  "campaign.detail.description": "Tazmert",
  "campaign.detail.launch": "Ssen",
  "campaign.detail.loadError": "Ur ttuɣal ad tssnif lcampegn.",
  "campaign.detail.missingId": "Idenfiyen ur ttuɣal.",
  "campaign.detail.noDescription": "Ur ttuɣal tazmert.",
  "campaign.detail.timeline": "Tazrigt",
  "campaign.participants.empty": "Ur ttuɣal aɣbalu n yisefra.",
  "campaign.participants.unknown": "Ur nniḍen",
  "campaign.stats.completed": "Sghed",
  "campaign.stats.enrolled": "Ineɣ",
  "campaign.stats.inProgress": "Di tazrigt",
  "campaign.stats.notStarted": "Ur ssnif",
  "campaign.tab.analytics": "Analytique",
  "campaign.tab.budget": "Budget",
  "campaign.tab.content": "Aɣbalu",
  "campaign.tab.overview": "Tazrigt n lcampegn",
  "campaign.tab.participants": "Yisefra",
  "campaign.timeline.end": "Ttawsa n tazrigt",
  "campaign.timeline.start": "Ttawsa n lcampegn",
  "campaigns.col.budget": "Budget",
  "campaigns.col.completion": "Sghed",
  "campaigns.col.enrolled": "Ineɣ",
  "campaigns.col.name": "Ism",
  "campaigns.col.period": "Tazrigt",
  "campaigns.col.status": "Tawsa",
  "campaigns.create.budget": "Budget (€)",
  "campaigns.create.budgetPlaceholder": "25000",
  "campaigns.create.departments": "Iḍrimen",
  "campaigns.create.description": "Tazmert",
  "campaigns.create.endDate": "Asle n tazrigt",
  "campaigns.create.error": "Ur ttuɣal ad ssneḍ.",
  "campaigns.create.individualSearchPlaceholder": "Sserḥi yisefra…",
  "campaigns.create.individuals": "Yisefra",
  "campaigns.create.launch": "Ssen lcampegn",
  "campaigns.create.launchNote": "Ssen ad yessnif lcampegn d yisefra s tazrigt n ttaḍa.",
  "campaigns.create.name": "Ism n lcampegn",
  "campaigns.create.namePlaceholder": "ex. Leadership 2025",
  "campaigns.create.review": "Tazmert",
  "campaigns.create.reviewFieldBudget": "Budget",
  "campaigns.create.reviewFieldName": "Ism",
  "campaigns.create.reviewFieldPeriod": "Aẓru",
  "campaigns.create.reviewContentItems": "Imazighen",
  "campaigns.create.contentSelected": "{{count}} yisel",
  "campaigns.create.selectContent": "Sselḍi les formations",
  "campaigns.create.startDate": "Aẓru n tmeddurt",
  "campaigns.create.steps.audience": "Aɣbalu n tazrawt",
  "campaigns.create.steps.basic": "Tazrawt n tmeddurt",
  "campaigns.create.steps.content": "Imazighen",
  "campaigns.create.steps.review": "Tazmert akked tazrawt",
  "campaigns.create.title": "Ssnif a campaign",
  "campaigns.dept.engineering": "Injeniyur",
  "campaigns.dept.product": "Aḍu",
  "campaigns.dept.sales": "Tazrawt",
  "campaigns.dept.marketing": "Tazrawt",
  "campaigns.dept.finance": "Aḍu n tazrawt",
  "campaigns.dept.legal": "Aḍu n tazrawt",
  "campaigns.dept.hr": "Aḍu n tazrawt",
  "campaigns.list.create": "Campaign nni",
  "campaigns.list.empty": "Ulac campaign yettwasn.",
  "campaigns.list.loadError": "Ur ttuḍiḍ ad yessineḍ les campagnes.",
  "campaigns.list.results": "campaignes",
  "campaigns.list.search": "Sserḥi les campagnes...",
  "campaigns.list.title": "Campaignes",
  "campaigns.page.documentTitle": "Campaignes - LyrraOne",
  "campaigns.sort.completion": "Tazmert",
  "campaigns.sort.enrolled": "Ineɣ",
  "campaigns.sort.name": "Ism",
  "campaigns.sort.startDate": "Aẓru n tmeddurt",
  "campaigns.status.active": "Aẓru",
  "campaigns.status.all": "Yellan",
  "campaigns.status.cancelled": "Yewwi",
  "campaigns.status.completed": "Tazmert",
  "campaigns.status.draft": "Tazmert",
  "campaigns.status.paused": "Di tazmert",
  "campaigns.status.scheduled": "Tazmert",
  "campaigns.validation.budgetRequired": "Aḍu d yebda.",
  "campaigns.validation.endDateRequired": "Aẓru n tazmert d yebda.",
  "campaigns.validation.nameRequired": "Ism n campaign d yebda.",
  "campaigns.validation.startDateRequired": "Aẓru n tmeddurt d yebda.",
  "catalog.backToCatalog": "Ssaḍ ad tazrawt",
  "catalog.categories": "Iḍraren",
  "catalog.category": "Tazrigt",
  "catalog.detailLoadError": "Ur tzemreɣ ad tḥemmleḍ tazrigt.",
  "catalog.enrollError": "Ur tzemreɣ ad tḥemmleḍ.",
  "catalog.enrollOk": "Tḥemmleḍ tzemreɣ.",
  "catalog.enrollments": "tḥemmleḍ",
  "catalog.flowFromTeacher": "Tazrigt n umḍakli",
  "catalog.format": "Tazrigt",
  "catalog.language": "Tamazight",
  "catalog.loadError": "Ur tzemreɣ ad tḥemmleḍ u catalog.",
  "catalog.missingId": "Idenfiyen ur tzemreɣ.",
  "catalog.noObjectives": "Ur ḥeqqiḍ tazrigt.",
  "catalog.noResults": "Ur ḥeqqiḍ tazrigt i tazrigt nwen.",
  "catalog.objectives": "Tazrigt / tazrigt",
  "catalog.prerequisites": "Tazrigt n tḥemmleḍ",
  "catalog.prerequisitesPlaceholder": "Tazrigt n tḥemmleḍ ɣef tazrigt ad yefkaḍ ḍaḥk.",
  "catalog.related": "Tazrigt n tazrigt",
  "catalog.results": "tazrigt(s)",
  "catalog.search": "Sserḥeḍ tazrigt…",
  "catalog.sortDuration": "Tazrigt",
  "catalog.sortName": "Isem",
  "catalog.sortPopular": "Tazrigt n tazrigt",
  "catalog.sortRating": "Tazrigt",
  "certificate.completed": "aḥemmleḍ ssuḍi.",
  "certificate.date": "Ameḍḍak",
  "certificate.download": "Ttḥemmleḍ PDF",
  "certificate.title": "Tazrigt n Tḥemmleḍ",
  "certificate.verification": "Tazrigt",
  "certification.completeToUnlock": "Sserḥeḍ ɣef tazrigt n tḥemmleḍ ad tḥemmleḍ tazrigt nwen.",
  "certification.download": "Ttḥemmleḍ",
  "certification.earned": "Tazrigt n tḥemmleḍ",
  "certification.locked": "Tazrigt",
  "certification.milestones": "tazrigt",
  "certification.preview": "Tazrigt",
  "certification.requirements": "Tazrigt n tḥemmleḍ ad yefkaḍ:",
  "certification.subtitle": "Sserḥeḍ tazrigt nwen ɣef tazrigt n tḥemmleḍ.",
  "certification.title": "Tazrigt n tḥemmleḍ",
  "codir.card.budgetAllocated": "Tazrigt n tḥemmleḍ (an n tazrigt)",
  "codir.card.campaigns": "Tazrigt n tazrigt",
  "codir.card.completionYtd": "Tazrigt n tḥemmleḍ (an n tazrigt)",
  "codir.card.costPerUser": "Tazrigt / amḍakli (tazrigt)",
  "codir.card.used": "tḥemmleḍ",
  "codir.dashboard.budgetOverview": "Tazrigt (an n tazrigt n tḥemmleḍ)",
  "codir.dashboard.competencyGaps": "Tazrigt n tmeddurt n tazrigt",
  "codir.dashboard.completionTrends": "Tazrigt s wussan",
  "codir.dashboard.completionsPerMonth": "Tazrigt / wussan",
  "codir.dashboard.deptPerformance": "Azzay n budget",
  "codir.dashboard.loadError": "Ur nsa ad tssar tazrigt.",
  "codir.dashboard.noBudget": "Ur ttsnigh",
  "codir.dashboard.noDeptData": "Ur ttsnigh tazrigt n budget",
  "codir.dashboard.noGaps": "Ur ttsnigh tazrigt n tmeddurt.",
  "codir.dashboard.remaining": "Ineggar",
  "codir.dashboard.spent": "Ttawit",
  "codir.dashboard.strategicKPIs": "Imuddu n tazrigt",
  "codir.dashboard.subtitle": "Imuddu n tmeddurt akked budget",
  "codir.dashboard.title": "Tazrigt n CODIR",
  "codir.dashboard.totalBudget": "Budget n tazrigt",
  "codir.dashboard.utilization": "Ttawit %",
  "codir.kpi.budget": "Budget ttawit",
  "codir.kpi.completion": "Tazrigt",
  "codir.kpi.recentCompletions": "Tazrigt 30 y.",
  "codir.kpi.satisfaction": "Tazmert",
  "collab.certificates.active": "aktif(s)",
  "collab.certificates.empty": "Ur ttsnigh tazrigt i wakka.",
  "collab.certificates.expires": "Yexbir s",
  "collab.certificates.issued": "Yettwasn s",
  "collab.certificates.title": "Tazrigt n yid",
  "collab.certificates.verify": "Ttawit",
  "collab.dashboard.activeTrainings": "Tmeddurt n tazrigt",
  "collab.dashboard.certificates": "Tazrigt",
  "collab.dashboard.completed": "Tazrigt",
  "collab.dashboard.level": "Azzay",
  "collab.dashboard.noActiveTrainings": "Ur ttsnigh tmeddurt n tazrigt.",
  "collab.dashboard.noCompleted": "Ur ttsnigh tmeddurt n tazrigt.",
  "collab.dashboard.noUpcoming": "Ur ttsnigh tmeddurt n tazrigt.",
  "collab.dashboard.title": "Tmeddurt n yid",
  "collab.dashboard.totalXp": "XP n tazrigt",
  "collab.dashboard.upcoming": "Azzay",
  "collab.page.documentTitle": "Tmeddurt n yid - LyrraOne",
  "collab.page.subtitle": "Sewwi tazrigt-ik akked tmeddurt-ik",
  "collab.page.tabs.certificates": "Tazrigt",
  "collab.page.tabs.dashboard": "Tazrigt",
  "collab.page.tabs.request": "Sewwi taleb",
  "collab.page.tabs.skills": "Tazrigt n yid",
  "collab.page.title": "Tmeddurt n yid",
  "collab.request.history": "Tazrawt n wudmawen",
  "collab.request.justification": "Tazrawt",
  "collab.request.justificationPlaceholder": "Ssefru amek i tazrawt a d-ttwafaq (min. 10 yennayer)…",
  "collab.request.newRequest": "Tazrawt n wudmawen nni",
  "collab.request.noHistory": "Ula d wudmawen i wakken.",
  "collab.request.preferredDate": "Tazrawt n tmeddurt",
  "collab.request.searchCatalog": "Sserreḍ deg uḍris…",
  "collab.request.submit": "Ssend tazrawt",
  "collab.request.title": "Tazrawt n tazrawt",
  "collab.request.training": "Tazrawt",
  "collab.skills.current": "Iḍrimen nni",
  "collab.skills.empty": "Ula d tazrawt i d-yefka.",
  "collab.skills.emptyHint": "Tazrawtin nwen a d-ssin ihi ma d-yefka.",
  "collab.skills.radar": "Radar n tazrawtin",
  "collab.skills.selfAssess": "Tazrawt n tazrawtin",
  "collab.skills.target": "Ameqran",
  "collab.skills.title": "Tazrawtin nwen",
  "common.back": "Akk",
  "common.cancel": "Ssnif",
  "common.close": "Sserḥ",
  "common.collaborator": "Aḍris",
  "common.comingSoon": "Di tazrawt",
  "common.comment": "Ameqran",
  "common.comments": "Ameqran",
  "common.complete": "Ssnif",
  "common.confirm": "Ssnif",
  "common.cost": "Aḍris",
  "common.current": "Iḍrimen nni",
  "common.date": "Tazrawt n tmeddurt",
  "common.delete": "Ssuḍ",
  "common.description": "Tazrawt",
  "common.download": "Sselḍ",
  "common.invalidEmail": "Email ur d-yefka",
  "common.justification": "Tazrawt",
  "common.managerComment": "Ameqran n umanager",
  "common.moveDown": "Sseḍ",
  "common.moveUp": "Sseḍ",
  "common.next": "Ssuivant",
  "common.noExpiry": "Ula d tazrawt",
  "common.noResults": "Ula d yennayer",
  "common.overall": "Ameqran",
  "common.preview": "Tazrawt",
  "common.previous": "Akkud",
  "common.publish": "Ssaḥ",
  "common.read": "sseɣ",
  "common.remove": "Sseɣ",
  "common.required": "Aɣbalu",
  "common.restore": "Sseɣ",
  "common.retry": "Ssaḥ",
  "common.save": "Sseɣ",
  "common.search": "Ttḥeqq…",
  "common.seeAll": "Sseɣ ttu",
  "common.select": "Sseɣ…",
  "common.sending": "Ttḥeqq…",
  "trainingRequest.panelTitle": "Aɣbalu n tmeddurt — iḥedran n tmeddurt",
  "trainingRequest.intro": "Sseɣ aɣbalu. Iṭṭij n RH yeddu ɣef aɣbalu; ma yeddu, yessineḍ ɣef tmeddurt.",
  "trainingRequest.fieldTitle": "Akkud n tmeddurt",
  "trainingRequest.fieldDescription": "Ttḥeqq n aɣbalu",
  "trainingRequest.fieldJustification": "Aɣbalu / iḥedran",
  "trainingRequest.fieldDate": "Asgwas n tmeddurt",
  "trainingRequest.datePlaceholder": "ex. T2 2026",
  "trainingRequest.fieldFormateur": "Aḥedrar n tmeddurt",
  "trainingRequest.formateurPlaceholder": "Sseɣ aḥedrar…",
  "trainingRequest.formateursEmpty": "Ur nḥeḍ aḥedrar yettwaslen ɣef tmeddurt nwen.",
  "trainingRequest.titleRequired": "Sseɣ akkud (2 iḥedran asgwas).",
  "trainingRequest.sent": "Aɣbalu yessineḍ. Ttḥeqq aɣbalu ɣef imail n tmeddurt.",
  "trainingRequest.sendError": "Ur nsaḥ aɣbalu. Ttḥeqq ɣef ttaḍiḍ nwen neɣ iḥedran nwen.",
  "trainingRequest.submit": "Ssend aɣbalu",
  "common.share": "Sseɣ",
  "common.startedOn": "Iḍeḍ ɣef",
  "common.status": "Ttḥeqq",
  "common.submit": "Ssend",
  "common.submittedAt": "Ssend ɣef",
  "common.title": "Akkud",
  "common.training": "Tmeddurt",
  "common.view": "Sseɣ",
  "common.words": "iwḍan",
  "compliance.download": "Sseɣ",
  "compliance.generate": "Ssaḥ",
  "compliance.generating": "Ssaḥ…",
  "compliance.lastGenerated": "Ssaḥ ɣef",
  "compliance.subtitle": "Ssaḥ neɣ ssenḍi iḥedran n tmeddurt neɣ tmeddurt.",
  "compliance.title": "Iḥedran n tmeddurt",
  "compliance.uploadEvidence": "Sseɣ aɣbalu n tmeddurt",
  "confirmDialog.cancel": "Iḍeḍ",
  "confirmDialog.confirm": "Aḍu",
  "dashboard.collaborators": "Iḍewwen",
  "dysModule.font": "OpenDyslexic",
  "dysModule.letter": "Aa",
  "dysModule.ruler": "Tazrigt",
  "dysModule.settings": "Tazrawt n dyslexia",
  "dysModule.word": "W",
  "eduflow.adaptiveReplacement.assist": "Aseggas",
  "eduflow.adaptiveReplacement.auto": "Auto",
  "eduflow.adaptiveReplacement.force": "Fercu la version jeu simplifiée pour ce bloc",
  "eduflow.adaptiveReplacement.manual": "Manuel",
  "eduflow.adaptiveReplacement.mode": "Mode",
  "eduflow.adaptiveReplacement.title": "Remplacement adaptatif",
  "eduflow.answerSubmitted": "✓ Amsay iḍeḍ ssuḍa",
  "eduflow.blocks": "Iḍewwen",
  "eduflow.collaborativeBadge": "Iḍewwen n tazrawt",
  "eduflow.contents": "Iḍewwen",
  "eduflow.correct": "✓ Iḍeḍ!",
  "eduflow.designer.autoLayoutDone": "Tazrawt aṭas iḍeḍ",
  "eduflow.designer.autoLayoutFailed": "Ur ttuḍiḍ ara tazrawt.",
  "eduflow.designer.autoLayoutNoBlocks": "Sseḍḍa aḍuḍ iḍewwen i tḥeḍḍem tazrawt.",
  "eduflow.designer.paletteCategory.institution": "Iḍewwen n tazrawt",
  "eduflow.duration": "Aḍuḍ (sekundat)",
  "eduflow.evaluation": "Tazrawt",
  "eduflow.evaluationSubmitted": "Tazrawt iḍeḍ ssuḍa",
  "eduflow.exportFlow": "Sseḍḍa Flow",
  "eduflow.flowSettings": "Tazrawt n Flow",
  "eduflow.form": "Tazrawt",
  "eduflow.formSubmitted": "Tazrawt iḍeḍ ssuḍa",
  "eduflow.incorrect": "✗ Ur iḍeḍ. Ssaḍḍiḍ.",
  "eduflow.list.coverLabel": "Tasga n tazrawt",
  "eduflow.list.coverRemove": "Sseḍḍa tasga",
  "eduflow.list.coverUpload": "Sseḍḍa tasga",
  "eduflow.list.flowProperties": "Tazrawt, tazrawt n tazrawt",
  "eduflow.list.propertiesPanelTitle": "Tazrawt n tazrawt",
  "eduflow.list.duplicatePanelTitle": "Sseḍḍa n tazrawt",
  "eduflow.list.duplicatePanelSubtitle": "Tazrawt n tazrawt: {{name}}",
  "eduflow.list.duplicateTitleSuffix": "tazrawt",
  "eduflow.list.duplicateSuccess": "Tazrawt sseḍḍa.",
  "eduflow.list.duplicateCoverHint": "Tasga akked tazrawt n tazrawt yebḍen.",
  "eduflow.list.propertiesSaveError": "Ur ttuḍiḍ ara tazrawt.",
  "eduflow.list.propertiesSaved": "Iḍelliwen yennḍen.",
  "eduflow.list.propertiesUploadError": "Tazrigt n teḍra n tazmert.",
  "eduflow.mindmap": "Mindmap",
  "eduflow.next": "Ssuɣ",
  "eduflow.noExtraConfig": "Ula d tazmert ɣef yisseg n wigi tazmert.",
  "eduflow.openQuestion": "Suʔel Iḍelli",
  "eduflow.phraseReveal.addPhrase": "Sserḥeḍ ɣef yid n tazmert",
  "eduflow.phraseReveal.autoScroll": "Tazrigt n tazmert",
  "eduflow.phraseReveal.displayDuration": "Aẓru n tazmert (s)",
  "eduflow.phraseReveal.emptyPhrase": "Tazmert ɣer",
  "eduflow.phraseReveal.noPhrases": "Ula d tazmert ɣef wigi.",
  "eduflow.phraseReveal.phraseContent": "Amazigh n tazmert",
  "eduflow.phraseReveal.phrasePlaceholder": "Sserḥeḍ i tazmert n wigi...",
  "eduflow.phraseReveal.showHistory": "Sshow ɣef tazmert n yid",
  "eduflow.quiz": "Quiz",
  "eduflow.readComplete": "Aḍu yennḍen",
  "eduflow.takeNotes": "Sserḥeḍ tazmert...",
  "eduflow.timeline.addEvent": "Aḍu n tazmert",
  "eduflow.timeline.alternatingSides": "Tazmert n iḍelliwen",
  "eduflow.timeline.animatedReveal": "Aḍu n tazmert",
  "eduflow.timeline.colorHint": "Aẓru n tazmert (aḍu)",
  "eduflow.timeline.colorLabel": "Aẓru",
  "eduflow.timeline.datePlaceholder": "Taɣult neɣ tazmert (ex. 1789, yanv. 2024)",
  "eduflow.timeline.descPlaceholder": "Aẓru (yennḍen ɣef tazmert)",
  "eduflow.timeline.events": "Iḍelliwen",
  "eduflow.timeline.horizontal": "Horiẓontale",
  "eduflow.timeline.orientation": "Tazmert",
  "eduflow.timeline.settings": "Tazmert",
  "eduflow.timeline.showConnectors": "Iḍelliwen n tazmert",
  "eduflow.timeline.untitled": "Ula d tazmert",
  "eduflow.timeline.vertical": "Vertikale",
  "eduflow.typeAnswer": "Sserḥeḍ i tazmert n wigi...",
  "eduflow.typeConfig": "Tazmert n tazmert",
  "eduflow.unsaved": "Iḍelliwen ur yennḍen",
  "eduflow.versionHistory.activateSuccess": "Version {{label}} yennḍen (aḍu)",
  "eduflow.versionHistory.activateTitle": "Yennḍen {{label}} ?",
  "eduflow.versionHistory.confirmActivate": "Yennḍen",
  "eduflow.versionHistory.copyFailed": "Tazrigt ur tazmert",
  "eduflow.versionHistory.copyHtml": "Sserḥeḍ HTML",
  "eduflow.versionHistory.copyPlain": "Sserḥeḍ tazmert n yid",
  "eduflow.versionHistory.createMajor": "Version meǧǧi",
  "eduflow.versionHistory.createMajorSuccess": "Version meǧǧi yennḍen",
  "eduflow.versionHistory.createMinor": "Version minora",
  "eduflow.versionHistory.createMinorSuccess": "Version minora tcrea",
  "eduflow.versionHistory.deleteError": "Erroure s lors de la suppression",
  "eduflow.versionHistory.deleteSuccess": "Version tssupprimt",
  "eduflow.versionHistory.deleteTitle": "Tssupprimer {{label}} ?",
  "eduflow.versionHistory.deleteWarning": "Akk d agi ttaɣt.",
  "eduflow.versionHistory.duplicateConfirm": "Dupliquer",
  "eduflow.versionHistory.duplicateError": "Erroure s lors de la duplication",
  "eduflow.versionHistory.duplicateMinor": "Dupliquer (minora)",
  "eduflow.versionHistory.duplicateSuccess": "Version tdupliqt — tcontent trestaurt d l’éditeur",
  "eduflow.versionHistory.duplicateTitle": "Dupliquer {{label}} ?",
  "eduflow.versionHistory.newFromCurrent": "Nouvelle version s d lcontent actuel",
  "eduflow.versionHistory.preview": "Aperçu",
  "eduflow.versionHistory.previewBlocks": "{{count}} blocs",
  "eduflow.versionHistory.previewEdges": "{{count}} connexions",
  "eduflow.versionHistory.previewError": "Impossible d charger l’aperçu",
  "eduflow.versionHistory.previewTitle": "Aperçu {{label}}",
  "eduflow.versionHistory.setPublic": "Activer",
  "eduflow.versionHistory.startDescModalTitle": "Descriptif — bloc Démarrage ({{version}})",
  "eduflow.videoCompleted": "Video twatcht",
  "gamification.active": "actives",
  "gamification.bestStreak": "Meilleur streak",
  "gamification.claim": "Récupérer",
  "gamification.completed": "Terminées",
  "gamification.days": "jours",
  "gamification.maxLevel": "✨ Niveau max tatti !",
  "gamification.missions": "Missions",
  "gamification.name": "Nom",
  "gamification.streakActive": "Streak en cours 🔥",
  "gamification.streakInactive": "Pas de streak actif",
  "gamification.xpRemaining": "${formatXp(xpForNextLevel - currentXp)} XP restants",
  "header.language": "Language",
  "institution.categories.color": "Couleur",
  "institution.categories.coverLabel": "Image de couverture",
  "institution.categories.coverUploadError": "Échec d l téléversement d la couverture.",
  "institution.categories.removeCover": "Retirer l’image",
  "institution.categories.descShortPh": "Décrivez l’usage d la catégorie",
  "institution.categories.edit": "Modifier la catégorie",
  "institution.categories.episodes": "épisode(s)",
  "institution.categories.learners": "apprenant(s)",
  "institution.categories.namePlaceholder": "Nom d la catégorie",
  "institution.categories.new": "Nouvelle catégorie",
  "institution.categories.preview": "Aperçu",
  "institution.categories.previewApiModeOff": "Prévisualisation indisponible (mode local).",
  "institution.categories.previewDesc": "Podcasts et parcours reliés à cette catégorie.",
  "institution.categories.previewError": "Erreur lors du chargement de l’aperçu.",
  "institution.categories.previewFormations": "Parcours / formations",
  "institution.categories.previewLoading": "Chargement de l’aperçu…",
  "institution.categories.previewNoFlows": "Aucune formation rattachée à cette catégorie.",
  "institution.categories.previewNoPodcasts": "Aucun podcast rattaché à cette catégorie.",
  "institution.categories.previewPodcasts": "Podcasts",
  "institution.categories.saveError": "Erreur lors de la sauvegarde.",
  "institution.categories.subscribers": "abonné(s)",
  "institution.categories.usageItems": "élément(s)",
  "institution.common.add": "Ajouter",
  "institution.common.cancel": "Annuler",
  "institution.common.close": "Fermer",
  "institution.common.delete": "Supprimer",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.loading": "Chargement…",
  "institution.common.name": "Nom",
  "institution.common.refresh": "Actualiser",
  "institution.common.required": "Requis",
  "institution.common.retry": "Réessayer",
  "institution.common.save": "Enregistré",
  "institution.contentPipeline.confirmDeletePath": "Supprimer ce parcours ?",
  "institution.contentPipeline.createPath": "Créer le parcours",
  "institution.contentPipeline.createPodcast": "Créer le podcast",
  "institution.contentPipeline.createShell": "Créer la fiche",
  "institution.contentPipeline.descPh": "Description / objectifs",
  "institution.contentPipeline.newPath": "Nouveau parcours",
  "institution.contentPipeline.newPodcastShell": "Pré-créer un podcast",
  "institution.contentPipeline.newShell": "Nouvelle fiche formation",
  "institution.contentPipeline.openDesigner": "Ouvrir dans le designer",
  "institution.contentPipeline.openStudio": "Épisodes",
  "institution.contentPipeline.pathDescLabel": "Description",
  "institution.contentPipeline.pathPlannedLaunch": "Date cible de lancement",
  "institution.contentPipeline.pathTitlePh": "Titre du parcours",
  "institution.contentPipeline.pickProducer": "Assigner producteur…",
  "institution.contentPipeline.pickTeacher": "Assigner…",
  "institution.contentPipeline.plannedDeadline": "Échéance",
  "institution.contentPipeline.plannedStart": "Début prévu",
  "institution.contentPipeline.planningColumn": "Planning création",
  "institution.contentPipeline.planningOptional": "Tazrigt n tazrigt (amzwaru)",
  "institution.contentPipeline.podDescPh": "Abrid / tasnif i tazrigt",
  "institution.contentPipeline.savePlanning": "Sgud tazrigt",
  "institution.contentPipeline.statFormations": "Fichas n tazrigt",
  "institution.contentPipeline.statPaths": "Abrid n tazrigt",
  "institution.contentPipeline.statPodcasts": "Podcasts",
  "institution.contentPipeline.tabFormations": "Fichas n tazrigt",
  "institution.contentPipeline.tabPaths": "Abrid",
  "institution.contentPipeline.tabPodcasts": "Podcasts",
  "institution.contentPipeline.title": "Tazrigt n tazrigt",
  "institution.contentPipeline.titlePh": "Tazrigt",
  "institution.learnerAnalytics.chartActivity": "Aghbalu akked tazrigt (8 yid n tazrigt)",
  "institution.learnerAnalytics.chartProgress": "Tazrigt n tazrigt (s wudma)",
  "institution.learnerAnalytics.chartStatus": "Tazrigt s tazrigt",
  "institution.learnerAnalytics.chartTopFlows": "Tazrigt yid n tazrigt",
  "institution.learnerAnalytics.colDone": "Tazrigt",
  "institution.learnerAnalytics.colFlow": "Tazrigt",
  "institution.learnerAnalytics.colLastAccess": "Aghbalu n tazrigt",
  "institution.learnerAnalytics.colName": "Aghbalu",
  "institution.learnerAnalytics.colTime": "Wakt",
  "institution.learnerAnalytics.count": "Ikkal",
  "institution.learnerAnalytics.done": "Tazrigt",
  "institution.learnerAnalytics.enrolled": "Ittasnin",
  "institution.learnerAnalytics.kpiEnrollments": "Ittasnin",
  "institution.learnerAnalytics.kpiLearners": "Aghbalu",
  "institution.learnerAnalytics.kpiLearnersSub": "Ittasnin i tazrigt",
  "institution.learnerAnalytics.kpiRate": "Tazrigt n tazrigt",
  "institution.learnerAnalytics.kpiRateSub": "S wudma n ittasnin",
  "institution.learnerAnalytics.kpiTime": "Wakt n tazrigt",
  "institution.learnerAnalytics.kpiTimeSub": "Wakt i tazrigt",
  "institution.learnerAnalytics.loadError": "Ur ttuɣal ara tazrigt.",
  "institution.learnerAnalytics.noData": "Ur yettwasn ara tazrigt.",
  "institution.learnerAnalytics.seriesActivity": "Aghbalu (ittasnin)",
  "institution.learnerAnalytics.seriesCompletions": "Tazrigt",
  "institution.learnerAnalytics.tableEmpty": "Ur yettwasn ara i tazrigt.",
  "institution.learnerAnalytics.tableSearch": "Sgud ism, email, tazrigt...",
  "institution.learnerAnalytics.tableTitle": "Tazrigt n ittasnin",
  "institution.learnerAnalytics.tableTruncated": "Aghbalu yid n 500 tazrigt — sɣur tazrigt i tazrigt n tazrigt.",
  "institution.learnerAnalytics.title": "Tazrigt & tazrigt n aghbalu",
  "institution.learnerAnalytics.xapiDataSourceTitle": "Aɣbalu n tazrigt & xAPI",
  "institution.learners.flowDone": "Tazrigt",
  "institution.learners.inProgress": "D tazrigt",
  "institution.menuBlocked.title": "Tazrigt ur ttsnaw",
  "institution.rhModule.pickFromMenu": "Ssiḍ aḍuḍ n umenḍu n Tazrigt & RH.",
  "institution.sirh.apiKey": "Aḍuḍ API",
  "institution.sirh.apiKeyStored": "d-yaḍen — ssiḍ aḍuḍ i ttsnaw",
  "institution.sirh.apiSecret": "Ssir / aḍuḍ nniḍen (asɣar)",
  "institution.sirh.apiSecretHint": "Yennaḍ di tazrigt X-API-Secret ma yessineḍ.",
  "institution.sirh.baseUrl": "URL n tazrigt n API",
  "institution.sirh.baseUrlHint": "Lyrra yessineḍ GET {URL}/employees s wul n Authorization: Bearer &lt;Aḍuḍ API&gt;.",
  "institution.sirh.enabled": "Tazrigt ttaḥt",
  "institution.sirh.formatTitle": "Format yessineḍ i GET /employees",
  "institution.sirh.loadError": "Ur ttsnaw aḍuḍ n SIRH.",
  "institution.sirh.mappingJob": "Poste / funtcion (jobTitle neɣ ex. position)",
  "institution.sirh.mappingTitle": "Tazrigt n yimeḍkan (JSON SIRH)",
  "institution.sirh.name": "Aḍuḍ n tazrigt",
  "institution.sirh.saveError": "Ur ttsnaw aḍuḍ.",
  "institution.sirh.saved": "Tazrigt ttsnaw.",
  "institution.sirh.secretStored": "d-yaḍen",
  "institution.sirh.syncDone": "Tazrigt : ${s.created} yessineḍ, ${s.updated} yewwiḍ, ${s.errors} ɣer, ${s.skipped} yessineḍ (aḍuḍ nniḍen).",
  "institution.sirh.syncError": "Ur ttsnaw tazrigt.",
  "institution.sirh.syncNow": "Tazrigt n umḍan",
  "institution.sirh.syncOk": "Tazrigt ttaḥt.",
  "institution.sirh.test": "Testiḍ aḍuḍ",
  "institution.sirh.testError": "Ur ttsnaw testiḍ.",
  "institution.sirh.title": "SIRH — tazrigt API",
  "institution.sirh.type": "Tayri / aḍuḍ",
  "institution.sirh.typeCustom": "API HTTP amezwaru",
  "institution.ssoOidc.autoProvision": "Ssiḍ aḍuḍ n umḍan di tazrigt nniḍen (ma yessineḍ)",
  "institution.ssoOidc.clientId": "Aḍuḍ n umḍan",
  "institution.ssoOidc.clientSecret": "Ssir n umḍan",
  "institution.ssoOidc.copied": "Yessineḍ",
  "institution.ssoOidc.copy": "Ssiḍ",
  "institution.ssoOidc.copyError": "Ur ttsnaw ssiḍ.",
  "institution.ssoOidc.defaultRole": "Rul n tazrigt (provisionnement)",
  "institution.ssoOidc.enableSsoGeneric": "Aktif aḍuḍ SSO i wul nniḍen",
  "institution.ssoOidc.flagsError": "Ur ttsnaw aḍuḍ n yimeḍkan.",
  "institution.ssoOidc.flagsSuccess": "Aḍuḍ SSO yessineḍ.",
  "institution.ssoOidc.formTitle": "Idenfiyen OpenID Connect",
  "institution.ssoOidc.issuer": "Issuer (URL)",
  "institution.ssoOidc.loadError": "Ur ttsnaw aḍuḍ n SSO.",
  "institution.ssoOidc.optionsTitle": "Aktif n tazrigt",
  "institution.ssoOidc.pageTitle": "SSO — OpenID Connect & SAML 2.0",
  "institution.ssoOidc.redirectTitle": "URL n tazrigt (callback)",
  "institution.ssoOidc.saveCredentials": "Sserḥa n iden",
  "institution.ssoOidc.saveError": "Sserḥa ur tḥeddem.",
  "institution.ssoOidc.saveOptions": "Sserḥa n uḍḍa",
  "institution.ssoOidc.saveSuccess": "Tazrigt n OpenID Connect sserḥet.",
  "institution.ssoOidc.scopes": "Scopes (ssefru d uzekka)",
  "institution.ssoOidc.secretOptional": "sserḥa ɣef aṭṭan n umḍak",
  "institution.ssoOidc.secretRequired": "Sseddeḍ aṭṭan n umḍak (tazrigt ameqran).",
  "institution.ssoOidc.tablistAria": "Protocole SSO",
  "institution.ssoSaml.acsTitle": "URL n Assertion Consumer Service (ACS)",
  "institution.ssoSaml.certOptional": "sserḥa ɣef aṭṭan n umḍak",
  "institution.ssoSaml.certificate": "Sertificat n signature IdP (PEM)",
  "institution.ssoSaml.copied": "Sserḥet",
  "institution.ssoSaml.copy": "Sserḥ",
  "institution.ssoSaml.copyError": "Sserḥ ur tḥeddem.",
  "institution.ssoSaml.downloadError": "Tazrigt n uḍḍa n métadonnées SP ur tḥeddem.",
  "institution.ssoSaml.downloadSp": "Métadonnées SP (XML)",
  "institution.ssoSaml.entityId": "Entity ID (Issuer IdP)",
  "institution.ssoSaml.manualTitle": "Paramètres IdP (manu)",
  "institution.ssoSaml.metadataEmpty": "Sserḥa XML n métadonnées IdP.",
  "institution.ssoSaml.metadataError": "Import n métadonnées ur tḥeddem.",
  "institution.ssoSaml.metadataFormTitle": "Import n métadonnées IdP (XML)",
  "institution.ssoSaml.metadataStored": "A file n métadonnées IdP yella d-ttwelleḍ.",
  "institution.ssoSaml.metadataSuccess": "Métadonnées SAML IdP sserḥet.",
  "institution.ssoSaml.metadataUrl": "URL n métadonnées IdP (aṭṭan)",
  "institution.ssoSaml.saveError": "Sserḥa SAML ur tḥeddem.",
  "institution.ssoSaml.saveManual": "Sserḥa n tazrigt SAML",
  "institution.ssoSaml.saveSuccess": "Tazrigt SAML sserḥet.",
  "institution.ssoSaml.sloUrl": "URL n deconnexion SLO (aṭṭan)",
  "institution.ssoSaml.ssoUrl": "URL n connexion SSO (IdP)",
  "institution.ssoSaml.uploadMetadata": "Sserḥa XML IdP",
  "institution.templates.blockType": "Aẓru n bloc",
  "institution.templates.create": "Sserḥ",
  "institution.templates.createDrawerTitle": "Sserḥa n modèle n bloc",
  "institution.templates.createNameRequired": "Sseddeḍ aṭṭan n tazrigt.",
  "institution.templates.editDrawerTitle": "Teggʷa n tazrigt",
  "institution.templates.modelDescPh": "Tazrigt n tazrigt",
  "institution.templates.modelNamePh": "Aṭṭan n tazrigt",
  "institution.templates.previewDrawerTitle": "Aperçu n tazrigt",
  "institution.templates.publish": "Sserḥ",
  "institution.templates.published": "Sserḥet",
  "institution.templates.typeConfig": "Tazrigt n bloc",
  "institution.templates.unpublish": "Ur sserḥ",
  "institution.xapi.accessToken": "Jeton n tazrigt (Bearer)",
  "institution.xapi.actorField": "Ameqran n umalu (tazrigt)",
  "institution.xapi.authBasic": "HTTP Basic (amuddu / uzn)",
  "institution.xapi.authBearer": "Bearer / jeton OAuth",
  "institution.xapi.authType": "Tazrigt LRS",
  "institution.xapi.enable": "Ssaḥḍeḍ l'ḥeqq n statements ɣef LRS",
  "institution.xapi.formTitle": "Iḍraren n LRS",
  "institution.xapi.loadError": "Ur nḥeḍ ara l'configurations xAPI.",
  "institution.xapi.loadStatements": "Ssaḥḍeḍ 15 statements (JSON)",
  "institution.xapi.lrsReadTitle": "Tawriḍ n lḥeqq (diagnostic)",
  "institution.xapi.lrsUrl": "URL n LRS",
  "institution.xapi.optionalKeep": "aḍu n tazrigt ɣef l'ḥeqq",
  "institution.xapi.password": "Uzn / ssen",
  "institution.xapi.payloadOptions": "Aḍan n statements (tawriḍ)",
  "institution.xapi.profile": "Profil / tazrigt",
  "institution.xapi.save": "Ssaḥḍeḍ",
  "institution.xapi.saveError": "Ur nḥeḍ ara.",
  "institution.xapi.saveSuccess": "Configuration xAPI ssaḥḍet.",
  "institution.xapi.sendCompletion": "Ssend l'complet",
  "institution.xapi.sendDuration": "Ssend l'duration",
  "institution.xapi.sendScore": "Ssend l'score",
  "institution.xapi.statementsError": "Ur nḥeḍ ara l'statements.",
  "institution.xapi.sync": "Ssaḥḍeḍ l'lot (aperçu)",
  "institution.xapi.syncError": "Ur nḥeḍ ara l'LRS.",
  "institution.xapi.test": "Testi l'LRS",
  "institution.xapi.testError": "Test ur nḥeḍ ara.",
  "institution.xapi.testFail": "Test n LRS ur ḥeḍ ara.",
  "institution.xapi.testOk": "LRS yella.",
  "institution.xapi.title": "xAPI — Iḍraren n Learning Record Store (LRS)",
  "institution.xapi.username": "Amuddu (Basic Auth)",
  "loading.label": "Ssaḥḍeḍ…",
  "manager.dashboard.loadError": "Ur nḥeḍ ara.",
  "manager.dashboard.noReports": "Ur yella ɣef umalu n umḍan di SIRH.",
  "manager.dashboard.pendingCount": "di tazrigt",
  "manager.dashboard.pendingWorkflowHint": "I workflows yellan d'awen ɣef ɣef tazrigt.",
  "manager.dashboard.pendingWorkflowTitle": "Tazrigt di l'circuit",
  "manager.dashboard.title": "Tablo n dashboard n umḍan",
  "manager.dashboard.workflowBox": "Tazrigt",
  "manager.kpi.activeTrainings": "Tazrigt n umalu",
  "manager.kpi.completionRate": "Tasa n l'complet",
  "manager.kpi.pendingWorkflow": "I workflows di tazrigt",
  "manager.nav.requests": "Tazrigt n umalu",
  "manager.nav.reviews": "Tazrigt",
  "manager.page.documentTitle": "Tazrigt n umanag - LyrraOne",
  "manager.page.subtitle": "Sserf tazrigt n tmeddurt akked tazrigt n team-ik",
  "manager.page.tabs.dashboard": "Tazrigt",
  "manager.page.tabs.requests": "Tazrigt",
  "manager.page.tabs.reviews": "Tazrigt",
  "manager.page.tabs.team": "Team",
  "manager.page.title": "Tazrigt n umanag",
  "manager.requests.commentPlaceholder": "Sserf a comment…",
  "manager.requests.empty": "Ula d tazrigt i wakken.",
  "manager.requests.title": "Tazrigt n tmeddurt",
  "manager.reviews.commentPlaceholder": "Commentaire i tazrigt-agi…",
  "manager.reviews.lastAssessment": "Tazrigt n umalu.",
  "manager.reviews.selectMember": "Sselk a tazrigt n umanag i tazrigt",
  "manager.reviews.submitted": "Tazrigt sserf",
  "manager.reviews.target": "Tazrigt",
  "manager.reviews.title": "Tazrigt n tazrigt",
  "manager.team.loadError": "Ula d tazrigt.",
  "notifications.empty": "Ula d notifications i wakken",
  "notifications.label": "Notifications",
  "notifications.markAllRead": "Sserf as tazrigt",
  "notifications.markRead": "Sserf i tazrigt",
  "notifications.title": "Notifications",
  "notifications.viewAll": "Sserf as notifications",
  "pages.branding.comingSoonDesc": "Sserf tazrigt, logos akked tazrigt n umanag n tmeddurt-ik.",
  "pages.branding.title": "Tazrigt n umanag",
  "pages.budget.comingSoonDesc": "Sserf akked sserf tazrigt n budget-ik, sserf tazrigt akked tazrigt n tmeddurt.",
  "pages.budget.description": "Sserf n budget n tmeddurt",
  "pages.budget.title": "Budget",
  "pages.campaigns.description": "Sserf n tazrigt n tmeddurt",
  "pages.campaigns.title": "Tazrigt",
  "pages.catalog.comingSoonDesc": "Sserf tazrigt n tmeddurt i wakken, sserf i tazrigt akked tmeddurt akked sserf i tmeddurt.",
  "pages.catalog.description": "Tazrigt n tmeddurt",
  "pages.catalog.title": "Tazrigt",
  "pages.certificates.comingSoonDesc": "Sserf akked sserf tazrigt n tmeddurt, tazrigt akked tazrigt n tmeddurt.",
  "pages.certificates.description": "Tazrigt n tmeddurt akked tazrigt",
  "pages.certificates.title": "Tazrigt",
  "pages.competencies.comingSoonDesc": "Sserf tazrigt n tmeddurt, sserf tazrigt akked tazrigt n tmeddurt.",
  "pages.competencies.description": "Tazrigt n tmeddurt",
  "pages.competencies.title": "Tazrigt",
  "pages.compliance.comingSoonDesc": "Sserf tazrigt n tmeddurt, tazrigt akked tazrigt n tmeddurt.",
  "pages.compliance.description": "Sserf n tmeddurt",
  "pages.compliance.title": "Tazmert",
  "pages.integrations.comingSoonDesc": "Ssned ur tazmert-nwen s yidles n RH, SIRH, LMS akked yidles nniḍen ɣef tazmert-nwen.",
  "pages.integrations.description": "Tazmert s yidles n yidles",
  "pages.integrations.title": "Tazmert",
  "pages.learners.statsAdaptiveChoice": "Aḍris n tazmert - yessuf: {{accepted}} · yefka: {{declined}}",
  "pages.learners.statsAdaptiveEvaluated": "Tazmert n tazmert: {{count}}",
  "pages.learners.statsAdaptiveReplaced": "Tazmert n tazmert n tazmert: {{count}}",
  "pages.reports.comingSoonDesc": "Ssned tazmert n yidles ɣef tazmert, tazmert akked tazmert n tazmert.",
  "pages.reports.description": "Tazmert akked tazmert n tazmert",
  "pages.reports.title": "Tazmert",
  "pages.requests.description": "Tazmert n tazmert",
  "pages.requests.title": "Tazmert",
  "pages.reviews.comingSoonDesc": "Ssned tazmert n tazmert, tazmert n tazmert akked tazmert n tazmert n tazmert.",
  "pages.reviews.description": "Tazmert akked tazmert",
  "pages.reviews.title": "Tazmert",
  "pages.settings.description": "Tazmert n tazmert-nwen akked tazmert",
  "pages.settings.title": "Tazmert",
  "pages.skills.description": "Tazmert n tazmert-nwen",
  "pages.skills.title": "Tazmert n tazmert",
  "pages.team.comingSoonDesc": "Ssned tazmert n tazmert, ssned tazmert akked tazmert n tazmert n tazmert.",
  "pages.team.description": "Tazmert n tazmert",
  "pages.team.title": "Tazmert n tazmert",
  "pages.training.comingSoonDesc": "Ssned tazmert n tazmert n tazmert, ssned tazmert-nwen akked ssned tazmert n tazmert.",
  "pages.training.description": "Tazmert n tazmert n tazmert",
  "pages.training.title": "Tazmert n tazmert",
  "pages.webhooks.comingSoonDesc": "Ssned tazmert n webhooks ɣef tazmert-nwen s yidles nniḍen akked ssned tazmert-nwen.",
  "pages.webhooks.description": "Tazmert n webhooks akked tazmert",
  "pages.webhooks.title": "Webhooks",
  "player.adaptiveGame.done": "Aḍris n tazmert n tazmert",
  "player.adaptiveGame.next": "Aḍris n tazmert",
  "player.adaptiveGame.step": "Aḍris {{index}} / {{total}}",
  "player.adaptiveGame.subtitle": "Aḍris n tazmert n tazmert n tazmert.",
  "player.adaptiveGame.title": "Tazmert n tazmert n tazmert",
  "player.adaptiveGame.validate": "Ssned",
  "player.adaptivePrompt.keepOriginal": "Ssned tazmert n tazmert",
  "player.adaptivePrompt.subtitle": "Tazmert n tazmert n tazmert n tazmert ?",
  "player.adaptivePrompt.title": "Tazmert n tazmert n tazmert n tazmert",
  "player.adaptivePrompt.useSimplified": "Ssned tazmert n tazmert",
  "player.descriptionTeleprompter": "Aḍris n tazmert",
  "player.descriptionTeleprompterOff": "Ssned tazmert",
  "player.descriptionVoiceover": "Tazmert n tazmert — tazmert n tazmert",
  "player.manualVoiceoverMic": "Ssned tazmert n tazmert ɣef tazmert n tazmert",
  "player.manualVoiceoverStudioTitle": "Studio n tazrigt n wussan",
  "player.manualVoiceoverStudioLang": "Tazrigt n wussan",
  "player.manualVoiceoverRecord": "Tazrigt",
  "player.manualVoiceoverStop": "Ssetta",
  "player.manualVoiceoverPlay": "Ssmim",
  "player.manualVoiceoverSave": "Tazrigt s wussan",
  "player.manualVoiceoverClose": "Sser",
  "player.manualVoiceoverHint": "S yiman: lxt tazrigt neɣ l'image n wussan di tazrigt iḍelli. Tazrigt, ɣef tazrigt s wussan iḍelli tazrigt n wussan.",
  "player.manualVoiceoverPreviewLoading": "Tazrigt n lqim…",
  "player.manualVoiceoverNoMic": "Mikro neɣ tazrigt ur nniḍ ara di yid n wussan.",
  "player.manualVoiceoverNoText": "Ur yella tazrigt n tazrigt iḍelli i wussan.",
  "player.manualVoiceoverSaveError": "Ur nsaɣ ara tazrigt n wussan s wussan.",
  "player.manualVoiceoverUploadError": "Tazrigt n tazrigt ur ttuɣ ara.",
  "player.manualVoiceoverSaved": "Tazrigt n wussan tazrigt s wussan.",
  "player.subflow.blockTitle": "Tazrigt n tazrigt",
  "player.subflow.defaultTitle": "Tazrigt n tazrigt",
  "player.subflow.loadError": "Ur nsaɣ ara tazrigt n tazrigt.",
  "player.subflow.loading": "Tazrigt…",
  "player.subflow.missingId": "Ur yella tazrigt n tazrigt iḍelli i wussan.",
  "player.subflow.noContext": "Ur nsaɣ ara tazrigt n tazrigt (tazrigt n yid ur nniḍ ara).",
  "player.subflow.start": "Bda tazrigt n tazrigt",
  "player.teleprompterNextParagraph": "Tazrigt n tazrigt",
  "player.teleprompterPrevParagraph": "Tazrigt n tazrigt",
  "podcast.episodes.chapters": "Tazrigt",
  "podcast.episodes.hideText": "Sseɣ lxt",
  "podcast.episodes.noChapters": "Ur yella tazrigt iḍelli.",
  "podcast.episodes.previewEpisodeTitle": "Tazrigt",
  "podcast.episodes.showText": "Sgɣ lxt",
  "qualiopi.actions": "Aksum",
  "qualiopi.completion": "Tazrigt",
  "qualiopi.noDocuments": "Ur yella tazrigt",
  "qualiopi.notes": "Tazrigt",
  "qualiopi.notesPlaceholder": "Sgɣ tazrigt…",
  "quickActions.hint": "Ssa",
  "quickActions.hintToggle": "i tazrigt",
  "quickActions.title": "Aksum n tazrigt",
  "rh.achievements": "Aksum",
  "rh.addComment": "Sgɣ tazrigt...",
  "rh.addCompetency": "Sgɣ tazrigt",
  "rh.afterApproval": "S yid n tazrigt",
  "rh.alert.forecast": "Tazrigt n tazrigt n wussan",
  "rh.alert.workflow": "Tazrigt n tazrigt",
  "rh.all": "Yid",
  "rh.allCompetencies": "Yid n Competencies",
  "rh.allDepartments": "Yid n Departments",
  "rh.allocated": "Alaou",
  "rh.approvalHistory": "Tazmert n Tazmert",
  "rh.approve": "Ala",
  "rh.approveConfirm": "Ssi tazmert ad t-ala yid n tazmert agi?",
  "rh.approveRequest": "Ala tazmert",
  "rh.approveSelected": "Ala",
  "rh.approved": "Ala",
  "rh.auditDateUnknown": "Ur nsen",
  "rh.auditOverdue": "Audit yid n tazmert",
  "rh.auditScheduleHint": "Ad d-efren di tazmert n tazmert",
  "rh.avgGap": "Ala n Tazmert",
  "rh.avgLevel": "Ala n Ighil",
  "rh.avgOverall": "Ala n Ighil",
  "rh.budget.subtitle": "Tazmert n budget i ROI",
  "rh.budget.title": "Budget n tazmert",
  "rh.budgetAlerts": "Alerte",
  "rh.budgetDashboard": "Budget n tazmert",
  "rh.budgetLoadError": "Ur t-ssin budget.",
  "rh.budgetRemaining": "Budget i yid",
  "rh.byDepartment": "Budget i yid n d-ig",
  "rh.competencies": "competencies",
  "rh.competencyMap": "Tazmert n Competency",
  "rh.competencyRadar": "Radar n Competency",
  "rh.completion": "Aman",
  "rh.compliance": "Tazmert",
  "rh.complianceAuditAction.qualiopi_corrective_action_create": "Ala d-ufr n tazmert Qualiopi",
  "rh.complianceAuditAction.qualiopi_corrective_action_delete": "Ssi d-ufr n tazmert Qualiopi",
  "rh.complianceAuditAction.qualiopi_corrective_action_update": "D-efren d-ufr n tazmert Qualiopi",
  "rh.complianceAuditAction.qualiopi_evidence_create": "Ala d-ufr n tazmert Qualiopi",
  "rh.complianceAuditAction.qualiopi_indicator_update": "D-efren d-indicateur Qualiopi",
  "rh.complianceAuditAction.compliance_regulatory_watch_create": "Ala d-ufr n tazmert n tazmert",
  "rh.complianceAuditAction.compliance_regulatory_watch_update": "D-efren d-ufr n tazmert n tazmert",
  "rh.complianceAuditAction.compliance_regulatory_watch_delete": "Ssi d-ufr n tazmert n tazmert",
  "rh.complianceCritical": "Tazmert: iḍraren n tazmert ur d-efren.",
  "rh.complianceGood": "Ih, tazmert n-ik yid n tazmert Qualiopi. Iḍraren ad d-efren.",
  "rh.compliancePage.documentTitle": "Tazmert & Qualiopi - LyrraOne",
  "rh.compliancePage.subtitle": "Tazmert n tazmert n tazmert i tazmert Qualiopi",
  "rh.compliancePage.tabs.dashboard": "Tabl n tazmert",
  "rh.compliancePage.tabs.difficulty": "Tazmert",
  "rh.compliancePage.tabs.handicap": "Aɣilif n handikap",
  "rh.compliancePage.tabs.learnerBilan": "Bilan n tɣerma",
  "rh.compliancePage.tabs.qualiopi": "Qualiopi",
  "rh.compliancePage.tabs.regulatory": "Tazmert n tazmert",
  "rh.regulatoryWatch.lyrraBadge": "LyrraOne",
  "rh.regulatoryWatch.ofResponse": "Aɣilif n wawal / tazmert",
  "rh.regulatoryWatch.ofResponsePlaceholder": "Aɣilif i d-ttwelfiḍ ɣef…",
  "rh.regulatoryWatch.ackStatus": "Tazmert",
  "rh.regulatoryWatch.ack.pending": "A t-ttwelfiḍ",
  "rh.regulatoryWatch.ack.read": "Aɣilif i d-ttwelfiḍ (lu)",
  "rh.regulatoryWatch.ack.actionTaken": "Aɣilif i d-ttwelfiḍ",
  "rh.regulatoryWatch.ack.notApplicable": "Ur n-ttwelfiḍ",
  "rh.regulatoryWatch.pdf.title": "Tazmert n tazmert",
  "rh.regulatoryWatch.pdf.subtitleFallback": "Tazmert",
  "rh.regulatoryWatch.pdf.generatedAt": "Aɣilif i d-ttwelfiḍ ɣef {{date}}",
  "rh.regulatoryWatch.pdf.colDate": "Aɣilif",
  "rh.regulatoryWatch.pdf.colCategory": "Cat.",
  "rh.regulatoryWatch.pdf.colTitle": "Tazmert",
  "rh.regulatoryWatch.pdf.colDesc": "Tazmert (tɣerma)",
  "rh.regulatoryWatch.pdf.colImpact": "Aɣilif",
  "rh.regulatoryWatch.pdf.colOrigin": "Aɣilif",
  "rh.regulatoryWatch.pdf.colStatus": "Tazmert",
  "rh.regulatoryWatch.pdf.colAction": "Aɣilif",
  "rh.regulatoryWatch.pdf.colWho": "Aɣilif",
  "rh.regulatoryWatch.pdf.colWhen": "Aɣilif n tazmert",
  "rh.regulatoryWatch.pdf.originLyrra": "LyrraOne",
  "rh.regulatoryWatch.pdf.originOf": "OF",
  "rh.regulatoryWatch.pdf.readYes": "Lu",
  "rh.regulatoryWatch.pdf.readNo": "Ur lu",
  "rh.regulatoryWatch.pdf.actionDone": "Aɣilif i d-ttwelfiḍ",
  "rh.regulatoryWatch.pdf.actionOpen": "Aɣilif i d-ttwelfiḍ",
  "rh.regulatoryWatch.pdf.emptyWatch": "Ur t-ttwelfiḍ i d-ttwelfiḍ",
  "rh.regulatoryWatch.pdf.auditSection": "Tazmert n tazmert (tazmert)",
  "rh.regulatoryWatch.pdf.auditHint": "Aɣilif i d-ttwelfiḍ ɣef tazmert.",
  "rh.regulatoryWatch.pdf.emptyAudit": "Ur t-ttwelfiḍ i d-ttwelfiḍ",
  "rh.regulatoryWatch.exportPdf": "Ssefru PDF",
  "rh.regulatoryWatch.exportPdfBusy": "Ssefru PDF…",
  "rh.regulatoryWatch.exportPdfError": "Ssefru PDF ur t-ttwelfiḍ",
  "rh.compliancePage.tabs.satisfaction": "Satisfaction",
  "rh.compliancePage.title": "Tazmert & Qualiopi",
  "rh.complianceWarning": "Aɣilif n tazmert i d-ttwelfiḍ ɣef tazmert.",
  "rh.compliant": "conformes",
  "rh.confirm": "Akked n Tazmert",
  "rh.confirmReject": "Akked n Tazmert n Tazmert",
  "rh.consumed": "Tazmert",
  "rh.costInfo": "Akhbar n Tazmert",
  "rh.critical": "Akkud",
  "rh.criticalGaps": "Akkud (Ameqqar)",
  "rh.current": "Ameqqar",
  "rh.currentLevel": "Ameqqar n Izzur",
  "rh.date": "Asgwas",
  "rh.daysRemaining": "yur n tazmert",
  "rh.department": "Tazmert",
  "rh.departmentBreakdown": "Tazmert n Tazmert",
  "rh.departments": "tazmert",
  "rh.description": "Tazmert",
  "rh.edit": "Ssned",
  "rh.employee": "Ameqqar",
  "rh.employeeInfo": "Akhbar n Ameqqar",
  "rh.evolution": "Tazmert",
  "rh.evolutionTimeline": "Tazmert n Tazmert",
  "rh.exportReport": "Ssend",
  "rh.gapAnalysis": "Tazmert n Tazmert",
  "rh.growth": "Tazmert n wussan",
  "rh.lastUpdated": "Tazmert n tazmert",
  "rh.level": "Izzur",
  "rh.manager": "Akkud",
  "rh.needsWork": "a tazmert",
  "rh.nextAudit": "Tazmert n tazmert",
  "rh.noAlerts": "Akkud n tazmert.",
  "rh.noAllocations": "Akkud n tazmert n tazmert.",
  "rh.noDeptData": "Akkud n tazmert",
  "rh.noGaps": "Akkud n tazmert i tazmert.",
  "rh.of": "n",
  "rh.ofTotal": "n tazmert",
  "rh.overallCompliance": "Tazmert n tazmert",
  "rh.pending": "Akkud",
  "rh.provider": "Akkud",
  "rh.qualiopiCompliance": "Tazmert n Qualiopi",
  "rh.qualiopiEmpty": "Akkud n tazmert Qualiopi i tazmert.",
  "rh.qualiopiLoading": "Tazmert n Qualiopi...",
  "v2.compliance": "Tazmert & Qualiopi",
  "rh.radar": "Radar",
  "rh.reject": "Tazmert",
  "rh.rejectConfirm": "D tzemreḍ ɣef tazrigt n tazmert? ",
  "rh.rejectRequest": "Sseɣ tazrigt",
  "rh.rejectSelected": "Sseɣ",
  "rh.rejected": "Sseɣt",
  "rh.remaining": "Iḍeɣ",
  "rh.requestInfo": "Akked n tazrigt",
  "rh.requests.subtitle": "Workflow n tazrigt d validasyon",
  "rh.requests.title": "Tazrigt n tazmert",
  "rh.required": "Iḍeɣ",
  "rh.rh": "RH",
  "rh.saveAssessment": "Sseɣ asnaw",
  "rh.searchCompetencies": "Tzriḍ tazmert…",
  "rh.selfAssess": "Nneɣ",
  "rh.showing": "Iḍeɣ",
  "rh.skillsSelfAssessment": "Tazmert d asnaw n nneɣ",
  "rh.spending": "Tazrigt",
  "rh.spendingTimeline": "Tazrigt s yennayer",
  "rh.status": "Aɣbalu",
  "rh.targetLevel": "Aɣbalu n tazmert",
  "rh.totalBudget": "Budgɛt n tazrigt",
  "rh.totalGaps": "Iḍeɣ n tazrigt",
  "rh.training": "Tazmert",
  "rh.trainingCost": "Aɣbalu n tazmert",
  "rh.trainingRequests": "Tazrigt n tazmert",
  "search.close": "ɣef tɣi",
  "search.input": "Tzriḍ n tazrigt",
  "search.navigate": "ɣef tazrigt",
  "search.placeholder": "Tzriḍ n lɛaq, projet, workflow...",
  "search.recent": "Aɣbalu",
  "search.select": "ɣef tazrigt",
  "search.title": "Tzriḍ",
  "status.completed": "Tazmert",
  "status.inProgress": "D uḍḍi",
  "status.notStarted": "Ur tzemreḍ",
  "store.noResults": "Ur tṭṭfaḍ tazrigt",
  "store.subtitle": "Sseɣ tazmert, templates d iḍeɣ n tazmert i d-ttwelleḍ",
  "webinar.room.closeParticipantCamerasView": "Sseɣ",
  "webinar.room.hideParticipantCameras": "Sseɣ tazmert n caméras",
  "webinar.room.participantCamerasViewTitle": "Caméras n tazmert",
  "webinar.room.showParticipantCameras": "D-ttwelleḍ caméras n tazmert",
  "designer.ctx.addBlock": "Sseɣ bloc",
  "designer.ctx.blockInfo": "Akked n bloc",
  "designer.ctx.changeColor": "Swiḍ n tazwart",
  "designer.ctx.copy": "Ssiḍ",
  "designer.ctx.delete": "Sseḥḥar",
  "designer.ctx.duplicate": "Ssiḍ n tazwart",
  "designer.ctx.edit": "Sseḥḥel",
  "designer.ctx.fitView": "Swiḍ n tazwart",
  "designer.ctx.lock": "Sseḥḥel",
  "designer.ctx.paste": "Sseḥḥel",
  "designer.ctx.toggleGrid": "Grille ON/OFF",
  "designer.ctx.toggleMinimap": "Minimap ON/OFF",
  "designer.ctx.unlock": "Sseḥḥel",
  "designer.edge.cancel": "Sseḥḥel",
  "designer.edge.color": "Tazwart",
  "designer.edge.name": "Isem",
  "designer.edge.namePlaceholder": "ex. Réussi, Branche A…",
  "designer.edge.save": "Sseḥḥel",
  "designer.edge.title": "Tazwart",
  "designer.gamification.badgeName": "Isem n badge",
  "designer.gamification.badges": "Badges",
  "designer.gamification.blocksGte": "Blocs ≥",
  "designer.gamification.bonusPerfect": "Bonus n tazwart amezwaru (quiz)",
  "designer.gamification.condition": "Tazwart",
  "designer.gamification.conditionPlaceholder": "ex: quiz_completed >= 3",
  "designer.gamification.description": "Tazwart",
  "designer.gamification.enable": "Swiḍ",
  "designer.gamification.enableLeaderboard": "Swiḍ n tazwart",
  "designer.gamification.icon": "Ikoni",
  "designer.gamification.leaderboard": "Tazwart",
  "designer.gamification.missionDesc": "Tazwart (ex: Terminer 3 quiz)",
  "designer.gamification.missionTitle": "Isem n tazwart",
  "designer.gamification.missions": "Tazwart",
  "designer.gamification.noBadges": "Ur n badge",
  "designer.gamification.noMissions": "Ur n tazwart",
  "designer.gamification.points": "Iḍrimen",
  "designer.gamification.pointsPerBlock": "Iḍrimen seg bloc",
  "designer.gamification.pointsPerSecond": "Iḍrimen seg ssaḥ",
  "designer.gamification.publicLeaderboard": "Tazwart amezwaru",
  "designer.gamification.reward": "Tazwart",
  "designer.gamification.scoreGte": "Score ≥",
  "designer.gamification.timeBonus": "Bonus n tazwart",
  "designer.gamification.title": "Gamification",
  "designer.gamification.topN": "Swiḍ n top N",
  "designer.objectives.add": "Seddar",
  "designer.objectives.addTitle": "Seddar un objectif",
  "designer.objectives.cancel": "Ssar",
  "designer.objectives.category": "Aɣbalu",
  "designer.objectives.completed": "Sɣur",
  "designer.objectives.empty": "Ur illi ara objectif.",
  "designer.objectives.emptyHint": "Seddar iḍelli nwen n objectifs pédagogiques.",
  "designer.objectives.errorToast": "Tawuri n tazmert",
  "designer.objectives.level": "Aɣbalu (Bloom)",
  "designer.objectives.linkedBlocks": "Blocs yellan",
  "designer.objectives.noContentBlocks": "Ur illi ara bloc n content.",
  "designer.objectives.required": "Aḍu",
  "designer.objectives.save": "Ssefru",
  "designer.objectives.savedToast": "Objectifs ssefru",
  "designer.objectives.scoreGte": "Score ≥",
  "designer.objectives.title": "Objectifs pédagogiques",
  "designer.objectives.update": "Ssnif",
  "designer.validation.circularPath": "Tazmert circular tazmurt",
  "designer.validation.duplicateStart": "Bloc Départ yellan ddu",
  "designer.validation.invalid": "Ur illi ara",
  "designer.validation.noEnd": "Ur illi ara bloc Fin yellan. Yella ddu 1.",
  "designer.validation.noIssues": "Ur illi ara problemi yellan",
  "designer.validation.noStart": "Yella ddu bloc Départ (ur illi ara).",
  "designer.validation.title": "Validation",
  "designer.validation.untitled": "Ur illi ara tittel",
  "designer.validation.valid": "Valid",
  "designer.validation.errorCount": "{{count}} tawuri(n)",
  "designer.validation.warningCount": "{{count}} aḍu(n)",
  "designer.validation.titleRequired": "Bloc « {{type}} » yella ddu tittel.",
  "designer.validation.summary": "Parcours : {{blocks}} bloc(s), {{edges}} liaison(s).",
  "designer.validation.multipleStart": "Akked blocs Départ ({{count}}) : yella ddu ɣer waḥed.",
  "designer.validation.noOutgoing": "Bloc « {{type}} » ur illi ara liaisons yellan ɣer bloc iḍelli.",
  "designer.validation.tooManyOutputs": "« {{label}} » : tazmurt n liaisons yellan ({{count}}, maximum {{max}}).",
  "designer.validation.deadEndBranch": "Branche ur illi ara tazmurt ɣer bloc Fin (s ɣer « {{label}} »).",
  "designer.validation.moreDeadEnds": "… akked {{count}} aḍu(n) branche(s) ur illi ara tazmurt ɣer fin.",
  "designer.validation.noConvergence": "Les branches s ɣer « {{label}} » ur illi ara yelḍen ɣer bloc iḍelli.",
  "designer.validation.orphanBlock": "Bloc ur illi ara s ɣer graphe amḍan : « {{title}} ». ",
  "designer.validation.endHasOutgoing": "Bloc Fin « {{title}} » yella ddu liaisons yellan.",
  "designer.validation.noScoring": "Paramètres n score ur illi ara s ɣer « {{title}} ». ",
  "designer.validation.emptyText": "Bloc texte « {{title}} » ur illi ara.",
  "designer.validation.textTooLong": "Bloc texte « {{title}} » yella ddu {{lines}} lines. Recommandé : {{min}} ɣer {{max}} lines.",
  "designer.validation.splitTextBlock": "Ssefru",
  "designer.validation.textSplitNotNeeded": "Akkud nniḍen ur d-yexdem ara i tazrawt n tmeddurt.",
  "designer.validation.textSplitUnable": "Ur d-ttwafaq ara i tazrawt n tmeddurt.",
  "designer.validation.textSplitComplexFlow": "Ur d-yexdem ara i tazrawt n tmeddurt (tazrawt n yidles/taḍra).",
  "designer.validation.textSplitDone": "{{count}} tazrawt n tmeddurt i d-yekken.",
  "designer.validation.textSplitConfirmTitle": "Tazrawt n tmeddurt « {{title}} »?",
  "designer.validation.textSplitConfirmMessage": "Tazrawt « {{title}} » yella d-yeḍḍen i {{lines}} tmeddurt. Nekk d-nessefru i {{parts}} tazrawt (tazrawt n tmeddurt i tazrawt n yidles) akked d-nessefru i tmeddurt nniḍen, di l-ǝmḍak.",
  "designer.validation.textSplitConfirmAction": "Tazrawt n tmeddurt",
  "designer.validation.formFieldRefsMissing": "« {{title}} » : tazrawt n tmeddurt ur d-yexdem ara : {{refs}}.",
  "designer.validation.formFieldRefsOrder": "« {{title}} » : tazrawt n tmeddurt ur d-yexdem ara {{refs}} — tazrawt n tmeddurt i d-yeḍḍen yella d-yeḍḍen i tmeddurt nniḍen.",
  "designer.confirmDeleteForm.title": "Tzid tazrawt n tmeddurt ?",
  "designer.confirmDeleteForm.message": "Yella d-yeḍḍen i tazrawt n tmeddurt i d-yekken i tmeddurt /id/. I tazrawt nniḍen yella d-yeḍḍen i tmeddurt. Nekk d-nessefru i tmeddurt akked ⌘Z ou Ctrl+Z.",
  "designer.confirmDeleteForm.batchTitle": "Tzid tazrawt n tmeddurt ?",
  "designer.confirmDeleteForm.batchMessage": "Tazrawt nniḍen yella d-yeḍḍen i tazrawt n tmeddurt. I tazrawt nniḍen i d-yekken i tmeddurt /id/ yella d-yeḍḍen i tmeddurt. Nekk d-nessefru i tmeddurt akked ⌘Z ou Ctrl+Z.",
  "designer.variables.camelCaseError": "Ism yella d-yeḍḍen i camelCase (ex: maVariable)",
  "designer.variables.copy": "Sser",
  "designer.variables.custom": "Tazrawt n tmeddurt nniḍen",
  "designer.variables.defaultValue": "Akkud n tmeddurt",
  "designer.variables.howToTitle": "Amek d-yeḍḍen i tazrawt n tmeddurt:",
  "designer.variables.noCustom": "Ur d-yekken ara tazrawt n tmeddurt nniḍen",
  "designer.variables.system": "Tazrawt n tmeddurt n tmeddurt",
  "designer.variables.systemHint": "Tmeddurt nniḍen — yella d-yeḍḍen i tazrawt n tmeddurt",
  "designer.variables.title": "Tazrawt n tmeddurt",
  "designer.variables.type": "Tazrawt",
  "voicePanel.title": "Tmeddurt n tmeddurt",
  "voicePanel.provider": "Tazrawt: Mistral AI",
  "voicePanel.hint": "Sselḍu tmeddurt i tmeddurt n tazrawt n tmeddurt.",
  "voicePanel.multiLangHint": "I tmeddurt n Mistral i tmeddurt (12 tmeddurt n tmeddurt), sselḍu tmeddurt n tmeddurt (ikona n tmeddurt di l-bar n tmeddurt).",
  "voicePanel.translationFrenchFallback": "Tazrawt n tmeddurt: ur d-yekken ara tmeddurt n tmeddurt i tmeddurt, l-motor yella d-yeḍḍen « Marie - sad » (Mistral) i tmeddurt, tmeddurt akked tmeddurt, akked « Paul - sad » i tmeddurt nniḍen.",
  "voicePanel.search": "Sser…",
  "voicePanel.allLanguages": "Tazrawt n tmeddurt",
  "voicePanel.loading": "Tmeddurt n tmeddurt…",
  "voicePanel.loadError": "Ur d-yekken ara tmeddurt n tmeddurt",
  "voicePanel.empty": "Ur d-yekken ara tmeddurt.",
  "voicePanel.emptyHint": "Sselḍu tazrawt n API Mistral di l-Administration → Tazrawt.",
  "voicePanel.noResults": "Ur d-yekken ara tmeddurt i tmeddurt n tmeddurt.",
  "voicePanel.saved": "Tmeddurt n tmeddurt i d-yekken.",
  "voicePanel.saveError": "Tazrawt n tmeddurt i d-yekken.",
  "voicePanel.default": "Par défaut",
  "voicePanel.female": "Féminine",
  "voicePanel.male": "Masculine",
  "voicePanel.playPreview": "Tester la voix",
  "voicePanel.stopPreview": "Arrêter",
  "voicePanel.noPreview": "Aɣbalu ur nttwaf",
  "voicePanel.previewLoading": "Iɣggen…",
  "voicePanel.previewGenerateError": "Ur nsaɣ iɣggen aɣbalu audio.",
  "voicePanel.previewPlayError": "Aɣbalu audio ur nttfa.",
  "voicePanel.filterNoVoicesForLang": "Ur nttwaf aɣbalu n uɣdud i tazwara — ssaɣ « Tazwara n uɣdud ».",
  "episodeEditor.voicePicker.blockVoice": "Aɣbalu i yissek",
  "episodeEditor.voicePicker.defaultVoice": "Aɣbalu n tazwara",
  "episodeEditor.voicePicker.voices": "aɣbalu",
  "episodeEditor.voicePicker.searchPlaceholder": "Ssaɣ aɣbalu…",
  "episodeEditor.voicePicker.noVoiceFound": "Ur nttwaf aɣbalu",
  "episodeEditor.voicePicker.female": "Tazrigt",
  "episodeEditor.voicePicker.male": "Tazriqt",
  "episodeEditor.voicePicker.stop": "Ssaɣ",
  "episodeEditor.voicePicker.preview": "Tazmert aɣbalu",
  "episodeEditor.voicePicker.stopPlayback": "Ssaɣ aɣbalu",
  "episodeEditor.errors.notFound": "Aɣbalu ur nttwaf",
  "episodeEditor.errors.titleRequired": "Aɣbalu n tazwara yella d req.",
  "episodeEditor.errors.saveFailed": "Aɣbalu n tazmert ur nttfa.",
  "episodeEditor.errors.noVoicesAvailable": "Ur nttwaf aɣbalu. Ssaɣ aɣbalu n API di Administration → Intégrations plateforme, ssaɣ aɣbalu n page.",
  "episodeEditor.errors.selectVoiceFirst": "Ssaɣ aɣbalu di tazwara « Aɣbalu » iɣggen aɣbalu n tazmert.",
  "episodeEditor.errors.invalidBlockVoice": "Yella d aɣbalu ur nttwaf. Fkku aɣbalu n tazwara i yissek neɣ ssaɣ aɣbalu n aɣbalu.",
  "episodeEditor.errors.addTextFirst": "Ssaɣ tazwara iɣggen aɣbalu audio.",
  "episodeEditor.errors.audioGenerationFailedApi": "Ur nsaɣ aɣbalu audio. {{message}} (tazmert n tazwara = asnaw.)",
  "episodeEditor.errors.audioGenerationFailed": "Aɣbalu n tazmert audio ur nttfa. Tazmert n tazwara = asnaw.",
  "episodeEditor.success.published": "Aɣbalu yella d published!",
  "episodeEditor.success.draftSaved": "Tazmert yella d saved",
  "episodeEditor.success.audioGenerated": "Aɣbalu audio yella d iɣggen aɣbalu {{count}} yissek",
  "episodeEditor.tabs.edit": "Tazmert",
  "episodeEditor.tabs.chapters": "Tazwara",
  "episodeEditor.tabs.voice": "Aɣbalu",
  "episodeEditor.tabs.podcasts": "Podcasts",
  "episodeEditor.toolbar.undo": "Aɣbalu (Ctrl+Z)",
  "episodeEditor.toolbar.redo": "Rétablir (Ctrl+Y)",
  "episodeEditor.toolbar.generating": "Iɣggen…",
  "episodeEditor.toolbar.generateAudio": "Iɣggen audio",
  "episodeEditor.toolbar.save": "Ssaɣ",
  "episodeEditor.toolbar.publish": "Publier",
  "episodeEditor.titlePlaceholder": "Aɣbalu n tazwara…",
  "episodeEditor.status.published": "Published",
  "episodeEditor.status.draft": "Draft",
  "episodeEditor.warnings.mistralNotConfigured": "Aɣbalu audio n tazwara yella d Mistral Voxtral TTS. Ssaɣ aɣbalu n Mistral di Administration → Intégrations plateforme, ssaɣ aɣbalu n page.",
  "episodeEditor.warnings.mistralNoVoices": "Aɣbalu n Mistral yella d recognized, mais l'API ur nttfa aɣbalu. Ssaɣ aɣbalu n logs n backend.",
  "episodeEditor.warnings.voiceLoadFailed": "Ur nttwaf n tazwit n uḍu. Sserḥeḍ aṭṭan Mistral di Administration → Integrations plateforme.",
  "episodeEditor.warnings.voiceOffDisabled": "Ula d uḍu nniḍen, tazwit n uḍu off tḥeddar ur tḥeddar.",
  "episodeEditor.edit.voiceOff": "Uḍu off",
  "episodeEditor.edit.voiceDescription": "S wul: tazwit Mistral Voxtral (tab n Uḍu neɣ pastille di lɣef) neɣ tazwit n mic. « Tazwit audio » tḥeddar aḍu n yid n tazwit di lqim.",
  "episodeEditor.edit.coverImage": "Taswira n tazwit",
  "episodeEditor.edit.coverAlt": "Taswira n l'épisode",
  "episodeEditor.edit.deleteCover": "Sserḥeḍ",
  "episodeEditor.edit.dropOrClickImage": "Clickeḍ neɣ ddu taswira",
  "episodeEditor.edit.selectedVoice": "Uḍu aḥḍar",
  "episodeEditor.edit.selectVoice": "Sleḥ uḍu",
  "episodeEditor.edit.defaultVoiceByLang": "Uḍu n tazwit (tamazight n podcast)",
  "episodeEditor.edit.lastAudioGenerated": "Aḍu n tazwit aḥḍar",
  "episodeEditor.edit.audioNotFound": "Fichier audio ur nttwaf — regénérez la voix off.",
  "episodeEditor.edit.generatingInProgress": "Tazwit di tazrigt…",
  "episodeEditor.edit.generateVoiceOff": "Tazwit uḍu off",
  "episodeEditor.chapters.title": "Iḥedran",
  "episodeEditor.chapters.add": "Ssefḍeḍ",
  "episodeEditor.chapters.defaultChapterTitle": "Tazwit",
  "episodeEditor.chapters.newChapterTitle": "Iḥedr {{n}}",
  "episodeEditor.chapters.blockCount": "{{count}} bloc(s)",
  "episodeEditor.chapters.readByAi": "Tazwit iḍu n l'IA",
  "episodeEditor.chapters.readByAiHint": "Ma ddu, l'IA tḥeddar tazwit n iḥedr qbel tazwit n yid n blocs (mḥeḍ uḍu off). Les blocs yebḍen ur tḥeddar.",
  "episodeEditor.voiceTab.availableVoices": "Uḍu n tazwit yebḍen",
  "episodeEditor.podcasts.linked": "Podcasts yebḍen",
  "episodeEditor.podcasts.assign": "Ssefḍeḍ",
  "episodeEditor.podcasts.noneAvailable": "Ur nttwaf podcast yebḍen",
  "episodeEditor.podcasts.close": "Sserḥeḍ",
  "episodeEditor.podcasts.noneLinked": "Ur nttwaf podcast yebḍen",
  "episodeEditor.podcasts.assignHint": "Ssefḍeḍ aḍu n tazwit iḥedr neɣ i podcasts iḍu",
  "episodeEditor.podcasts.remove": "Sserḥeḍ",
  "episodeEditor.editor.addTextBlock": "Ssefḍeḍ bloc n tazwit",
  "episodeEditor.editor.scriptPlaceholder": "Sseḥḥeḍ aḍu n script…",
  "episodeEditor.editor.addBlock": "Ssefḍeḍ bloc",
  "episodeEditor.block.source": "Aselmad",
  "episodeEditor.block.sourceTts": "IA",
  "episodeEditor.block.sourceMic": "Mic",
  "episodeEditor.block.pauseBefore": "Aḍu qbel",
  "episodeEditor.block.pauseBeforeHint": "Silence qbel n tḥeddar aḍu n bloc (lqim).",
  "episodeEditor.block.pause0": "0 s",
  "episodeEditor.block.pause05": "0,5 s",
  "episodeEditor.block.pause1": "1 s",
  "episodeEditor.block.record": "Sserḥeḍ",
  "episodeEditor.block.stopRecording": "Ssaḥ",
  "episodeEditor.block.microMode": "Aḍḍar n micro i wakken",
  "episodeEditor.block.notesRecordingPlaceholder": "Aḍḍay n tazmert (ur yettwasen s micro)",
  "episodeEditor.block.removeRecording": "Ssiḍ audio",
  "episodeEditor.edit.audioMixedHumanAndAi": "Tiziri IA + tazmert n micro",
  "episodeEditor.errors.addTextOrRecording": "Sseḍḍ aḍḍay (synthèse IA) neɣ ssiḍ audio ɣef yid n wakken.",
  "episodeEditor.errors.saveDraftBeforeRecording": "Ur nsaḥ ad tḥeḍ l’épisode i micro. Sseḍḍ aḍḍay neɣ ssiḍ s l’épisode i d-yeḍ.",
  "episodeEditor.errors.microNotSupported": "Micro ur yettwasen ɣef wagi n browser.",
  "episodeEditor.errors.microPermission": "Ur nsaḥ ad neḍḍ aḍḍar (tazmert ur yettwasen).",
  "episodeEditor.errors.recordingUploadFailed": "Tazmert n upload n l’enregistrement ur yettwasen.",
  "episodeEditor.player.loop": "Aḍḍar",
  "episodeEditor.player.playbackSpeed": "Vitesse n tazmert",
  "episodeEditor.player.collapse": "Ssiḍ",
  "episodeEditor.player.expand": "Aḍḍar",
  "episodeEditor.player.waveformHidden": "Waveform ur yettwasen",
  "podcast.episodes.listen": "Ssemḥ",
  "podcast.episodes.noAudioShort": "Ur yettwasen audio",
  "podcast.episodes.edit": "Meddar",
  "podcast.episodes.delete": "Ssiḍ",
  "podcast.episodes.unmute": "Aḍḍar le son",
  "podcast.episodes.mute": "Ssiḍ le son",
  "podcast.episodes.totalEpisodes": "{{count}} épisode(s) i yid",
  "eduflow.designer.toast.blockCopied": "Block yessawel",
  "eduflow.designer.toast.blockPasted": "Block yessawel s",
  "eduflow.designer.toast.blockDuplicated": "Block yessawel",
  "eduflow.designer.toast.connectionUpdated": "Tazmert yessawel",
  "eduflow.designer.toast.flowExported": "Parcours yessawel",
  "eduflow.designer.toast.flowImported": "Parcours yessawel",
  "eduflow.designer.toast.flowPastedFromClipboard": "Parcours yessawel s l’presse-papiers",
  "eduflow.designer.toast.invalidFile": "Fichier ur yessawel",
  "eduflow.designer.toast.exportFailed": "Export ur yettwasen.",
  "eduflow.designer.toast.importPackageFailed": "Import n package .lyrra ur yettwasen.",
  "eduflow.designer.untitled": "Ur yettwasen",
  "eduflow.designer.importedFlow": "Parcours yessawel",
  "eduflow.designer.collaborator.online": "Di l’line",
  "eduflow.designer.collaborator.offline": "Ur di l’line",
  "eduflow.designer.collaborator.defaultName": "Utilisateur",
  "eduflow.designer.collaborator.editor": "Editeur",
  "eduflow.designer.collaborator.viewer": "Lecteur",
  "eduflow.designer.resizePanel": "Reddimensionner le panneau",
  "eduflow.designer.published": "Yessawel",
  "eduflow.designer.draft": "Brouillon",
  "eduflow.designer.quizOutput.success": "Ssuḍi",
  "eduflow.designer.quizOutput.failure": "Aḍḍi",
  "eduflow.designer.loopHandle.loop": "Aḍḍu",
  "eduflow.designer.loopHandle.end": "Tazrigt",
  "eduflow.designer.handle.default": "Aḍḍif",
  "eduflow.designer.genError": "Aɣil n tazmert. Rreḍi.",
  "trainerTour.welcome.title": "Ssalut ɣef tazrigt nwen",
  "trainerTour.welcome.description": "Tazmert agi tṣṣaɣt ɣef tazrigt n taddart akked tmenna. S waggur, ɣef kull page i tḥeqqiḍ, tazmert tḥeqqiḍ i tḥeqqiḍ ɣef lḥeqq. Ttḥeqqiḍ aḍḍuḍ ɣef tazrigt: tazmert ur tḥeqqiḍ ara.",
  "trainerTour.dashboard.header.title": "Tazrigt nwen",
  "trainerTour.dashboard.header.description": "Aɣil n tazrigt nwen: tazmert akked tazmert n tazrigt i tḥeqqiḍ.",
  "trainerTour.dashboard.actions.title": "Ssnif tazmert",
  "trainerTour.dashboard.actions.description": "Tazmert n tazmert n EduFlow, podcast walla parcours. Ussin ɣef tazmert n tazrigt ur tḥeqqiḍ ara.",
  "trainerTour.dashboard.stats.title": "Tazmert",
  "trainerTour.dashboard.stats.description": "Tazmert, parcours i tḥeqqiḍ, tazmert n tazrigt akked podcasts: ssuḍi tazmert n tazrigt nwen ɣef lḥeqq.",
  "trainerTour.dashboard.activity.title": "Tazmert n tazrigt",
  "trainerTour.dashboard.activity.description": "Tazmert n tazmert i tḥeqqiḍ. Ttḥeqqiḍ ɣef tazmert i tḥeqqiḍ ɣef lḥeqq.",
  "trainerTour.sidebar.title": "Tazrigt n tmenna",
  "trainerTour.sidebar.description": "Tazmert (tazrigt, tazmert n tazrigt, tazmert, missions), ssnif (tazmert, podcasts, parcours, webinars ma yella tazrigt nwen), tazmert n tazrigt akked tazmert n tazrigt. Ttḥeqqiḍ ɣef tazmert ɣef lḥeqq: tazmert ur tḥeqqiḍ ara.",
  "trainerTour.routes.learners.title": "Tazmert n tazrigt",
  "trainerTour.routes.learners.description": "Tazmert n tazmert i tḥeqqiḍ ɣef tazmert, tazmert, exports. Aɣil n tazmert n tazrigt.",
  "trainerTour.routes.analytics.title": "Tazmert",
  "trainerTour.routes.analytics.description": "Tazmert akked tazmert ɣef tazmert akked tazmert. Tazmert ɣef tazmert n tazrigt.",
  "trainerTour.routes.eduflow.title": "Tazmert (EduFlow)",
  "trainerTour.routes.eduflow.description": "Ssnif akked tazmert n tazrigt, tazmert, tazmert akked tazmert. Aɣil n tazmert n tazrigt.",
  "trainerTour.routes.podcasts.title": "Podcasts",
  "trainerTour.routes.podcasts.description": "Tazmert n tazmert, tazmert, tazmert akked tazmert n tazrigt.",
  "trainerTour.routes.parcours.title": "Parcours",
  "trainerTour.routes.parcours.description": "Tazmert n tazmert akked tazmert: tazmert n tazmert akked tazmert.",
  "trainerTour.routes.videos.title": "Vidéos",
  "trainerTour.routes.videos.description": "Tazmert n vidéos i tḥeqqiḍ ɣef tazmert akked tazmert.",
  "trainerTour.routes.sounds.title": "Sons",
  "trainerTour.routes.sounds.description": "Fichiers audio akked tags ɣef tazmert akked tazmert n tazrigt.",
  "trainerTour.routes.images.title": "Images",
  "trainerTour.routes.images.description": "Visuels n tazmert: import, dossiers akked tazmert n tazmert.",
  "trainerTour.routes.documents.title": "Documents",
  "trainerTour.routes.documents.description": "PDF akked tazmert n tazmert, akked tazmert n tazmert ɣef tazmert ma yella tazmert.",
  "trainerTour.routes.help.title": "Aide",
  "trainerTour.routes.help.description": "Articles, tutoriels akked tazmert n tazmert ɣef LyrraOne. Rreḍi ɣef tazmert ma tḥeqqiḍ ɣef tazmert.",
  "trainerTour.routes.producerAssignments.title": "Missions n tazmert",
  "trainerTour.routes.producerAssignments.description": "Ma yella tazmert nwen yefka tazmert i tḥeqqiḍ (catalogue n tazrigt), tazmert yella ɣef tazmert n tazrigt.",
  "trainerTour.routes.webinars.title": "Webinaires",
  "trainerTour.routes.webinars.description": "Ssnif tazmert n tazmert, tazmert akked tazmert n tazmert ɣef tazrigt.",
  "trainerTour.driver.progress": "{{current}} / {{total}}",
  "trainerTour.driver.next": "Ssuivant",
  "trainerTour.driver.prev": "Ssuqed",
  "trainerTour.driver.done": "OK",
  "trainerTour.driver.gotIt": "Akhir",
  "player.lightMode": "Amazigh n tazrigt",
  "player.darkMode": "Amazigh n tazrigt uḍḍi",
  "a11y.skipToContent": "Ssiḍ i tazrigt tamezwarut",
  "a11y.skipToNav": "Ssiḍ i tazrigt n tazrigt",
  "a11y.skipToPlayerMain": "Ssiḍ i tazrigt n tazrigt",
  "a11y.playerMainLandmark": "Tazrigt n tazrigt",
  "a11y.dialog": "Tazrawt",
  "a11y.closeDialog": "Ssiḍ i tazrawt",
  "a11y.dismissNotification": "Ssiḍ i tazrawt n tazrawt",
  "a11y.notificationsRegion": "Tazrawt",
  "a11y.skipLinksLandmark": "Tazrawt n tazrigt",
  "eduflow.blockEditor.audio.estimatedSeconds": "~{{sec}}s n tazrigt",
  "eduflow.blockEditor.audio.fileLabel": "Fichier n tazrigt",
  "eduflow.blockEditor.audio.formatsHint": "MP3, WAV, OGG",
  "eduflow.blockEditor.audio.generateButton": "Sgen i tazrigt",
  "eduflow.blockEditor.audio.generateTts": "Sgen TTS",
  "eduflow.blockEditor.audio.import": "Sseḍ",
  "eduflow.blockEditor.audio.langDe": "Alemannisch",
  "eduflow.blockEditor.audio.langEn": "Anglais",
  "eduflow.blockEditor.audio.langEs": "Espagnol",
  "eduflow.blockEditor.audio.langFr": "Français",
  "eduflow.blockEditor.audio.langIt": "Italien",
  "eduflow.blockEditor.audio.language": "Tamazight",
  "eduflow.blockEditor.audio.mistralVoice": "Tafukt (Mistral TTS)",
  "eduflow.blockEditor.audio.mistralVoicePlaceholder": "ID tafukt Mistral (console Mistral / API)",
  "eduflow.blockEditor.audio.voicesLoading": "Ssiḍ i tafukt…",
  "eduflow.blockEditor.audio.voicesLoadError": "Ur nssin ara tafukt Mistral.",
  "eduflow.blockEditor.audio.voicesEmptyHint": "Ur nssin ara tafukt i tazrawt. Ssiḍ i tazrawt Mistral (Administration → Intégrations). Tazrawt tura ssiḍ i tafukt n tazrigt.",
  "eduflow.blockEditor.audio.voiceFallbackOption": "{{id}} (n tazrigt)",
  "eduflow.blockEditor.audio.generating": "Sgen…",
  "eduflow.blockEditor.audio.generateNeedText": "Ssiḍ i tazrigt n tazrigt.",
  "eduflow.blockEditor.audio.generateBadResponse": "Tazrawt TTS ur nssin ara.",
  "eduflow.blockEditor.audio.generateSuccess": "Tazrigt sgen.",
  "eduflow.blockEditor.audio.generateError": "Ur ssiḍ ara (Mistral TTS / intégrations).",
  "eduflow.blockEditor.audio.preview": "Tazrawt n tazrigt",
  "eduflow.blockEditor.audio.source": "Surs n tazrigt",
  "eduflow.blockEditor.audio.speedLabel": "Tazrigt: {{speed}}x",
  "eduflow.blockEditor.audio.syncWithText": "Synchronized s wul n ttext (subtitles)",
  "eduflow.blockEditor.audio.syncWithTextHelp": "Di l'lecteur: uma zwan s wul n ttext i d-ssin, yefka s wul n tposition n llecteur (taddukt n ttext i d-ssin, ur d-ttfile VTT).",
  "eduflow.blockEditor.audio.ttsPlaceholder": "Sseggas wul n ttext i yeddu s wul n tvoice n synthesis...",
  "eduflow.blockEditor.audio.ttsText": "Wul i yeddu",
  "eduflow.blockEditor.audio.urlLabel": "Ne URL n tfile n audio",
  "eduflow.blockEditor.audio.urlPlaceholder": "https://example.com/audio.mp3",
  "eduflow.blockEditor.browser.allowExternalAria": "Aẓẓel d-ikwen n lsite n web",
  "eduflow.blockEditor.browser.allowExternalHelp": "{{off}}: iframe n tprotection (sandbox) — yefka popups akked tbehaviors n lout. {{on}}: aẓẓel n tcompatibilité s wul n tpages n rich (videos, widgets); navigation yefka s wul n tframe.",
  "eduflow.blockEditor.browser.allowExternalOff": "Ur d-tt",
  "eduflow.blockEditor.browser.allowExternalOn": "D-tt",
  "eduflow.blockEditor.browser.allowExternalTitle": "Aẓẓel d-ikwen n lsite n web",
  "eduflow.blockEditor.browser.frameTitleFallback": "Page n web n tintegrée",
  "eduflow.blockEditor.browser.fullscreen": "Plein écran",
  "eduflow.blockEditor.browser.fullscreenTitle": "Aperçu — Page n web n tintegrée",
  "eduflow.blockEditor.browser.openTab": "Uẓẓi s wul n tab",
  "eduflow.blockEditor.browser.preview": "Aperçu",
  "eduflow.blockEditor.browser.urlHelp": "Sseggas l'adresse n tcomplete (https). L'aperçu yefka s wul n tdecor n tfenêtre — ur d-tt browser: l'apprenant ur d-yeddu l'URL s wul n tinterface.",
  "eduflow.blockEditor.browser.urlLabel": "URL n tpage",
  "eduflow.blockEditor.browser.urlPlaceholder": "https://…",
  "eduflow.blockEditor.chart.addLabel": "Label",
  "eduflow.blockEditor.chart.addSeries": "Série",
  "eduflow.blockEditor.chart.animation": "Animation",
  "eduflow.blockEditor.chart.chartTitle": "Titre n tgraphique",
  "eduflow.blockEditor.chart.chartType": "Type n tgraphique",
  "eduflow.blockEditor.chart.colorTitle": "Couleur",
  "eduflow.blockEditor.chart.datasets": "Séries n données ({{count}})",
  "eduflow.blockEditor.chart.defaultLabel": "Label {{n}}",
  "eduflow.blockEditor.chart.defaultSeries": "Série {{n}}",
  "eduflow.blockEditor.chart.interactive": "Interactif (infobulles)",
  "eduflow.blockEditor.chart.labelsX": "Labels (axe X)",
  "eduflow.blockEditor.chart.noSeries": "Ur d-serie. Uẓẓi s « Série » i d-ssin.",
  "eduflow.blockEditor.chart.readerPreviewHint": "Aperçu yefka s wul n tmode n lecteur",
  "eduflow.blockEditor.chart.seriesNamePlaceholder": "Isem n tseries",
  "eduflow.blockEditor.chart.settings": "Paramètres",
  "eduflow.blockEditor.chart.showGrid": "Aẓẓel la grille",
  "eduflow.blockEditor.chart.showLegend": "Aẓẓel la légende",
  "eduflow.blockEditor.chart.titlePlaceholder": "Titre n toptionnel",
  "eduflow.blockEditor.chart.typeArea": "Aire",
  "eduflow.blockEditor.chart.typeBar": "Barres",
  "eduflow.blockEditor.chart.typeDoughnut": "Anneau",
  "eduflow.blockEditor.chart.typeLine": "Ligne",
  "eduflow.blockEditor.chart.typePie": "Camembert",
  "eduflow.blockEditor.chart.typeRadar": "Radar",
  "eduflow.blockEditor.timer.sectionTitle": "Minuteur",
  "eduflow.blockEditor.timer.enable": "Activer le minuteur (lecteur)",
  "eduflow.blockEditor.timer.modeLabel": "Mode",
  "eduflow.blockEditor.timer.modeCountup": "Minuteur (0 → limite)",
  "eduflow.blockEditor.timer.countupHint": "Les 10 dernières secondes avant la limite passent en rouge.",
  "eduflow.blockEditor.timer.modeCountdown": "Décompte (limite → 0)",
  "eduflow.blockEditor.timer.countdownHint": "Les 5 dernières secondes passent en rouge.",
  "eduflow.blockEditor.timer.maxSecondsLabel": "Temps maximum (secondes)",
  "eduflow.blockEditor.evaluation.aiQuestions": "Générer des questions IA",
  "eduflow.blockEditor.evaluation.editFullscreen": "Éditer le formulaire (plein écran)",
  "eduflow.blockEditor.evaluation.hint": "Ouvrez l’éditeur plein écran pour composer le formulaire : glissez les types de champs depuis la colonne de gauche et réordonnez les questions par la poignée.",
  "eduflow.blockEditor.evaluation.metaLine": "{{qPart}} · {{pPart}} au total",
  "eduflow.blockEditor.evaluation.pointPlural": "points",
  "eduflow.blockEditor.evaluation.pointSingular": "point",
  "eduflow.blockEditor.evaluation.questionPlural": "questions",
  "eduflow.blockEditor.evaluation.questionSingular": "question",
  "eduflow.blockEditor.evaluation.title": "Formulaire d’évaluation",
  "eduflow.blockEditor.evaluationForm.addFreeText": "Ajouter texte libre",
  "eduflow.blockEditor.evaluationForm.addOption": "Option",
  "eduflow.blockEditor.evaluationForm.close": "Fermer",
  "eduflow.blockEditor.evaluationForm.delete": "Supprimer",
  "eduflow.blockEditor.evaluationForm.dropEmptyHint": "Déposez ici un type de question depuis le panneau de gauche, ou utilisez le bouton « Ajouter ».",
  "eduflow.blockEditor.evaluationForm.escapeHint": "Échap pour fermer",
  "eduflow.blockEditor.evaluationForm.expectedValue": "Valeur attendue",
  "eduflow.blockEditor.evaluationForm.footerStats": "{{n}} question(s) · {{pts}} pts au total",
  "eduflow.blockEditor.evaluationForm.headerSubtitle": "Glissez un type de question depuis la gauche vers la zone centrale. Réordonnez par la poignée ⋮⋮.",
  "eduflow.blockEditor.evaluationForm.headerTitle": "Éditeur de formulaire d’évaluation",
  "eduflow.blockEditor.evaluationForm.maxAttempts": "Tentatives max",
  "eduflow.blockEditor.evaluationForm.moveQuestion": "Déplacer la question",
  "eduflow.blockEditor.evaluationForm.optionPlaceholder": "Option…",
  "eduflow.blockEditor.evaluationForm.optionsHint": "Cliquez sur le pictogramme pour marquer la ou les bonnes réponses.",
  "eduflow.blockEditor.evaluationForm.overlayUntitled": "(sans titre)",
  "eduflow.blockEditor.evaluationForm.paletteSubtitle": "Déposez dans le canevas pour ajouter une question.",
  "eduflow.blockEditor.evaluationForm.paletteTitle": "Champs",
  "eduflow.blockEditor.evaluationForm.passThreshold": "Seuil de réussite : {{pct}}%",
  "eduflow.blockEditor.evaluationForm.pointsShort": "pts",
  "eduflow.blockEditor.evaluationForm.qTypeDropdown": "Liste déroulante",
  "eduflow.blockEditor.evaluationForm.qTypeFile": "Fichier",
  "eduflow.blockEditor.evaluationForm.qTypeMultiple": "Choix multiple",
  "eduflow.blockEditor.evaluationForm.qTypeNumeric": "Numérique",
  "eduflow.blockEditor.evaluationForm.qTypeSingle": "Choix unique",
  "eduflow.blockEditor.evaluationForm.qTypeText": "Tiznit n tazmert",
  "eduflow.blockEditor.evaluationForm.questionTitlePlaceholder": "Tazmert n tazmert...",
  "eduflow.blockEditor.evaluationForm.refAnswerLabel": "Amsay n tazmert (ayen yebda)",
  "eduflow.blockEditor.evaluationForm.refAnswerPlaceholder": "Amsay yebda...",
  "eduflow.blockEditor.evaluationForm.refEmptyHint": "Ur nniḍen: kull amsay ur yebda d amḍan.",
  "eduflow.blockEditor.evaluationForm.required": "Aḍu.",
  "eduflow.blockEditor.evaluationForm.semanticGrading": "Tazmert n IA (tazmert n tazmert)",
  "eduflow.blockEditor.evaluationForm.semanticThreshold": "Aḍris n tazmert: {{pct}}%",
  "eduflow.blockEditor.evaluationForm.showCorrect": "Ssaḥ i tazmert n tazmert",
  "eduflow.blockEditor.evaluationForm.showResults": "Ssaḥ i tazmert",
  "eduflow.blockEditor.evaluationForm.timeLimit": "Aḍris n waqt",
  "eduflow.blockEditor.evaluationForm.tolerance": "Tolerans ±",
  "eduflow.blockEditor.glossary.add": "Sseḍ",
  "eduflow.blockEditor.glossary.categories": "Iḍraren",
  "eduflow.blockEditor.glossary.definitionPlaceholder": "Aḍris",
  "eduflow.blockEditor.glossary.description": "Tazmert",
  "eduflow.blockEditor.glossary.descriptionPlaceholder": "Ayd n tazmert n lqvocabulaire...",
  "eduflow.blockEditor.glossary.enableQuiz": "Ssaḥ i quiz n tazmert",
  "eduflow.blockEditor.glossary.includeInQuiz": "Ssaḥ i quiz",
  "eduflow.blockEditor.glossary.newCategoryPlaceholder": "Iḍraren nniḍen",
  "eduflow.blockEditor.glossary.noCategory": "Ur nniḍen",
  "eduflow.blockEditor.glossary.panelHint": "Sseḍ i term nwen u ssaḥ i mode quiz i tazmert.",
  "eduflow.blockEditor.glossary.panelTitle": "Glossaire + Quiz n tazmert",
  "eduflow.blockEditor.glossary.termPlaceholder": "Term",
  "eduflow.blockEditor.glossary.termSingular": "Term",
  "eduflow.blockEditor.glossary.termsCount": "Term ({{count}})",
  "eduflow.blockEditor.glossary.titleLabel": "Tazmert n glossaire",
  "eduflow.blockEditor.glossary.titlePlaceholder": "Glossaire",
  "eduflow.blockEditor.htmlSource.formatButton": "Reformat",
  "eduflow.blockEditor.htmlSource.formatTitle": "Reindent u ssen i HTML (tazmert n tazmert n mode code)",
  "eduflow.blockEditor.htmlSource.findVerb": "sserḥ",
  "eduflow.blockEditor.htmlSource.indentVerb": "indente",
  "eduflow.blockEditor.htmlSource.modeLabel": "Mode code HTML",
  "eduflow.blockEditor.mindmap.addChild": "Aḍu n nœud",
  "eduflow.blockEditor.mindmap.addMainBranch": "Sseḍ i brans n tazmert",
  "eduflow.blockEditor.mindmap.branchTitle": "Branche · {{title}}",
  "eduflow.blockEditor.mindmap.centralTheme": "Tazmert n tazmert",
  "eduflow.blockEditor.mindmap.close": "Sserḥ",
  "eduflow.blockEditor.mindmap.configureFullscreen": "Ssaḥ i mode n tazmert",
  "eduflow.blockEditor.mindmap.descriptionLabel": "Tazmert",
  "eduflow.blockEditor.mindmap.descriptionPlaceholder": "Tazmert n tazmert",
  "eduflow.blockEditor.mindmap.dialogTitle": "Carte heuristique",
  "eduflow.blockEditor.mindmap.optional": "Aɣilif",
  "eduflow.blockEditor.mindmap.playerHint": "I yid: tazrigt n tazrigt (tixsiwin ɣef tazrigt n tazrigt, tazrigt, tazrigt). Zom ɣef tazrigt n uḍris. URL: ikoni ↗ (tab n uḍris).",
  "eduflow.blockEditor.mindmap.remove": "Sɣur",
  "eduflow.blockEditor.mindmap.structure": "Tazrigt",
  "eduflow.blockEditor.mindmap.subtitleLabel": "Tazrigt n tazrigt",
  "eduflow.blockEditor.mindmap.titleLabel": "Tazrigt",
  "eduflow.blockEditor.mindmap.titlePlaceholder": "Tazrigt n uḍris",
  "eduflow.blockEditor.mindmap.untitled": "Ur nniḍen",
  "eduflow.blockEditor.mindmap.urlLabel": "Tazrigt URL",
  "eduflow.blockEditor.mindmap.urlPlaceholder": "https://…",
  "eduflow.blockEditor.pdf.allowDownload": "Aɣilif leḍḍa",
  "eduflow.blockEditor.pdf.badgePdf": "PDF",
  "eduflow.blockEditor.pdf.completionLabel": "Tazrigt n tazrigt",
  "eduflow.blockEditor.pdf.completionPlaceholder": "Tazrigt tazrigt",
  "eduflow.blockEditor.pdf.documentFallback": "Tazrigt PDF",
  "eduflow.blockEditor.pdf.emptyLibrary": "Ur ǧi tazrigt di tazrigt nwen.",
  "eduflow.blockEditor.pdf.focusMode": "Tazrigt n tazrigt",
  "eduflow.blockEditor.pdf.focusModeDesc": "Chrome n tazrigt, tazrigt ɣef tazrigt",
  "eduflow.blockEditor.pdf.importFailed": "Tazrigt ur ttuɣal",
  "eduflow.blockEditor.pdf.importFailedGeneric": "Tazrigt ur ttuɣal.",
  "eduflow.blockEditor.pdf.importSubtitle": "Tazrigt ḍa tazrigt nwen.",
  "eduflow.blockEditor.pdf.importTitle": "Ttughal PDF",
  "eduflow.blockEditor.pdf.librarySubtitle": "Ttughal PDF di tazrigt nwen neɣ sselḍiḍ tazrigt.",
  "eduflow.blockEditor.pdf.libraryTitle": "Tazrigt n tazrigt",
  "eduflow.blockEditor.pdf.loadingDocs": "Ttughal tazrigt…",
  "eduflow.blockEditor.pdf.myDocuments": "Tazrigt nwen",
  "eduflow.blockEditor.pdf.pagesAuto": "I yid yid tazrigt yid tazrigt n tazrigt.",
  "eduflow.blockEditor.pdf.pagesDetected": "{{count}} tazrigt yid tazrigt.",
  "eduflow.blockEditor.pdf.pickFromLibrary": "Sselḍiḍ PDF yid tazrigt nwen.",
  "eduflow.blockEditor.pdf.previewTitle": "Aperçu n tazrigt",
  "eduflow.blockEditor.pdf.readerMode": "Tazrigt n tazrigt",
  "eduflow.blockEditor.pdf.readerModeDesc": "Tazrigt ɣef tazrigt, zom, tazrigt n tazrigt",
  "eduflow.blockEditor.pdf.readingExperience": "Tazrigt n tazrigt",
  "eduflow.blockEditor.pdf.showProgress": "Sshow tazrigt n tazrigt",
  "eduflow.blockEditor.pdf.smartExtractSoon": "Tazrigt n tazrigt yid tazrigt",
  "eduflow.blockEditor.pdf.startPage": "Tazrigt n tazrigt",
  "eduflow.blockEditor.pdf.uploadedDesc": "{{name}} d-ttawen di tazrigt nwen.",
  "eduflow.blockEditor.pdf.uploadedToast": "PDF ttughal",
  "eduflow.blockEditor.pdf.uploading": "Ttughal di tazrigt",
  "eduflow.blockEditor.phraseReveal.addPhrase": "Sselḍiḍ tazrigt",
  "eduflow.blockEditor.phraseReveal.aiSummaryTitle": "Tazrigt n tazrigt n tazrigt ɣef tazrigt n tazrigt",
  "eduflow.blockEditor.phraseReveal.autoScroll": "Tazrigt n tazrigt",
  "eduflow.blockEditor.phraseReveal.displayDuration": "Aɣbalu n umḍak (s)",
  "eduflow.blockEditor.phraseReveal.editorHint": "Sseɣḍeḍ aɣbalu n umḍak s l'editor n tazmert. L'lecteur yefka aɣbalu ɣef wayen; clic ou Espace ɣef wayen n yid.",
  "eduflow.blockEditor.phraseReveal.emptyPhrase": "Aɣbalu ɣer",
  "eduflow.blockEditor.phraseReveal.importLegacy": "Sseɣḍeḍ l'ancient champ « Tazmert i yefka » ɣef aɣbalu (yemmas).",
  "eduflow.blockEditor.phraseReveal.noPhrases": "Ur yella aɣbalu ɣef wayen.",
  "eduflow.blockEditor.phraseReveal.phraseContent": "Imazighen n aɣbalu",
  "eduflow.blockEditor.phraseReveal.phrasePlaceholder": "Sseɣḍeḍ tazmert n wayen...",
  "eduflow.blockEditor.phraseReveal.showHistory": "Sseɣḍeḍ l'historique n aɣbalu",
  "eduflow.blockEditor.phraseReveal.showHistoryHelp": "Aɣbalu yefka yellan d l'carte di tazmert n wayen d l'blak.",
  "eduflow.blockEditor.presentation.addSlide": "Diapositive",
  "eduflow.blockEditor.presentation.autoAdvance": "Avance automatique",
  "eduflow.blockEditor.presentation.delayLabel": "Délai : {{sec}}s",
  "eduflow.blockEditor.presentation.duplicateTitleSuffix": " (copie)",
  "eduflow.blockEditor.presentation.globalSettings": "Paramètres globaux",
  "eduflow.blockEditor.presentation.layoutImageText": "Image + texte",
  "eduflow.blockEditor.presentation.layoutTitleContent": "Titre + contenu",
  "eduflow.blockEditor.presentation.layoutTitleOnly": "Titre seul",
  "eduflow.blockEditor.presentation.layoutTwoCol": "Duo n lkolumn",
  "eduflow.blockEditor.presentation.layoutVideoOnly": "Vidéo seul",
  "eduflow.blockEditor.presentation.layoutVideoText": "Texte + vidéo",
  "eduflow.blockEditor.presentation.loop": "Boucle",
  "eduflow.blockEditor.presentation.noSlides": "Ur yella diapositive. Clic ɣef aɣbalu.",
  "eduflow.blockEditor.presentation.slideCount_one": "{{count}} diapositive",
  "eduflow.blockEditor.presentation.slideCount_other": "{{count}} diapositives",
  "eduflow.blockEditor.presentation.slideNumbers": "Numéros n diapositive",
  "eduflow.blockEditor.presentation.slidesHeading": "Diapositives",
  "eduflow.blockEditor.presentation.transition": "Transition",
  "eduflow.blockEditor.presentation.transitionFade": "Fondu",
  "eduflow.blockEditor.presentation.transitionNone": "Ur yella",
  "eduflow.blockEditor.presentation.transitionSlide": "Glissement",
  "eduflow.blockEditor.presentation.transitionZoom": "Zoom",
  "eduflow.blockEditor.quiz.addAnswer": "Ajouter une réponse",
  "eduflow.blockEditor.quiz.addOrderingItem": "Ajouter un élément",
  "eduflow.blockEditor.quiz.aiMcqTitle": "Générer un QCM par IA ɣef les blocs n umḍak",
  "eduflow.blockEditor.quiz.answerPlaceholder": "Réponse {{n}}",
  "eduflow.blockEditor.quiz.answersCount": "Réponses ({{count}}/10)",
  "eduflow.blockEditor.quiz.branching": "Branchement",
  "eduflow.blockEditor.quiz.correctAnswer": "Bonne réponse",
  "eduflow.blockEditor.quiz.correctAnswerPlaceholder": "Sélectionner...",
  "eduflow.blockEditor.quiz.explanation": "Explication",
  "eduflow.blockEditor.quiz.explanationPlaceholder": "Explication complémentaire...",
  "eduflow.blockEditor.quiz.false": "Faux",
  "eduflow.blockEditor.quiz.feedback": "Akhbar",
  "eduflow.blockEditor.quiz.ifCorrect": "Ma ykoun correct →",
  "eduflow.blockEditor.quiz.ifIncorrect": "Ma ykoun incorrect →",
  "eduflow.blockEditor.quiz.markAsCorrect": "Nmarku k as correct",
  "eduflow.blockEditor.quiz.markCorrect": "Rasponse correct",
  "eduflow.blockEditor.quiz.msgCorrect": "Akhbar ma ykoun correct",
  "eduflow.blockEditor.quiz.msgCorrectPlaceholder": "Bravo ! Dda ykoun as correct.",
  "eduflow.blockEditor.quiz.msgIncorrect": "Akhbar ma ykoun incorrect",
  "eduflow.blockEditor.quiz.msgIncorrectPlaceholder": "Ula ykoun as correct.",
  "eduflow.blockEditor.quiz.nextBlockAuto": "Bloc as-snext (auto)",
  "eduflow.blockEditor.quiz.orderingHint": "Ilemnt i ykoun ad-ordren (l’ordre as-aktuel = ordre correct)",
  "eduflow.blockEditor.quiz.orderingItemPlaceholder": "Ilemnt {{n}}",
  "eduflow.blockEditor.quiz.partialScoring": "Score partiel (QCM)",
  "eduflow.blockEditor.quiz.question": "Sual",
  "eduflow.blockEditor.quiz.questionPlaceholder": "Sasrigh as-sual ik...",
  "eduflow.blockEditor.quiz.quizType": "No3 as-quizz",
  "eduflow.blockEditor.quiz.score": "Score",
  "eduflow.blockEditor.quiz.showCorrect": "Affichu as-sas correct",
  "eduflow.blockEditor.quiz.shuffle": "Mélanger",
  "eduflow.blockEditor.quiz.true": "Vrai",
  "eduflow.blockEditor.quiz.typeMcq": "QCM",
  "eduflow.blockEditor.quiz.typeFillBlank": "Teks i tghur",
  "eduflow.blockEditor.quiz.typeOrdering": "Classement",
  "eduflow.blockEditor.quiz.typeTrueFalse": "Vrai / Faux",
  "eduflow.blockEditor.quiz.branchingMode": "Mode as-branching",
  "eduflow.blockEditor.quiz.branchingNone": "Aucun (linéaire)",
  "eduflow.blockEditor.quiz.branchingCorrectIncorrect": "Correct / Incorrect",
  "eduflow.blockEditor.quiz.branchingPerAnswer": "Par réponse individuelle",
  "eduflow.blockEditor.loop.maxIterationsLabel": "Nummu as-max d'itérations (0 = infini)",
  "eduflow.blockEditor.loop.infiniteHint": "La boucle tcontinuera indéfiniment jusqu'à ce que la condition ykoun remplie.",
  "eduflow.blockEditor.loop.limitedHint": "La boucle tarrêtera après {{count}} tentative(s) maximum.",
  "eduflow.blockEditor.loop.howItWorksTitle": "Comment ça fonctionne :",
  "eduflow.blockEditor.loop.howItWorksText": "La boucle tredirect l'utilisateur vers le bloc connecté sur la sortie « Boucle » tant que la condition ma ykoun remplie (nummu max d'itérations : 0 = infini). Utilisez la sortie « Fin » pour la suite du parcours.",
  "eduflow.blockEditor.selfAssessment.addBadge": "Ajouter",
  "eduflow.blockEditor.selfAssessment.addCriterion": "Ajouter",
  "eduflow.blockEditor.selfAssessment.badgeInputPlaceholder": "Ex. Souvent, Jamais, Parfois…",
  "eduflow.blockEditor.selfAssessment.badgeOptionsHint": "Mots ou courtes expressions : l’apprenant les choisit comme pastilles. Sans proposition → champ texte libre.",
  "eduflow.blockEditor.selfAssessment.badgeOptionsLabel": "Propositions (badges)",
  "eduflow.blockEditor.selfAssessment.criteriaSection": "Critères",
  "eduflow.blockEditor.selfAssessment.criterionDescription": "Description (optionnelle)",
  "eduflow.blockEditor.selfAssessment.criterionDescriptionPh": "Précisez ce que l’apprenant doit observer ou comment se positionner…",
  "eduflow.blockEditor.selfAssessment.criterionTitle": "Intitulé",
  "eduflow.blockEditor.selfAssessment.criterionTitlePh": "Ex. Tazrawt, Tazwat…",
  "eduflow.blockEditor.selfAssessment.emptyCriteria": "Ula d-critère. Ssefru ad yefka d-ufus n tazrawt i yebda yefka s-udma.",
  "eduflow.blockEditor.selfAssessment.moveDown": "Ssefru",
  "eduflow.blockEditor.selfAssessment.moveUp": "Ssemmi",
  "eduflow.blockEditor.selfAssessment.panelHint": "Ssefru yella d-iman n tazrawt i yefka: tazrawt ghas, akked, ma yebda, tazrawt i yebda.",
  "eduflow.blockEditor.selfAssessment.panelTitle": "Tazrawt n-udma",
  "eduflow.blockEditor.selfAssessment.removeBadge": "Ssefru",
  "eduflow.blockEditor.selfAssessment.removeCriterion": "Ssefru d-critère",
  "eduflow.blockEditor.selfAssessment.responseTypeLabel": "Tazrawt n-tawuri",
  "eduflow.blockEditor.selfAssessment.scaleHint": "S 1 d N (ex. 5 = Likert)",
  "eduflow.blockEditor.selfAssessment.scaleLabel": "Tazrawt n-tawuri",
  "eduflow.blockEditor.selfAssessment.starCountHint": "Azzay 5",
  "eduflow.blockEditor.selfAssessment.starCountLabel": "Nber n-tizrawin",
  "eduflow.blockEditor.selfAssessment.textModeHint": "S d-critère: ssefru d-tizrawin i yebda (s-seleksiyun) nekkini s-ufus i tazrawt. Tazrawt n-udma yella d-ufus i tazrawt.",
  "eduflow.blockEditor.selfAssessment.typeNumeric": "Iḍraren",
  "eduflow.blockEditor.selfAssessment.typeNumericHint": "Iḍraren 1 d N",
  "eduflow.blockEditor.selfAssessment.typeStars": "Tizrawin",
  "eduflow.blockEditor.selfAssessment.typeStarsHint": "Tazrawt n-tawuri",
  "eduflow.blockEditor.selfAssessment.typeText": "Tazrawt n-tawuri",
  "eduflow.blockEditor.selfAssessment.typeTextHint": "Tazrawt n-udma s d-critère",
  "eduflow.blockEditor.shared.alignCenter": "Ssefru",
  "eduflow.blockEditor.shared.alignLeft": "Ssefru d-ibedd",
  "eduflow.blockEditor.shared.alignRight": "Ssefru d-ibedd",
  "eduflow.blockEditor.shared.annotationCount_one": "{{count}} tazrawt",
  "eduflow.blockEditor.shared.annotationCount_other": "{{count}} tazrawtin",
  "eduflow.blockEditor.shared.blocksCount": "{{count}} blocs",
  "eduflow.blockEditor.shared.bold": "Gras",
  "eduflow.blockEditor.shared.border": "Bordure",
  "eduflow.blockEditor.shared.bulletList": "Liste à puces",
  "eduflow.blockEditor.shared.cancel": "Annuler",
  "eduflow.blockEditor.shared.choose": "Ssefru",
  "eduflow.blockEditor.shared.close": "Fermer",
  "eduflow.blockEditor.shared.configure": "Configurer",
  "eduflow.blockEditor.shared.delete": "Ssefru",
  "eduflow.blockEditor.shared.duplicate": "Dupliquer",
  "eduflow.blockEditor.shared.imageLabel": "Image",
  "eduflow.blockEditor.shared.italic": "Italique",
  "eduflow.blockEditor.shared.layoutPrefix": "Layout : ",
  "eduflow.blockEditor.shared.linked": "Lié",
  "eduflow.blockEditor.shared.maxAttempts": "Tentatives max",
  "eduflow.blockEditor.shared.mediaImage": " Image",
  "eduflow.blockEditor.shared.mediaNone": " Pas de média",
  "eduflow.blockEditor.shared.mediaVideo": "Tvidi",
  "eduflow.blockEditor.shared.minutes": "Daqiq",
  "eduflow.blockEditor.shared.noImage": "Ula d image",
  "eduflow.blockEditor.shared.numberedList": "Azzay n umddu",
  "eduflow.blockEditor.shared.option": "Ikhtiyar",
  "eduflow.blockEditor.shared.pages": "{{count}} tpage",
  "eduflow.blockEditor.shared.points": "Ipoints",
  "eduflow.blockEditor.shared.retry": "Ihder",
  "eduflow.blockEditor.shared.rounded": "Ighrimen",
  "eduflow.blockEditor.shared.save": "Ssave",
  "eduflow.blockEditor.shared.selected": "Ihder",
  "eduflow.blockEditor.shared.shadow": "Tazmert",
  "eduflow.blockEditor.shared.slideCounter": "Slide {{index}}/{{total}}",
  "eduflow.blockEditor.shared.speedTicks": "{{v}}x",
  "eduflow.blockEditor.shared.strike": "Ighur",
  "eduflow.blockEditor.shared.underline": "Ihder",
  "eduflow.blockEditor.shared.untitledSlide": "Ula d ttitle",
  "eduflow.blockEditor.shared.updatedOn": "Ihder {{date}}",
  "eduflow.blockEditor.subflow.emptyPublished": "Ula d tformation n umddu",
  "eduflow.blockEditor.subflow.emptySearch": "Ula d tformation",
  "eduflow.blockEditor.subflow.linkedTraining": "Tformation tlinka",
  "eduflow.blockEditor.subflow.loadError": "Ur tssna tformations",
  "eduflow.blockEditor.subflow.loading": "Tssna…",
  "eduflow.blockEditor.subflow.openInTab": "Fta tformation tlinka f tab jdid",
  "eduflow.blockEditor.subflow.remove": "Ssi",
  "eduflow.blockEditor.subflow.searchPlaceholder": "Sserf tformation n umddu…",
  "eduflow.blockEditor.summary.addItem": "Ssefr point",
  "eduflow.blockEditor.summary.aiRecapTitle": "Sgenrer trecap n IA seg lblocks n umddu",
  "eduflow.blockEditor.summary.editorHint": "Slisti lnotions negh l'étapes n tformation. Kull line tazra d bullet f llecteur.",
  "eduflow.blockEditor.summary.emptyList": "Ula d point f l'waqt. Ssefr wahed.",
  "eduflow.blockEditor.summary.itemPlaceholder": "Ex. : Les risques incendie en entreprise",
  "eduflow.blockEditor.text.audioTts": "Audio (TTS)",
  "eduflow.blockEditor.text.charWordCount": "{{chars}} ikkar · {{words}} lkelmat",
  "eduflow.blockEditor.text.content": "Icontent",
  "eduflow.blockEditor.text.contentPlaceholder": "Sisi lcontent n lblock texte…",
  "eduflow.blockEditor.text.formatting": "Mise en forme",
  "eduflow.blockEditor.text.headingH1": "Titre 1",
  "eduflow.blockEditor.text.headingH2": "Titre 2",
  "eduflow.blockEditor.text.headingH3": "Titre 3",
  "eduflow.blockEditor.text.headingH4": "Titre 4",
  "eduflow.blockEditor.text.headingH5": "Titre 5",
  "eduflow.blockEditor.text.headingH6": "Titre 6",
  "eduflow.blockEditor.text.headingLevel": "Ihder n titer",
  "eduflow.blockEditor.text.headingParagraph": "Paragraphe",
  "eduflow.blockEditor.text.previewSoon": "Aɣbalu (bentay)",
  "eduflow.blockEditor.text.readTime": "~{{min}} min n tɣrɣit",
  "eduflow.blockEditor.text.speedLabel": "Tazrigt : {{speed}}x",
  "eduflow.blockEditor.text.voice": "Tafukt",
  "eduflow.blockEditor.text.voiceAdam": "Adam (FR masculin)",
  "eduflow.blockEditor.text.voiceBella": "Bella (FR féminin)",
  "eduflow.blockEditor.text.voiceHeart": "Heart (FR féminin)",
  "eduflow.blockEditor.text.voiceMichael": "Michael (EN masculin)",
  "eduflow.blockEditor.text.voiceNova": "Nova (EN féminin)",
  "eduflow.blockEditor.text.voiceSky": "Sky (EN féminin)",
  "eduflow.blockEditor.timeline.addEvent": "Aɣbalu",
  "eduflow.blockEditor.timeline.alternatingSides": "Tazrawt n yid",
  "eduflow.blockEditor.timeline.animatedReveal": "Tazrawt n tazmert",
  "eduflow.blockEditor.timeline.colorHint": "Aɣbalu n tazrigt (amḍak)",
  "eduflow.blockEditor.timeline.colorLabel": "Tazrigt",
  "eduflow.blockEditor.timeline.datePlaceholder": "Aɣbalu neɣ tazrawt (ex. 1789, yanir 2024)",
  "eduflow.blockEditor.timeline.descPlaceholder": "Tazmert (tazmert ɣef tazrigt)",
  "eduflow.blockEditor.timeline.emptyEvents": "Ur n yid. Sɣur aɣbalu ɣef tazrawt.",
  "eduflow.blockEditor.timeline.events": "Yid",
  "eduflow.blockEditor.timeline.horizontal": "Horrizontale",
  "eduflow.blockEditor.timeline.iconAward": "Medal",
  "eduflow.blockEditor.timeline.iconCheck": "Tazmert",
  "eduflow.blockEditor.timeline.iconClock": "Aɣlud",
  "eduflow.blockEditor.timeline.iconFlag": "Aɣbalu",
  "eduflow.blockEditor.timeline.iconStar": "Tislit",
  "eduflow.blockEditor.timeline.moveDown": "Sɣur",
  "eduflow.blockEditor.timeline.moveUp": "Ttɣi",
  "eduflow.blockEditor.timeline.orientation": "Tazrawt",
  "eduflow.blockEditor.timeline.settings": "Iɣlan",
  "eduflow.blockEditor.timeline.showConnectors": "Tazrawt n tazmert",
  "eduflow.blockEditor.timeline.titlePlaceholder": "Ihder n aɣbalu",
  "eduflow.blockEditor.timeline.untitled": "Ur n titer",
  "eduflow.blockEditor.timeline.vertical": "Vertikale",
  "eduflow.blockEditor.videoSubtitles.cancel": "Sǝnni",
  "eduflow.blockEditor.videoSubtitles.invalidResponse": "Tazmert ur tteḍḍa ɣef uɣal.",
  "eduflow.blockEditor.videoSubtitles.invalidUrl": "URL n tazrawt ur tteḍḍa.",
  "eduflow.blockEditor.videoSubtitles.loadError": "Ur tteḍḍa.",
  "eduflow.blockEditor.videoSubtitles.loadFailed": "Ur tteḍḍa tazrawt ({{status}}).",
  "eduflow.blockEditor.videoSubtitles.loading": "Ttɣi n tazrawt…",
  "eduflow.blockEditor.videoSubtitles.modalSubtitle": "Aɣbalu ɣef tazrawt. Iɣlan n tazrawt yella; ur tteḍḍa tazmert.",
  "eduflow.blockEditor.videoSubtitles.modalTitle": "Ssar n tazwit",
  "eduflow.blockEditor.videoSubtitles.noSegments": "Ula d tazwit n yid n tazwit.",
  "eduflow.blockEditor.videoSubtitles.saveFailed": "Ur ttuɣal ad tserḥ.",
  "eduflow.blockEditor.videoSubtitles.saveTrack": "Sserḥeḍ tazwit",
  "eduflow.blockEditor.videoSubtitles.savedToast": "Tazwit i sserḥeḍ",
  "eduflow.blockEditor.videoSubtitles.segmentN": "Tazwit {{n}}",
  "eduflow.blockEditor.videoSubtitles.segmentRequiredToast": "Yella tazwit n yid s tazwit.",
  "eduflow.blockEditor.videoSubtitles.trackLang": "Tamazight n tazwit : {{label}}",
  "eduflow.blockEditor.video.autoCaptionBullet": "Ttḍuḍ n tazwit (ffmpeg) akked tanzuft Mistral. URL n tazwit .mp4 yella s tazwit; ur yella page YouTube.",
  "eduflow.blockEditor.video.autoCaptionErrorFallback": "Sserḥeḍ tazwit Mistral, ffmpeg s uɣil akked yella tazwit n tazwit.",
  "eduflow.blockEditor.video.autoCaptionSection": "Tazwit n tazwit",
  "eduflow.blockEditor.video.autoCaptionsButton": "Ssar tazwit (tazwit + IA)",
  "eduflow.blockEditor.video.availableSubtitlesChip": "Tazwit i yellan",
  "eduflow.blockEditor.video.completionThreshold": "Aḍris n tazwit (%)",
  "eduflow.blockEditor.video.editCueButton": "Ssar tazwit (s tazwit)",
  "eduflow.blockEditor.video.endSeconds": "Ttawri (sec)",
  "eduflow.blockEditor.video.escHint": "Esc s tferḥ",
  "eduflow.blockEditor.video.libraryEmpty": "Ula d tazwit i yellan s tazwit n tazwit.",
  "eduflow.blockEditor.video.libraryTitle": "Tazwit n tazwit",
  "eduflow.blockEditor.video.libraryHint": "Sselḍeḍ tazwit i yellan s tazwit n tazwit.",
  "eduflow.blockEditor.video.libraryLoading": "Ttḍuḍ n tazwit…",
  "eduflow.blockEditor.video.optionalEnd": "Aḍris",
  "eduflow.blockEditor.video.accent.primary": "Aḍris",
  "eduflow.blockEditor.video.aspectFormat": "Format",
  "eduflow.blockEditor.video.aspect.ratio169": "16:9",
  "eduflow.blockEditor.video.aspect.ratio219": "21:9",
  "eduflow.blockEditor.video.aspect.ratio43": "4:3",
  "eduflow.blockEditor.video.aspect.ratio11": "1:1",
  "eduflow.blockEditor.video.pickFromLibrary": "Sselḍeḍ",
  "eduflow.blockEditor.video.playerBadge": "Player n tazwit",
  "eduflow.blockEditor.video.previewTitleFallback": "Lecteur n tazwit",
  "eduflow.blockEditor.video.reduced": "Sserḥeḍ",
  "eduflow.blockEditor.video.regenerateCaptions": "Ssar tazwit",
  "eduflow.blockEditor.video.previewHint": "Upload, YouTube ou URL n tazwit akked design n tazwit.",
  "eduflow.blockEditor.video.previewIframeTitle": "Tazwit n tazwit",
  "eduflow.blockEditor.video.subtitleBadge": "Tazwit",
  "eduflow.blockEditor.video.selected": "Sselḍeḍ",
  "eduflow.blockEditor.video.designTab": "Design",
  "eduflow.blockEditor.video.radius.soft": "Aḍris",
  "eduflow.blockEditor.video.radius.rounded": "Aḍris",
  "eduflow.blockEditor.video.radius.square": "Aḍris",
  "eduflow.blockEditor.video.shadow.soft": "Aḍris",
  "eduflow.blockEditor.video.shadow.glow": "Lhuwra",
  "eduflow.blockEditor.video.shadow.dramatic": "Dramatik",
  "eduflow.blockEditor.video.shadowLabel": "Umbra",
  "eduflow.blockEditor.video.radiusCornerLabel": "Akkud",
  "eduflow.blockEditor.video.themeEditorial.desc": "Azzay, asan, istnit",
  "eduflow.blockEditor.video.themeEditorial.label": "Isntit",
  "eduflow.blockEditor.video.themeCinema.desc": "Azzur, premium, imersif",
  "eduflow.blockEditor.video.themeCinema.label": "Cinemâ",
  "eduflow.blockEditor.video.themeGlass.desc": "Translucide, modern, lhim",
  "eduflow.blockEditor.video.themeGlass.label": "Glass",
  "eduflow.blockEditor.video.themeApp.desc": "Ala ddu, yeddu s ltheme agi",
  "eduflow.blockEditor.video.themeApp.label": "Aplikasiyon",
  "eduflow.blockEditor.video.themeAccent": "Azzay n accent",
  "eduflow.blockEditor.video.themePlayer": "Theme n player",
  "eduflow.blockEditor.video.toast.autoCaptionsError": "Tiwit n tazmert automatik ur yella",
  "eduflow.blockEditor.video.toast.autoCaptionsOk": "Tiwit n tazmert yeddu",
  "eduflow.blockEditor.video.toast.autoCaptionsOkDesc": "Yella deg waqt n tazrigt gher lplayer.",
  "eduflow.blockEditor.video.toast.uploadErrorDesc": "L'import ur yella.",
  "eduflow.blockEditor.video.toast.uploadErrorTitle": "Import ur yella",
  "eduflow.blockEditor.video.toast.uploadedDesc": "{{name}} yella ready deg block n video.",
  "eduflow.blockEditor.video.toast.uploadedTitle": "Video yedda",
  "eduflow.blockEditor.video.fullscreenExpandTitle": "Ftaḥ gher l'plein écran",
  "eduflow.blockEditor.video.fullscreenHeading": "Block n video",
  "eduflow.blockEditor.video.importDragTitle": "Importi video",
  "eduflow.blockEditor.video.importFormats": "MP4, WebM, OGG, MOV · max {{maxMb}} MB s l'UI",
  "eduflow.blockEditor.video.noneSelected": "Ur yella video yedda",
  "eduflow.blockEditor.video.playbackTab": "Tazrigt",
  "eduflow.blockEditor.video.playbackSettingsTitle": "Paramètres n tazrigt",
  "eduflow.blockEditor.video.loop": "Boucle",
  "eduflow.blockEditor.video.autoplay": "Tazrigt automatik",
  "eduflow.blockEditor.video.mutedStart": "Muet deg tazrigt",
  "eduflow.blockEditor.video.showControls": "Fhḍa les contrôles",
  "eduflow.blockEditor.video.embedSubtitlesYoutubeVimeo": "Deg {{platform}}, ftaḥ les sous-titres deg l'player intégré (CC). L'player yeddu les pistes n tazmert n la plateforme.",
  "eduflow.blockEditor.video.trackReadyHint": "Piste WebVTT yella ready : deg l'player, yeddu deg l'langue yedda n l'apprenant (les 12 langues n l'player ; traduction à la volée ma ykhas).",
  "eduflow.blockEditor.video.langTranscriptionTrack": "Langue (transcription / piste source)",
  "eduflow.blockEditor.video.placeholderUrlGeneric": "https://example.com/video.mp4",
  "eduflow.blockEditor.video.placeholderVimeo": "https://vimeo.com/…",
  "eduflow.blockEditor.video.placeholderYoutube": "https://www.youtube.com/watch?v=…",
  "eduflow.blockEditor.video.invalidUrlSource": "URL ur yella n cette source",
  "eduflow.blockEditor.video.urlHelpDirect": "Compatible s les URLs directes gher fichier n video.",
  "eduflow.blockEditor.video.labelUrlGeneric": "URL n video",
  "eduflow.blockEditor.video.labelUrlVimeo": "URL Vimeo",
  "eduflow.blockEditor.video.labelUrlYoutube": "URL YouTube",
  "eduflow.blockEditor.video.readyInBlock": "Vidéo tazrigt di bloc",
  "eduflow.blockEditor.video.uploadInProgress": "Upload d-ikkin",
  "eduflow.blockEditor.video.sectionSubtitlesDesign": "Tazrit",
  "eduflow.blockEditor.video.sourceLabel": "Asnaw n vidéo",
  "eduflow.blockEditor.video.sourceTab": "Asnaw",
  "eduflow.blockEditor.video.sourceUrl": "URL",
  "eduflow.blockEditor.video.sourceUpload": "Fichier",
  "eduflow.blockEditor.video.startSeconds": "Tazrigt (sec)",
  "eduflow.blockEditor.video.showPlayerHeader": "Ssi l’en-tête n player",
  "eduflow.blockEditor.video.accent.amber": "Ambre",
  "eduflow.blockEditor.video.accent.emerald": "Émeraude",
  "eduflow.blockEditor.richText.collapsedHintHtml": "Redd d-ikkin (mode HTML akti)",
  "eduflow.blockEditor.richText.collapsedHintReopen": "Cliquer i t-rouvrir d-ikkin",
  "eduflow.blockEditor.richText.defaultPlaceholder": "Skrib i t-content n-nek hna…",
  "eduflow.blockEditor.richText.slashPlaceholder": "Ssi t-skrib walla t-tayb « / » i l-commands",
  "eduflow.blockEditor.richText.slashButtonDefaultLabel": "Bouton",
  "eduflow.blockEditor.richText.slash.empty": "Aucune command n-ttawri",
  "eduflow.blockEditor.richText.slash.menuLabel": "Commands n mise en forme",
  "eduflow.blockEditor.richText.slash.sectionBasic": "Basique",
  "eduflow.blockEditor.richText.slash.sectionFormFields": "Champs formulaire",
  "eduflow.blockEditor.richText.slash.helpMeWrite": "Aidez-ni i t-skrib",
  "eduflow.blockEditor.richText.slash.helpMeWriteKeywords": "ia ai assistant rédaction",
  "eduflow.blockEditor.richText.slash.paragraph": "Paragraphe",
  "eduflow.blockEditor.richText.slash.paragraphKeywords": "texte normal",
  "eduflow.blockEditor.richText.slash.heading2": "Titre 2",
  "eduflow.blockEditor.richText.slash.heading2Keywords": "h2 sous-titre",
  "eduflow.blockEditor.richText.slash.heading3": "Titre 3",
  "eduflow.blockEditor.richText.slash.heading3Keywords": "h3",
  "eduflow.blockEditor.richText.slash.orderedList": "Liste numérotée",
  "eduflow.blockEditor.richText.slash.orderedListKeywords": "numéros 1 2 3",
  "eduflow.blockEditor.richText.slash.bulletList": "Liste à puces",
  "eduflow.blockEditor.richText.slash.bulletListKeywords": "puces points",
  "eduflow.blockEditor.richText.slash.blockquote": "Citation",
  "eduflow.blockEditor.richText.slash.blockquoteKeywords": "quote guillemets",
  "eduflow.blockEditor.richText.slash.divider": "Séparateur",
  "eduflow.blockEditor.richText.slash.dividerKeywords": "ligne hr trait",
  "eduflow.blockEditor.richText.slash.code": "Code",
  "eduflow.blockEditor.richText.slash.codeKeywords": "bloc snippet",
  "eduflow.blockEditor.richText.slash.emoji": "Émoji",
  "eduflow.blockEditor.richText.slash.emojiKeywords": "smiley emoticon",
  "eduflow.blockEditor.richText.slash.button": "Bouton",
  "eduflow.blockEditor.richText.slash.buttonKeywords": "lien cta action",
  "eduflow.blockEditor.richText.fullscreenTitleFallback": "Editeur",
  "eduflow.blockEditor.richText.calloutBody": "Tazrigt nnek d-...",
  "eduflow.blockEditor.richText.calloutTitle": "Titr n l'encart",
  "eduflow.blockEditor.richText.fullscreen": "Plein écran",
  "eduflow.blockEditor.richText.highlight": "Surligner",
  "eduflow.blockEditor.richText.imageTab": "Image",
  "eduflow.blockEditor.richText.importTab": "Importer",
  "eduflow.blockEditor.richText.infoPanelBody": "Ssefru d-ittij n tazrigt i l'apprenant.",
  "eduflow.blockEditor.richText.infoPanelTitle": "Aman n tazrigt",
  "eduflow.blockEditor.richText.inlineCode": "Code inline",
  "eduflow.blockEditor.richText.insertBadge": "Badge",
  "eduflow.blockEditor.richText.insertCallout": "Encart",
  "eduflow.blockEditor.richText.insertCalloutCompact": "Sser d encart",
  "eduflow.blockEditor.richText.insertImage": "Sser d image",
  "eduflow.blockEditor.richText.insertImageAction": "Sser l'image",
  "eduflow.blockEditor.richText.insertInfoPanel": "Panneau info",
  "eduflow.blockEditor.richText.insertVideo": "Sser d vidéo",
  "eduflow.blockEditor.richText.insertVideoAction": "Sser la vidéo",
  "eduflow.blockEditor.richText.libraryTab": "Mes images",
  "eduflow.blockEditor.richText.link": "Lien",
  "eduflow.blockEditor.richText.linkOk": "OK",
  "eduflow.blockEditor.richText.linkPlaceholderHttps": "https://...",
  "eduflow.blockEditor.richText.linkPrompt": "URL n lien :",
  "eduflow.blockEditor.richText.mediaFormatsHint": "PNG, JPG, GIF, WebP · max 10 Mo",
  "eduflow.blockEditor.richText.minimizeToolbar": "Réduire",
  "eduflow.blockEditor.richText.modalLibraryEmpty": "Aucune image dans votre bibliothèque",
  "eduflow.blockEditor.richText.modalUploading": "Envoi en cours...",
  "eduflow.blockEditor.richText.openImportTab": "Importer une image",
  "eduflow.blockEditor.richText.placeholderImageUrl": "https://exemple.com/image.jpg",
  "eduflow.blockEditor.richText.placeholderYoutube": "https://youtube.com/watch?v=...",
  "eduflow.blockEditor.richText.quote": "Citation",
  "eduflow.blockEditor.richText.redo": "Refaire",
  "eduflow.blockEditor.richText.separatorRule": "Séparateur",
  "eduflow.blockEditor.richText.showHtmlSource": "Afficher / modifier le HTML",
  "eduflow.blockEditor.richText.returnToVisual": "Revenir à l’éditeur visuel",
  "eduflow.blockEditor.richText.tplBadgeLabel": "Badge",
  "eduflow.blockEditor.richText.uploadDropPrompt": "Glisser-déposer ou",
  "eduflow.blockEditor.richText.uploadDropClick": "cliquer pour sélectionner",
  "eduflow.blockEditor.richText.heading1": "Titre 1",
  "eduflow.blockEditor.richText.heading2": "Titre 2",
  "eduflow.blockEditor.richText.heading3": "Titre 3",
  "eduflow.blockEditor.richText.justify": "Azzay",
  "eduflow.blockEditor.richText.undo": "Ssiw",
  "eduflow.blockEditor.richText.videoYoutubePaste": "Ssiw l'URL YouTube d-ttw",
  "eduflow.blockEditor.richText.videoYoutubeToolbar": "Vidéo YouTube",
  "eduflow.blockEditor.richText.urlTab": "URL"
};
